import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from 'react-query';
import { transport } from 'app-react-query/protected-transport';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type ApiToken = {
  created_at: Scalars['Int'];
  token_hint?: Maybe<Scalars['String']>;
  token_id: Scalars['ID'];
  token_name: Scalars['String'];
};

export type Action = {
  created_at: Scalars['Int'];
  display: ActionDisplay;
  group_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  user_id?: Maybe<Scalars['ID']>;
};

export type ActionDisplay = {
  message: Scalars['String'];
  substitutions: ActionDisplayParams;
  urls: ActionDisplayParams;
};

export type ActionDisplayParams = {
  actor: Scalars['String'];
  adjective: Scalars['String'];
};

export type Actions = {
  id_lt?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<Action>>>;
};

export type ActivityStat = {
  calendar_day?: Maybe<Scalars['String']>;
  clicks: Scalars['Int'];
  comments: Scalars['Int'];
  engagements: Scalars['Int'];
  impressions: Scalars['Int'];
  posts: Scalars['Int'];
  reactions: Scalars['Int'];
  shares: Scalars['Int'];
};

export type Address = {
  address: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  google_place_id?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type AddressInput = {
  address: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  google_place_id?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type AdminUpdateClientInput = {
  allow_group_creation?: InputMaybe<Scalars['Boolean']>;
  allow_sharing?: InputMaybe<Scalars['Boolean']>;
  allow_user_invites?: InputMaybe<Scalars['Boolean']>;
  allow_user_signup?: InputMaybe<Scalars['Boolean']>;
  client_url?: InputMaybe<Scalars['String']>;
  content_domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email_address?: InputMaybe<Scalars['String']>;
  email_domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  icon?: InputMaybe<S3ObjectInput>;
  id: Scalars['ID'];
  image?: InputMaybe<S3ObjectInput>;
  last_setup_step?: InputMaybe<Scalars['Int']>;
  moderator_can_mark_as_important?: InputMaybe<Scalars['Boolean']>;
  phone_number?: InputMaybe<Scalars['String']>;
  referral_headline?: InputMaybe<Scalars['String']>;
  referral_message?: InputMaybe<Scalars['String']>;
  setup_completed?: InputMaybe<Scalars['Boolean']>;
  social_config?: InputMaybe<SocialConfigInput>;
  social_media_policy?: InputMaybe<Scalars['String']>;
  social_media_policy_enabled?: InputMaybe<Scalars['Boolean']>;
  social_media_policy_title?: InputMaybe<Scalars['String']>;
  social_media_policy_url?: InputMaybe<Scalars['String']>;
  stickers_enabled?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum AdvancedFilters {
  Companies = 'companies',
  CompanyPages = 'company_pages',
  Posts = 'posts',
  Users = 'users'
}

export type AllowedCounts = {
  facebook?: Maybe<Scalars['Int']>;
  linkedin?: Maybe<Scalars['Int']>;
  twitter?: Maybe<Scalars['Int']>;
  xing?: Maybe<Scalars['Int']>;
};

export type AnalyticsCompany = {
  change?: Maybe<Scalars['Int']>;
  company?: Maybe<CompanyDetails>;
  engager_roles?: Maybe<Array<Maybe<EngagerRole>>>;
  engager_titles?: Maybe<Array<Maybe<EngagerTitle>>>;
  rank?: Maybe<Scalars['Int']>;
  total_engagers?: Maybe<Scalars['Int']>;
};

export type AnalyticsProfile = {
  company?: Maybe<CompanyDetails>;
  email_address?: Maybe<Scalars['String']>;
  engagement_summary?: Maybe<EngagementSummary>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network_bio?: Maybe<Scalars['String']>;
  network_profile_image?: Maybe<Scalars['String']>;
  network_profile_url?: Maybe<Scalars['String']>;
  profile_id?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
  registered?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Assignment = {
  active: Scalars['Boolean'];
  extracted_users?: Maybe<Scalars['Int']>;
  groups_required?: Maybe<Scalars['Int']>;
  groups_required_objects?: Maybe<Array<Maybe<GroupSuggestion>>>;
  groups_suggested?: Maybe<Scalars['Int']>;
  groups_suggested_objects?: Maybe<Array<Maybe<GroupSuggestion>>>;
  id: Scalars['ID'];
  rule: AssignmentRule;
  target_user: AssignmentTargetUser;
  title?: Maybe<Scalars['String']>;
  users_required?: Maybe<Scalars['Int']>;
  users_required_objects?: Maybe<Array<Maybe<MinimalUserProfile>>>;
  users_suggested?: Maybe<Scalars['Int']>;
  users_suggested_objects?: Maybe<Array<Maybe<MinimalUserProfile>>>;
};

export type AssignmentInput = {
  active: Scalars['Boolean'];
  client_id: Scalars['ID'];
  groups_required_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  groups_suggested_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  rule: AssignmentRuleInput;
  target_user: AssignmentTargetUser;
  title: Scalars['String'];
  users_required_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  users_suggested_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export enum AssignmentOperator {
  And = 'and',
  Or = 'or'
}

export type AssignmentRule = {
  all_users: Scalars['Boolean'];
  department_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  location_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  operator: AssignmentOperator;
};

export type AssignmentRuleInput = {
  all_users: Scalars['Boolean'];
  department_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  operator?: InputMaybe<AssignmentOperator>;
};

export enum AssignmentTargetUser {
  All = 'all',
  Existing = 'existing',
  New = 'new'
}

export type AssignmentUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  groups_required_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  groups_suggested_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  rule?: InputMaybe<AssignmentRuleInput>;
  target_user?: InputMaybe<AssignmentTargetUser>;
  title?: InputMaybe<Scalars['String']>;
  users_required_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  users_suggested_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type AssignmentsResponse = {
  next_id?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<Assignment>>>;
  total_count: Scalars['Int'];
};

export type Auth = {
  impersonator?: Maybe<UserProfile>;
  user?: Maybe<UserProfile>;
};

export enum AuthenticationType {
  Auth = 'auth',
  Passwordless = 'passwordless',
  Sso = 'sso'
}

export type BatchUpdateSocialConnectionInput = {
  items: Array<UpdateSocialConnectionInputs>;
};

export type BillableUserEventInput = {
  event_type: BillableUserEventType;
  measure_reference: Scalars['String'];
  measure_source: Scalars['String'];
};

export enum BillableUserEventType {
  AppRouteSwitched = 'app_route_switched',
  AuthLoggedIn = 'auth_logged_in',
  AuthLoggedOut = 'auth_logged_out'
}

export type Billing = {
  billable_user_count: Scalars['Int'];
  stripe_account_id: Scalars['String'];
  stripe_customer_id: Scalars['String'];
  stripe_price_id: Scalars['String'];
  stripe_product_id: Scalars['String'];
  stripe_subscription_id: Scalars['String'];
  stripe_subscription_item_id: Scalars['String'];
  stripe_subscription_status?: Maybe<Scalars['String']>;
  stripe_teams_trial_end?: Maybe<Scalars['Int']>;
  stripe_teams_trial_start?: Maybe<Scalars['Int']>;
};

export type BillingAddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  postal_code: Scalars['String'];
  state: Scalars['String'];
};

export type BillingCustomerPortalEphemeralUrl = {
  url: Scalars['String'];
};

export enum BillingPortalPlanType {
  Starter = 'starter',
  Teams = 'teams'
}

export enum BillingPortalRoute {
  Overview = 'overview',
  Plan = 'plan'
}

export enum BillingStatusType {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Trialing = 'trialing',
  Unconfigured = 'unconfigured',
  Unpaid = 'unpaid'
}

export enum BillingTypeType {
  Manual = 'manual',
  Stripe = 'stripe',
  Unconfigured = 'unconfigured'
}

export type BlockList = {
  terms: Array<Maybe<Scalars['String']>>;
};

export type BlockedTerm = {
  end: Scalars['Int'];
  start: Scalars['Int'];
  term: Scalars['String'];
};

export type BootstrapData = {
  capabilities?: Maybe<Array<Maybe<Scalars['String']>>>;
  client: Client;
  release_toggles?: Maybe<Array<Maybe<Scalars['String']>>>;
  user: ProfileContext;
  user_id: Scalars['ID'];
  user_leaderboards?: Maybe<Array<LeaderboardConfig>>;
  user_pages?: Maybe<Array<LinkedInPage>>;
  user_social_accounts?: Maybe<Array<SocialAccount>>;
};

export type BootstrapInput = {
  user_id?: InputMaybe<Scalars['ID']>;
};

export type BulkUpdateContent = {
  approval: ContentApprovalTypes;
  content_group_list: Array<InputMaybe<ContentGroupInput>>;
};

export type BulkUpdateContentResults = {
  error: Scalars['Int'];
  success: Scalars['Int'];
};

export type CeClickInfo = {
  content_id: Scalars['ID'];
  liked: Scalars['Boolean'];
  opened: Scalars['Boolean'];
  shared: Scalars['Boolean'];
};

export type CsCreateUserInput = {
  client_id: Scalars['ID'];
  email_address: Scalars['String'];
  email_address_verified?: InputMaybe<Scalars['Boolean']>;
  full_name?: InputMaybe<Scalars['String']>;
  job_title?: InputMaybe<Scalars['String']>;
  onboarding_completed?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  user_status?: InputMaybe<UserStatus>;
  user_type?: InputMaybe<UserType>;
};

export type CsUpdateClientInput = {
  allow_external_share?: InputMaybe<Scalars['Boolean']>;
  allow_group_creation?: InputMaybe<Scalars['Boolean']>;
  allow_group_discovery?: InputMaybe<Scalars['Boolean']>;
  allow_sharing?: InputMaybe<Scalars['Boolean']>;
  allow_user_invites?: InputMaybe<Scalars['Boolean']>;
  allow_user_share_commentary?: InputMaybe<Scalars['Boolean']>;
  allow_user_signup?: InputMaybe<Scalars['Boolean']>;
  authentication_type?: InputMaybe<AuthenticationType>;
  client_aliases?: InputMaybe<Array<InputMaybe<ClientAliasInput>>>;
  client_status?: InputMaybe<ClientStatus>;
  compliance_notification_email?: InputMaybe<Scalars['String']>;
  compliance_notification_emails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  compliance_notification_enabled?: InputMaybe<Scalars['Boolean']>;
  compliance_notification_frequency?: InputMaybe<Scalars['String']>;
  content_domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contract_committed_user_count?: InputMaybe<Scalars['Int']>;
  contract_end_at?: InputMaybe<Scalars['Int']>;
  contract_start_at?: InputMaybe<Scalars['Int']>;
  contract_type?: InputMaybe<ContractType>;
  departments_in_signup?: InputMaybe<Scalars['Boolean']>;
  departments_in_signup_required?: InputMaybe<Scalars['Boolean']>;
  disable_comments?: InputMaybe<Scalars['Boolean']>;
  disable_timeline?: InputMaybe<Scalars['Boolean']>;
  email_address?: InputMaybe<Scalars['String']>;
  email_domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email_from_address?: InputMaybe<Scalars['String']>;
  email_sending_domain?: InputMaybe<Scalars['String']>;
  features?: InputMaybe<Array<InputMaybe<Feature>>>;
  icon?: InputMaybe<S3ObjectInput>;
  id: Scalars['ID'];
  image?: InputMaybe<S3ObjectInput>;
  locations_in_signup?: InputMaybe<Scalars['Boolean']>;
  locations_in_signup_required?: InputMaybe<Scalars['Boolean']>;
  menu_item?: InputMaybe<ClientMenuItemInput>;
  menu_item_enabled?: InputMaybe<Scalars['Boolean']>;
  moderator_can_mark_as_important?: InputMaybe<Scalars['Boolean']>;
  public_post_details?: InputMaybe<Scalars['Boolean']>;
  public_post_force_login?: InputMaybe<Scalars['Boolean']>;
  public_post_page?: InputMaybe<Scalars['Boolean']>;
  referral_headline?: InputMaybe<Scalars['String']>;
  referral_message?: InputMaybe<Scalars['String']>;
  sort_mode?: InputMaybe<SortMode>;
  sso_configuration?: InputMaybe<SsoConfigurationInput>;
  sso_provider?: InputMaybe<Scalars['String']>;
  subdomain?: InputMaybe<Scalars['String']>;
  support_multiple_languages?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  yearly_enrichment_quota?: InputMaybe<Scalars['Int']>;
};

export type Capability = {
  capability_id?: Maybe<Scalars['String']>;
  client_count?: Maybe<Scalars['Int']>;
  clients?: Maybe<Array<Maybe<ClientCapability>>>;
  description?: Maybe<Scalars['String']>;
  entity_type?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
};

export enum CapabilityGroup {
  Slack = 'slack',
  Teams = 'teams'
}

export type ChannelInfo = {
  channel_id: Scalars['String'];
  channel_name?: Maybe<Scalars['String']>;
  status?: Maybe<ChannelRepostStatus>;
  team_id: Scalars['String'];
};

export enum ChannelRepostStatus {
  Pending = 'pending',
  Published = 'published'
}

export type Client = {
  added_by_user_id: Scalars['ID'];
  adobe_api_url?: Maybe<Scalars['String']>;
  adobe_integration_code?: Maybe<Scalars['String']>;
  allow_external_share: Scalars['Boolean'];
  allow_group_creation: Scalars['Boolean'];
  allow_group_discovery: Scalars['Boolean'];
  allow_sharing?: Maybe<Scalars['Boolean']>;
  allow_user_invites: Scalars['Boolean'];
  allow_user_share_commentary: Scalars['Boolean'];
  allow_user_signup: Scalars['Boolean'];
  authentication_type: AuthenticationType;
  billing?: Maybe<Billing>;
  billing_address?: Maybe<Address>;
  billing_status?: Maybe<BillingStatusType>;
  billing_teams_trial_end?: Maybe<Scalars['Int']>;
  billing_teams_trial_start?: Maybe<Scalars['Int']>;
  billing_type?: Maybe<BillingTypeType>;
  client_aliases?: Maybe<Array<Maybe<ClientAlias>>>;
  client_status: ClientStatus;
  client_url?: Maybe<Scalars['String']>;
  compliance_notification_email?: Maybe<Scalars['String']>;
  compliance_notification_emails?: Maybe<Array<Maybe<Scalars['String']>>>;
  compliance_notification_enabled?: Maybe<Scalars['Boolean']>;
  compliance_notification_frequency?: Maybe<Scalars['String']>;
  content_domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  contract_committed_user_count?: Maybe<Scalars['Int']>;
  contract_end_at?: Maybe<Scalars['Int']>;
  contract_start_at?: Maybe<Scalars['Int']>;
  contract_type?: Maybe<ContractType>;
  created_at: Scalars['Int'];
  default_language?: Maybe<Scalars['String']>;
  default_timezone?: Maybe<Scalars['String']>;
  departments_in_signup: Scalars['Boolean'];
  departments_in_signup_required: Scalars['Boolean'];
  disable_comments: Scalars['Boolean'];
  disable_timeline?: Maybe<Scalars['Boolean']>;
  disclosures?: Maybe<Array<Maybe<ClientDisclosure>>>;
  email_address?: Maybe<Scalars['String']>;
  email_domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  email_from_address?: Maybe<Scalars['String']>;
  email_sending_domain?: Maybe<Scalars['String']>;
  feature_plan_type?: Maybe<FeaturePlanType>;
  features?: Maybe<Array<Maybe<Feature>>>;
  icon?: Maybe<S3Object>;
  id: Scalars['ID'];
  image?: Maybe<S3Object>;
  is_self_serve?: Maybe<Scalars['Boolean']>;
  last_setup_step?: Maybe<Scalars['Int']>;
  locations_in_signup: Scalars['Boolean'];
  locations_in_signup_required: Scalars['Boolean'];
  menu_item?: Maybe<ClientMenuItem>;
  menu_item_enabled?: Maybe<Scalars['Boolean']>;
  moderator_can_mark_as_important?: Maybe<Scalars['Boolean']>;
  phone_number?: Maybe<Scalars['String']>;
  privacy_policy?: Maybe<Scalars['String']>;
  privacy_policy_enabled?: Maybe<Scalars['Boolean']>;
  privacy_policy_url?: Maybe<Scalars['String']>;
  public_post_details?: Maybe<Scalars['Boolean']>;
  public_post_force_login?: Maybe<Scalars['Boolean']>;
  public_post_page?: Maybe<Scalars['Boolean']>;
  referral_headline?: Maybe<Scalars['String']>;
  referral_message?: Maybe<Scalars['String']>;
  salesforce_bcc_email?: Maybe<Scalars['String']>;
  salesforce_enabled?: Maybe<Scalars['Boolean']>;
  setup_completed?: Maybe<Scalars['Boolean']>;
  social_config?: Maybe<SocialConfig>;
  social_media_policy?: Maybe<Scalars['String']>;
  social_media_policy_enabled?: Maybe<Scalars['Boolean']>;
  social_media_policy_title?: Maybe<Scalars['String']>;
  social_media_policy_url?: Maybe<Scalars['String']>;
  sort_mode?: Maybe<SortMode>;
  sso_configuration?: Maybe<SsoConfiguration>;
  /** @deprecated Use authentication_config.provider instead */
  sso_provider?: Maybe<Scalars['String']>;
  stickers?: Maybe<Array<Maybe<S3Object>>>;
  stickers_enabled?: Maybe<Scalars['Boolean']>;
  subdomain?: Maybe<Scalars['String']>;
  support_multiple_languages: Scalars['Boolean'];
  terms_and_conditions?: Maybe<Scalars['String']>;
  terms_and_conditions_enabled?: Maybe<Scalars['Boolean']>;
  terms_and_conditions_url?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updated_at: Scalars['Int'];
  url_tracking_enabled?: Maybe<Scalars['Boolean']>;
  url_tracking_feature?: Maybe<Scalars['Boolean']>;
  url_tracking_force_defaults?: Maybe<Scalars['Boolean']>;
  utm_medium_override?: Maybe<Scalars['String']>;
  utm_source_override?: Maybe<Scalars['String']>;
  yearly_enrichment_quota?: Maybe<Scalars['Int']>;
};

export type ClientAlias = {
  company_id: Scalars['String'];
  name: Scalars['String'];
};

export type ClientAliasInput = {
  company_id: Scalars['String'];
  name: Scalars['String'];
};

export type ClientAndUser = {
  client: Client;
  user: UserProfile;
};

export type ClientBillingReportAggregate = {
  calendar_month: Scalars['String'];
  client_id: Scalars['String'];
  client_subdomain: Scalars['String'];
  contract_committed_user_count?: Maybe<Scalars['Int']>;
  contract_end_at?: Maybe<Scalars['Int']>;
  contract_start_at?: Maybe<Scalars['Int']>;
  contract_type?: Maybe<ContractType>;
  created_at: Scalars['String'];
  last_month_total_users?: Maybe<Scalars['Int']>;
  num_anonymous_users: Scalars['Int'];
  num_email_users: Scalars['Int'];
  num_potential_users?: Maybe<Scalars['Int']>;
  num_registered_users: Scalars['Int'];
  registered_rate?: Maybe<Scalars['Float']>;
  total_users: Scalars['Int'];
  two_months_ago_total_users?: Maybe<Scalars['Int']>;
  updated_at: Scalars['String'];
  usage_rate?: Maybe<Scalars['Float']>;
  user_overage?: Maybe<Scalars['Int']>;
};

export type ClientBillingReportAggregateResultSet = {
  count?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<ClientBillingReportAggregate>>>;
  last_evaluated_key?: Maybe<Scalars['String']>;
};

export type ClientBillingReportAggregateSearchFilter = {
  calendar_month__eq?: InputMaybe<Scalars['String']>;
  client_subdomain__contains?: InputMaybe<Scalars['String']>;
  usage_rate__gte?: InputMaybe<Scalars['Float']>;
  usage_rate__lte?: InputMaybe<Scalars['Float']>;
};

export type ClientCapability = {
  active?: Maybe<Scalars['Boolean']>;
  capability_id?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_subdomain?: Maybe<Scalars['String']>;
  client_title?: Maybe<Scalars['String']>;
  entity_type?: Maybe<Scalars['String']>;
  quota?: Maybe<Scalars['Int']>;
  usage?: Maybe<Scalars['Int']>;
};

export type ClientContentTag = {
  created_at: Scalars['Int'];
  tag_id: Scalars['String'];
  title: Scalars['String'];
  updated_at: Scalars['Int'];
};

export type ClientDepartment = {
  client_id: Scalars['ID'];
  department_status: ClientDepartmentStatus;
  groups_total?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  profiles_total?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type ClientDepartmentList = {
  client_departments?: Maybe<Array<Maybe<ClientDepartment>>>;
  count: Scalars['Int'];
  id?: Maybe<Scalars['ID']>;
  paginate: Scalars['Boolean'];
  title_lower?: Maybe<Scalars['String']>;
};

export type ClientDepartmentListInput = {
  count?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  title_lower?: InputMaybe<Scalars['String']>;
};

export enum ClientDepartmentStatus {
  Active = 'active',
  Disabled = 'disabled'
}

export type ClientDepartmentStatusList = {
  client_departments?: Maybe<Array<Maybe<ClientDepartment>>>;
  count: Scalars['Int'];
  department_status?: Maybe<ClientDepartmentStatus>;
  id?: Maybe<Scalars['ID']>;
  paginate: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
};

export type ClientDepartmentStatusListInput = {
  count?: InputMaybe<Scalars['Boolean']>;
  department_status: ClientDepartmentStatus;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ClientDisclosure = {
  disclosure: Scalars['String'];
  disclosure_status: ClientDisclosureStatus;
  id: Scalars['ID'];
};

export type ClientDisclosureList = {
  client_disclosures?: Maybe<Array<Maybe<ClientDisclosure>>>;
  count: Scalars['Int'];
  id?: Maybe<Scalars['ID']>;
  paginate: Scalars['Boolean'];
};

export type ClientDisclosureListInput = {
  count?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export enum ClientDisclosureStatus {
  Active = 'active',
  Disabled = 'disabled'
}

export type ClientDisclosureStatusList = {
  client_disclosures?: Maybe<Array<Maybe<ClientDisclosure>>>;
  count: Scalars['Int'];
  disclosure_status?: Maybe<ClientDisclosureStatus>;
  id?: Maybe<Scalars['ID']>;
  paginate: Scalars['Boolean'];
};

export type ClientDisclosureStatusListInput = {
  count?: InputMaybe<Scalars['Boolean']>;
  disclosure_status: ClientDisclosureStatus;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ClientEngagementStat = {
  comments: Scalars['Int'];
  groups: Scalars['Int'];
  posts: Scalars['Int'];
  reactions: Scalars['Int'];
  users: Scalars['Int'];
};

export type ClientFollowMapping = {
  all_users?: Maybe<Scalars['Boolean']>;
  client_id: Scalars['ID'];
  created_at: Scalars['Int'];
  follow_condition_conjunction?: Maybe<Scalars['Boolean']>;
  follow_conditions?: Maybe<FollowConditions>;
  id: Scalars['ID'];
  mapping_status: ClientFollowMappingStatus;
  required_groups?: Maybe<Array<Maybe<Group>>>;
  required_users?: Maybe<Array<Maybe<PublicUserProfile>>>;
  suggested_groups?: Maybe<Array<Maybe<Group>>>;
  suggested_users?: Maybe<Array<Maybe<PublicUserProfile>>>;
  title: Scalars['String'];
  updated_at: Scalars['Int'];
};

export type ClientFollowMappingList = {
  client_follow_mappings?: Maybe<Array<Maybe<ClientFollowMapping>>>;
  count: Scalars['Int'];
  id?: Maybe<Scalars['ID']>;
  paginate: Scalars['Boolean'];
  title_lower?: Maybe<Scalars['String']>;
};

export type ClientFollowMappingListInput = {
  count?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  title_lower?: InputMaybe<Scalars['String']>;
};

export enum ClientFollowMappingStatus {
  Active = 'active',
  Disabled = 'disabled'
}

export type ClientFollowMappingStatusList = {
  client_follow_mappings?: Maybe<Array<Maybe<ClientFollowMapping>>>;
  count: Scalars['Int'];
  id?: Maybe<Scalars['ID']>;
  mapping_status?: Maybe<ClientDepartmentStatus>;
  paginate: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
};

export type ClientFollowMappingStatusListInput = {
  count?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  mapping_status: ClientFollowMappingStatus;
  title?: InputMaybe<Scalars['String']>;
};

export type ClientGroupSource = {
  approval?: Maybe<ContentApproval>;
  client_id: Scalars['ID'];
  created_at: Scalars['Int'];
  disclosures?: Maybe<Array<Maybe<ContentDisclosures>>>;
  group_id: Scalars['ID'];
  id: Scalars['ID'];
  last_processed_at?: Maybe<Scalars['Int']>;
  parent_id?: Maybe<Scalars['ID']>;
  processing_started_at?: Maybe<Scalars['Int']>;
  source_status: SourceStatus;
  source_type: GroupSourceType;
  source_value: Scalars['String'];
  user_id: Scalars['ID'];
};

export type ClientGroupSourceUpdate = {
  approval?: InputMaybe<ContentApproval>;
  id: Scalars['ID'];
  source_status?: InputMaybe<SourceStatus>;
};

export type ClientInvitation = {
  accepted_at?: Maybe<Scalars['Int']>;
  accepted_by_user?: Maybe<PublicUserProfile>;
  accepted_by_user_id?: Maybe<Scalars['ID']>;
  added_by_user?: Maybe<PublicUserProfile>;
  added_by_user_id?: Maybe<Scalars['ID']>;
  client_id: Scalars['ID'];
  created_at: Scalars['Int'];
  department?: Maybe<ClientDepartment>;
  department_id?: Maybe<Scalars['ID']>;
  email_address: Scalars['String'];
  email_from_address?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invitation_status: ClientInvitationStatus;
  last_sent_at?: Maybe<Scalars['Int']>;
  location?: Maybe<ClientLocation>;
  location_id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  retries?: Maybe<Scalars['Int']>;
  subject?: Maybe<Scalars['String']>;
  updated_at: Scalars['Int'];
  user_type?: Maybe<UserType>;
};

export type ClientInvitationResultSet = {
  count?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<ClientInvitation>>>;
  last_evaluated_key?: Maybe<Scalars['String']>;
};

export type ClientInvitationSearchFilter = {
  added_by_user_id__in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  created_at__gte?: InputMaybe<Scalars['Int']>;
  created_at__lt?: InputMaybe<Scalars['Int']>;
  department_id__in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  invitation_status__eq?: InputMaybe<ClientInvitationStatus>;
  location_id__in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  query?: InputMaybe<Scalars['String']>;
  user_type?: InputMaybe<UserType>;
};

export enum ClientInvitationStatus {
  Accepted = 'accepted',
  Active = 'active'
}

export type ClientInvitationsClientList = {
  client_id: Scalars['ID'];
  client_invitations?: Maybe<Array<Maybe<ClientInvitation>>>;
  count: Scalars['Int'];
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  invitation_status: ClientInvitationStatus;
  paginate: Scalars['Boolean'];
};

export type ClientInvitationsClientListInput = {
  count?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  invitation_status: ClientInvitationStatus;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ClientLocation = {
  block_message?: Maybe<Scalars['String']>;
  client_id: Scalars['ID'];
  groups_total?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  location_status: ClientLocationStatus;
  profiles_total?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type ClientLocationList = {
  client_locations?: Maybe<Array<Maybe<ClientLocation>>>;
  count: Scalars['Int'];
  id?: Maybe<Scalars['ID']>;
  paginate: Scalars['Boolean'];
  title_lower?: Maybe<Scalars['String']>;
};

export type ClientLocationListInput = {
  count?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  title_lower?: InputMaybe<Scalars['String']>;
};

export enum ClientLocationStatus {
  Active = 'active',
  Disabled = 'disabled'
}

export type ClientLocationStatusList = {
  client_locations?: Maybe<Array<Maybe<ClientLocation>>>;
  count: Scalars['Int'];
  id?: Maybe<Scalars['ID']>;
  location_status?: Maybe<ClientLocationStatus>;
  paginate: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
};

export type ClientLocationStatusListInput = {
  count?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  location_status: ClientLocationStatus;
  title?: InputMaybe<Scalars['String']>;
};

export type ClientMenuItem = {
  link: Scalars['String'];
  title: Scalars['String'];
};

export type ClientMenuItemInput = {
  link: Scalars['String'];
  title: Scalars['String'];
};

export type ClientPageMapping = {
  active: Scalars['Boolean'];
  connected_count: Scalars['Int'];
  linkedin_page_id: Scalars['String'];
  name: Scalars['String'];
  token_ids?: Maybe<Array<Scalars['String']>>;
};

export type ClientReleaseToggle = {
  active?: Maybe<Scalars['Boolean']>;
  client_id?: Maybe<Scalars['String']>;
  client_subdomain?: Maybe<Scalars['String']>;
  client_title?: Maybe<Scalars['String']>;
  entity_type?: Maybe<Scalars['String']>;
  quota?: Maybe<Scalars['Int']>;
  release_id?: Maybe<Scalars['String']>;
  usage?: Maybe<Scalars['Int']>;
};

export type ClientResultSet = {
  count?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Client>>;
  last_evaluated_key?: Maybe<Scalars['String']>;
};

export type ClientSearchFilter = {
  client_status__eq?: InputMaybe<ClientStatus>;
  query?: InputMaybe<Scalars['String']>;
  subdomain__eq?: InputMaybe<Scalars['String']>;
};

export enum ClientStatus {
  Active = 'active',
  Disabled = 'disabled'
}

export type ClientTrendingData = {
  calendar_day: Scalars['String'];
  clicks: Scalars['Int'];
  posts: Scalars['Int'];
  shares: Scalars['Int'];
  users: Scalars['Int'];
};

export type ClientTrendingEngagementStat = {
  data: Array<Maybe<ClientTrendingData>>;
  total_clicks: Scalars['Int'];
  total_posts: Scalars['Int'];
  total_shares: Scalars['Int'];
  total_users: Scalars['Int'];
};

export type ClientUrlParams = {
  client_id: Scalars['ID'];
  configuration?: Maybe<Array<Maybe<ClientUrlParamsConfiguration>>>;
  content_domain: Scalars['String'];
  id: Scalars['ID'];
  /** @deprecated Field is deprecated and is ignored on the server side! */
  params_status?: Maybe<ParamsStatus>;
};

export type ClientUrlParamsConfiguration = {
  default_option_value?: Maybe<Scalars['String']>;
  dynamic_value?: Maybe<ClientUrlParamsDynamicValues>;
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
  value_options?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ClientUrlParamsConfigurationInput = {
  default_option_value?: InputMaybe<Scalars['String']>;
  dynamic_value?: InputMaybe<ClientUrlParamsDynamicValues>;
  key: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
  value_options?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum ClientUrlParamsDynamicValues {
  Network = 'network',
  ShareId = 'share_id',
  User = 'user'
}

export type ClientUrlParamsUpdateInput = {
  configuration?: InputMaybe<Array<InputMaybe<ClientUrlParamsConfigurationInput>>>;
  id: Scalars['ID'];
  params_status?: InputMaybe<ParamsStatus>;
};

export type ClientsFeatureToggleUpdateInput = {
  active: Scalars['Boolean'];
  client_id: Scalars['String'];
};

export type Comment = {
  comment_status: CommentStatus;
  comment_text: Scalars['String'];
  created_at: Scalars['Int'];
  depth: Scalars['Int'];
  has_substitutions: Scalars['Boolean'];
  id: Scalars['ID'];
  object_id: Scalars['ID'];
  object_type: ObjectType;
  parent_id?: Maybe<Scalars['ID']>;
  updated_at: Scalars['Int'];
  user?: Maybe<PublicUserProfile>;
  user_id: Scalars['ID'];
  user_mentions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users_mentioned?: Maybe<Array<Maybe<PublicUserProfile>>>;
};

export type CommentInput = {
  comment_text: Scalars['String'];
  object_id: Scalars['ID'];
  object_type: ObjectType;
  parent_id?: InputMaybe<Scalars['ID']>;
};

export enum CommentStatus {
  Active = 'active',
  Deleted = 'deleted',
  Removed = 'removed'
}

export type CommentStatusInput = {
  count?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  object_id: Scalars['ID'];
  object_type: ObjectType;
};

export type CommentUpdateInput = {
  comment_text: Scalars['String'];
  id: Scalars['ID'];
};

export type CommentUserInput = {
  comment_status: CommentStatus;
  count?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  user_id: Scalars['ID'];
};

export type CommentsList = {
  comments?: Maybe<Array<Maybe<Comment>>>;
  count: Scalars['Int'];
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
  object_id: Scalars['ID'];
  object_type: ObjectType;
  paginate: Scalars['Boolean'];
};

export type CompanyDetails = {
  company_logo?: Maybe<Scalars['String']>;
  job_company_name?: Maybe<Scalars['String']>;
};

export type CompanyEntity = {
  company_id: Scalars['String'];
  display_name?: Maybe<Scalars['String']>;
  facebook_url?: Maybe<Scalars['String']>;
  icon?: Maybe<S3Object>;
  linkedin_url?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  twitter_url?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type CompleteMultiPart = {
  etag: Scalars['String'];
};

export type Content = {
  approval?: Maybe<ContentApproval>;
  audit?: Maybe<Array<Maybe<ContentAudit>>>;
  can_be_engaged?: Maybe<Scalars['Boolean']>;
  can_be_shared?: Maybe<Scalars['Boolean']>;
  click_count?: Maybe<Scalars['Int']>;
  client_id: Scalars['ID'];
  comment_count?: Maybe<Scalars['Int']>;
  commentary?: Maybe<Array<Maybe<ContentCommentary>>>;
  commented_by?: Maybe<Array<Maybe<MinimalUserProfile>>>;
  comments?: Maybe<CommentsList>;
  content_id: Scalars['ID'];
  content_object: ContentObject;
  content_source_id?: Maybe<Scalars['ID']>;
  content_tags?: Maybe<Array<Maybe<TaggedContentMeta>>>;
  created_at: Scalars['Int'];
  default_engageable?: Maybe<Scalars['Boolean']>;
  default_shareable?: Maybe<Scalars['Boolean']>;
  disclosures?: Maybe<Array<Maybe<ContentDisclosures>>>;
  engage_count?: Maybe<Scalars['Int']>;
  engagement_count?: Maybe<Scalars['Int']>;
  group_id_approvals: Array<Maybe<GroupIdApproval>>;
  group_ids: Array<Maybe<Scalars['ID']>>;
  groups?: Maybe<Array<Maybe<Group>>>;
  has_requesting_user_shared?: Maybe<Scalars['Boolean']>;
  important_to_share?: Maybe<Scalars['Boolean']>;
  is_branded?: Maybe<Scalars['Boolean']>;
  is_engage?: Maybe<Scalars['Boolean']>;
  is_engageable?: Maybe<Scalars['Boolean']>;
  is_important?: Maybe<Scalars['Boolean']>;
  is_important_message?: Maybe<Scalars['String']>;
  is_network?: Maybe<Scalars['Boolean']>;
  is_pinned?: Maybe<Scalars['Boolean']>;
  is_private?: Maybe<Scalars['Boolean']>;
  is_shareable?: Maybe<Scalars['Boolean']>;
  lock_commentary?: Maybe<Scalars['Boolean']>;
  ms_teams_channels?: Maybe<Array<Maybe<ChannelInfo>>>;
  network_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  pinned_end_at?: Maybe<Scalars['Int']>;
  pinned_to_groups?: Maybe<Array<Maybe<PinnedGroup>>>;
  primary_group_id?: Maybe<Scalars['String']>;
  publish_at: Scalars['Int'];
  reacted_by?: Maybe<Array<Maybe<MinimalUserProfile>>>;
  reaction_count?: Maybe<Scalars['Int']>;
  reactions?: Maybe<ContentReactions>;
  schedule?: Maybe<ScheduleObject>;
  score?: Maybe<Scalars['Float']>;
  share_count?: Maybe<Scalars['Int']>;
  shared_by?: Maybe<Array<Maybe<MinimalUserProfile>>>;
  /** @deprecated Field is deprecated! */
  sharing_count?: Maybe<Scalars['Int']>;
  slack_channels?: Maybe<Array<Maybe<ChannelInfo>>>;
  submitter_role?: Maybe<SubmitterRole>;
  url_param_options?: Maybe<Array<Maybe<ContentUrlParamOptions>>>;
  url_param_values?: Maybe<Array<Maybe<ContentUrlParamValues>>>;
  user?: Maybe<PublicUserProfile>;
  user_id?: Maybe<Scalars['ID']>;
};

export enum ContentApproval {
  Approved = 'approved',
  Autoapproved = 'autoapproved',
  Deleted = 'deleted',
  Pending = 'pending',
  Removed = 'removed',
  Submitted = 'submitted'
}

export enum ContentApprovalTypes {
  Approved = 'approved',
  Deleted = 'deleted',
  Removed = 'removed',
  Scheduled = 'scheduled',
  Submitted = 'submitted'
}

export type ContentApprovalsInput = {
  group_id_approvals: Array<InputMaybe<GroupIdApprovalInput>>;
  message?: InputMaybe<Scalars['String']>;
};

export type ContentAudit = {
  ACTION: Scalars['String'];
  by_user_id?: Maybe<Scalars['ID']>;
  by_user_profile?: Maybe<PublicUserProfile>;
  message?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Int']>;
};

export type ContentCommentary = {
  commentary: Scalars['String'];
  mentions?: Maybe<Array<Maybe<MentionObject>>>;
  network: Network;
};

export type ContentCommentaryInput = {
  commentary: Scalars['String'];
  mentions?: InputMaybe<Array<InputMaybe<MentionObjectInput>>>;
  network: Network;
};

export type ContentDisclosure = {
  commentary: Scalars['String'];
  network: Network;
};

export type ContentDisclosures = {
  disclosure?: Maybe<Scalars['String']>;
  disclosure_id: Scalars['ID'];
  disclosure_status?: Maybe<ClientDisclosureStatus>;
  network: Network;
  title?: Maybe<Scalars['String']>;
};

export type ContentDisclosuresInput = {
  disclosure_id: Scalars['ID'];
  network: Network;
};

export type ContentEmailHistory = {
  featured_content?: Maybe<Array<Maybe<Content>>>;
  registered_user_count: Scalars['Int'];
  sent_at: Scalars['Int'];
  spec: ContentEmailSpec;
  spec_id: Scalars['ID'];
  total_clicks: Scalars['Int'];
  total_delivered: Scalars['Int'];
  total_emails: Scalars['Int'];
  total_opened: Scalars['Int'];
  unregistered_user_count: Scalars['Int'];
};

export type ContentEmailHistoryList = {
  history?: Maybe<Array<Maybe<ContentEmailHistory>>>;
  paginate: Scalars['Boolean'];
  sent_at?: Maybe<Scalars['Int']>;
  spec_id?: Maybe<Scalars['ID']>;
};

export type ContentEmailHistoryListInput = {
  all_history?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  sent_at?: InputMaybe<Scalars['Int']>;
  spec_id?: InputMaybe<Scalars['ID']>;
};

export type ContentEmailSpec = {
  accent_color?: Maybe<Scalars['String']>;
  all_users: Scalars['Boolean'];
  banner?: Maybe<S3Object>;
  banner_url?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['ID']>;
  config_status?: Maybe<GenericStatus>;
  content_specs: Array<Maybe<ContentSelector>>;
  created_at?: Maybe<Scalars['Int']>;
  delivery_interval?: Maybe<Scalars['Int']>;
  email_from?: Maybe<Scalars['String']>;
  email_reply_to?: Maybe<Scalars['String']>;
  footer?: Maybe<Scalars['String']>;
  grouping_interval?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  intro?: Maybe<Scalars['String']>;
  segment_ids: Array<Maybe<Scalars['ID']>>;
  send_at: Scalars['Int'];
  subject?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  use_sto?: Maybe<Scalars['Boolean']>;
};

export type ContentEmailSpecInput = {
  accent_color?: InputMaybe<Scalars['String']>;
  all_users: Scalars['Boolean'];
  banner?: InputMaybe<S3ObjectInput>;
  banner_url?: InputMaybe<Scalars['String']>;
  config_status?: InputMaybe<GenericStatus>;
  content_specs?: InputMaybe<Array<InputMaybe<ContentSelectorInput>>>;
  delivery_interval?: InputMaybe<Scalars['Int']>;
  email_from?: InputMaybe<Scalars['String']>;
  email_reply_to?: InputMaybe<Scalars['String']>;
  footer?: InputMaybe<Scalars['String']>;
  grouping_interval?: InputMaybe<Scalars['Int']>;
  intro?: InputMaybe<Scalars['String']>;
  segment_ids: Array<InputMaybe<Scalars['ID']>>;
  send_at: Scalars['Int'];
  subject?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  use_sto?: InputMaybe<Scalars['Boolean']>;
};

export type ContentEmailSpecList = {
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  items: Array<Maybe<ContentEmailSpec>>;
  paginate: Scalars['Boolean'];
};

export type ContentEmailSpecListInput = {
  created_at?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  recurringOnly?: InputMaybe<Scalars['Boolean']>;
};

export type ContentEmailSpecMutation = {
  accent_color?: InputMaybe<Scalars['String']>;
  all_users?: InputMaybe<Scalars['Boolean']>;
  banner?: InputMaybe<S3ObjectInput>;
  banner_url?: InputMaybe<Scalars['String']>;
  config_status?: InputMaybe<GenericStatus>;
  content_specs?: InputMaybe<Array<InputMaybe<ContentSelectorInput>>>;
  delivery_interval?: InputMaybe<Scalars['Int']>;
  email_from?: InputMaybe<Scalars['String']>;
  email_reply_to?: InputMaybe<Scalars['String']>;
  footer?: InputMaybe<Scalars['String']>;
  grouping_interval?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  intro?: InputMaybe<Scalars['String']>;
  segment_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  send_at?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  use_sto?: InputMaybe<Scalars['Boolean']>;
};

export enum ContentEmailType {
  Featured = 'featured',
  Group = 'group',
  Timeline = 'timeline'
}

export type ContentGroupInput = {
  content_id: Scalars['String'];
  group_id: Scalars['String'];
};

export type ContentIdTimes = {
  content_id?: Maybe<Scalars['String']>;
  timestamps?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type ContentIdsCounter = {
  content_id?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};

export type ContentInput = {
  commentary?: InputMaybe<Array<InputMaybe<ContentCommentaryInput>>>;
  content_id?: InputMaybe<Scalars['ID']>;
  content_object?: InputMaybe<ContentObjectInput>;
  content_source_id: Scalars['ID'];
  content_tags?: InputMaybe<Array<InputMaybe<TaggedContentMetaInput>>>;
  created_at?: InputMaybe<Scalars['Int']>;
  disclosures?: InputMaybe<Array<InputMaybe<ContentDisclosuresInput>>>;
  group_ids: Array<InputMaybe<Scalars['ID']>>;
  is_branded?: InputMaybe<Scalars['Boolean']>;
  is_engageable?: InputMaybe<Scalars['Boolean']>;
  is_important?: InputMaybe<Scalars['Boolean']>;
  is_important_message?: InputMaybe<Scalars['String']>;
  is_pinned?: InputMaybe<Scalars['Boolean']>;
  is_shareable?: InputMaybe<Scalars['Boolean']>;
  lock_commentary?: InputMaybe<Scalars['Boolean']>;
  ms_teams_channels?: InputMaybe<Array<InputMaybe<SharingChannelInfo>>>;
  network_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pinned_end_at?: InputMaybe<Scalars['Int']>;
  pinned_to_groups?: InputMaybe<Array<InputMaybe<PinnedGroupInput>>>;
  primary_group_id?: InputMaybe<Scalars['String']>;
  publish_at?: InputMaybe<Scalars['Int']>;
  schedule?: InputMaybe<ScheduleObjectInput>;
  slack_channels?: InputMaybe<Array<InputMaybe<SharingChannelInfo>>>;
  url_param_values?: InputMaybe<Array<InputMaybe<ContentUrlParamValuesInput>>>;
};

export type ContentObject = {
  body?: Maybe<Scalars['String']>;
  content_hash?: Maybe<Scalars['String']>;
  instagram_metadata?: Maybe<InstagramMetadata>;
  media?: Maybe<MediaObject>;
  media_type?: Maybe<Scalars['String']>;
  metadata_keys?: Maybe<Array<Maybe<MetadataKey>>>;
  photos?: Maybe<Array<Maybe<S3Object>>>;
  post_type: PostType;
  primary_url_metadata_image?: Maybe<Scalars['Int']>;
  reddit_metadata?: Maybe<RedditMetadata>;
  title?: Maybe<Scalars['String']>;
  tweet_metadata?: Maybe<TweetMetadata>;
  url?: Maybe<Scalars['String']>;
  url_metadata?: Maybe<UrlMetadata>;
  video_url?: Maybe<Scalars['String']>;
  youtube_metadata?: Maybe<YoutubeMetadata>;
};

export type ContentObjectInput = {
  body?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<MediaObjectInput>;
  photos?: InputMaybe<Array<InputMaybe<S3ObjectInput>>>;
  post_type: PostType;
  primary_url_metadata_image?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  url_metadata?: InputMaybe<UrlMetadataInput>;
  url_metadata_override?: InputMaybe<UrlMetadataOverrideInput>;
};

export type ContentReactions = {
  reaction_count?: Maybe<ReactionCount>;
  reaction_user_details?: Maybe<Array<Maybe<PublicUserProfile>>>;
  user_reactions?: Maybe<Array<Maybe<ReactionType>>>;
};

export type ContentSelected = {
  content_id?: Maybe<Scalars['ID']>;
  content_type: ContentEmailType;
  id?: Maybe<Scalars['ID']>;
};

export type ContentSelector = {
  content_type: ContentEmailType;
  id?: Maybe<Scalars['ID']>;
};

export type ContentSelectorInput = {
  content_type: ContentEmailType;
  id?: InputMaybe<Scalars['ID']>;
};

export type ContentSharePreview = {
  allowed_counts?: Maybe<AllowedCounts>;
  disclosures: Array<ContentDisclosures>;
  locked_commentary?: Maybe<Scalars['Boolean']>;
  shortened_urls?: Maybe<ShortenedUrLs>;
  suggested_commentary: Array<ContentCommentary>;
  suggested_share_time?: Maybe<Scalars['Int']>;
};

export type ContentTagMetaInput = {
  title: Scalars['String'];
};

export type ContentTagMetaResults = {
  tag_id: Scalars['String'];
  title: Scalars['String'];
  warning?: Maybe<Scalars['String']>;
};

export enum ContentType {
  Link = 'link',
  Photo = 'photo',
  Text = 'text',
  Video = 'video'
}

export type ContentUrlParamOptions = {
  default_option_value?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  options: Array<Maybe<Scalars['String']>>;
};

export type ContentUrlParamValues = {
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type ContentUrlParamValuesInput = {
  key: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export enum ContractType {
  Demo = 'demo',
  FairBilling = 'fair_billing',
  Sandbox = 'sandbox',
  Traditional = 'traditional',
  Unlimited = 'unlimited'
}

export type CreateApiTokenInput = {
  token_name: Scalars['String'];
};

export type CreateApiTokenOutput = {
  api_token: Scalars['String'];
  token_id: Scalars['ID'];
  token_name: Scalars['String'];
};

export type CreateClientDepartmentInput = {
  department_status: ClientDepartmentStatus;
  title: Scalars['String'];
};

export type CreateClientDisclosureInput = {
  disclosure: Scalars['String'];
  disclosure_status: ClientDisclosureStatus;
};

export type CreateClientFollowMappingInput = {
  all_users: Scalars['Boolean'];
  follow_condition_conjunction?: InputMaybe<Scalars['Boolean']>;
  follow_conditions?: InputMaybe<FollowConditionsInput>;
  mapping_status: ClientFollowMappingStatus;
  required_group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  required_user_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  suggested_group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  suggested_user_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  title: Scalars['String'];
};

export type CreateClientInput = {
  allow_external_share?: InputMaybe<Scalars['Boolean']>;
  allow_group_creation: Scalars['Boolean'];
  allow_group_discovery: Scalars['Boolean'];
  allow_sharing?: InputMaybe<Scalars['Boolean']>;
  allow_user_invites: Scalars['Boolean'];
  allow_user_share_commentary: Scalars['Boolean'];
  allow_user_signup: Scalars['Boolean'];
  authentication_type: AuthenticationType;
  client_aliases?: InputMaybe<Array<InputMaybe<ClientAliasInput>>>;
  client_status: ClientStatus;
  compliance_notification_email?: InputMaybe<Scalars['String']>;
  compliance_notification_emails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  compliance_notification_enabled?: InputMaybe<Scalars['Boolean']>;
  compliance_notification_frequency?: InputMaybe<Scalars['String']>;
  content_domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contract_committed_user_count?: InputMaybe<Scalars['Int']>;
  contract_end_at?: InputMaybe<Scalars['Int']>;
  contract_start_at?: InputMaybe<Scalars['Int']>;
  contract_type?: InputMaybe<ContractType>;
  departments_in_signup: Scalars['Boolean'];
  departments_in_signup_required: Scalars['Boolean'];
  disable_comments: Scalars['Boolean'];
  disable_timeline?: InputMaybe<Scalars['Boolean']>;
  email_address: Scalars['String'];
  email_domains: Array<InputMaybe<Scalars['String']>>;
  email_from_address?: InputMaybe<Scalars['String']>;
  email_sending_domain?: InputMaybe<Scalars['String']>;
  features?: InputMaybe<Array<InputMaybe<Feature>>>;
  first_admin_user?: InputMaybe<Scalars['Boolean']>;
  image: S3ObjectInput;
  locations_in_signup: Scalars['Boolean'];
  locations_in_signup_required: Scalars['Boolean'];
  menu_item?: InputMaybe<ClientMenuItemInput>;
  menu_item_enabled?: InputMaybe<Scalars['Boolean']>;
  moderator_can_mark_as_important?: InputMaybe<Scalars['Boolean']>;
  public_post_details?: InputMaybe<Scalars['Boolean']>;
  public_post_force_login?: InputMaybe<Scalars['Boolean']>;
  public_post_page?: InputMaybe<Scalars['Boolean']>;
  referral_headline?: InputMaybe<Scalars['String']>;
  referral_message?: InputMaybe<Scalars['String']>;
  sort_mode?: InputMaybe<SortMode>;
  sso_configuration?: InputMaybe<SsoConfigurationInput>;
  sso_provider?: InputMaybe<Scalars['String']>;
  subdomain: Scalars['String'];
  support_multiple_languages: Scalars['Boolean'];
  title: Scalars['String'];
  yearly_enrichment_quota?: InputMaybe<Scalars['Int']>;
};

export type CreateClientInvitationInput = {
  department_id?: InputMaybe<Scalars['ID']>;
  email_addresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email_from_address?: InputMaybe<Scalars['String']>;
  location_id?: InputMaybe<Scalars['ID']>;
  message?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  uploadfile?: InputMaybe<S3ObjectInput>;
  user_type?: InputMaybe<UserType>;
};

export type CreateClientLocationInput = {
  location_status: ClientLocationStatus;
  title: Scalars['String'];
};

export type CreateClientPageMappingInput = {
  linkedin_page_id: Scalars['String'];
  name: Scalars['String'];
  token_ids: Array<InputMaybe<Scalars['ID']>>;
};

export type CreateClientSelfServeInput = {
  cognito_user_name: Scalars['String'];
  email_address: Scalars['String'];
  full_name: Scalars['String'];
  title: Scalars['String'];
};

export type CreateClientStickerInput = {
  client_id: Scalars['ID'];
  image: S3ObjectInput;
};

export type CreateGroupInput = {
  allow_user_posts: Scalars['Boolean'];
  color: GroupColor;
  content_approval_type: GroupContentApprovalType;
  department_id?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  icon: GroupIcon;
  icon_color: GroupIconColor;
  image?: InputMaybe<S3ObjectInput>;
  is_private?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['ID']>;
  read_only?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type CreateReadmeLoginJwtOutput = {
  jwt: Scalars['String'];
  url: Scalars['String'];
};

export type CreateUserSegmentInput = {
  department_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  email_addresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  others_csv?: InputMaybe<S3ObjectInput>;
  segment_status: SegmentStatus;
  title: Scalars['String'];
  user_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type DailyGroupStat = {
  data?: Maybe<Array<Maybe<IndividualGroupStat>>>;
  summary: GroupSummary;
};

export type DailyLeaderboardEventStat = {
  data?: Maybe<Array<Maybe<IndividualLeaderboardEvent>>>;
  summary: LeaderboardEventSummary;
};

export type DailyPostStat = {
  data?: Maybe<Array<Maybe<IndividualPostStat>>>;
  summary: PostSummary;
};

export type DailyShareStat = {
  data?: Maybe<Array<Maybe<IndividualShareStat>>>;
  summary: ShareSummary;
};

export type DailyUserStat = {
  data?: Maybe<Array<Maybe<IndividualUserStat>>>;
  summary: UserSummary;
};

export enum DateGrouping {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

export type DeleteApiTokenOutput = {
  is_deleted: Scalars['Boolean'];
  token_id?: Maybe<Scalars['ID']>;
  token_name?: Maybe<Scalars['String']>;
};

export type DeleteTokenApiInput = {
  token_id: Scalars['ID'];
};

export type EbrIntroduction = {
  registered_users_count?: Maybe<Scalars['Int']>;
  shares_count?: Maybe<Scalars['Int']>;
  top_companies?: Maybe<Array<Maybe<CompanyDetails>>>;
  top_profiles?: Maybe<Array<Maybe<AnalyticsProfile>>>;
};

export type EbrOrganicInsights = {
  company_industries?: Maybe<Array<Maybe<EbrProfilesCount>>>;
  company_sizes?: Maybe<Array<Maybe<EbrProfilesCount>>>;
  countries?: Maybe<Array<Maybe<EbrProfilesCount>>>;
  job_roles?: Maybe<Array<Maybe<EbrProfilesCount>>>;
  job_titles?: Maybe<Array<Maybe<EbrProfilesCount>>>;
  key_insights?: Maybe<Scalars['String']>;
  top_companies?: Maybe<Array<Maybe<CompanyDetails>>>;
};

export type EbrProfilesCount = {
  count: Scalars['Int'];
  name: Scalars['String'];
  percentage: Scalars['Int'];
};

export type EngagementComparison = {
  engagements_per_share_client_max?: Maybe<Scalars['Float']>;
  engagements_per_share_client_min?: Maybe<Scalars['Float']>;
  engagements_per_share_user?: Maybe<Scalars['Float']>;
  engagements_per_share_user_rank?: Maybe<Scalars['Int']>;
  reach_growth_client_max?: Maybe<Scalars['Float']>;
  reach_growth_client_min?: Maybe<Scalars['Float']>;
  reach_growth_user?: Maybe<Scalars['Float']>;
  reach_growth_user_rank?: Maybe<Scalars['Int']>;
  reach_size_client_max?: Maybe<Scalars['Int']>;
  reach_size_client_min?: Maybe<Scalars['Int']>;
  reach_size_user?: Maybe<Scalars['Int']>;
  reach_size_user_rank?: Maybe<Scalars['Int']>;
};

export type EngagementDetail = {
  content_url?: Maybe<Scalars['String']>;
  engagement_type?: Maybe<InsightsEngagementType>;
  network?: Maybe<Network>;
  share_url?: Maybe<Scalars['String']>;
};

export type EngagementHistory = {
  content_id?: Maybe<Scalars['String']>;
  content_id_times?: Maybe<Array<Maybe<ContentIdTimes>>>;
  engagement_type?: Maybe<EngagementType>;
  followers_count?: Maybe<Scalars['Int']>;
  following_count?: Maybe<Scalars['Int']>;
  network?: Maybe<Network>;
  network_bio?: Maybe<Scalars['String']>;
  network_profile_handle?: Maybe<Scalars['String']>;
  network_profile_id?: Maybe<Scalars['String']>;
  network_profile_image?: Maybe<Scalars['String']>;
  network_profile_name?: Maybe<Scalars['String']>;
  network_profile_url?: Maybe<Scalars['String']>;
  share_url?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  total_content_ids?: Maybe<Array<Maybe<ContentIdsCounter>>>;
  total_engagement_types?: Maybe<Array<Maybe<EngagementTypesCounter>>>;
  total_engagements?: Maybe<Scalars['Int']>;
};

export enum EngagementHistoryFormat {
  Aggregate = 'aggregate',
  Chronological = 'chronological'
}

export type EngagementSummary = {
  engagements?: Maybe<Scalars['Int']>;
  first_engagement?: Maybe<Scalars['Float']>;
  last_engagement?: Maybe<Scalars['Float']>;
  last_engagement_detail?: Maybe<EngagementDetail>;
};

export enum EngagementType {
  Comment = 'Comment',
  CommentReaction = 'CommentReaction',
  Like = 'Like',
  Quote = 'Quote',
  Reaction = 'Reaction',
  Retweet = 'Retweet'
}

export type EngagementTypesCounter = {
  count?: Maybe<Scalars['Int']>;
  engagement_type?: Maybe<EngagementType>;
};

export type EngagerRole = {
  role?: Maybe<Scalars['String']>;
};

export type EngagerTitle = {
  title?: Maybe<Scalars['String']>;
};

export type EveryoneSocialLeaderboardCategory = {
  actions?: Maybe<Array<Maybe<LeaderboardEventScores>>>;
  posting?: Maybe<Array<Maybe<LeaderboardEventScores>>>;
  teammates?: Maybe<Array<Maybe<LeaderboardEventScores>>>;
};

export type EveryoneSocialLeaderboardCategoryInput = {
  actions?: InputMaybe<Array<InputMaybe<LeaderboardEventScoreInput>>>;
  posting?: InputMaybe<Array<InputMaybe<LeaderboardEventScoreInput>>>;
  teammates?: InputMaybe<Array<InputMaybe<LeaderboardEventScoreInput>>>;
};

export type ExpressActivatedUserNetwork = {
  profile_image_url?: Maybe<Scalars['String']>;
  profile_name?: Maybe<Scalars['String']>;
  profile_url_suffix?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  reach?: Maybe<Scalars['Int']>;
};

export type ExpressActivatedUsers = {
  access_key: Scalars['String'];
  created_at: Scalars['Int'];
  email: Scalars['String'];
  registered_networks: Array<Maybe<ExpressActivatedUserNetwork>>;
  status: Scalars['String'];
};

export type ExpressActivatedUsersResultSet = {
  last_evaluated_key?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  total: Scalars['Int'];
  users: Array<Maybe<ExpressActivatedUsers>>;
};

export type ExpressActivationFiltersInput = {
  order_by_date: Scalars['String'];
};

export type ExternalMapping = {
  external: Scalars['String'];
  internal: Scalars['String'];
};

export type ExternalMappingInput = {
  external: Scalars['String'];
  internal: Scalars['String'];
};

export type ExternalOverviewStat = {
  data?: Maybe<Array<Maybe<ExternalStat>>>;
  summary: ExternalSummary;
};

export type ExternalShare = {
  article_title?: Maybe<Scalars['String']>;
  engagement_count?: Maybe<Scalars['Int']>;
  first_engaged_at?: Maybe<Scalars['Int']>;
  linkedin_page_share: Scalars['Boolean'];
  network: Network;
  share_id: Scalars['ID'];
  share_url?: Maybe<Scalars['String']>;
  shared_image_url?: Maybe<Scalars['String']>;
  user_commentary?: Maybe<Scalars['String']>;
  user_email?: Maybe<Scalars['String']>;
  user_reach?: Maybe<Scalars['Int']>;
};

export type ExternalShareUpdateInput = {
  engage_content_created: Scalars['Boolean'];
};

export type ExternalSharesResponse = {
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<Maybe<ExternalShare>>>;
};

export enum ExternalSharesSortFields {
  EngagementCount = 'engagement_count',
  FirstEngagedAt = 'first_engaged_at',
  UserReach = 'user_reach'
}

export type ExternalStat = {
  branded_clicks: Scalars['Int'];
  branded_engagements: Scalars['Int'];
  branded_shares: Scalars['Int'];
  calendar_day: Scalars['String'];
  impressions?: Maybe<Scalars['Int']>;
  non_branded_clicks: Scalars['Int'];
  non_branded_engagements: Scalars['Int'];
  non_branded_shares: Scalars['Int'];
};

export type ExternalSummary = {
  clicks: IndividualStat;
  engagements: IndividualStat;
  impressions?: Maybe<IndividualStat>;
  shares: IndividualStat;
};

export type ExternalUserMappings = {
  department?: Maybe<Array<ExternalMapping>>;
  location?: Maybe<Array<ExternalMapping>>;
  user_status?: Maybe<Array<ExternalMapping>>;
  user_type?: Maybe<Array<ExternalMapping>>;
};

export type ExternalUserMappingsInput = {
  department?: InputMaybe<Array<ExternalMappingInput>>;
  location?: InputMaybe<Array<ExternalMappingInput>>;
  user_status?: InputMaybe<Array<ExternalMappingInput>>;
  user_type?: InputMaybe<Array<ExternalMappingInput>>;
};

export type FacebookLeaderboardCategory = {
  general?: Maybe<Array<Maybe<LeaderboardEventScores>>>;
};

export type FacebookLeaderboardCategoryInput = {
  general?: InputMaybe<Array<InputMaybe<LeaderboardEventScoreInput>>>;
};

export enum Feature {
  CentralPostManagement = 'central_post_management',
  ClientInvitationTemplateV2 = 'client_invitation_template_v2',
  ClientInvitationsV2 = 'client_invitations_v2',
  CommentNotifications = 'comment_notifications',
  ContentEmails = 'content_emails',
  DashboardFilters = 'dashboard_filters',
  DashboardV2 = 'dashboard_v2',
  EditorV2 = 'editor_v2',
  FeatureFlagsV2 = 'feature_flags_v2',
  LegacyAuthDomain = 'legacy_auth_domain',
  Messaging = 'messaging',
  MobileForceEdge = 'mobile_force_edge',
  ModeratorDashboard = 'moderator_dashboard',
  MsTeams = 'ms_teams',
  NativePostV2 = 'native_post_v2',
  OnboardingV2 = 'onboarding_v2',
  PostV2 = 'post_v2',
  PrivateGroups = 'private_groups',
  SkipOnboardingSelectGroups = 'skip_onboarding_select_groups',
  Slack = 'slack',
  UserManagementV2 = 'user_management_v2',
  WebNotifications = 'web_notifications'
}

export enum FeaturePlanType {
  E = 'e',
  F = 'f',
  T = 't'
}

export type Feed = {
  id_lt?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<Maybe<Content>>>;
};

export type FeedByUser = {
  client: Client;
  feed_follows?: Maybe<Array<Maybe<UserFeedFollow>>>;
  followed_by_users?: Maybe<Array<Maybe<PublicUserProfile>>>;
  user: ProfileContext;
  user_id: Scalars['ID'];
};

export type FeedByUserInput = {
  feed?: InputMaybe<FeedKey>;
  user_id?: InputMaybe<Scalars['ID']>;
};

export type FeedFollow = {
  id: Scalars['ID'];
  key: FeedKey;
  user_id: Scalars['ID'];
};

export type FeedFollowList = {
  id: Scalars['ID'];
  key: FeedKey;
  user?: Maybe<PublicUserProfile>;
  user_id: Scalars['ID'];
};

export type FeedFollowing = {
  count?: Maybe<Scalars['Int']>;
  feed: FeedKey;
  feed_follows?: Maybe<Array<Maybe<UserFeedFollow>>>;
  id: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  paginate: Scalars['Boolean'];
  start_key?: Maybe<Scalars['String']>;
  user: UserProfile;
  user_id?: Maybe<Scalars['ID']>;
};

export type FeedFollowingInput = {
  count?: InputMaybe<Scalars['Boolean']>;
  feed: FeedKey;
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  start_key?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['ID']>;
};

export enum FeedKey {
  Alluser = 'alluser',
  Firehose = 'firehose',
  Group = 'group',
  Privateuser = 'privateuser',
  Removedgroup = 'removedgroup',
  Removeduser = 'removeduser',
  Scheduled = 'scheduled',
  Submittedgroup = 'submittedgroup',
  Timeline = 'timeline',
  User = 'user'
}

export type FollowConditions = {
  department_id?: Maybe<Array<Maybe<Scalars['ID']>>>;
  departments?: Maybe<Array<Maybe<ClientDepartment>>>;
  email_domain?: Maybe<Array<Maybe<Scalars['String']>>>;
  language?: Maybe<Array<Maybe<Scalars['String']>>>;
  location_id?: Maybe<Array<Maybe<Scalars['ID']>>>;
  locations?: Maybe<Array<Maybe<ClientLocation>>>;
};

export type FollowConditionsInput = {
  department_id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  email_domain?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  location_id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export enum GenericStatus {
  Active = 'active',
  Disabled = 'disabled'
}

export type GetChannelResults = {
  msteams_channels?: Maybe<Array<Maybe<ChannelInfo>>>;
  slack_channels?: Maybe<Array<Maybe<ChannelInfo>>>;
};

export type GetCompaniesResult = {
  results: Array<Maybe<AnalyticsCompany>>;
  total: Scalars['Int'];
};

export type GetEmployeesResult = {
  results: Array<Maybe<AnalyticsProfile>>;
  total: Scalars['Int'];
};

export type GetIntelligenceResult = {
  distinct_user_engagements: Scalars['Int'];
  intelligent_company_extrapolation: Scalars['Int'];
};

export type GetPeopleResult = {
  results: Array<Maybe<AnalyticsProfile>>;
  total: Scalars['Int'];
};

export type GetTeamsResults = {
  ms_teams?: Maybe<Array<Maybe<TeamInfo>>>;
};

export type Group = {
  allow_user_posts: Scalars['Boolean'];
  client_id: Scalars['ID'];
  color: GroupColor;
  color_map: GroupColorMap;
  content_approval_type: GroupContentApprovalType;
  created_at: Scalars['Int'];
  department_id?: Maybe<Scalars['ID']>;
  department_title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  follower_count?: Maybe<Scalars['Int']>;
  group_status: GroupStatus;
  icon: GroupIcon;
  icon_color: GroupIconColor;
  icon_color_map: GroupIconColorMap;
  icon_map: GroupIconMap;
  id: Scalars['ID'];
  image?: Maybe<S3Object>;
  is_private?: Maybe<Scalars['Boolean']>;
  location_id?: Maybe<Scalars['ID']>;
  location_title?: Maybe<Scalars['String']>;
  read_only?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  updated_at?: Maybe<Scalars['Int']>;
  user?: Maybe<PublicUserProfile>;
  user_id: Scalars['ID'];
};

export type GroupActionUrls = {
  Group: Scalars['String'];
  actor: Scalars['String'];
};

export enum GroupColor {
  Aquamarine = 'aquamarine',
  Crimson = 'crimson',
  Forrest = 'forrest',
  LimeGreen = 'lime_green',
  Magenta = 'magenta',
  Midnight = 'midnight',
  Navy = 'navy',
  SkyBlue = 'sky_blue',
  Slate = 'slate',
  Sunset = 'sunset',
  Terracota = 'terracota',
  Violet = 'violet'
}

export type GroupColorMap = {
  group_color?: Maybe<GroupColor>;
  hex: Scalars['String'];
  label: Scalars['String'];
};

export enum GroupContentApprovalType {
  Auto = 'auto',
  FourEyes = 'four_eyes',
  Review = 'review'
}

export enum GroupIcon {
  Alert = 'alert',
  Asterisk = 'asterisk',
  Barchart = 'barchart',
  Beaker = 'beaker',
  Bin = 'bin',
  Bookmark = 'bookmark',
  Box = 'box',
  Buld = 'buld',
  Calendar = 'calendar',
  Cloud = 'cloud',
  Code = 'code',
  Compass = 'compass',
  Es = 'es',
  Eye = 'eye',
  Flag = 'flag',
  Folder = 'folder',
  Globe = 'globe',
  Heart = 'heart',
  Image = 'image',
  Info = 'info',
  Knot = 'knot',
  Lightening = 'lightening',
  Mail = 'mail',
  Mustache = 'mustache',
  Network = 'network',
  Paths = 'paths',
  Saturn = 'saturn',
  Search = 'search',
  Star = 'star',
  Time = 'time',
  Volume = 'volume',
  Windows = 'windows',
  Wrench = 'wrench'
}

export enum GroupIconColor {
  Aquamarine = 'aquamarine',
  Crimson = 'crimson',
  Forrest = 'forrest',
  LimeGreen = 'lime_green',
  Magenta = 'magenta',
  Midnight = 'midnight',
  Navy = 'navy',
  SkyBlue = 'sky_blue',
  Slate = 'slate',
  Sunset = 'sunset',
  Terracota = 'terracota',
  Violet = 'violet'
}

export type GroupIconColorMap = {
  group_icon_color?: Maybe<GroupIconColor>;
  hex: Scalars['String'];
  label: Scalars['String'];
};

export type GroupIconMap = {
  bucket: Scalars['String'];
  file_key: Scalars['String'];
  group_icon?: Maybe<GroupIcon>;
  height?: Maybe<Scalars['Int']>;
  label: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type GroupIdApproval = {
  approval?: Maybe<ContentApproval>;
  group_id?: Maybe<Scalars['ID']>;
};

export type GroupIdApprovalInput = {
  approval: ContentApproval;
  group_id: Scalars['ID'];
};

export type GroupInputList = {
  groups?: InputMaybe<Array<InputMaybe<CreateGroupInput>>>;
};

export type GroupList = {
  count: Scalars['Int'];
  groups?: Maybe<Array<Maybe<Group>>>;
  id?: Maybe<Scalars['ID']>;
  paginate: Scalars['Boolean'];
  title_lower?: Maybe<Scalars['String']>;
};

export type GroupListInput = {
  count?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  title_lower?: InputMaybe<Scalars['String']>;
};

export type GroupModerator = {
  added_by_user_id: Scalars['ID'];
  client_id: Scalars['ID'];
  created_at: Scalars['Int'];
  group_id: Scalars['ID'];
  user?: Maybe<PublicUserProfile>;
  user_id: Scalars['ID'];
};

export enum GroupRole {
  Member = 'member',
  Moderator = 'moderator',
  Owner = 'owner'
}

export enum GroupSourceType {
  Keyword = 'keyword',
  Rss = 'rss',
  TwitterHandle = 'twitter_handle'
}

export enum GroupStatus {
  Active = 'active',
  Deleted = 'deleted'
}

export type GroupSuggestion = {
  client_id: Scalars['ID'];
  color: GroupColor;
  color_map: GroupColorMap;
  icon: GroupIcon;
  icon_color: GroupIconColor;
  icon_color_map: GroupIconColorMap;
  icon_map: GroupIconMap;
  id: Scalars['ID'];
  image?: Maybe<S3Object>;
  title: Scalars['String'];
};

export type GroupSummary = {
  active_groups: Scalars['Int'];
  change: Scalars['Float'];
  inactive_groups: Scalars['Int'];
};

export type GroupWebhooks = {
  webhooks: Array<Maybe<Webhook>>;
  workvivo_workspaces: Array<Maybe<WorkvivoWorkspace>>;
};

export enum GroupsSortFields {
  CreatedAt = 'created_at',
  CreatedBy = 'created_by',
  Members = 'members',
  Posts = 'posts',
  Title = 'title'
}

export type IUrls = {
  original_url: Scalars['String'];
  shared_url: Scalars['String'];
  shortened_url: Scalars['String'];
};

export type IdentityProvider = {
  creation_date: Scalars['String'];
  last_modified_date: Scalars['String'];
  provider_details?: Maybe<ProviderDetails>;
  provider_name: Scalars['String'];
  provider_type: ProviderType;
  user_pool_id: Scalars['String'];
};

export type Inbox = {
  created_at: Scalars['Int'];
  id: Scalars['ID'];
  item_read: Scalars['Boolean'];
  message: Scalars['String'];
  to_user_id: Scalars['ID'];
  updated_at: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
};

export type InboxList = {
  count: Scalars['Int'];
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  inbox?: Maybe<Array<Maybe<Inbox>>>;
  limit?: Maybe<Scalars['Int']>;
  paginate: Scalars['Boolean'];
};

export type InboxStatusInput = {
  count?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  item_read?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type IndividualGroupStat = {
  active_groups: Scalars['Int'];
  calendar_day: Scalars['String'];
  inactive_groups: Scalars['Int'];
};

export type IndividualLeaderboardEvent = {
  calendar_day: Scalars['String'];
  external_points: Scalars['Int'];
  internal_points: Scalars['Int'];
};

export type IndividualPostStat = {
  branded_posts: Scalars['Int'];
  calendar_day: Scalars['String'];
  non_branded_posts: Scalars['Int'];
};

export type IndividualShareStat = {
  branded_shares: Scalars['Int'];
  calendar_day: Scalars['String'];
  non_branded_shares: Scalars['Int'];
};

export type IndividualStat = {
  change: Scalars['Float'];
  count: Scalars['Int'];
};

export type IndividualUserStat = {
  active_users: Scalars['Int'];
  calendar_day: Scalars['String'];
  inactive_users: Scalars['Int'];
};

export enum InsightsEngagementType {
  Comment = 'comment',
  CommentReaction = 'comment_reaction',
  Like = 'like',
  Quote = 'quote',
  Reaction = 'reaction',
  Retweet = 'retweet'
}

export type InstagramLocation = {
  has_public_page: Scalars['Boolean'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type InstagramLocationInput = {
  has_public_page: Scalars['Boolean'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  slug?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type InstagramMedia = {
  bucket?: Maybe<Scalars['String']>;
  display_url?: Maybe<Scalars['String']>;
  file_key?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  is_video: Scalars['Boolean'];
  shortcode: Scalars['String'];
  tagged_users?: Maybe<Array<Maybe<InstagramTaggedUser>>>;
  width?: Maybe<Scalars['Int']>;
};

export type InstagramMediaInput = {
  bucket?: InputMaybe<Scalars['String']>;
  display_url?: InputMaybe<Scalars['String']>;
  file_key?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  id: Scalars['String'];
  is_video: Scalars['Boolean'];
  shortcode: Scalars['String'];
  tagged_users?: InputMaybe<Array<InputMaybe<InstagramTaggedUserInput>>>;
  width?: InputMaybe<Scalars['Int']>;
};

export type InstagramMetadata = {
  id?: Maybe<Scalars['String']>;
  shortcode?: Maybe<Scalars['String']>;
};

export type InstagramMetadataInput = {
  id?: InputMaybe<Scalars['String']>;
  shortcode?: InputMaybe<Scalars['String']>;
};

export type InstagramOwner = {
  full_name?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  is_private: Scalars['Boolean'];
  is_verified: Scalars['Boolean'];
  profile_pic_bucket?: Maybe<Scalars['String']>;
  profile_pic_file_key?: Maybe<Scalars['String']>;
  profile_pic_height?: Maybe<Scalars['Int']>;
  profile_pic_url?: Maybe<Scalars['String']>;
  profile_pic_width?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  username: Scalars['String'];
};

export type InstagramOwnerInput = {
  full_name?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  is_private: Scalars['Boolean'];
  is_verified: Scalars['Boolean'];
  profile_pic_bucket?: InputMaybe<Scalars['String']>;
  profile_pic_file_key?: InputMaybe<Scalars['String']>;
  profile_pic_height?: InputMaybe<Scalars['Int']>;
  profile_pic_url?: InputMaybe<Scalars['String']>;
  profile_pic_width?: InputMaybe<Scalars['Int']>;
  url: Scalars['String'];
  username: Scalars['String'];
};

export type InstagramTaggedUser = {
  id: Scalars['String'];
  url: Scalars['String'];
  username: Scalars['String'];
};

export type InstagramTaggedUserInput = {
  id: Scalars['String'];
  url: Scalars['String'];
  username: Scalars['String'];
};

export type InternalEngagementStat = {
  clicks: Scalars['Int'];
  comments: Scalars['Int'];
  engagements: Scalars['Int'];
  groups: Scalars['Int'];
  posts: Scalars['Int'];
  reactions: Scalars['Int'];
  shares: Scalars['Int'];
};

export type InternalOverviewStat = {
  data?: Maybe<Array<Maybe<InternalStat>>>;
  summary: InternalSummary;
};

export type InternalStat = {
  active_groups_count: Scalars['Int'];
  branded_comments_count: Scalars['Int'];
  branded_posts: Scalars['Int'];
  branded_reactions_count: Scalars['Int'];
  calendar_day: Scalars['String'];
  daily_active_users: Scalars['Int'];
  daily_inactive_users: Scalars['Int'];
  inactive_groups_count: Scalars['Int'];
  non_branded_comments_count: Scalars['Int'];
  non_branded_posts: Scalars['Int'];
  non_branded_reactions_count: Scalars['Int'];
};

export type InternalSummary = {
  comments: IndividualStat;
  groups: IndividualStat;
  posts: IndividualStat;
  reactions: IndividualStat;
  users: IndividualStat;
};

export type ItemsListInput = {
  count?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type LeaderboardConfig = {
  all_users: Scalars['Boolean'];
  created_at: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  end_at?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  leaderboard_status: GenericStatus;
  scoring_aggregate?: Maybe<LeaderboardEventAggregate>;
  segment_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  segments?: Maybe<Array<Maybe<UserSegment>>>;
  start_at?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type LeaderboardConfigInput = {
  all_users?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  end_at?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  leaderboard_status?: InputMaybe<GenericStatus>;
  scoring_aggregate?: InputMaybe<LeaderboardEventAggregateInput>;
  segment_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  start_at?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type LeaderboardConfigScores = {
  id: Scalars['ID'];
  scores: Array<Maybe<LeaderboardEventScores>>;
};

export type LeaderboardConfigScoresInput = {
  id: Scalars['ID'];
  scores: Array<InputMaybe<LeaderboardEventScoreInput>>;
};

export type LeaderboardEventAggregate = {
  everyonesocial?: Maybe<EveryoneSocialLeaderboardCategory>;
  facebook?: Maybe<FacebookLeaderboardCategory>;
  linkedin?: Maybe<LinkedInLeaderboardCategory>;
  twitter?: Maybe<TwitterLeaderboardCategory>;
};

export type LeaderboardEventAggregateInput = {
  everyonesocial?: InputMaybe<EveryoneSocialLeaderboardCategoryInput>;
  facebook?: InputMaybe<FacebookLeaderboardCategoryInput>;
  linkedin?: InputMaybe<LinkedInLeaderboardCategoryInput>;
  twitter?: InputMaybe<TwitterLeaderboardCategoryInput>;
};

export type LeaderboardEventScoreInput = {
  event: LeaderboardEventType;
  score: Scalars['String'];
};

export type LeaderboardEventScores = {
  event: LeaderboardEventType;
  score: Scalars['String'];
};

export type LeaderboardEventSummary = {
  change: Scalars['Float'];
  external_points: Scalars['Int'];
  internal_points: Scalars['Int'];
};

export enum LeaderboardEventType {
  BrandedFacebookClick = 'branded_facebook_click',
  BrandedFacebookEngagement = 'branded_facebook_engagement',
  BrandedFacebookShare = 'branded_facebook_share',
  BrandedLinkedinClick = 'branded_linkedin_click',
  BrandedLinkedinComment = 'branded_linkedin_comment',
  BrandedLinkedinEngagement = 'branded_linkedin_engagement',
  BrandedLinkedinLike = 'branded_linkedin_like',
  BrandedLinkedinShare = 'branded_linkedin_share',
  BrandedMicrosoftClick = 'branded_microsoft_click',
  BrandedMicrosoftComment = 'branded_microsoft_comment',
  BrandedMicrosoftEngagement = 'branded_microsoft_engagement',
  BrandedMicrosoftLike = 'branded_microsoft_like',
  BrandedMicrosoftShare = 'branded_microsoft_share',
  BrandedTwitterClick = 'branded_twitter_click',
  BrandedTwitterEngagement = 'branded_twitter_engagement',
  BrandedTwitterLike = 'branded_twitter_like',
  BrandedTwitterRetweet = 'branded_twitter_retweet',
  BrandedTwitterShare = 'branded_twitter_share',
  Comment = 'comment',
  CommentReaction = 'comment_reaction',
  FacebookClick = 'facebook_click',
  FacebookConnected = 'facebook_connected',
  FacebookEngagement = 'facebook_engagement',
  FacebookShare = 'facebook_share',
  FollowGroup = 'follow_group',
  FollowUser = 'follow_user',
  Followed = 'followed',
  GroupCreated = 'group_created',
  InvitationAccepted = 'invitation_accepted',
  InvitationSent = 'invitation_sent',
  LinkedinClick = 'linkedin_click',
  LinkedinConnected = 'linkedin_connected',
  LinkedinEngagement = 'linkedin_engagement',
  LinkedinShare = 'linkedin_share',
  MicrosoftClick = 'microsoft_click',
  MicrosoftConnected = 'microsoft_connected',
  MicrosoftEngagement = 'microsoft_engagement',
  MicrosoftShare = 'microsoft_share',
  NetworkConnected = 'network_connected',
  NonBrandedLinkedinComment = 'non_branded_linkedin_comment',
  NonBrandedLinkedinLike = 'non_branded_linkedin_like',
  NonBrandedMicrosoftComment = 'non_branded_microsoft_comment',
  NonBrandedMicrosoftLike = 'non_branded_microsoft_like',
  NonBrandedTwitterLike = 'non_branded_twitter_like',
  NonBrandedTwitterRetweet = 'non_branded_twitter_retweet',
  PhotoPost = 'photo_post',
  Post = 'post',
  ProfilePhoto = 'profile_photo',
  Reaction = 'reaction',
  ReceivedComment = 'received_comment',
  ReceivedCommentReaction = 'received_comment_reaction',
  ReceivedReaction = 'received_reaction',
  ReceivedShare = 'received_share',
  ShareableBrandedPost = 'shareable_branded_post',
  ShareablePhotoPost = 'shareable_photo_post',
  ShareablePost = 'shareable_post',
  TwitterClick = 'twitter_click',
  TwitterConnected = 'twitter_connected',
  TwitterEngagement = 'twitter_engagement',
  TwitterShare = 'twitter_share',
  UserMention = 'user_mention'
}

export type LeaderboardForUser = {
  leaderboard_config?: Maybe<LeaderboardConfig>;
  leaderboard_configs?: Maybe<Array<Maybe<LeaderboardConfig>>>;
  leaderboard_scores?: Maybe<LeaderboardScores>;
  user_score?: Maybe<LeaderboardScore>;
};

export type LeaderboardScore = {
  events: Array<Maybe<LeaderboardEventScores>>;
  leaderboard_config_id: Scalars['ID'];
  position_change?: Maybe<Scalars['Int']>;
  ranking: Scalars['Int'];
  score: Scalars['String'];
  user: PublicUserProfile;
  user_id: Scalars['ID'];
};

export type LeaderboardScores = {
  items?: Maybe<Array<Maybe<LeaderboardScore>>>;
  leaderboard_config_id?: Maybe<Scalars['ID']>;
  paginate: Scalars['Boolean'];
  ranking?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['ID']>;
};

export type LinkedInLeaderboardCategory = {
  general?: Maybe<Array<Maybe<LeaderboardEventScores>>>;
};

export type LinkedInLeaderboardCategoryInput = {
  general?: InputMaybe<Array<InputMaybe<LeaderboardEventScoreInput>>>;
};

export type LinkedInPage = {
  id: Scalars['String'];
  identifier?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  profile_name?: Maybe<Scalars['String']>;
  profile_url?: Maybe<Scalars['String']>;
  provider: Network;
  role?: Maybe<Scalars['String']>;
  urn?: Maybe<Scalars['String']>;
};

export type LinkedInPageInput = {
  id: Scalars['String'];
  identifier?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  profile_name?: InputMaybe<Scalars['String']>;
  profile_url?: InputMaybe<Scalars['String']>;
  provider: Network;
  role?: InputMaybe<Scalars['String']>;
  urn?: InputMaybe<Scalars['String']>;
};

export type MsTeamsShareResults = {
  results?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ManualNotificationEmail = {
  body: Scalars['String'];
  body_formats?: Maybe<ManualNotificationEmailBodyFormats>;
  format?: Maybe<ManualNotificationEmailFormat>;
  subject: Scalars['String'];
};

export type ManualNotificationEmailBodyFormats = {
  html?: Maybe<Scalars['String']>;
  markdown?: Maybe<Scalars['String']>;
};

export enum ManualNotificationEmailFormat {
  Html = 'html',
  Markdown = 'markdown',
  Text = 'text'
}

export type ManualNotificationEmailInput = {
  body: Scalars['String'];
  format?: InputMaybe<ManualNotificationEmailFormat>;
  subject: Scalars['String'];
};

export type ManualNotificationMessage = {
  body: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type ManualNotificationMessageInput = {
  body: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export enum ManualNotificationType {
  Now = 'now',
  Scheduled = 'scheduled'
}

export type ManualNotificationsItem = {
  client_id: Scalars['ID'];
  created_at: Scalars['Int'];
  email?: Maybe<ManualNotificationEmail>;
  email_count?: Maybe<Scalars['Int']>;
  entire_company?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  message: ManualNotificationMessage;
  notification_type?: Maybe<ManualNotificationType>;
  segment_ids: Array<Maybe<Scalars['ID']>>;
  segments: Array<Maybe<UserSegment>>;
  send_at: Scalars['Int'];
  user_count?: Maybe<Scalars['Int']>;
  user_id: Scalars['ID'];
};

export type ManualNotificationsItemInput = {
  email?: InputMaybe<ManualNotificationEmailInput>;
  entire_company?: InputMaybe<Scalars['Boolean']>;
  message: ManualNotificationMessageInput;
  notification_type?: InputMaybe<ManualNotificationType>;
  segment_ids: Array<InputMaybe<Scalars['ID']>>;
  send_at?: InputMaybe<Scalars['Int']>;
};

export type ManualNotificationsItemUpdateInput = {
  email?: InputMaybe<ManualNotificationEmailInput>;
  entire_company?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  message?: InputMaybe<ManualNotificationMessageInput>;
  notification_type?: InputMaybe<ManualNotificationType>;
  segment_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  send_at?: InputMaybe<Scalars['Int']>;
};

export type ManualNotificationsItemsList = {
  count: Scalars['Int'];
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  items?: Maybe<Array<Maybe<ManualNotificationsItem>>>;
  limit?: Maybe<Scalars['Int']>;
  paginate: Scalars['Boolean'];
};

export type MediaObject = {
  video?: Maybe<S3VideoObject>;
};

export type MediaObjectInput = {
  video?: InputMaybe<S3VideoObjectInput>;
};

export type MentionItem = {
  identifier: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type MentionObject = {
  identifier: Scalars['String'];
  length: Scalars['Int'];
  provider: Scalars['String'];
  start: Scalars['Int'];
};

export type MentionObjectInput = {
  identifier: Scalars['String'];
  length: Scalars['Int'];
  provider: Scalars['String'];
  start: Scalars['Int'];
};

export type MentionResponse = {
  count?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<MentionItem>>;
  page_key?: Maybe<Scalars['String']>;
};

export enum MetadataKey {
  InstagramMetadata = 'instagram_metadata',
  RedditMetadata = 'reddit_metadata',
  TweetMetadata = 'tweet_metadata',
  UrlMetadata = 'url_metadata',
  YoutubeMetadata = 'youtube_metadata'
}

export type MinimalGroup = {
  allow_user_posts: Scalars['Boolean'];
  client_id: Scalars['ID'];
  color: GroupColor;
  color_map: GroupColorMap;
  content_approval_type: GroupContentApprovalType;
  created_at: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  follower_count?: Maybe<Scalars['Int']>;
  group_status: GroupStatus;
  icon: GroupIcon;
  icon_color: GroupIconColor;
  icon_color_map: GroupIconColorMap;
  icon_map: GroupIconMap;
  id: Scalars['ID'];
  image?: Maybe<S3Object>;
  is_private?: Maybe<Scalars['Boolean']>;
  read_only?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  updated_at?: Maybe<Scalars['Int']>;
};

export type MinimalPost = {
  approval?: Maybe<ContentApproval>;
  click_count?: Maybe<Scalars['Int']>;
  client_id: Scalars['ID'];
  comment_count?: Maybe<Scalars['Int']>;
  content_id: Scalars['ID'];
  content_object: ContentObject;
  created_at: Scalars['Int'];
  engagement_count?: Maybe<Scalars['Int']>;
  groups?: Maybe<Array<Maybe<MinimalGroup>>>;
  has_requesting_user_shared?: Maybe<Scalars['Boolean']>;
  important_to_share?: Maybe<Scalars['Boolean']>;
  is_branded?: Maybe<Scalars['Boolean']>;
  is_engage?: Maybe<Scalars['Boolean']>;
  is_engageable?: Maybe<Scalars['Boolean']>;
  is_important?: Maybe<Scalars['Boolean']>;
  is_shareable?: Maybe<Scalars['Boolean']>;
  primary_group?: Maybe<MinimalGroup>;
  publish_at: Scalars['Int'];
  reaction_count?: Maybe<Scalars['Int']>;
  share_count?: Maybe<Scalars['Int']>;
  user?: Maybe<PublicUserProfile>;
};

export type MinimalUserProfile = {
  full_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<S3Object>;
};

export type MultiPartListInput = {
  etag: Scalars['String'];
  part_number: Scalars['Int'];
};

export type Mutation = {
  addReactionAnalytics: Scalars['Boolean'];
  adminSetPassword: UserProfile;
  adminUpdateClient: Client;
  backendInboxItemCreated?: Maybe<Inbox>;
  batchCreateGroups: GroupList;
  batchDeleteGroups: Array<Maybe<Group>>;
  batchSendBillingBillableUserEventDirect: Status;
  batchSendBillingBillableUserEventQueue: Status;
  batchUpdateSocialConnection: SocialAccountConnections;
  batchUpdateUserProfileStatus: Array<Maybe<UserProfile>>;
  batchUpdateUserProfileUserType: Array<Maybe<UserProfile>>;
  bulkResendClientInvitations: Scalars['Boolean'];
  bulkUpdateClientInvitations: Scalars['Boolean'];
  bulkUpdateContent?: Maybe<BulkUpdateContentResults>;
  clientGroupSourceCreate: ClientGroupSource;
  clientGroupSourceDelete: Status;
  clientGroupSourceUpdate: ClientGroupSource;
  completeMultiPartUpload?: Maybe<CompleteMultiPart>;
  contentUpdated?: Maybe<UpdatedContent>;
  createAPIToken: CreateApiTokenOutput;
  createAssignment: Assignment;
  /** @deprecated Depreciate after 2021-09-01 at all costs (SRS) */
  createBillingCustomer: Status;
  createClient: Client;
  createClientContentTags?: Maybe<Array<Maybe<ContentTagMetaResults>>>;
  createClientDepartment: ClientDepartment;
  createClientDisclosure: ClientDisclosure;
  createClientFollowMapping: ClientFollowMapping;
  createClientInvitation: Array<Maybe<ClientInvitation>>;
  createClientLocation: ClientLocation;
  createClientPageMapping: Scalars['Boolean'];
  createClientSelfServe: ClientAndUser;
  createClientSticker: StickerResponse;
  createComment: Comment;
  createContentEmailSpec: ContentEmailSpec;
  createGenericWebhook: Webhook;
  createGroup: Group;
  createGroupModerator: GroupModerator;
  createGroupWebhookWorkvivo: Webhook;
  createLoginTokenForCurrentUserInClient?: Maybe<Scalars['String']>;
  createManualNotification?: Maybe<ManualNotificationsItem>;
  createMultiPartUpload?: Maybe<S3SignedUrlMultiPart>;
  createReaction: Reaction;
  createReadmeLoginJWT: CreateReadmeLoginJwtOutput;
  createReportRequest: ReportRequest;
  createS3SignedURL?: Maybe<S3SignedUrl>;
  createScimToken: ScimToken;
  createUpdateLeaderboardConfig: LeaderboardConfig;
  createUserProfileForCurrentUserInClient?: Maybe<UserProfile>;
  createUserSegment: UserSegment;
  createWorkvivoWebhook: Webhook;
  csCreateUser: UserProfile;
  csUpdateClient: Client;
  deleteAPIToken: DeleteApiTokenOutput;
  deleteAssignment: Scalars['Boolean'];
  deleteClientInvitations: Scalars['Boolean'];
  deleteClientPageMapping: Scalars['Boolean'];
  deleteClientSticker: StickerResponse;
  deleteComment: Comment;
  deleteGroupModerator: Scalars['Boolean'];
  deleteGroupWebhook?: Maybe<Webhook>;
  deleteManualNotification?: Maybe<ManualNotificationsItem>;
  deleteReaction: Status;
  deleteScheduledShare: ScheduledShareItem;
  deleteScheduledShares: Array<Maybe<SharesItem>>;
  deleteScimToken: Scalars['Boolean'];
  deleteSocialConnection: Status;
  deleteUserManagementUserProfile: Scalars['ID'];
  deleteWebhook?: Maybe<Webhook>;
  disableContentEmailSpec: ContentEmailSpec;
  follow?: Maybe<UserFeedFollow>;
  generateClientBillingReportAggregateDownload: Scalars['Boolean'];
  generateClientBillingUserReportDownload: Scalars['Boolean'];
  markInboxAsRead: Status;
  markInboxItemAsRead?: Maybe<Inbox>;
  mediaStatus?: Maybe<Content>;
  modifyContentEmailSpec: ContentEmailSpec;
  oauthCreateClientAdmin?: Maybe<OauthClient>;
  oauthSubmitAuthorize: OauthSubmitOutput;
  oauthUserRevoke?: Maybe<OauthClient>;
  previewContentEmailSpec: Scalars['String'];
  processContent: Content;
  processContentV2: ProcessContentResults;
  processScheduledShare: Status;
  reconcileExpressActivatedUsers: ReconcileExpressActivatedUsersResult;
  sendBillingBillableUserEventDirect: Status;
  sendBillingBillableUserEventQueue: Status;
  setBlockList: BlockList;
  shareChatContent?: Maybe<SharedContentResults>;
  shareContent?: Maybe<SharedContentResults>;
  suspendUserManagementUserProfile: UserProfile;
  syncBillingCustomer: Status;
  toggleCapabilityGroup: Status;
  unfollow?: Maybe<UserFeedFollow>;
  unsuspendUserManagementUserProfile: UserProfile;
  updateAssignment: Assignment;
  updateClientDepartment: ClientDepartment;
  updateClientDisclosure: ClientDisclosure;
  updateClientFollowMapping: ClientFollowMapping;
  updateClientLocation: ClientLocation;
  updateClientUrlParams: ClientUrlParams;
  updateClientsToCapabilities?: Maybe<Capability>;
  updateClientsToReleaseToggles?: Maybe<ReleaseToggle>;
  updateComment: Comment;
  updateContentApprovals?: Maybe<Content>;
  updateExpressActivatedUsers: UpdateExpressActivatedUsersResult;
  updateExternalShare: Scalars['Boolean'];
  updateGroup: Group;
  updateManualNotification?: Maybe<ManualNotificationsItem>;
  updateProviderDetailsForClient: Client;
  updateScheduledShares: Array<ScheduledShareItem>;
  updateSocialConnection: SocialAccount;
  updateUserManagementUserProfile: UserProfile;
  updateUserMappingsForClient?: Maybe<UserMappings>;
  updateUserProfile: UserProfile;
  updateUserProfileOnboarding: UserProfile;
  updateUserROIValues?: Maybe<Status>;
  updateUserSegment: UserSegment;
  upsertBillingCustomer: Status;
};


export type MutationAddReactionAnalyticsArgs = {
  data: ReactionInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationAdminSetPasswordArgs = {
  password: Scalars['String'];
  permanent?: InputMaybe<Scalars['Boolean']>;
  user_id: Scalars['ID'];
};


export type MutationAdminUpdateClientArgs = {
  data: AdminUpdateClientInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationBackendInboxItemCreatedArgs = {
  id: Scalars['ID'];
};


export type MutationBatchCreateGroupsArgs = {
  group_input_list?: InputMaybe<GroupInputList>;
};


export type MutationBatchDeleteGroupsArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationBatchSendBillingBillableUserEventDirectArgs = {
  billable_user_events: Array<InputMaybe<BillableUserEventInput>>;
  client_id: Scalars['ID'];
  user_id: Scalars['ID'];
};


export type MutationBatchSendBillingBillableUserEventQueueArgs = {
  billable_user_events: Array<InputMaybe<BillableUserEventInput>>;
  client_id: Scalars['ID'];
  user_id: Scalars['ID'];
};


export type MutationBatchUpdateSocialConnectionArgs = {
  data: BatchUpdateSocialConnectionInput;
};


export type MutationBatchUpdateUserProfileStatusArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
  user_status: UserStatus;
};


export type MutationBatchUpdateUserProfileUserTypeArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
  user_type: UserType;
};


export type MutationBulkResendClientInvitationsArgs = {
  invitation_ids?: InputMaybe<Array<Scalars['ID']>>;
  search_filter?: InputMaybe<ClientInvitationSearchFilter>;
};


export type MutationBulkUpdateClientInvitationsArgs = {
  department_id?: InputMaybe<Scalars['ID']>;
  invitation_ids?: InputMaybe<Array<Scalars['ID']>>;
  location_id?: InputMaybe<Scalars['ID']>;
  search_filter?: InputMaybe<ClientInvitationSearchFilter>;
  user_type?: InputMaybe<UserType>;
};


export type MutationBulkUpdateContentArgs = {
  bulk_update: BulkUpdateContent;
};


export type MutationClientGroupSourceCreateArgs = {
  approval?: InputMaybe<ContentApproval>;
  disclosures?: InputMaybe<Array<InputMaybe<ContentDisclosuresInput>>>;
  group_id: Scalars['ID'];
  override?: InputMaybe<OverrideInput>;
  source_status: SourceStatus;
  source_type: GroupSourceType;
  source_value: Scalars['String'];
};


export type MutationClientGroupSourceDeleteArgs = {
  id: Scalars['ID'];
  override?: InputMaybe<OverrideInput>;
};


export type MutationClientGroupSourceUpdateArgs = {
  data: ClientGroupSourceUpdate;
  override?: InputMaybe<OverrideInput>;
};


export type MutationCompleteMultiPartUploadArgs = {
  bucket_name: Scalars['String'];
  multipart_upload: Array<InputMaybe<MultiPartListInput>>;
  object_name: Scalars['String'];
  upload_id: Scalars['String'];
};


export type MutationContentUpdatedArgs = {
  content_id: Scalars['ID'];
};


export type MutationCreateApiTokenArgs = {
  data: CreateApiTokenInput;
};


export type MutationCreateAssignmentArgs = {
  data: AssignmentInput;
};


export type MutationCreateBillingCustomerArgs = {
  billing_address_city: Scalars['String'];
  billing_address_country: Scalars['String'];
  billing_address_line1: Scalars['String'];
  billing_address_line2?: InputMaybe<Scalars['String']>;
  billing_address_postal_code: Scalars['String'];
  billing_address_state: Scalars['String'];
  billing_email?: InputMaybe<Scalars['String']>;
  billing_phone?: InputMaybe<Scalars['String']>;
  client_id: Scalars['ID'];
  user_id: Scalars['ID'];
};


export type MutationCreateClientArgs = {
  data: CreateClientInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationCreateClientContentTagsArgs = {
  tags: Array<InputMaybe<ContentTagMetaInput>>;
};


export type MutationCreateClientDepartmentArgs = {
  data: CreateClientDepartmentInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationCreateClientDisclosureArgs = {
  data: CreateClientDisclosureInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationCreateClientFollowMappingArgs = {
  data: CreateClientFollowMappingInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationCreateClientInvitationArgs = {
  data: CreateClientInvitationInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationCreateClientLocationArgs = {
  data: CreateClientLocationInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationCreateClientPageMappingArgs = {
  data: CreateClientPageMappingInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationCreateClientSelfServeArgs = {
  data: CreateClientSelfServeInput;
};


export type MutationCreateClientStickerArgs = {
  data: CreateClientStickerInput;
};


export type MutationCreateCommentArgs = {
  data: CommentInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationCreateContentEmailSpecArgs = {
  data: ContentEmailSpecInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationCreateGenericWebhookArgs = {
  callback_url: Scalars['String'];
  secret_token: Scalars['String'];
  webhook_events: Array<InputMaybe<WebhookEvents>>;
  webhook_name: Scalars['String'];
  webhook_status: GenericStatus;
};


export type MutationCreateGroupArgs = {
  data: CreateGroupInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationCreateGroupModeratorArgs = {
  group_id: Scalars['ID'];
  override?: InputMaybe<OverrideInput>;
  user_id: Scalars['ID'];
};


export type MutationCreateGroupWebhookWorkvivoArgs = {
  group_id: Scalars['ID'];
  webhook_id: Scalars['String'];
  workvivo_workspace_id: Scalars['String'];
};


export type MutationCreateLoginTokenForCurrentUserInClientArgs = {
  client_id: Scalars['ID'];
};


export type MutationCreateManualNotificationArgs = {
  data?: InputMaybe<ManualNotificationsItemInput>;
};


export type MutationCreateMultiPartUploadArgs = {
  bucket_name: Scalars['String'];
  object_name: Scalars['String'];
  total_parts: Scalars['Int'];
};


export type MutationCreateReactionArgs = {
  data: ReactionInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationCreateReportRequestArgs = {
  data: RunReportInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationCreateS3SignedUrlArgs = {
  bucket_name: Scalars['String'];
  object_name: Scalars['String'];
};


export type MutationCreateScimTokenArgs = {
  token: ScimTokenInput;
};


export type MutationCreateUpdateLeaderboardConfigArgs = {
  data: LeaderboardConfigInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationCreateUserProfileForCurrentUserInClientArgs = {
  client_id: Scalars['ID'];
};


export type MutationCreateUserSegmentArgs = {
  data: CreateUserSegmentInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationCreateWorkvivoWebhookArgs = {
  api_token: Scalars['String'];
  webhook_status: GenericStatus;
  workvivo_org_id: Scalars['String'];
};


export type MutationCsCreateUserArgs = {
  data: CsCreateUserInput;
};


export type MutationCsUpdateClientArgs = {
  data: CsUpdateClientInput;
};


export type MutationDeleteApiTokenArgs = {
  data: DeleteTokenApiInput;
};


export type MutationDeleteAssignmentArgs = {
  client_id: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteClientInvitationsArgs = {
  invitation_ids?: InputMaybe<Array<Scalars['ID']>>;
  search_filter?: InputMaybe<ClientInvitationSearchFilter>;
};


export type MutationDeleteClientPageMappingArgs = {
  linkedin_page_id: Scalars['String'];
};


export type MutationDeleteClientStickerArgs = {
  client_id: Scalars['ID'];
  sticker_key: Scalars['String'];
};


export type MutationDeleteCommentArgs = {
  id: Scalars['ID'];
  override?: InputMaybe<OverrideInput>;
};


export type MutationDeleteGroupModeratorArgs = {
  group_id: Scalars['ID'];
  override?: InputMaybe<OverrideInput>;
  user_id: Scalars['ID'];
};


export type MutationDeleteGroupWebhookArgs = {
  group_id: Scalars['ID'];
  webhook_id: Scalars['String'];
};


export type MutationDeleteManualNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteReactionArgs = {
  data: ReactionInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationDeleteScheduledShareArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteScheduledSharesArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationDeleteScimTokenArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSocialConnectionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserManagementUserProfileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteWebhookArgs = {
  webhook_id: Scalars['ID'];
};


export type MutationDisableContentEmailSpecArgs = {
  id: Scalars['ID'];
};


export type MutationFollowArgs = {
  id: Scalars['ID'];
  key: FeedKey;
  override?: InputMaybe<OverrideInput>;
  target_user_id?: InputMaybe<Scalars['String']>;
};


export type MutationGenerateClientBillingReportAggregateDownloadArgs = {
  search_filter?: InputMaybe<ClientBillingReportAggregateSearchFilter>;
};


export type MutationGenerateClientBillingUserReportDownloadArgs = {
  calendar_month?: InputMaybe<Scalars['String']>;
  client_id?: InputMaybe<Scalars['String']>;
};


export type MutationMarkInboxItemAsReadArgs = {
  id: Scalars['ID'];
};


export type MutationMediaStatusArgs = {
  content_id: Scalars['ID'];
  user?: InputMaybe<UserProfileInput>;
};


export type MutationModifyContentEmailSpecArgs = {
  data: ContentEmailSpecMutation;
  override?: InputMaybe<OverrideInput>;
};


export type MutationOauthCreateClientAdminArgs = {
  data: OauthCreateClientInput;
};


export type MutationOauthSubmitAuthorizeArgs = {
  data: OauthSubmitInput;
};


export type MutationOauthUserRevokeArgs = {
  data: OauthClientInput;
};


export type MutationPreviewContentEmailSpecArgs = {
  data: ContentEmailSpecInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationProcessContentArgs = {
  content: ContentInput;
  override?: InputMaybe<OverrideInput>;
  process_metadata: Scalars['Boolean'];
  save: Scalars['Boolean'];
};


export type MutationProcessContentV2Args = {
  content: ContentInput;
  override?: InputMaybe<OverrideInput>;
  process_metadata: Scalars['Boolean'];
  save: Scalars['Boolean'];
};


export type MutationProcessScheduledShareArgs = {
  network_id: Scalars['ID'];
  share_id: Scalars['ID'];
  share_queue_id: Scalars['ID'];
};


export type MutationReconcileExpressActivatedUsersArgs = {
  users: Array<InputMaybe<ReconcileExpressActivatedUsersInput>>;
};


export type MutationSendBillingBillableUserEventDirectArgs = {
  billable_user_event: BillableUserEventInput;
  client_id: Scalars['ID'];
  user_id: Scalars['ID'];
};


export type MutationSendBillingBillableUserEventQueueArgs = {
  billable_user_event: BillableUserEventInput;
  client_id: Scalars['ID'];
  user_id: Scalars['ID'];
};


export type MutationSetBlockListArgs = {
  terms: Array<InputMaybe<Scalars['String']>>;
};


export type MutationShareChatContentArgs = {
  channels: Array<InputMaybe<SharingChannelInfo>>;
  content_id: Scalars['String'];
  network: Network;
  share_at?: InputMaybe<Scalars['Int']>;
};


export type MutationShareContentArgs = {
  content_id: Scalars['ID'];
  items: Array<InputMaybe<ShareContentInput>>;
  share_session_id?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type MutationSuspendUserManagementUserProfileArgs = {
  id: Scalars['ID'];
};


export type MutationSyncBillingCustomerArgs = {
  override?: InputMaybe<OverrideInput>;
};


export type MutationToggleCapabilityGroupArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  capability_group?: InputMaybe<CapabilityGroup>;
  client_id?: InputMaybe<Scalars['String']>;
};


export type MutationUnfollowArgs = {
  id: Scalars['ID'];
  key: FeedKey;
  override?: InputMaybe<OverrideInput>;
  target_user_id?: InputMaybe<Scalars['String']>;
};


export type MutationUnsuspendUserManagementUserProfileArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateAssignmentArgs = {
  client_id: Scalars['ID'];
  data: AssignmentUpdateInput;
  id: Scalars['ID'];
};


export type MutationUpdateClientDepartmentArgs = {
  data: UpdateClientDepartmentInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationUpdateClientDisclosureArgs = {
  data: UpdateClientDisclosureInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationUpdateClientFollowMappingArgs = {
  data: UpdateClientFollowMappingInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationUpdateClientLocationArgs = {
  data: UpdateClientLocationInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationUpdateClientUrlParamsArgs = {
  data: ClientUrlParamsUpdateInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationUpdateClientsToCapabilitiesArgs = {
  capability_ids: Array<InputMaybe<Scalars['String']>>;
  clients: Array<InputMaybe<ClientsFeatureToggleUpdateInput>>;
};


export type MutationUpdateClientsToReleaseTogglesArgs = {
  clients: Array<InputMaybe<ClientsFeatureToggleUpdateInput>>;
  release_toggle_ids: Array<InputMaybe<Scalars['String']>>;
};


export type MutationUpdateCommentArgs = {
  data: CommentUpdateInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationUpdateContentApprovalsArgs = {
  content_approvals: ContentApprovalsInput;
  content_id: Scalars['String'];
  override?: InputMaybe<OverrideInput>;
};


export type MutationUpdateExpressActivatedUsersArgs = {
  users: Array<InputMaybe<UpdateExpressActivatedUsersInput>>;
};


export type MutationUpdateExternalShareArgs = {
  data: ExternalShareUpdateInput;
  share_id: Scalars['ID'];
};


export type MutationUpdateGroupArgs = {
  data: UpdateGroupInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationUpdateManualNotificationArgs = {
  data?: InputMaybe<ManualNotificationsItemUpdateInput>;
};


export type MutationUpdateProviderDetailsForClientArgs = {
  client_id: Scalars['ID'];
  provider_details: ProviderDetailsInput;
  provider_type: ProviderType;
};


export type MutationUpdateScheduledSharesArgs = {
  data: ScheduledShareContentInput;
};


export type MutationUpdateSocialConnectionArgs = {
  data: UpdateSocialConnectionInput;
};


export type MutationUpdateUserManagementUserProfileArgs = {
  input: UpdateUserManagementUserProfileInput;
};


export type MutationUpdateUserMappingsForClientArgs = {
  client_id: Scalars['ID'];
  user_mappings: UserMappingsInput;
};


export type MutationUpdateUserProfileArgs = {
  data: UserProfileInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationUpdateUserProfileOnboardingArgs = {
  data: UserProfileOnboardingInput;
};


export type MutationUpdateUserRoiValuesArgs = {
  roi_currency_values: RoiCurrencyValuesInput;
  user_id: Scalars['ID'];
};


export type MutationUpdateUserSegmentArgs = {
  data: UpdateUserSegmentInput;
  override?: InputMaybe<OverrideInput>;
};


export type MutationUpsertBillingCustomerArgs = {
  data?: InputMaybe<UpsertBillingCustomerInput>;
  override?: InputMaybe<OverrideInput>;
};

export enum Network {
  Facebook = 'facebook',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  LinkedinPage = 'linkedin_page',
  Msteams = 'msteams',
  Salesloft = 'salesloft',
  Slack = 'slack',
  Twitter = 'twitter',
  Xing = 'xing'
}

export enum NotificationDeliveryType {
  Email = 'email',
  Inbox = 'inbox',
  Push = 'push',
  Subscription = 'subscription'
}

export type OauthClient = {
  oauth_client_description: Scalars['String'];
  oauth_client_id: Scalars['String'];
  oauth_client_logo_url: Scalars['String'];
  oauth_client_name: Scalars['String'];
};

export type OauthClientInput = {
  oauth_client_id: Scalars['String'];
};

export type OauthClientSecret = {
  oauth_client_id: Scalars['String'];
  oauth_client_secret: Scalars['String'];
};

export type OauthCreateClientInput = {
  oauth_client_description: Scalars['String'];
  oauth_client_logo_url: Scalars['String'];
  oauth_client_name: Scalars['String'];
  oauth_redirect_urls?: InputMaybe<Array<Scalars['String']>>;
};

export type OauthSubmitInput = {
  oauth_client_id: Scalars['String'];
  oauth_redirect_uri: Scalars['String'];
  oauth_response_type: Scalars['String'];
  oauth_state: Scalars['String'];
};

export type OauthSubmitOutput = {
  redirect_url: Scalars['String'];
};

export enum ObjectType {
  Content = 'content'
}

export enum Ordering {
  Newest = 'newest',
  Top = 'top'
}

export type OrganicInsightsAdvancedFilters = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company_pages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filter_out_incomplete_profiles?: InputMaybe<Scalars['Boolean']>;
  posts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**   the following fields are used exclusively for the getPeople newest query */
  remove_duplicates?: InputMaybe<Scalars['Boolean']>;
  shares?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OrganicInsightsReportFilter = {
  hide_company?: InputMaybe<Scalars['Boolean']>;
  hide_teammates?: InputMaybe<Scalars['Boolean']>;
  registration_status?: InputMaybe<RegistrationStatus>;
};

export enum OrganicInsightsSortFields {
  EngagementDate = 'engagement_date',
  Engagements = 'engagements',
  TotalFollowers = 'total_followers'
}

export type OrganicInsightsSortParam = {
  direction: SortDirections;
  field: OrganicInsightsSortFields;
};

export type OverrideInput = {
  client_id?: InputMaybe<Scalars['ID']>;
};

export type PaginatedFollowedByUsers = {
  client: Client;
  count: Scalars['Int'];
  followed_by_user_id?: Maybe<Scalars['ID']>;
  followed_by_users?: Maybe<Array<PublicUserProfile>>;
  user: ProfileContext;
  username?: Maybe<Scalars['String']>;
};

export type PaginatedFollowedByUsersInput = {
  followed_by_user_id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
};

export type PaginatedUserFeedFollows = {
  client: Client;
  client_id__feed__id?: Maybe<Scalars['String']>;
  count: Scalars['Int'];
  feed_follows?: Maybe<Array<UserFeedFollow>>;
  title_lower?: Maybe<Scalars['String']>;
};

export type PaginatedUserFeedFollowsInput = {
  client_id__feed__id?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  title_lower?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['ID']>;
};

export enum ParamsStatus {
  Active = 'active',
  Disabled = 'disabled'
}

export type ParseBlockListResult = {
  blocked_terms?: Maybe<Array<Maybe<BlockedTerm>>>;
  uuid: Scalars['String'];
};

export type PartnerDetails = {
  partner_name: Scalars['String'];
  redirect_uris?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PinnedGroup = {
  group_id: Scalars['String'];
  pinned_end_at?: Maybe<Scalars['Int']>;
};

export type PinnedGroupInput = {
  group_id: Scalars['String'];
  pinned_end_at?: InputMaybe<Scalars['Int']>;
};

export enum PostShareStatus {
  AllPosts = 'all_posts',
  AlreadyShared = 'already_shared',
  NotShared = 'not_shared'
}

export enum PostSource {
  External = 'external',
  User = 'user'
}

export type PostSummary = {
  branded_posts: Scalars['Int'];
  change: Scalars['Float'];
  non_branded_posts: Scalars['Int'];
};

export enum PostType {
  Instagram = 'instagram',
  Manual = 'manual',
  Quickshare = 'quickshare',
  Tweet = 'tweet',
  Url = 'url',
  Youtube = 'youtube'
}

export type PostedToGroup = {
  group_id: Scalars['ID'];
  score: Scalars['Int'];
};

export enum PostsSortFields {
  ApprovedBy = 'approved_by',
  Branded = 'branded',
  Comments = 'comments',
  CreatedAt = 'created_at',
  Reactions = 'reactions',
  Shares = 'shares',
  SubmittedBy = 'submitted_by',
  Title = 'title'
}

export enum PreviewUrlSourceType {
  ExternalShare = 'external_share',
  Posting = 'posting'
}

export type PrivateEnv = {
  GOOGLE_MAPS_API_KEY?: Maybe<Scalars['String']>;
  REACT_APP_GETSTREAM_API_KEY?: Maybe<Scalars['String']>;
  REACT_APP_SEGMENT_ANDROID_KEY?: Maybe<Scalars['String']>;
  REACT_APP_SEGMENT_IOS_KEY?: Maybe<Scalars['String']>;
};

export type ProcessContentResults = {
  content?: Maybe<Content>;
  warnings: Array<Maybe<ParseBlockListResult>>;
};

export type ProfileContext = PublicUserProfile | UserProfile;

export type ProfileSuggestion = {
  client_id: Scalars['ID'];
  id: Scalars['ID'];
  image?: Maybe<S3Object>;
  title: Scalars['String'];
};

export type ProviderDetails = {
  attributes_request_method?: Maybe<Scalars['String']>;
  attributes_url_add_attributes?: Maybe<Scalars['String']>;
  authorize_scopes?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  i_d_p_signout?: Maybe<Scalars['String']>;
  metadata_file?: Maybe<Scalars['String']>;
  metadata_u_r_l?: Maybe<Scalars['String']>;
  oidc_issuer?: Maybe<Scalars['String']>;
  s_l_o_redirect_binding_u_r_i?: Maybe<Scalars['String']>;
  s_s_o_redirect_binding_u_r_i?: Maybe<Scalars['String']>;
};

export type ProviderDetailsInput = {
  attributes_request_method?: InputMaybe<Scalars['String']>;
  attributes_url_add_attributes?: InputMaybe<Scalars['String']>;
  authorize_scopes?: InputMaybe<Scalars['String']>;
  client_id?: InputMaybe<Scalars['String']>;
  client_secret?: InputMaybe<Scalars['String']>;
  i_d_p_signout?: InputMaybe<Scalars['String']>;
  metadata_file?: InputMaybe<Scalars['String']>;
  metadata_u_r_l?: InputMaybe<Scalars['String']>;
  oidc_issuer?: InputMaybe<Scalars['String']>;
  s_l_o_redirect_binding_u_r_i?: InputMaybe<Scalars['String']>;
  s_s_o_redirect_binding_u_r_i?: InputMaybe<Scalars['String']>;
};

export enum ProviderType {
  Oidc = 'OIDC',
  Saml = 'SAML'
}

export type PublicUserProfile = {
  client_id: Scalars['ID'];
  department?: Maybe<ClientDepartment>;
  department_id?: Maybe<Scalars['ID']>;
  department_title?: Maybe<Scalars['String']>;
  email_address: Scalars['String'];
  follower_count?: Maybe<Scalars['Int']>;
  full_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<S3Object>;
  job_title?: Maybe<Scalars['String']>;
  karma?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
  last_accessed_at?: Maybe<Scalars['Int']>;
  leaderboard_enabled?: Maybe<Scalars['Boolean']>;
  location?: Maybe<ClientLocation>;
  location_id?: Maybe<Scalars['ID']>;
  location_title?: Maybe<Scalars['String']>;
  onboarding_completed?: Maybe<Scalars['Boolean']>;
  reach?: Maybe<Scalars['Int']>;
  user_status: UserStatus;
  user_type: UserType;
};

export type PushNotificationConfiguration = {
  device_platform: Scalars['String'];
  token: Scalars['String'];
};

export type PushNotificationConfigurationInput = {
  device_platform: Scalars['String'];
  token: Scalars['String'];
};

export type PushNotificationStatus = {
  paused: Scalars['Boolean'];
  paused_at?: Maybe<Scalars['Int']>;
};

export type Query = {
  bootstrap: BootstrapData;
  clientDailyStats?: Maybe<ClientTrendingEngagementStat>;
  clientEngagementStats?: Maybe<ClientEngagementStat>;
  clientReachStats?: Maybe<Array<Maybe<ReachStat>>>;
  contextGetPostedToGroups?: Maybe<Array<Maybe<PostedToGroup>>>;
  dailyGroupStats?: Maybe<DailyGroupStat>;
  dailyLeaderboardStats?: Maybe<DailyLeaderboardEventStat>;
  dailyPostStats?: Maybe<DailyPostStat>;
  dailyShareStats?: Maybe<DailyShareStat>;
  dailyUserStats?: Maybe<DailyUserStat>;
  externalOverviewStats?: Maybe<ExternalOverviewStat>;
  externalShares?: Maybe<ExternalSharesResponse>;
  feedFollowing?: Maybe<FeedFollowing>;
  getAPITokens?: Maybe<Array<ApiToken>>;
  getActions: Actions;
  getActiveClientByAttr?: Maybe<Client>;
  getActiveComments: CommentsList;
  getActiveGroups: GroupList;
  getAllClientDepartments: ClientDepartmentList;
  getAllClientDisclosures: ClientDisclosureList;
  getAllClientFollowMappings: ClientFollowMappingList;
  getAllClientLocations: ClientLocationList;
  getAllClientUrlParams?: Maybe<Array<Maybe<ClientUrlParams>>>;
  getAssignment?: Maybe<Assignment>;
  getAssignments?: Maybe<AssignmentsResponse>;
  getAvailableClientsForSignup?: Maybe<ClientResultSet>;
  getBillingCustomerPortalEphemeralUrl: BillingCustomerPortalEphemeralUrl;
  /** @deprecated Use bootstrap instead - non paginated */
  getByUserFeed: FeedByUser;
  getCapabilities?: Maybe<Array<Maybe<Capability>>>;
  getCapabilityDetails?: Maybe<Capability>;
  getChatChannels?: Maybe<GetChannelResults>;
  getChatTeams?: Maybe<GetTeamsResults>;
  getClient?: Maybe<Client>;
  getClientBillingReportAggregate?: Maybe<ClientBillingReportAggregate>;
  getClientByEmailDomain?: Maybe<Client>;
  getClientContentTags?: Maybe<Array<Maybe<ClientContentTag>>>;
  getClientDepartment?: Maybe<ClientDepartment>;
  getClientDepartmentsByStatus: ClientDepartmentStatusList;
  getClientDisclosure?: Maybe<ClientDisclosure>;
  getClientDisclosuresByStatus: ClientDisclosureStatusList;
  getClientFollowMapping?: Maybe<ClientFollowMapping>;
  getClientFollowMappingsByStatus: ClientFollowMappingStatusList;
  getClientGroupSourcesByGroup?: Maybe<Array<Maybe<ClientGroupSource>>>;
  getClientInvitation?: Maybe<ClientInvitation>;
  /** @deprecated Use search client invitations instead */
  getClientInvitationsByClient: ClientInvitationsClientList;
  getClientLocation?: Maybe<ClientLocation>;
  getClientLocationsByStatus: ClientLocationStatusList;
  getClientPageMappings?: Maybe<Array<Maybe<ClientPageMapping>>>;
  getClients: Array<Maybe<Client>>;
  getCompanies?: Maybe<GetCompaniesResult>;
  getContent?: Maybe<Content>;
  getContentEmailHistory: ContentEmailHistoryList;
  getContentEmailSpec?: Maybe<ContentEmailSpec>;
  getContentEmailSpecs: ContentEmailSpecList;
  getContentUrlParamOptions?: Maybe<Array<Maybe<ContentUrlParamOptions>>>;
  getEbrIntroduction: EbrIntroduction;
  getEbrOrganicInsights: EbrOrganicInsights;
  getEmployees?: Maybe<GetEmployeesResult>;
  getExistingClientsForCurrentUser?: Maybe<ClientResultSet>;
  getExpressActivatedUsers?: Maybe<ExpressActivatedUsersResultSet>;
  getFeed: Feed;
  getGroup?: Maybe<Group>;
  getGroupColors: Array<Maybe<GroupColorMap>>;
  getGroupIconColors: Array<Maybe<GroupIconColorMap>>;
  getGroupIcons: Array<Maybe<GroupIconMap>>;
  getGroupWebhookList?: Maybe<GroupWebhooks>;
  getGroups?: Maybe<Array<Maybe<Group>>>;
  getIdentityProviderForClient?: Maybe<IdentityProvider>;
  getInboxItem: Inbox;
  getInboxItems: InboxList;
  getIntelligence?: Maybe<GetIntelligenceResult>;
  getLeaderboardConfig: LeaderboardConfig;
  getLeaderboardConfigAggregate: LeaderboardConfig;
  getLeaderboardConfigScores: Array<Maybe<LeaderboardEventScores>>;
  getLeaderboardConfigs: Array<Maybe<LeaderboardConfig>>;
  getLeaderboardForUser?: Maybe<LeaderboardForUser>;
  getLeaderboardScoreForUser: LeaderboardScore;
  getLeaderboardScores: LeaderboardScores;
  getManualNotificationItems?: Maybe<ManualNotificationsItemsList>;
  getMention: MentionResponse;
  getModeratorsByGroup?: Maybe<Array<Maybe<GroupModerator>>>;
  getOrganicInsightReports?: Maybe<Scalars['Boolean']>;
  getPaginatedFollowedByUsers: PaginatedFollowedByUsers;
  getPaginatedUserFeedFollows: PaginatedUserFeedFollows;
  getPartnerDetails?: Maybe<PartnerDetails>;
  getPeople?: Maybe<GetPeopleResult>;
  getPrivateEnv?: Maybe<PrivateEnv>;
  getProfilesByClientIdFullName?: Maybe<Array<Maybe<PublicUserProfile>>>;
  getProfilesByUserStatus: UserProfilesByStatusList;
  getPublicUserProfile?: Maybe<PublicUserProfile>;
  getReleaseToggleDetails?: Maybe<ReleaseToggle>;
  getReleaseToggles?: Maybe<Array<Maybe<ReleaseToggle>>>;
  getReportRequest: ReportRequest;
  getReportRequests: ReportRequestList;
  getReportResult: ReportResult;
  getReports?: Maybe<Array<Maybe<Report>>>;
  getReportsUrl?: Maybe<Array<Maybe<ReportUrl>>>;
  getSecurityCapabilities?: Maybe<Array<Maybe<Scalars['String']>>>;
  getSharePreviewInfo: ContentSharePreview;
  getSharesItems: SharesList;
  getTrackingDetails?: Maybe<SegmentEventDetails>;
  getUserClientFollowMappings: UserFollowMappings;
  getUserClients?: Maybe<UserClientResultSet>;
  getUserMappingsForClient?: Maybe<UserMappings>;
  getUserProfile?: Maybe<UserProfile>;
  getUserROIValues?: Maybe<RoiCurrencyValues>;
  getUserReachGraphData?: Maybe<UserReachGraphData>;
  getUserSearches?: Maybe<Array<Maybe<Scalars['String']>>>;
  getUserSearchesV2?: Maybe<UserSearchesV2Results>;
  getUserSegment?: Maybe<UserSegment>;
  getUserSegmentOthers?: Maybe<S3Object>;
  getUserSegmentOthersPresignedUrl?: Maybe<S3SignedUrlOnly>;
  getUserSegmentUsers?: Maybe<UserSegmentUsers>;
  getUserSegments?: Maybe<Array<Maybe<UserSegment>>>;
  getUserSocialConnections: SocialAccountConnectionsList;
  getUsersByEmailAddress?: Maybe<Array<Maybe<UserProfile>>>;
  getWebhookList?: Maybe<Webhooks>;
  internalOverviewStats?: Maybe<InternalOverviewStat>;
  isGroupModerator: Scalars['Boolean'];
  oauthClientDetails: OauthClient;
  oauthClientListAdmin: Array<Maybe<OauthClient>>;
  oauthClientSecretAdmin: OauthClientSecret;
  oauthUserIntegrations: Array<Maybe<OauthClient>>;
  previewURL: Content;
  reachOverviewStats?: Maybe<ReachOverviewStat>;
  recommendContent: RecommendedContentResults;
  roiClicksOverviewStats?: Maybe<RoiOverviewStat>;
  roiEngagementsOverviewStats?: Maybe<RoiOverviewStat>;
  roiImpressionsOverviewStats?: Maybe<RoiOverviewStat>;
  roiReachOverviewStats?: Maybe<RoiOverviewStat>;
  search: SearchResults;
  searchAggregates: SearchAggregates;
  searchClientBillingReportAggregate: ClientBillingReportAggregateResultSet;
  searchClientInvitations?: Maybe<ClientInvitationResultSet>;
  searchClients?: Maybe<ClientResultSet>;
  searchCompanies?: Maybe<Array<Maybe<CompanyEntity>>>;
  searchContent?: Maybe<SearchContentResults>;
  searchEveryoneSocial: SearchEveryoneSocialResults;
  searchScimTokens?: Maybe<ScimTokenResultSet>;
  sortedGroups?: Maybe<Array<Maybe<SortedGroup>>>;
  sortedLeaderboards?: Maybe<Array<Maybe<SortedLeaderboard>>>;
  sortedPosts?: Maybe<Array<Maybe<SortedPost>>>;
  sortedShares?: Maybe<Array<Maybe<SortedShare>>>;
  sortedUsers?: Maybe<Array<Maybe<SortedUser>>>;
  suggest: SuggestionResults;
  userActivityStats?: Maybe<UserActivityStat>;
  userDailyStats?: Maybe<TrendingEngagementStat>;
  userEngagementComparison?: Maybe<EngagementComparison>;
  userEngagementHistory?: Maybe<Array<Maybe<EngagementHistory>>>;
  userEngagementStats?: Maybe<InternalEngagementStat>;
  userHasLeaderboards: Scalars['Boolean'];
  userReachStats?: Maybe<Array<Maybe<ReachStat>>>;
  userTrendingStats?: Maybe<TrendingEngagementStat>;
};


export type QueryBootstrapArgs = {
  data?: InputMaybe<BootstrapInput>;
};


export type QueryClientDailyStatsArgs = {
  client_id: Scalars['ID'];
  grouping: StatsGrouping;
};


export type QueryClientEngagementStatsArgs = {
  client_id: Scalars['ID'];
  grouping: StatsGrouping;
  value: Scalars['Int'];
};


export type QueryClientReachStatsArgs = {
  client_id: Scalars['ID'];
  grouping: StatsGrouping;
  value: Scalars['Int'];
};


export type QueryDailyGroupStatsArgs = {
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  filter?: InputMaybe<ReportingFilter>;
  start_date: Scalars['String'];
};


export type QueryDailyLeaderboardStatsArgs = {
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  leaderboard_config_id: Scalars['ID'];
  start_date: Scalars['String'];
};


export type QueryDailyPostStatsArgs = {
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  filter?: InputMaybe<ReportingFilter>;
  start_date: Scalars['String'];
};


export type QueryDailyShareStatsArgs = {
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  filter?: InputMaybe<ReportingFilter>;
  start_date: Scalars['String'];
};


export type QueryDailyUserStatsArgs = {
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  filter?: InputMaybe<ReportingFilter>;
  start_date: Scalars['String'];
};


export type QueryExternalOverviewStatsArgs = {
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
};


export type QueryExternalSharesArgs = {
  client_id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ExternalSharesSortFields>;
  sort_direction?: InputMaybe<SortDirections>;
  timestamp_end: Scalars['Int'];
  timestamp_start: Scalars['Int'];
  user_id: Scalars['ID'];
};


export type QueryFeedFollowingArgs = {
  data?: InputMaybe<FeedFollowingInput>;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetActionsArgs = {
  group_id?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  override?: InputMaybe<OverrideInput>;
  user_id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetActiveClientByAttrArgs = {
  key: UniqueClientKey;
  override?: InputMaybe<OverrideInput>;
  value: Scalars['String'];
};


export type QueryGetActiveCommentsArgs = {
  data: CommentStatusInput;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetActiveGroupsArgs = {
  data: GroupListInput;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetAllClientDepartmentsArgs = {
  data: ClientDepartmentListInput;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetAllClientDisclosuresArgs = {
  data: ClientDisclosureListInput;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetAllClientFollowMappingsArgs = {
  data: ClientFollowMappingListInput;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetAllClientLocationsArgs = {
  data: ClientLocationListInput;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetAllClientUrlParamsArgs = {
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetAssignmentArgs = {
  client_id: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryGetAssignmentsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  client_id: Scalars['ID'];
};


export type QueryGetAvailableClientsForSignupArgs = {
  last_evaluated_key?: InputMaybe<Scalars['String']>;
};


export type QueryGetBillingCustomerPortalEphemeralUrlArgs = {
  client_id: Scalars['ID'];
  plan_type?: InputMaybe<BillingPortalPlanType>;
  return_url: Scalars['String'];
  route?: InputMaybe<BillingPortalRoute>;
  user_id: Scalars['ID'];
};


export type QueryGetByUserFeedArgs = {
  data?: InputMaybe<FeedByUserInput>;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetCapabilityDetailsArgs = {
  capability_id: Scalars['String'];
};


export type QueryGetChatChannelsArgs = {
  network: Network;
  team_id?: InputMaybe<Scalars['String']>;
};


export type QueryGetChatTeamsArgs = {
  network: Network;
};


export type QueryGetClientArgs = {
  id: Scalars['ID'];
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetClientBillingReportAggregateArgs = {
  calendar_month__eq?: InputMaybe<Scalars['String']>;
};


export type QueryGetClientByEmailDomainArgs = {
  email_domain: Scalars['String'];
};


export type QueryGetClientDepartmentArgs = {
  id: Scalars['ID'];
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetClientDepartmentsByStatusArgs = {
  data: ClientDepartmentStatusListInput;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetClientDisclosureArgs = {
  id: Scalars['ID'];
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetClientDisclosuresByStatusArgs = {
  data: ClientDisclosureStatusListInput;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetClientFollowMappingArgs = {
  id: Scalars['ID'];
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetClientFollowMappingsByStatusArgs = {
  data: ClientFollowMappingStatusListInput;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetClientGroupSourcesByGroupArgs = {
  group_id: Scalars['ID'];
};


export type QueryGetClientInvitationArgs = {
  id: Scalars['ID'];
};


export type QueryGetClientInvitationsByClientArgs = {
  data: ClientInvitationsClientListInput;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetClientLocationArgs = {
  id: Scalars['ID'];
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetClientLocationsByStatusArgs = {
  data: ClientLocationStatusListInput;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetClientPageMappingsArgs = {
  id: Scalars['ID'];
};


export type QueryGetClientsArgs = {
  client_status: ClientStatus;
};


export type QueryGetCompaniesArgs = {
  advanced_filters?: InputMaybe<OrganicInsightsAdvancedFilters>;
  end: Scalars['Int'];
  hide_company: Scalars['Boolean'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort_by?: InputMaybe<OrganicInsightsSortParam>;
  start: Scalars['Int'];
};


export type QueryGetContentArgs = {
  content_id: Scalars['String'];
  display_only?: InputMaybe<Scalars['Boolean']>;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetContentEmailHistoryArgs = {
  data: ContentEmailHistoryListInput;
};


export type QueryGetContentEmailSpecArgs = {
  id: Scalars['ID'];
};


export type QueryGetContentEmailSpecsArgs = {
  data: ContentEmailSpecListInput;
};


export type QueryGetContentUrlParamOptionsArgs = {
  content_id?: InputMaybe<Scalars['String']>;
  override?: InputMaybe<OverrideInput>;
  url?: InputMaybe<Scalars['String']>;
};


export type QueryGetEbrIntroductionArgs = {
  client_id: Scalars['ID'];
  end: Scalars['Int'];
  start: Scalars['Int'];
};


export type QueryGetEbrOrganicInsightsArgs = {
  client_id: Scalars['ID'];
  end: Scalars['Int'];
  start: Scalars['Int'];
};


export type QueryGetEmployeesArgs = {
  advanced_filters?: InputMaybe<OrganicInsightsAdvancedFilters>;
  end: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  registration_status: RegistrationStatus;
  sort_by?: InputMaybe<OrganicInsightsSortParam>;
  start: Scalars['Int'];
};


export type QueryGetExistingClientsForCurrentUserArgs = {
  last_evaluated_key?: InputMaybe<Scalars['String']>;
};


export type QueryGetExpressActivatedUsersArgs = {
  filters: ExpressActivationFiltersInput;
  last_evaluated_key: Scalars['String'];
};


export type QueryGetFeedArgs = {
  id: Scalars['String'];
  id_lt?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  override?: InputMaybe<OverrideInput>;
  sort?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetGroupArgs = {
  id: Scalars['ID'];
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetGroupColorsArgs = {
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetGroupIconColorsArgs = {
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetGroupIconsArgs = {
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetGroupWebhookListArgs = {
  group_id: Scalars['ID'];
};


export type QueryGetGroupsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetIdentityProviderForClientArgs = {
  client_id: Scalars['ID'];
};


export type QueryGetInboxItemArgs = {
  id: Scalars['ID'];
};


export type QueryGetInboxItemsArgs = {
  data: InboxStatusInput;
};


export type QueryGetIntelligenceArgs = {
  client_id: Scalars['ID'];
  end: Scalars['Int'];
  start: Scalars['Int'];
};


export type QueryGetLeaderboardConfigArgs = {
  id: Scalars['ID'];
};


export type QueryGetLeaderboardConfigAggregateArgs = {
  id: Scalars['ID'];
};


export type QueryGetLeaderboardConfigScoresArgs = {
  id: Scalars['ID'];
};


export type QueryGetLeaderboardForUserArgs = {
  leaderboard_config_id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetLeaderboardScoreForUserArgs = {
  leaderboard_config_id: Scalars['ID'];
  user_id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetLeaderboardScoresArgs = {
  leaderboard_config_id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  ranking?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetManualNotificationItemsArgs = {
  data?: InputMaybe<ItemsListInput>;
  scheduled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetMentionArgs = {
  page_key?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  token_id: Scalars['String'];
};


export type QueryGetModeratorsByGroupArgs = {
  group_id: Scalars['ID'];
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetOrganicInsightReportsArgs = {
  advanced_filters?: InputMaybe<OrganicInsightsAdvancedFilters>;
  end: Scalars['Int'];
  organic_insights_report_filter?: InputMaybe<OrganicInsightsReportFilter>;
  report: ReportNames;
  start: Scalars['Int'];
};


export type QueryGetPaginatedFollowedByUsersArgs = {
  data?: InputMaybe<PaginatedFollowedByUsersInput>;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetPaginatedUserFeedFollowsArgs = {
  data?: InputMaybe<PaginatedUserFeedFollowsInput>;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetPartnerDetailsArgs = {
  partner_name: Scalars['String'];
};


export type QueryGetPeopleArgs = {
  advanced_filters?: InputMaybe<OrganicInsightsAdvancedFilters>;
  end: Scalars['Int'];
  hide_teammates: Scalars['Boolean'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering: Ordering;
  sort_by?: InputMaybe<OrganicInsightsSortParam>;
  start: Scalars['Int'];
};


export type QueryGetPrivateEnvArgs = {
  env_id: Scalars['ID'];
};


export type QueryGetProfilesByClientIdFullNameArgs = {
  full_name: Scalars['String'];
  limit: Scalars['Int'];
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetProfilesByUserStatusArgs = {
  data: UserProfilesByStatusListInput;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetPublicUserProfileArgs = {
  override?: InputMaybe<OverrideInput>;
  user_id: Scalars['ID'];
};


export type QueryGetReleaseToggleDetailsArgs = {
  release_toggle_id: Scalars['String'];
};


export type QueryGetReportRequestArgs = {
  request_id: Scalars['ID'];
};


export type QueryGetReportRequestsArgs = {
  data: ReportRequestListInput;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetReportResultArgs = {
  request_id: Scalars['ID'];
};


export type QueryGetReportsUrlArgs = {
  override?: InputMaybe<OverrideInput>;
  report_id: Scalars['ID'];
};


export type QueryGetSecurityCapabilitiesArgs = {
  capability_specifiers: Array<InputMaybe<Scalars['String']>>;
};


export type QueryGetSharePreviewInfoArgs = {
  content_id: Scalars['String'];
};


export type QueryGetSharesItemsArgs = {
  data: ItemsListInput;
  group_by_session?: InputMaybe<Scalars['Boolean']>;
  scheduled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetTrackingDetailsArgs = {
  event_name?: InputMaybe<SegmentEventType>;
  user_id: Scalars['ID'];
};


export type QueryGetUserClientFollowMappingsArgs = {
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetUserClientsArgs = {
  last_evaluated_key?: InputMaybe<Scalars['String']>;
};


export type QueryGetUserMappingsForClientArgs = {
  client_id: Scalars['ID'];
};


export type QueryGetUserProfileArgs = {
  id?: InputMaybe<Scalars['ID']>;
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetUserRoiValuesArgs = {
  user_id: Scalars['ID'];
};


export type QueryGetUserReachGraphDataArgs = {
  end_date: Scalars['String'];
  start_date: Scalars['String'];
};


export type QueryGetUserSearchesArgs = {
  limit: Scalars['Int'];
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetUserSearchesV2Args = {
  active?: InputMaybe<Scalars['Boolean']>;
  client_id?: InputMaybe<Scalars['String']>;
  department_ids?: InputMaybe<Array<Scalars['ID']>>;
  location_ids?: InputMaybe<Array<Scalars['ID']>>;
  next_id?: InputMaybe<Scalars['String']>;
  onboarding_completed?: InputMaybe<Scalars['Boolean']>;
  q?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SearchSortFieldsV2>;
  user_status?: InputMaybe<UserStatus>;
  user_type?: InputMaybe<UserType>;
};


export type QueryGetUserSegmentArgs = {
  id: Scalars['ID'];
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetUserSegmentOthersArgs = {
  id: Scalars['ID'];
};


export type QueryGetUserSegmentOthersPresignedUrlArgs = {
  id: Scalars['ID'];
};


export type QueryGetUserSegmentUsersArgs = {
  active: Scalars['Boolean'];
  count?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  override?: InputMaybe<OverrideInput>;
};


export type QueryGetUserSegmentsArgs = {
  override?: InputMaybe<OverrideInput>;
  segment_status?: InputMaybe<SegmentStatus>;
};


export type QueryGetUserSocialConnectionsArgs = {
  user_id: Scalars['String'];
};


export type QueryGetUsersByEmailAddressArgs = {
  email_address_list: Array<InputMaybe<Scalars['String']>>;
};


export type QueryInternalOverviewStatsArgs = {
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
};


export type QueryIsGroupModeratorArgs = {
  group_id: Scalars['ID'];
  user_id: Scalars['ID'];
};


export type QueryOauthClientDetailsArgs = {
  data: OauthClientInput;
};


export type QueryOauthClientSecretAdminArgs = {
  data: OauthClientInput;
};


export type QueryPreviewUrlArgs = {
  app_source?: InputMaybe<Scalars['String']>;
  content: ContentInput;
};


export type QueryReachOverviewStatsArgs = {
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
};


export type QueryRecommendContentArgs = {
  auto_exclude_sharing?: InputMaybe<Scalars['Boolean']>;
  auto_restrict_groups?: InputMaybe<Scalars['Boolean']>;
  auto_weight_groups?: InputMaybe<Scalars['Boolean']>;
  exclude_content_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  for_sharing?: InputMaybe<Scalars['Boolean']>;
  override?: InputMaybe<OverrideInput>;
  restrict_group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  results_from: Scalars['Int'];
  size: Scalars['Int'];
};


export type QueryRoiClicksOverviewStatsArgs = {
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  facebook_currency_value?: InputMaybe<Scalars['Float']>;
  linkedin_currency_value?: InputMaybe<Scalars['Float']>;
  start_date: Scalars['String'];
  twitter_currency_value?: InputMaybe<Scalars['Float']>;
};


export type QueryRoiEngagementsOverviewStatsArgs = {
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  facebook_currency_value?: InputMaybe<Scalars['Float']>;
  linkedin_currency_value?: InputMaybe<Scalars['Float']>;
  start_date: Scalars['String'];
  twitter_currency_value?: InputMaybe<Scalars['Float']>;
};


export type QueryRoiImpressionsOverviewStatsArgs = {
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  linkedin_currency_value?: InputMaybe<Scalars['Float']>;
  start_date: Scalars['String'];
  twitter_currency_value?: InputMaybe<Scalars['Float']>;
};


export type QueryRoiReachOverviewStatsArgs = {
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  linkedin_currency_value?: InputMaybe<Scalars['Float']>;
  start_date: Scalars['String'];
  twitter_currency_value?: InputMaybe<Scalars['Float']>;
};


export type QuerySearchArgs = {
  auto_exclude?: InputMaybe<Scalars['Boolean']>;
  documents: Array<InputMaybe<SearchDocuments>>;
  exclude_group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  exclude_profile_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  override?: InputMaybe<OverrideInput>;
  q?: InputMaybe<Scalars['String']>;
  q_documents_must_match?: InputMaybe<Array<InputMaybe<SearchDocuments>>>;
  required_department_id?: InputMaybe<Scalars['ID']>;
  required_location_id?: InputMaybe<Scalars['ID']>;
  results_from: Scalars['Int'];
  size: Scalars['Int'];
  sort?: InputMaybe<SearchSortFields>;
  sort_direction?: InputMaybe<SearchSortDirections>;
};


export type QuerySearchAggregatesArgs = {
  document: SearchDocuments;
  override?: InputMaybe<OverrideInput>;
};


export type QuerySearchClientBillingReportAggregateArgs = {
  last_evaluated_key?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  search_filter?: InputMaybe<ClientBillingReportAggregateSearchFilter>;
};


export type QuerySearchClientInvitationsArgs = {
  count?: InputMaybe<Scalars['Boolean']>;
  last_evaluated_key?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  report?: InputMaybe<Scalars['Boolean']>;
  search_filter?: InputMaybe<ClientInvitationSearchFilter>;
};


export type QuerySearchClientsArgs = {
  count?: InputMaybe<Scalars['Boolean']>;
  last_evaluated_key?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  report?: InputMaybe<Scalars['Boolean']>;
  search_filter?: InputMaybe<ClientSearchFilter>;
};


export type QuerySearchCompaniesArgs = {
  query: Scalars['String'];
};


export type QuerySearchContentArgs = {
  search_content: SearchContentInput;
};


export type QuerySearchEveryoneSocialArgs = {
  data: SearchEveryoneSocialInput;
};


export type QuerySearchScimTokensArgs = {
  count?: InputMaybe<Scalars['Boolean']>;
  last_evaluated_key?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  search_filter?: InputMaybe<ScimTokenSearchFilter>;
};


export type QuerySortedGroupsArgs = {
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  filter?: InputMaybe<ReportingFilter>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  report?: InputMaybe<ReportNames>;
  snapshot?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<GroupsSortFields>;
  sort_direction?: InputMaybe<SortDirections>;
  start_date: Scalars['String'];
};


export type QuerySortedLeaderboardsArgs = {
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  leaderboard_config_id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  report?: InputMaybe<ReportNames>;
  start_date: Scalars['String'];
};


export type QuerySortedPostsArgs = {
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  filter?: InputMaybe<ReportingFilter>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  report?: InputMaybe<ReportNames>;
  snapshot?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<PostsSortFields>;
  sort_direction?: InputMaybe<SortDirections>;
  start_date: Scalars['String'];
};


export type QuerySortedSharesArgs = {
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  filter?: InputMaybe<ReportingFilter>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  report?: InputMaybe<ReportNames>;
  snapshot?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<SharesSortFields>;
  sort_direction?: InputMaybe<SortDirections>;
  start_date: Scalars['String'];
};


export type QuerySortedUsersArgs = {
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  filter?: InputMaybe<ReportingFilter>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  report?: InputMaybe<ReportNames>;
  snapshot?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<UsersSortFields>;
  sort_direction?: InputMaybe<SortDirections>;
  start_date: Scalars['String'];
};


export type QuerySuggestArgs = {
  index?: InputMaybe<SuggestIndex>;
  override?: InputMaybe<OverrideInput>;
  prefix: Scalars['String'];
};


export type QueryUserActivityStatsArgs = {
  end_date: Scalars['String'];
  start_date: Scalars['String'];
  user_id: Scalars['ID'];
};


export type QueryUserDailyStatsArgs = {
  grouping: StatsGrouping;
  user_id: Scalars['ID'];
};


export type QueryUserEngagementComparisonArgs = {
  user_id: Scalars['ID'];
};


export type QueryUserEngagementHistoryArgs = {
  content_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  exclude_internal?: InputMaybe<Scalars['Boolean']>;
  format?: InputMaybe<EngagementHistoryFormat>;
  limit?: InputMaybe<Scalars['Int']>;
  network_profile_id?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  timestamp_end?: InputMaybe<Scalars['Float']>;
  timestamp_start?: InputMaybe<Scalars['Float']>;
  user_id: Scalars['ID'];
};


export type QueryUserEngagementStatsArgs = {
  grouping: StatsGrouping;
  user_id: Scalars['ID'];
  value: Scalars['Int'];
};


export type QueryUserHasLeaderboardsArgs = {
  user_id?: InputMaybe<Scalars['ID']>;
};


export type QueryUserReachStatsArgs = {
  grouping: StatsGrouping;
  user_id: Scalars['ID'];
  value: Scalars['Int'];
};


export type QueryUserTrendingStatsArgs = {
  grouping: StatsGrouping;
  user_id: Scalars['ID'];
  value: Scalars['Int'];
};

export type RoiCurrencyValues = {
  clicks_facebook?: Maybe<Scalars['Float']>;
  clicks_linkedin?: Maybe<Scalars['Float']>;
  clicks_twitter?: Maybe<Scalars['Float']>;
  engagements_facebook?: Maybe<Scalars['Float']>;
  engagements_linkedin?: Maybe<Scalars['Float']>;
  engagements_twitter?: Maybe<Scalars['Float']>;
  impressions_linkedin?: Maybe<Scalars['Float']>;
  impressions_twitter?: Maybe<Scalars['Float']>;
  reach_linkedin?: Maybe<Scalars['Float']>;
  reach_twitter?: Maybe<Scalars['Float']>;
};

export type RoiCurrencyValuesInput = {
  clicks_facebook?: InputMaybe<Scalars['Float']>;
  clicks_linkedin?: InputMaybe<Scalars['Float']>;
  clicks_twitter?: InputMaybe<Scalars['Float']>;
  engagements_facebook?: InputMaybe<Scalars['Float']>;
  engagements_linkedin?: InputMaybe<Scalars['Float']>;
  engagements_twitter?: InputMaybe<Scalars['Float']>;
  impressions_facebook?: InputMaybe<Scalars['Float']>;
  impressions_linkedin?: InputMaybe<Scalars['Float']>;
  impressions_twitter?: InputMaybe<Scalars['Float']>;
  reach_linkedin?: InputMaybe<Scalars['Float']>;
  reach_twitter?: InputMaybe<Scalars['Float']>;
};

export type RoiDailyStat = {
  calendar_day: Scalars['String'];
  currency?: Maybe<Scalars['Float']>;
  previous_calendar_day?: Maybe<Scalars['String']>;
  previous_currency?: Maybe<Scalars['Float']>;
};

export type RoiIndividualStat = {
  change: Scalars['Float'];
  currency: Scalars['Float'];
  facebook?: Maybe<Scalars['Float']>;
  facebook_count?: Maybe<Scalars['Int']>;
  linkedin?: Maybe<Scalars['Float']>;
  linkedin_count?: Maybe<Scalars['Int']>;
  twitter?: Maybe<Scalars['Float']>;
  twitter_count?: Maybe<Scalars['Int']>;
};

export type RoiOverviewStat = {
  data?: Maybe<Array<Maybe<RoiDailyStat>>>;
  summary: RoiIndividualStat;
};

export type ReachDailyStat = {
  calendar_day: Scalars['String'];
  linkedin_reach: Scalars['Int'];
  reach?: Maybe<Scalars['Int']>;
  twitter_reach: Scalars['Int'];
};

export type ReachOverviewStat = {
  data?: Maybe<Array<Maybe<ReachDailyStat>>>;
  summary: ReachSummary;
};

export type ReachStat = {
  previous_reach?: Maybe<Scalars['Int']>;
  profile_identifier?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  reach: Scalars['Int'];
};

export type ReachSummary = {
  linkedin_reach: IndividualStat;
  reach: IndividualStat;
  twitter_reach: IndividualStat;
};

export type Reaction = {
  created_at: Scalars['Int'];
  object_id: Scalars['String'];
  object_type: ObjectType;
  reaction_type: ReactionType;
  user_id: Scalars['String'];
};

export type ReactionCount = {
  reaction_types?: Maybe<Array<Maybe<ReactionTypeCount>>>;
  total: Scalars['Int'];
};

export type ReactionInput = {
  object_id: Scalars['String'];
  object_type: ObjectType;
  reaction_type: ReactionType;
};

export enum ReactionType {
  Click = 'click',
  Comment = 'comment',
  Engagement = 'engagement',
  Like = 'like',
  Share = 'share'
}

export type ReactionTypeCount = {
  reaction_type?: Maybe<ReactionType>;
  total: Scalars['Int'];
};

export type RecommendedContentResults = {
  count: Scalars['Int'];
  results?: Maybe<Array<Maybe<Content>>>;
  results_from: Scalars['Int'];
};

export type ReconcileExpressActivatedUsersInput = {
  access_key: Scalars['String'];
  user_id: Scalars['ID'];
};

export type ReconcileExpressActivatedUsersResult = {
  message: Scalars['String'];
  results: Array<Maybe<ReconciledUserResult>>;
};

export type ReconciledUserResult = {
  access_key: Scalars['String'];
  oauth_token_id?: Maybe<Scalars['String']>;
  user_id: Scalars['String'];
};

export type RedditMetadata = {
  archived: Scalars['Boolean'];
  author: Scalars['String'];
  author_id: Scalars['String'];
  created_utc: Scalars['Int'];
  distinguished?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  is_original_content: Scalars['Boolean'];
  is_self: Scalars['Boolean'];
  is_video: Scalars['Boolean'];
  media_only: Scalars['Boolean'];
  name: Scalars['String'];
  num_comments?: Maybe<Scalars['Int']>;
  oembed_description?: Maybe<Scalars['String']>;
  oembed_height?: Maybe<Scalars['Int']>;
  oembed_html?: Maybe<Scalars['String']>;
  oembed_html_secure?: Maybe<Scalars['String']>;
  oembed_provider_name?: Maybe<Scalars['String']>;
  oembed_provider_url?: Maybe<Scalars['String']>;
  oembed_thumbnail_bucket?: Maybe<Scalars['String']>;
  oembed_thumbnail_file_key?: Maybe<Scalars['String']>;
  oembed_thumbnail_height?: Maybe<Scalars['Int']>;
  oembed_thumbnail_url?: Maybe<Scalars['String']>;
  oembed_thumbnail_width?: Maybe<Scalars['Int']>;
  oembed_title?: Maybe<Scalars['String']>;
  oembed_type?: Maybe<Scalars['String']>;
  oembed_width?: Maybe<Scalars['Int']>;
  over_18: Scalars['Boolean'];
  permalink: Scalars['String'];
  preview_image_bucket?: Maybe<Scalars['String']>;
  preview_image_file_key?: Maybe<Scalars['String']>;
  preview_image_height?: Maybe<Scalars['Int']>;
  preview_image_url?: Maybe<Scalars['String']>;
  preview_image_width?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  selftext?: Maybe<Scalars['String']>;
  selftext_html?: Maybe<Scalars['String']>;
  spoiler: Scalars['Boolean'];
  subreddit: Scalars['String'];
  subreddit_id: Scalars['String'];
  subreddit_name_prefixed: Scalars['String'];
  subreddit_type: Scalars['String'];
  subscribers?: Maybe<Scalars['Int']>;
  thumbnail_bucket?: Maybe<Scalars['String']>;
  thumbnail_file_key?: Maybe<Scalars['String']>;
  thumbnail_height?: Maybe<Scalars['Int']>;
  thumbnail_url?: Maybe<Scalars['String']>;
  thumbnail_width?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  url: Scalars['String'];
  video_duration?: Maybe<Scalars['Int']>;
  video_height?: Maybe<Scalars['Int']>;
  video_url?: Maybe<Scalars['String']>;
  video_width?: Maybe<Scalars['Int']>;
};

export type RedditMetadataInput = {
  archived: Scalars['Boolean'];
  author: Scalars['String'];
  author_id: Scalars['String'];
  created_utc: Scalars['Int'];
  distinguished?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  is_original_content: Scalars['Boolean'];
  is_self: Scalars['Boolean'];
  is_video: Scalars['Boolean'];
  media_only: Scalars['Boolean'];
  name: Scalars['String'];
  num_comments?: InputMaybe<Scalars['Int']>;
  oembed_description?: InputMaybe<Scalars['String']>;
  oembed_height?: InputMaybe<Scalars['Int']>;
  oembed_html?: InputMaybe<Scalars['String']>;
  oembed_html_secure?: InputMaybe<Scalars['String']>;
  oembed_provider_name?: InputMaybe<Scalars['String']>;
  oembed_provider_url?: InputMaybe<Scalars['String']>;
  oembed_thumbnail_bucket?: InputMaybe<Scalars['String']>;
  oembed_thumbnail_file_key?: InputMaybe<Scalars['String']>;
  oembed_thumbnail_height?: InputMaybe<Scalars['Int']>;
  oembed_thumbnail_url?: InputMaybe<Scalars['String']>;
  oembed_thumbnail_width?: InputMaybe<Scalars['Int']>;
  oembed_title?: InputMaybe<Scalars['String']>;
  oembed_type?: InputMaybe<Scalars['String']>;
  oembed_width?: InputMaybe<Scalars['Int']>;
  over_18: Scalars['Boolean'];
  permalink: Scalars['String'];
  preview_image_bucket?: InputMaybe<Scalars['String']>;
  preview_image_file_key?: InputMaybe<Scalars['String']>;
  preview_image_height?: InputMaybe<Scalars['Int']>;
  preview_image_url?: InputMaybe<Scalars['String']>;
  preview_image_width?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['Int']>;
  selftext?: InputMaybe<Scalars['String']>;
  selftext_html?: InputMaybe<Scalars['String']>;
  spoiler: Scalars['Boolean'];
  subreddit: Scalars['String'];
  subreddit_id: Scalars['String'];
  subreddit_name_prefixed: Scalars['String'];
  subreddit_type: Scalars['String'];
  subscribers?: InputMaybe<Scalars['Int']>;
  thumbnail_bucket?: InputMaybe<Scalars['String']>;
  thumbnail_file_key?: InputMaybe<Scalars['String']>;
  thumbnail_height?: InputMaybe<Scalars['Int']>;
  thumbnail_url?: InputMaybe<Scalars['String']>;
  thumbnail_width?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  url: Scalars['String'];
  video_duration?: InputMaybe<Scalars['Int']>;
  video_height?: InputMaybe<Scalars['Int']>;
  video_url?: InputMaybe<Scalars['String']>;
  video_width?: InputMaybe<Scalars['Int']>;
};

export enum RegistrationStatus {
  All = 'all',
  Registered = 'registered',
  Unregistered = 'unregistered'
}

export type ReleaseToggle = {
  client_count?: Maybe<Scalars['Int']>;
  clients?: Maybe<Array<Maybe<ClientReleaseToggle>>>;
  description?: Maybe<Scalars['String']>;
  entity_type?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['String']>;
};

export type Report = {
  available: Scalars['Boolean'];
  description: Scalars['String'];
  name: Scalars['String'];
};

export type ReportFilter = {
  filter_ids: Array<InputMaybe<Scalars['ID']>>;
  filter_type: ReportFilterType;
};

export enum ReportFilterType {
  Group = 'group',
  Leaderboard = 'leaderboard'
}

export enum ReportNames {
  Companies = 'companies',
  Employee = 'employee',
  Groups = 'groups',
  Leaderboards = 'leaderboards',
  PeopleNewest = 'people_newest',
  PeopleTop = 'people_top',
  Posts = 'posts',
  Shares = 'shares',
  SharesDetailed = 'shares_detailed',
  UserExternal = 'user_external',
  UserInternal = 'user_internal'
}

export type ReportRequest = {
  client_id: Scalars['ID'];
  end_at?: Maybe<Scalars['Int']>;
  error_details?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  report: Report;
  report_end: Scalars['Int'];
  report_start: Scalars['Int'];
  report_url?: Maybe<Scalars['String']>;
  request_status: ReportRequestStatus;
  requestor?: Maybe<PublicUserProfile>;
  start_at?: Maybe<Scalars['Int']>;
};

export type ReportRequestList = {
  count: Scalars['Int'];
  paginate: Scalars['Boolean'];
  report_requests?: Maybe<Array<Maybe<ReportRequest>>>;
};

export type ReportRequestListInput = {
  end_at?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  report_name?: InputMaybe<Scalars['String']>;
  requestor?: InputMaybe<Scalars['ID']>;
  start_at?: InputMaybe<Scalars['Int']>;
};

export enum ReportRequestStatus {
  Completed = 'Completed',
  Error = 'Error',
  Generating = 'Generating'
}

export type ReportResult = {
  request: ReportRequest;
  result: Scalars['String'];
};

export type ReportUrl = {
  request_id: Scalars['ID'];
  url: Scalars['String'];
};

export type ReportingFilter = {
  department_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  segment_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type RunReportInput = {
  end_at?: InputMaybe<Scalars['Int']>;
  filter_by?: InputMaybe<Array<InputMaybe<ReportFilter>>>;
  group_by?: InputMaybe<StatsGrouping>;
  report_name: Scalars['String'];
  start_at?: InputMaybe<Scalars['Int']>;
};

export type S3Object = {
  bucket: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  key: Scalars['String'];
  region: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type S3ObjectInput = {
  bucket: Scalars['String'];
  height?: InputMaybe<Scalars['Int']>;
  key: Scalars['String'];
  localUri?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  region: Scalars['String'];
  width?: InputMaybe<Scalars['Int']>;
};

export type S3SignedUrl = {
  fields_json: Scalars['String'];
  url: Scalars['String'];
};

export type S3SignedUrlMultiPart = {
  upload_id: Scalars['String'];
  upload_urls?: Maybe<Array<Scalars['String']>>;
};

export type S3SignedUrlOnly = {
  url: Scalars['String'];
};

export type S3VideoObject = {
  bucket?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  playlist?: Maybe<Scalars['String']>;
  poster?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  thumbnails?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type S3VideoObjectInput = {
  bucket: Scalars['String'];
  key: Scalars['String'];
  localUri?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  playlist?: InputMaybe<Scalars['String']>;
  poster?: InputMaybe<Scalars['String']>;
  region: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  thumbnails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ScheduleObject = {
  expire?: Maybe<Scalars['Int']>;
  publish?: Maybe<Scalars['Int']>;
};

export type ScheduleObjectInput = {
  expire?: InputMaybe<Scalars['Int']>;
  publish?: InputMaybe<Scalars['Int']>;
};

export type ScheduledShareContentInput = {
  items: Array<ScheduledShareUpdateInputItem>;
};

export type ScheduledShareItem = {
  id: Scalars['ID'];
  network: Scalars['String'];
  network_id: Scalars['ID'];
  share_at: Scalars['String'];
  share_session_id: Scalars['ID'];
  shared_at?: Maybe<Scalars['String']>;
  user_commentary: Scalars['String'];
};

export type ScheduledShareUpdateInputItem = {
  id: Scalars['ID'];
  network_id?: InputMaybe<Scalars['String']>;
  share_at?: InputMaybe<Scalars['Int']>;
  share_type?: InputMaybe<ShareType>;
  user_commentary?: InputMaybe<Scalars['String']>;
};

export type ScimToken = {
  client_id: Scalars['ID'];
  expires_at: Scalars['Int'];
  id: Scalars['ID'];
  not_valid_before: Scalars['Int'];
  rate_limit_max_requests: Scalars['Int'];
  rate_limit_window_duration: Scalars['Int'];
  rate_limit_window_end_at?: Maybe<Scalars['Int']>;
  user_id: Scalars['ID'];
};

export type ScimTokenInput = {
  client_id: Scalars['ID'];
  expires_at: Scalars['Int'];
  not_valid_before: Scalars['Int'];
  rate_limit_max_requests: Scalars['Int'];
  rate_limit_window_duration: Scalars['Int'];
  user_id: Scalars['ID'];
};

export type ScimTokenResultSet = {
  count?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<ScimToken>>>;
  last_evaluated_key?: Maybe<Scalars['String']>;
};

export type ScimTokenSearchFilter = {
  client_id__eq?: InputMaybe<Scalars['ID']>;
  user_id__eq?: InputMaybe<Scalars['ID']>;
};

export type SearchAggregates = {
  departments?: Maybe<Array<Maybe<ClientDepartment>>>;
  locations?: Maybe<Array<Maybe<ClientLocation>>>;
  total: Scalars['Int'];
};

export type SearchContentInput = {
  aggregate_content?: InputMaybe<Scalars['Boolean']>;
  approval: ContentApprovalTypes;
  commentary?: InputMaybe<Scalars['Boolean']>;
  content_type?: InputMaybe<ContentType>;
  created_after?: InputMaybe<Scalars['Int']>;
  created_before?: InputMaybe<Scalars['Int']>;
  group_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  is_branded?: InputMaybe<Scalars['Boolean']>;
  is_engageable?: InputMaybe<Scalars['Boolean']>;
  is_shareable?: InputMaybe<Scalars['Boolean']>;
  next_id?: InputMaybe<Scalars['String']>;
  search_text?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  sort_by?: InputMaybe<Array<InputMaybe<SearchContentSortParam>>>;
  source?: InputMaybe<PostSource>;
  submitter_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  submitter_role?: InputMaybe<SubmitterRole>;
};

export type SearchContentResults = {
  next_id?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<Content>>>;
  total_count: Scalars['Int'];
};

export enum SearchContentSortFields {
  ContentType = 'content_type',
  CreatedAt = 'created_at',
  FullName = 'full_name',
  GroupTitle = 'group_title',
  IsBranded = 'is_branded',
  PublishAt = 'publish_at',
  SubmitterRole = 'submitter_role',
  Title = 'title'
}

export type SearchContentSortParam = {
  direction: SortDirections;
  field: SearchContentSortFields;
};

export enum SearchDocuments {
  Content = 'content',
  Groups = 'groups',
  Profiles = 'profiles'
}

export enum SearchEveryoneSocialContent {
  Groups = 'groups',
  Posts = 'posts',
  Users = 'users'
}

export type SearchEveryoneSocialInput = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  post_filter?: InputMaybe<SearchPostsFilter>;
  search_string: Scalars['String'];
  search_types: Array<SearchEveryoneSocialContent>;
};

export type SearchEveryoneSocialResults = {
  cursor?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Maybe<MinimalGroup>>>;
  posts?: Maybe<Array<Maybe<MinimalPost>>>;
  users?: Maybe<Array<Maybe<MinimalUserProfile>>>;
};

export type SearchPostsFilter = {
  content_types?: InputMaybe<Array<InputMaybe<ContentType>>>;
  group_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  is_branded?: InputMaybe<Scalars['Boolean']>;
  is_engageable?: InputMaybe<Scalars['Boolean']>;
  is_shareable?: InputMaybe<Scalars['Boolean']>;
  published_after?: InputMaybe<Scalars['Int']>;
  published_before?: InputMaybe<Scalars['Int']>;
  share_status?: InputMaybe<PostShareStatus>;
  source?: InputMaybe<PostSource>;
  submitter_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchResults = {
  count: Scalars['Int'];
  results?: Maybe<Array<Maybe<SearchResultsObject>>>;
  results_from: Scalars['Int'];
};

export type SearchResultsObject = Content | Group | PublicUserProfile;

export enum SearchSortDirections {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SearchSortFields {
  CreatedAt = 'created_at',
  FollowerCount = 'follower_count',
  Title = 'title'
}

export enum SearchSortFieldsV2 {
  FullName = 'full_name',
  Title = 'title'
}

export type SegmentEventDetails = {
  event_args?: Maybe<Scalars['String']>;
  event_name?: Maybe<Scalars['String']>;
};

export enum SegmentEventType {
  SignupLoginExistingUserCreateClientClientCreated = 'signup_login_existing_user_create_client_client_created',
  SignupLoginExistingUserCreateClientClientModifiedCreateGroups = 'signup_login_existing_user_create_client_client_modified_create_groups',
  SignupLoginExistingUserCreateClientClientModifiedInviteColleagues = 'signup_login_existing_user_create_client_client_modified_invite_colleagues',
  SignupLoginExistingUserLoginClientSelected = 'signup_login_existing_user_login_client_selected',
  SignupLoginNewUserCreateClientClientCreated = 'signup_login_new_user_create_client_client_created',
  SignupLoginNewUserCreateClientClientModifiedCreateGroups = 'signup_login_new_user_create_client_client_modified_create_groups',
  SignupLoginNewUserCreateClientClientModifiedInviteColleagues = 'signup_login_new_user_create_client_client_modified_invite_colleagues',
  SignupLoginNewUserSignupClientUserModifiedConnectNetwork = 'signup_login_new_user_signup_client_user_modified_connect_network',
  SignupLoginNewUserSignupClientUserModifiedCreateUser = 'signup_login_new_user_signup_client_user_modified_create_user',
  SignupLoginNewUserSignupClientUserModifiedSelectDeptloc = 'signup_login_new_user_signup_client_user_modified_select_deptloc'
}

export enum SegmentStatus {
  Active = 'active',
  Disabled = 'disabled'
}

export enum ShareContentDestination {
  Direct = 'direct',
  Email = 'email',
  Facebook = 'facebook'
}

export type ShareContentInput = {
  destination?: InputMaybe<ShareContentDestination>;
  group_id?: InputMaybe<Scalars['String']>;
  mentions?: InputMaybe<Array<InputMaybe<MentionObjectInput>>>;
  network_id?: InputMaybe<Scalars['String']>;
  page_id?: InputMaybe<Scalars['String']>;
  photos?: InputMaybe<Array<S3ObjectInput>>;
  share_at?: InputMaybe<Scalars['Int']>;
  share_type?: InputMaybe<ShareType>;
  user_commentary?: InputMaybe<Scalars['String']>;
};

export type ShareSummary = {
  branded_shares: Scalars['Int'];
  change: Scalars['Float'];
  non_branded_shares: Scalars['Int'];
};

export enum ShareType {
  Auto = 'auto',
  Frontend = 'frontend',
  Now = 'now',
  Scheduled = 'scheduled'
}

export type SharedContentItem = {
  error?: Maybe<Scalars['String']>;
  network_id: Scalars['ID'];
  share_session_id: Scalars['ID'];
  shortened_url?: Maybe<ShortenedUrlItem>;
  status: SharedStatus;
  url?: Maybe<Scalars['String']>;
};

export type SharedContentResults = {
  results: Array<SharedContentItem>;
  warnings: Array<Maybe<ParseBlockListResult>>;
};

export enum SharedStatus {
  Failed = 'failed',
  Pending = 'pending',
  Successful = 'successful'
}

export type SharesItem = {
  clicks?: Maybe<Scalars['Int']>;
  client_id: Scalars['ID'];
  content?: Maybe<Content>;
  content_id: Scalars['ID'];
  created_at: Scalars['Int'];
  destination?: Maybe<Scalars['String']>;
  engagements?: Maybe<Scalars['Int']>;
  group_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifier?: Maybe<Scalars['String']>;
  impressions?: Maybe<Scalars['Int']>;
  network: Scalars['String'];
  network_id?: Maybe<Scalars['String']>;
  network_profile_name?: Maybe<Scalars['String']>;
  photo_share: Scalars['Boolean'];
  share_at: Scalars['Int'];
  share_content_type?: Maybe<Scalars['String']>;
  share_identifier?: Maybe<Scalars['String']>;
  share_session_id: Scalars['ID'];
  share_source?: Maybe<Scalars['String']>;
  share_type?: Maybe<Scalars['String']>;
  shared_at?: Maybe<Scalars['Int']>;
  successful: Scalars['Boolean'];
  urls: IUrls;
  user_commentary?: Maybe<Scalars['String']>;
  user_id: Scalars['ID'];
};

export type SharesList = {
  count: Scalars['Int'];
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  items: Array<SharesItem>;
  items_by_session?: Maybe<Array<Array<SharesItem>>>;
  limit?: Maybe<Scalars['Int']>;
  paginate: Scalars['Boolean'];
};

export enum SharesSortFields {
  ApprovedBy = 'approved_by',
  Branded = 'branded',
  Clicks = 'clicks',
  Engagements = 'engagements',
  FirstSharedAt = 'first_shared_at',
  Shares = 'shares',
  Title = 'title'
}

export type SharingChannelInfo = {
  channel_id: Scalars['String'];
  channel_name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ChannelRepostStatus>;
  team_id: Scalars['String'];
};

export type ShortenedUrLs = {
  direct?: Maybe<ShortenedUrlItem>;
  email?: Maybe<ShortenedUrlItem>;
  facebook?: Maybe<ShortenedUrlItem>;
  linkedin?: Maybe<ShortenedUrlItem>;
  twitter?: Maybe<ShortenedUrlItem>;
};

export type ShortenedUrlItem = {
  id?: Maybe<Scalars['String']>;
  short_link?: Maybe<Scalars['String']>;
};

export type SocialAccount = {
  expires_soon: Scalars['Boolean'];
  id: Scalars['String'];
  identifier?: Maybe<Scalars['String']>;
  profile_name?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['String']>;
  profile_url?: Maybe<Scalars['String']>;
  provider: Network;
  reach?: Maybe<Scalars['Int']>;
  smart_schedule?: Maybe<Scalars['Boolean']>;
};

export type SocialAccountConnection = {
  item: SocialAccount;
  pages?: Maybe<Array<Maybe<LinkedInPage>>>;
};

export type SocialAccountConnections = {
  items: Array<Maybe<SocialAccountConnection>>;
};

export type SocialAccountConnectionsList = {
  count: Scalars['Int'];
  items: Array<SocialAccount>;
  pages?: Maybe<Array<Maybe<LinkedInPage>>>;
};

export type SocialConfig = {
  facebook_engageable?: Maybe<Scalars['Boolean']>;
  facebook_shareable?: Maybe<Scalars['Boolean']>;
  instagram_engageable?: Maybe<Scalars['Boolean']>;
  instagram_shareable?: Maybe<Scalars['Boolean']>;
  linkedin_engageable?: Maybe<Scalars['Boolean']>;
  linkedin_shareable?: Maybe<Scalars['Boolean']>;
  reddit_engageable?: Maybe<Scalars['Boolean']>;
  reddit_shareable?: Maybe<Scalars['Boolean']>;
  tiktok_engageable?: Maybe<Scalars['Boolean']>;
  tiktok_shareable?: Maybe<Scalars['Boolean']>;
  twitter_engageable?: Maybe<Scalars['Boolean']>;
  twitter_shareable?: Maybe<Scalars['Boolean']>;
  wechat_engageable?: Maybe<Scalars['Boolean']>;
  wechat_shareable?: Maybe<Scalars['Boolean']>;
  weibo_engageable?: Maybe<Scalars['Boolean']>;
  weibo_shareable?: Maybe<Scalars['Boolean']>;
  youtube_engageable?: Maybe<Scalars['Boolean']>;
  youtube_shareable?: Maybe<Scalars['Boolean']>;
};

export type SocialConfigInput = {
  facebook_engageable?: InputMaybe<Scalars['Boolean']>;
  facebook_shareable?: InputMaybe<Scalars['Boolean']>;
  instagram_engageable?: InputMaybe<Scalars['Boolean']>;
  instagram_shareable?: InputMaybe<Scalars['Boolean']>;
  linkedin_engageable?: InputMaybe<Scalars['Boolean']>;
  linkedin_shareable?: InputMaybe<Scalars['Boolean']>;
  reddit_engageable?: InputMaybe<Scalars['Boolean']>;
  reddit_shareable?: InputMaybe<Scalars['Boolean']>;
  tiktok_engageable?: InputMaybe<Scalars['Boolean']>;
  tiktok_shareable?: InputMaybe<Scalars['Boolean']>;
  twitter_engageable?: InputMaybe<Scalars['Boolean']>;
  twitter_shareable?: InputMaybe<Scalars['Boolean']>;
  wechat_engageable?: InputMaybe<Scalars['Boolean']>;
  wechat_shareable?: InputMaybe<Scalars['Boolean']>;
  weibo_engageable?: InputMaybe<Scalars['Boolean']>;
  weibo_shareable?: InputMaybe<Scalars['Boolean']>;
  youtube_engageable?: InputMaybe<Scalars['Boolean']>;
  youtube_shareable?: InputMaybe<Scalars['Boolean']>;
};

export enum SortDirections {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SortMode {
  Chronological = 'chronological',
  Trending = 'trending'
}

export type SortedGroup = {
  created_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  group_id: Scalars['ID'];
  members?: Maybe<Scalars['Int']>;
  posts?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type SortedLeaderboard = {
  department?: Maybe<Scalars['String']>;
  last_seen_at?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  rank: Scalars['Int'];
  score?: Maybe<Scalars['Float']>;
  user_id: Scalars['ID'];
};

export type SortedPost = {
  approved_by?: Maybe<Scalars['String']>;
  branded?: Maybe<Scalars['Boolean']>;
  comments?: Maybe<Scalars['Int']>;
  content_id: Scalars['ID'];
  created_at?: Maybe<Scalars['String']>;
  reactions?: Maybe<Scalars['Int']>;
  shares?: Maybe<Scalars['Int']>;
  submitted_by?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type SortedShare = {
  approved_by?: Maybe<Scalars['String']>;
  branded?: Maybe<Scalars['Boolean']>;
  clicks?: Maybe<Scalars['Int']>;
  content_id: Scalars['ID'];
  engagements?: Maybe<Scalars['Int']>;
  first_shared_at?: Maybe<Scalars['String']>;
  impressions?: Maybe<Scalars['Int']>;
  num_anonymous_users?: Maybe<Scalars['Int']>;
  shares?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SortedUser = {
  clicks?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['String']>;
  last_accessed_at?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onboarding_completed?: Maybe<Scalars['Boolean']>;
  posts?: Maybe<Scalars['Int']>;
  reach?: Maybe<Scalars['Int']>;
  shares?: Maybe<Scalars['Int']>;
  user_id: Scalars['ID'];
  user_status?: Maybe<UserStatus>;
  user_type?: Maybe<UserType>;
};

export enum SourceStatus {
  Active = 'active',
  Disabled = 'disabled'
}

export type SsoConfiguration = {
  app_client_id?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  identity_pool_id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['String']>;
  metadata_url?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  redirect_sign_out?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  user_pool_id?: Maybe<Scalars['String']>;
};

export type SsoConfigurationInput = {
  metadata?: InputMaybe<Scalars['String']>;
  metadata_url?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
};

export enum StatsGrouping {
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

export type Status = {
  status: Scalars['Boolean'];
};

export type StickerResponse = {
  client: Client;
  sticker: S3Object;
  success: Scalars['Boolean'];
};

export enum SubmitterRole {
  Admin = 'admin',
  Contributor = 'contributor',
  External = 'external',
  Moderator = 'moderator',
  Owner = 'owner',
  User = 'user'
}

export type Subscription = {
  followed?: Maybe<UserFeedFollow>;
  /**   "to_user_id" must be available in the result of the mutation for this subscription to work! */
  inboxItemCreated?: Maybe<Inbox>;
  onContentUpdate?: Maybe<UpdatedContent>;
  onMediaStatus?: Maybe<Content>;
  unfollowed?: Maybe<UserFeedFollow>;
};


export type SubscriptionFollowedArgs = {
  user_id: Scalars['ID'];
};


export type SubscriptionInboxItemCreatedArgs = {
  to_user_id: Scalars['ID'];
};


export type SubscriptionOnContentUpdateArgs = {
  client_id: Scalars['ID'];
};


export type SubscriptionOnMediaStatusArgs = {
  user_id: Scalars['ID'];
};


export type SubscriptionUnfollowedArgs = {
  user_id: Scalars['ID'];
};

export enum SuggestIndex {
  Suggestedgroups = 'suggestedgroups',
  Suggestedprofiles = 'suggestedprofiles'
}

export type SuggestionResults = {
  results?: Maybe<Array<Maybe<SuggestionResultsObject>>>;
};

export type SuggestionResultsObject = GroupSuggestion | ProfileSuggestion;

export type TaggedContentMeta = {
  tag_id: Scalars['String'];
  title: Scalars['String'];
};

export type TaggedContentMetaInput = {
  tag_id: Scalars['String'];
  title: Scalars['String'];
};

export type TeamInfo = {
  team_id: Scalars['String'];
  team_name?: Maybe<Scalars['String']>;
};

export type TrendingData = {
  calendar_day: Scalars['String'];
  clicks: Scalars['Int'];
  posts: Scalars['Int'];
  shares: Scalars['Int'];
};

export type TrendingEngagementStat = {
  data: Array<Maybe<TrendingData>>;
  total_clicks: Scalars['Int'];
  total_posts: Scalars['Int'];
  total_shares: Scalars['Int'];
};

export type TweetHashtag = {
  text: Scalars['String'];
};

export type TweetHashtagInput = {
  text: Scalars['String'];
};

export type TweetMedia = {
  media_url_https?: Maybe<Scalars['String']>;
  media_url_original?: Maybe<Scalars['String']>;
  media_url_proxy?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type TweetMediaInput = {
  media_url_https?: InputMaybe<Scalars['String']>;
  media_url_original?: InputMaybe<Scalars['String']>;
  media_url_proxy?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type TweetMetadata = {
  created_at?: Maybe<Scalars['String']>;
  favorite_count?: Maybe<Scalars['Int']>;
  hashtags?: Maybe<Array<Maybe<TweetHashtag>>>;
  id_str: Scalars['String'];
  in_reply_to_status_id_str?: Maybe<Scalars['String']>;
  in_reply_to_user_id_str?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Maybe<TweetMedia>>>;
  place?: Maybe<TweetPlace>;
  possibly_sensitive?: Maybe<Scalars['Boolean']>;
  retweet_count?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  urls?: Maybe<Array<Maybe<TweetUrl>>>;
  user: TweetUser;
  user_mentions?: Maybe<Array<Maybe<TweetUserMention>>>;
};

export type TweetMetadataInput = {
  created_at?: InputMaybe<Scalars['String']>;
  favorite_count?: InputMaybe<Scalars['Int']>;
  hashtags?: InputMaybe<Array<InputMaybe<TweetHashtagInput>>>;
  id_str: Scalars['String'];
  in_reply_to_status_id_str?: InputMaybe<Scalars['String']>;
  in_reply_to_user_id_str?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Array<InputMaybe<TweetMediaInput>>>;
  place?: InputMaybe<TweetPlaceInput>;
  possibly_sensitive?: InputMaybe<Scalars['Boolean']>;
  retweet_count?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
  urls?: InputMaybe<Array<InputMaybe<TweetUrlInput>>>;
  user: TweetUserInput;
  user_mentions?: InputMaybe<Array<InputMaybe<TweetUserMentionInput>>>;
};

export type TweetPlace = {
  country?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  place_type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TweetPlaceInput = {
  country?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  place_type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type TweetUrl = {
  display_url?: Maybe<Scalars['String']>;
  expanded_url?: Maybe<Scalars['String']>;
};

export type TweetUrlInput = {
  display_url?: InputMaybe<Scalars['String']>;
  expanded_url?: InputMaybe<Scalars['String']>;
};

export type TweetUser = {
  created_at?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  followers_count?: Maybe<Scalars['Int']>;
  friends_count?: Maybe<Scalars['Int']>;
  id_str: Scalars['String'];
  lang?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  profile_image_url_https?: Maybe<Scalars['String']>;
  profile_image_url_original?: Maybe<Scalars['String']>;
  profile_image_url_proxy?: Maybe<Scalars['Boolean']>;
  protected?: Maybe<Scalars['Boolean']>;
  screen_name: Scalars['String'];
  statuses_count?: Maybe<Scalars['Int']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type TweetUserInput = {
  created_at?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  followers_count?: InputMaybe<Scalars['Int']>;
  friends_count?: InputMaybe<Scalars['Int']>;
  id_str: Scalars['String'];
  lang?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  profile_image_url_https?: InputMaybe<Scalars['String']>;
  profile_image_url_original?: InputMaybe<Scalars['String']>;
  profile_image_url_proxy?: InputMaybe<Scalars['Boolean']>;
  protected?: InputMaybe<Scalars['Boolean']>;
  screen_name: Scalars['String'];
  statuses_count?: InputMaybe<Scalars['Int']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type TweetUserMention = {
  id_str?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  screen_name?: Maybe<Scalars['String']>;
};

export type TweetUserMentionInput = {
  id_str?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  screen_name?: InputMaybe<Scalars['String']>;
};

export type TwitterLeaderboardCategory = {
  general?: Maybe<Array<Maybe<LeaderboardEventScores>>>;
};

export type TwitterLeaderboardCategoryInput = {
  general?: InputMaybe<Array<InputMaybe<LeaderboardEventScoreInput>>>;
};

export enum UniqueClientKey {
  EmailDomain = 'email_domain',
  Id = 'id',
  Provider = 'provider',
  Subdomain = 'subdomain'
}

export type UpdateClientDepartmentInput = {
  department_status?: InputMaybe<ClientDepartmentStatus>;
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateClientDisclosureInput = {
  disclosure?: InputMaybe<Scalars['String']>;
  disclosure_status?: InputMaybe<ClientDisclosureStatus>;
  id: Scalars['ID'];
};

export type UpdateClientFollowMappingInput = {
  all_users: Scalars['Boolean'];
  follow_condition_conjunction?: InputMaybe<Scalars['Boolean']>;
  follow_conditions?: InputMaybe<FollowConditionsInput>;
  id: Scalars['ID'];
  mapping_status: ClientFollowMappingStatus;
  required_group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  required_user_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  suggested_group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  suggested_user_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  title: Scalars['String'];
};

export type UpdateClientLocationInput = {
  id: Scalars['ID'];
  location_status?: InputMaybe<ClientLocationStatus>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateExpressActivatedUsersInput = {
  email: Scalars['String'];
  status: Scalars['String'];
};

export type UpdateExpressActivatedUsersResult = {
  message?: Maybe<Scalars['String']>;
  updated_users?: Maybe<Array<Maybe<UpdatedExpressActivatedUser>>>;
};

export type UpdateGroupInput = {
  allow_user_posts?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<GroupColor>;
  content_approval_type?: InputMaybe<GroupContentApprovalType>;
  department_id?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  group_status?: InputMaybe<GroupStatus>;
  icon?: InputMaybe<GroupIcon>;
  icon_color?: InputMaybe<GroupIconColor>;
  id: Scalars['ID'];
  image?: InputMaybe<S3ObjectInput>;
  is_private?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['ID']>;
  read_only?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateSocialConnectionInput = {
  smart_schedule?: InputMaybe<Scalars['Boolean']>;
  token_id: Scalars['String'];
};

export type UpdateSocialConnectionInputs = {
  linkedin_pages?: InputMaybe<Array<LinkedInPageInput>>;
  smart_schedule?: InputMaybe<Scalars['Boolean']>;
  token_id: Scalars['String'];
};

export type UpdateUserManagementUserProfileInput = {
  department_id?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  location_id?: InputMaybe<Scalars['ID']>;
  user_type?: InputMaybe<UserType>;
};

export type UpdateUserSegmentInput = {
  department_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  email_addresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id: Scalars['ID'];
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  others_csv?: InputMaybe<S3ObjectInput>;
  segment_status: SegmentStatus;
  title: Scalars['String'];
  user_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UpdatedContent = {
  click_count?: Maybe<Scalars['Int']>;
  client_id: Scalars['ID'];
  comment_count?: Maybe<Scalars['Int']>;
  commented_by?: Maybe<Array<Maybe<MinimalUserProfile>>>;
  content_id: Scalars['ID'];
  reacted_by?: Maybe<Array<Maybe<MinimalUserProfile>>>;
  reaction_count?: Maybe<Scalars['Int']>;
  share_count?: Maybe<Scalars['Int']>;
  shared_by?: Maybe<Array<Maybe<MinimalUserProfile>>>;
  user_id?: Maybe<Scalars['ID']>;
};

export type UpdatedExpressActivatedUser = {
  email_address: Scalars['String'];
  status: Scalars['String'];
  updated: Scalars['Boolean'];
};

export type UpsertBillingCustomerInput = {
  billing_address?: InputMaybe<BillingAddressInput>;
};

export type UrlMetadata = {
  description?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<UrlMetadataImage>>>;
  media?: Maybe<UrlMetadataMedia>;
  original_url?: Maybe<Scalars['String']>;
  provider_display?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_url?: Maybe<Scalars['String']>;
  safe?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type: UrlMetadataType;
  url?: Maybe<Scalars['String']>;
};

export type UrlMetadataImage = {
  bucket?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  file_key?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  primary?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  url_original?: Maybe<Scalars['String']>;
  url_proxy?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Int']>;
};

export type UrlMetadataImageInput = {
  bucket?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  file_key?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<Scalars['Int']>;
  url: Scalars['String'];
  url_original?: InputMaybe<Scalars['String']>;
  url_proxy?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type UrlMetadataInput = {
  description?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Array<InputMaybe<UrlMetadataImageInput>>>;
  media?: InputMaybe<UrlMetadataMediaInput>;
  original_url?: InputMaybe<Scalars['String']>;
  provider_display?: InputMaybe<Scalars['String']>;
  provider_name?: InputMaybe<Scalars['String']>;
  provider_url?: InputMaybe<Scalars['String']>;
  safe?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  type: UrlMetadataType;
  url?: InputMaybe<Scalars['String']>;
};

export type UrlMetadataMedia = {
  bucket?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  file_key?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  html?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  url_original?: Maybe<Scalars['String']>;
  url_proxy?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Int']>;
};

export type UrlMetadataMediaInput = {
  bucket?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  file_key?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  html?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
  url_original?: InputMaybe<Scalars['String']>;
  url_proxy?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type UrlMetadataOverrideInput = {
  description?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum UrlMetadataType {
  Audio = 'audio',
  Html = 'html',
  Image = 'image',
  Unknown = 'unknown',
  Video = 'video'
}

export type UserActivityStat = {
  daily_stats?: Maybe<Array<Maybe<ActivityStat>>>;
  percent_change?: Maybe<ActivityStat>;
  summary_stats?: Maybe<ActivityStat>;
};

export type UserClient = {
  client: Client;
  user_client_status: UserClientStatus;
};

export type UserClientResultSet = {
  count?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<UserClient>>;
  last_evaluated_key?: Maybe<Scalars['String']>;
};

export enum UserClientStatus {
  Active = 'active',
  ClientDisabled = 'client_disabled',
  InvitationRequired = 'invitation_required',
  SignUpAvailable = 'sign_up_available',
  UserDisabled = 'user_disabled'
}

export type UserFeedFollow = {
  created_at: Scalars['Int'];
  feed: FeedKey;
  followed_by_user: PublicUserProfile;
  group?: Maybe<Group>;
  group_role?: Maybe<GroupRole>;
  postable: Scalars['Boolean'];
  required?: Maybe<Scalars['Boolean']>;
  user?: Maybe<PublicUserProfile>;
  user_id: Scalars['ID'];
};

export type UserFollowMappings = {
  required_group_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  required_groups?: Maybe<Array<Maybe<Group>>>;
  required_user_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  required_users?: Maybe<Array<Maybe<PublicUserProfile>>>;
  suggested_group_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  suggested_groups?: Maybe<Array<Maybe<Group>>>;
  suggested_user_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  suggested_users?: Maybe<Array<Maybe<PublicUserProfile>>>;
};

export type UserMappings = {
  department_attr?: Maybe<Scalars['String']>;
  email_attr: Scalars['String'];
  external_user_mappings?: Maybe<ExternalUserMappings>;
  full_name_attr?: Maybe<Scalars['String']>;
  job_title_attr?: Maybe<Scalars['String']>;
  location_attr?: Maybe<Scalars['String']>;
  user_status_attr?: Maybe<Scalars['String']>;
  user_type_attr?: Maybe<Scalars['String']>;
};

export type UserMappingsInput = {
  department_attr?: InputMaybe<Scalars['String']>;
  email_attr: Scalars['String'];
  external_user_mappings?: InputMaybe<ExternalUserMappingsInput>;
  full_name_attr?: InputMaybe<Scalars['String']>;
  job_title_attr?: InputMaybe<Scalars['String']>;
  location_attr?: InputMaybe<Scalars['String']>;
  user_status_attr?: InputMaybe<Scalars['String']>;
  user_type_attr?: InputMaybe<Scalars['String']>;
};

export type UserProfile = {
  backup_email_address?: Maybe<Scalars['String']>;
  backup_email_address_verified?: Maybe<Scalars['Boolean']>;
  client_id: Scalars['ID'];
  created_at?: Maybe<Scalars['Int']>;
  deactivated_at?: Maybe<Scalars['Int']>;
  deactivated_by_user_id?: Maybe<Scalars['String']>;
  deactivated_message?: Maybe<Scalars['String']>;
  department?: Maybe<ClientDepartment>;
  department_id?: Maybe<Scalars['ID']>;
  department_title?: Maybe<Scalars['String']>;
  email_address: Scalars['String'];
  email_address_verified: Scalars['Boolean'];
  follower_count?: Maybe<Scalars['Int']>;
  full_name?: Maybe<Scalars['String']>;
  german_privacy?: Maybe<Scalars['Boolean']>;
  getstream_token?: Maybe<Scalars['String']>;
  group_moderator?: Maybe<Array<Maybe<GroupModerator>>>;
  id: Scalars['ID'];
  image?: Maybe<S3Object>;
  invitation_sent_at?: Maybe<Scalars['Int']>;
  job_title?: Maybe<Scalars['String']>;
  karma?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
  last_accessed_at?: Maybe<Scalars['Int']>;
  last_onboarding_step?: Maybe<Scalars['Int']>;
  last_setup_step?: Maybe<Scalars['Int']>;
  leaderboard_enabled?: Maybe<Scalars['Boolean']>;
  location?: Maybe<ClientLocation>;
  location_id?: Maybe<Scalars['ID']>;
  location_title?: Maybe<Scalars['String']>;
  notification_delivery_types?: Maybe<Array<Maybe<NotificationDeliveryType>>>;
  onboarding_completed?: Maybe<Scalars['Boolean']>;
  phone_number?: Maybe<Scalars['String']>;
  push_notification_configuration?: Maybe<Array<Maybe<PushNotificationConfiguration>>>;
  push_notifications_status?: Maybe<PushNotificationStatus>;
  reach?: Maybe<Scalars['Int']>;
  send_invitations?: Maybe<Scalars['Boolean']>;
  setup_completed?: Maybe<Scalars['Boolean']>;
  smart_schedule_acknowledgement?: Maybe<Scalars['Boolean']>;
  smart_schedule_viewed?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['Int']>;
  user_pool_id: Scalars['String'];
  user_status: UserStatus;
  user_timezone?: Maybe<Scalars['String']>;
  user_type: UserType;
};

export type UserProfileInput = {
  backup_email_address?: InputMaybe<Scalars['String']>;
  backup_email_address_verified?: InputMaybe<Scalars['Boolean']>;
  client_id?: InputMaybe<Scalars['ID']>;
  created_at?: InputMaybe<Scalars['Int']>;
  deactivated_at?: InputMaybe<Scalars['Int']>;
  deactivated_by_user_id?: InputMaybe<Scalars['String']>;
  deactivated_message?: InputMaybe<Scalars['String']>;
  delete_push_token?: InputMaybe<Scalars['String']>;
  department_id?: InputMaybe<Scalars['ID']>;
  email_address?: InputMaybe<Scalars['String']>;
  email_address_verified?: InputMaybe<Scalars['Boolean']>;
  full_name?: InputMaybe<Scalars['String']>;
  german_privacy?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image?: InputMaybe<S3ObjectInput>;
  impersonate_user_id?: InputMaybe<Scalars['ID']>;
  invitation_sent_at?: InputMaybe<Scalars['Int']>;
  job_title?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Scalars['String']>;
  last_accessed_at?: InputMaybe<Scalars['Int']>;
  last_onboarding_step?: InputMaybe<Scalars['Int']>;
  last_setup_step?: InputMaybe<Scalars['Int']>;
  location_id?: InputMaybe<Scalars['ID']>;
  notification_delivery_types?: InputMaybe<Array<InputMaybe<NotificationDeliveryType>>>;
  onboarding_completed?: InputMaybe<Scalars['Boolean']>;
  phone_number?: InputMaybe<Scalars['String']>;
  push_notification_configuration?: InputMaybe<Array<InputMaybe<PushNotificationConfigurationInput>>>;
  reach?: InputMaybe<Scalars['Int']>;
  send_invitations?: InputMaybe<Scalars['Boolean']>;
  setup_completed?: InputMaybe<Scalars['Boolean']>;
  smart_schedule_acknowledged?: InputMaybe<Scalars['Int']>;
  smart_schedule_acknowledgement?: InputMaybe<Scalars['Boolean']>;
  smart_schedule_viewed?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['Int']>;
  user_pool_id?: InputMaybe<Scalars['String']>;
  user_status?: InputMaybe<UserStatus>;
  user_timezone?: InputMaybe<Scalars['String']>;
  user_type?: InputMaybe<UserType>;
};

export type UserProfileOnboardingInput = {
  id?: InputMaybe<Scalars['ID']>;
  last_onboarding_step: Scalars['Int'];
  last_setup_step?: InputMaybe<Scalars['Int']>;
  onboarding_completed: Scalars['Boolean'];
  setup_completed?: InputMaybe<Scalars['Boolean']>;
};

export type UserProfilesByStatusList = {
  count: Scalars['Int'];
  full_name_lower?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  paginate: Scalars['Boolean'];
  profiles?: Maybe<Array<Maybe<UserProfile>>>;
};

export type UserProfilesByStatusListInput = {
  count?: InputMaybe<Scalars['Boolean']>;
  full_name_lower?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  user_status: UserStatus;
};

export type UserReachGraphData = {
  data?: Maybe<Array<UserReachGraphDataItem>>;
  summary: UserReachGraphSummary;
};

export type UserReachGraphDataItem = {
  calendar_day: Scalars['String'];
  company_reach: Scalars['Int'];
  linkedin_reach: Scalars['Int'];
  twitter_reach: Scalars['Int'];
};

export type UserReachGraphSummary = {
  company_reach: IndividualStat;
  linkedin_reach: IndividualStat;
  total_reach: IndividualStat;
  twitter_reach: IndividualStat;
};

export type UserSearchesV2Results = {
  next_id?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<UserProfile>>>;
  total_count: Scalars['Int'];
};

export type UserSegment = {
  client_id: Scalars['ID'];
  created_at?: Maybe<Scalars['Int']>;
  department_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  departments?: Maybe<Array<Maybe<ClientDepartment>>>;
  email_addresses?: Maybe<Array<Maybe<Scalars['String']>>>;
  group_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  groups?: Maybe<Array<Maybe<Group>>>;
  id: Scalars['ID'];
  location_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  locations?: Maybe<Array<Maybe<ClientLocation>>>;
  others_csv?: Maybe<S3Object>;
  registered_count?: Maybe<Scalars['Int']>;
  segment_status: SegmentStatus;
  third_party_count?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  user_id: Scalars['ID'];
  user_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<PublicUserProfile>>>;
};

export type UserSegmentUsers = {
  email_addresses?: Maybe<Array<Maybe<Scalars['String']>>>;
  email_addresses_count: Scalars['Int'];
  users?: Maybe<Array<Maybe<UserProfile>>>;
  users_count: Scalars['Int'];
};

export type UserSegmentsByStatusList = {
  count: Scalars['Int'];
  id?: Maybe<Scalars['ID']>;
  paginate: Scalars['Boolean'];
  segment_status?: Maybe<SegmentStatus>;
  title?: Maybe<Scalars['String']>;
  user_segments?: Maybe<Array<Maybe<UserSegment>>>;
};

export enum UserStatus {
  Active = 'active',
  Anonymous = 'anonymous',
  Deleted = 'deleted',
  Disabled = 'disabled',
  PreInitialized = 'pre_initialized'
}

export type UserSummary = {
  active_users: Scalars['Int'];
  change: Scalars['Float'];
  inactive_users: Scalars['Int'];
};

export enum UserType {
  Admin = 'admin',
  Contributor = 'contributor',
  Cs = 'cs',
  User = 'user'
}

export enum UsersSortFields {
  Clicks = 'clicks',
  CreatedAt = 'created_at',
  LastAccessedAt = 'last_accessed_at',
  Name = 'name',
  OnboardingCompleted = 'onboarding_completed',
  Posts = 'posts',
  Reach = 'reach',
  Shares = 'shares',
  UserType = 'user_type'
}

export type Webhook = {
  callback_url?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Maybe<Scalars['ID']>>>;
  webhook_id: Scalars['ID'];
  webhook_name: Scalars['String'];
  webhook_status: GenericStatus;
  webhook_type: WebhookTypes;
  workvivo_org_id?: Maybe<Scalars['String']>;
  workvivo_workspace_id?: Maybe<Scalars['String']>;
};

export enum WebhookEvents {
  ContentCreated = 'content_created',
  ContentDeleted = 'content_deleted',
  ContentPublished = 'content_published',
  ContentUpdated = 'content_updated'
}

export enum WebhookTypes {
  Generic = 'generic',
  Workvivo = 'workvivo'
}

export type Webhooks = {
  webhooks: Array<Maybe<Webhook>>;
};

export type WorkvivoWorkspace = {
  workspace_name: Scalars['String'];
  workvivo_workspace_id: Scalars['String'];
};

export type YoutubeMetadata = {
  channel_country?: Maybe<Scalars['String']>;
  channel_description?: Maybe<Scalars['String']>;
  channel_id?: Maybe<Scalars['String']>;
  channel_thumbnail_bucket?: Maybe<Scalars['String']>;
  channel_thumbnail_file_key?: Maybe<Scalars['String']>;
  channel_thumbnail_height?: Maybe<Scalars['Int']>;
  channel_thumbnail_original_url?: Maybe<Scalars['String']>;
  channel_thumbnail_width?: Maybe<Scalars['Int']>;
  channel_title?: Maybe<Scalars['String']>;
  channel_url?: Maybe<Scalars['String']>;
  video_definition?: Maybe<Scalars['String']>;
  video_description?: Maybe<Scalars['String']>;
  video_dimension?: Maybe<Scalars['String']>;
  video_duration?: Maybe<Scalars['String']>;
  video_id?: Maybe<Scalars['String']>;
  video_player?: Maybe<Scalars['String']>;
  video_projection?: Maybe<Scalars['String']>;
  video_published_at?: Maybe<Scalars['Int']>;
  video_thumbnail_bucket?: Maybe<Scalars['String']>;
  video_thumbnail_file_key?: Maybe<Scalars['String']>;
  video_thumbnail_height?: Maybe<Scalars['Int']>;
  video_thumbnail_original_url?: Maybe<Scalars['String']>;
  video_thumbnail_width?: Maybe<Scalars['Int']>;
  video_title?: Maybe<Scalars['String']>;
  video_url: Scalars['String'];
};

export type YoutubeMetadataInput = {
  channel_country?: InputMaybe<Scalars['String']>;
  channel_description?: InputMaybe<Scalars['String']>;
  channel_id?: InputMaybe<Scalars['String']>;
  channel_thumbnail_bucket?: InputMaybe<Scalars['String']>;
  channel_thumbnail_file_key?: InputMaybe<Scalars['String']>;
  channel_thumbnail_height?: InputMaybe<Scalars['Int']>;
  channel_thumbnail_original_url?: InputMaybe<Scalars['String']>;
  channel_thumbnail_width?: InputMaybe<Scalars['Int']>;
  channel_title?: InputMaybe<Scalars['String']>;
  channel_url?: InputMaybe<Scalars['String']>;
  video_definition?: InputMaybe<Scalars['String']>;
  video_description?: InputMaybe<Scalars['String']>;
  video_dimension?: InputMaybe<Scalars['String']>;
  video_duration?: InputMaybe<Scalars['String']>;
  video_id: Scalars['String'];
  video_player?: InputMaybe<Scalars['String']>;
  video_projection?: InputMaybe<Scalars['String']>;
  video_published_at?: InputMaybe<Scalars['Int']>;
  video_thumbnail_bucket?: InputMaybe<Scalars['String']>;
  video_thumbnail_file_key?: InputMaybe<Scalars['String']>;
  video_thumbnail_height?: InputMaybe<Scalars['Int']>;
  video_thumbnail_original_url?: InputMaybe<Scalars['String']>;
  video_thumbnail_width?: InputMaybe<Scalars['Int']>;
  video_title?: InputMaybe<Scalars['String']>;
  video_url: Scalars['String'];
};

export type ActivityStatFragment = { comments: number, reactions: number, posts: number, shares: number, engagements: number, clicks: number, impressions: number, calendar_day?: string | null | undefined };

export type AssignmentFragment = { id: string, title?: string | null | undefined, groups_required?: number | null | undefined, users_required?: number | null | undefined, groups_suggested?: number | null | undefined, users_suggested?: number | null | undefined, extracted_users?: number | null | undefined, active: boolean, target_user: AssignmentTargetUser, groups_required_objects?: Array<{ client_id: string, id: string, title: string, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, color_map: { hex: string, label: string, group_color?: GroupColor | null | undefined }, icon_color_map: { hex: string, label: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { bucket: string, label: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, groups_suggested_objects?: Array<{ client_id: string, id: string, title: string, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, color_map: { hex: string, label: string, group_color?: GroupColor | null | undefined }, icon_color_map: { hex: string, label: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { bucket: string, label: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, users_required_objects?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, users_suggested_objects?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, rule: { all_users: boolean, operator: AssignmentOperator, department_ids?: Array<string | null | undefined> | null | undefined, location_ids?: Array<string | null | undefined> | null | undefined } };

export type CapabilityFragment = { capability_id?: string | null | undefined, entity_type?: string | null | undefined, group?: string | null | undefined, description?: string | null | undefined, client_count?: number | null | undefined, clients?: Array<{ capability_id?: string | null | undefined, client_id?: string | null | undefined, entity_type?: string | null | undefined, quota?: number | null | undefined, usage?: number | null | undefined, client_title?: string | null | undefined, client_subdomain?: string | null | undefined, active?: boolean | null | undefined } | null | undefined> | null | undefined };

export type ChannelInfoFragment = { channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined };

export type ClientCommonFragment = { id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, content_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy_url?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, disclosures?: Array<{ id: string, disclosure: string, disclosure_status: ClientDisclosureStatus } | null | undefined> | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined };

export type ClientBillingReportAggregateFragment = { client_id: string, calendar_month: string, client_subdomain: string, created_at: string, updated_at: string, contract_committed_user_count?: number | null | undefined, contract_type?: ContractType | null | undefined, contract_end_at?: number | null | undefined, contract_start_at?: number | null | undefined, num_registered_users: number, num_anonymous_users: number, num_email_users: number, total_users: number, user_overage?: number | null | undefined, usage_rate?: number | null | undefined, last_month_total_users?: number | null | undefined, two_months_ago_total_users?: number | null | undefined, num_potential_users?: number | null | undefined, registered_rate?: number | null | undefined };

export type ClientCapabilityFragment = { capability_id?: string | null | undefined, client_id?: string | null | undefined, entity_type?: string | null | undefined, quota?: number | null | undefined, usage?: number | null | undefined, client_title?: string | null | undefined, client_subdomain?: string | null | undefined, active?: boolean | null | undefined };

export type ContentTagMetaResultsFragment = { title: string, tag_id: string, warning?: string | null | undefined };

export type ClientDepartmentFragment = { id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined };

export type ClientDisclosureFragment = { id: string, disclosure: string, disclosure_status: ClientDisclosureStatus };

export type ClientFollowMappingFragment = { id: string, title: string, mapping_status: ClientFollowMappingStatus, all_users?: boolean | null | undefined, follow_condition_conjunction?: boolean | null | undefined, required_groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, suggested_groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, required_users?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, suggested_users?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, follow_conditions?: { department_id?: Array<string | null | undefined> | null | undefined, location_id?: Array<string | null | undefined> | null | undefined, language?: Array<string | null | undefined> | null | undefined, email_domain?: Array<string | null | undefined> | null | undefined, departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ClientGroupSourceFragment = { id: string, group_id: string, source_status: SourceStatus, source_type: GroupSourceType, source_value: string, approval?: ContentApproval | null | undefined };

export type ClientInvitationFragment = { id: string, client_id: string, email_address: string, invitation_status: ClientInvitationStatus, created_at: number, updated_at: number, accepted_at?: number | null | undefined, user_type?: UserType | null | undefined, accepted_by_user?: { id: string, full_name?: string | null | undefined, email_address: string, user_status: UserStatus, onboarding_completed?: boolean | null | undefined, user_type: UserType } | null | undefined, added_by_user?: { id: string, full_name?: string | null | undefined, email_address: string } | null | undefined };

export type ClientLocationFragment = { id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined };

export type ClientPageMappingFragment = { active: boolean, connected_count: number, linkedin_page_id: string, name: string, token_ids?: Array<string> | null | undefined };

export type ClientProtectedFragment = { created_at: number, email_from_address?: string | null | undefined, allow_user_invites: boolean, content_domains?: Array<string | null | undefined> | null | undefined, allow_group_creation: boolean, disable_comments: boolean, allow_external_share: boolean, sort_mode?: SortMode | null | undefined, email_address?: string | null | undefined, sso_provider?: string | null | undefined, allow_sharing?: boolean | null | undefined, email_sending_domain?: string | null | undefined, compliance_notification_emails?: Array<string | null | undefined> | null | undefined, compliance_notification_enabled?: boolean | null | undefined, moderator_can_mark_as_important?: boolean | null | undefined, is_self_serve?: boolean | null | undefined, referral_headline?: string | null | undefined, referral_message?: string | null | undefined, stickers_enabled?: boolean | null | undefined, features?: Array<Feature | null | undefined> | null | undefined, setup_completed?: boolean | null | undefined, feature_plan_type?: FeaturePlanType | null | undefined, billing_status?: BillingStatusType | null | undefined, billing_type?: BillingTypeType | null | undefined, billing_teams_trial_start?: number | null | undefined, billing_teams_trial_end?: number | null | undefined, contract_committed_user_count?: number | null | undefined, contract_type?: ContractType | null | undefined, contract_end_at?: number | null | undefined, contract_start_at?: number | null | undefined, added_by_user_id: string, allow_group_discovery: boolean, allow_user_share_commentary: boolean, departments_in_signup: boolean, locations_in_signup: boolean, updated_at: number, menu_item_enabled?: boolean | null | undefined, yearly_enrichment_quota?: number | null | undefined, id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy_url?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, stickers?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, disclosures?: Array<{ id: string, disclosure: string, disclosure_status: ClientDisclosureStatus } | null | undefined> | null | undefined, social_config?: { twitter_shareable?: boolean | null | undefined, twitter_engageable?: boolean | null | undefined, linkedin_shareable?: boolean | null | undefined, linkedin_engageable?: boolean | null | undefined, facebook_shareable?: boolean | null | undefined, facebook_engageable?: boolean | null | undefined, youtube_shareable?: boolean | null | undefined, youtube_engageable?: boolean | null | undefined, instagram_shareable?: boolean | null | undefined, instagram_engageable?: boolean | null | undefined, reddit_shareable?: boolean | null | undefined, reddit_engageable?: boolean | null | undefined, tiktok_shareable?: boolean | null | undefined, tiktok_engageable?: boolean | null | undefined, weibo_shareable?: boolean | null | undefined, weibo_engageable?: boolean | null | undefined, wechat_shareable?: boolean | null | undefined, wechat_engageable?: boolean | null | undefined } | null | undefined, billing?: { billable_user_count: number, stripe_account_id: string, stripe_customer_id: string, stripe_price_id: string, stripe_product_id: string, stripe_subscription_id: string, stripe_subscription_item_id: string } | null | undefined, billing_address?: { address: string, address2?: string | null | undefined, city: string, state: string, zip: string, country: string } | null | undefined, menu_item?: { title: string, link: string } | null | undefined, icon?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, client_aliases?: Array<{ company_id: string, name: string } | null | undefined> | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined };

export type ClientPublicFragment = { id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, content_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy_url?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, disclosures?: Array<{ id: string, disclosure: string, disclosure_status: ClientDisclosureStatus } | null | undefined> | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined };

export type ClientReleaseToggleFragment = { release_id?: string | null | undefined, client_id?: string | null | undefined, entity_type?: string | null | undefined, quota?: number | null | undefined, usage?: number | null | undefined, client_title?: string | null | undefined, client_subdomain?: string | null | undefined, active?: boolean | null | undefined };

export type ClientUrlParamsFragment = { id: string, params_status?: ParamsStatus | null | undefined, content_domain: string, configuration?: Array<{ key: string, value?: string | null | undefined, dynamic_value?: ClientUrlParamsDynamicValues | null | undefined, value_options?: Array<string | null | undefined> | null | undefined, default_option_value?: string | null | undefined } | null | undefined> | null | undefined };

export type ContentFragment = { approval?: ContentApproval | null | undefined, content_id: string, content_source_id?: string | null | undefined, is_branded?: boolean | null | undefined, is_shareable?: boolean | null | undefined, is_important?: boolean | null | undefined, is_important_message?: string | null | undefined, is_engage?: boolean | null | undefined, is_engageable?: boolean | null | undefined, is_pinned?: boolean | null | undefined, pinned_end_at?: number | null | undefined, important_to_share?: boolean | null | undefined, reaction_count?: number | null | undefined, comment_count?: number | null | undefined, share_count?: number | null | undefined, engage_count?: number | null | undefined, click_count?: number | null | undefined, publish_at: number, group_ids: Array<string | null | undefined>, primary_group_id?: string | null | undefined, has_requesting_user_shared?: boolean | null | undefined, lock_commentary?: boolean | null | undefined, submitter_role?: SubmitterRole | null | undefined, user_id?: string | null | undefined, slack_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, ms_teams_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, pinned_to_groups?: Array<{ group_id: string, pinned_end_at?: number | null | undefined } | null | undefined> | null | undefined, commentary?: Array<{ network: Network, commentary: string, mentions?: Array<{ provider: string, identifier: string, start: number, length: number } | null | undefined> | null | undefined } | null | undefined> | null | undefined, disclosures?: Array<{ network: Network, disclosure_id: string } | null | undefined> | null | undefined, group_id_approvals: Array<{ group_id?: string | null | undefined, approval?: ContentApproval | null | undefined } | null | undefined>, content_object: { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id?: string | null | undefined } | null | undefined, instagram_metadata?: { id?: string | null | undefined, shortcode?: string | null | undefined } | null | undefined, reddit_metadata?: { url: string } | null | undefined }, reactions?: { user_reactions?: Array<ReactionType | null | undefined> | null | undefined, reaction_count?: { total: number } | null | undefined, reaction_user_details?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined, groups?: Array<{ id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, url_param_values?: Array<{ key: string, value?: string | null | undefined } | null | undefined> | null | undefined, reacted_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, shared_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, commented_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, schedule?: { publish?: number | null | undefined, expire?: number | null | undefined } | null | undefined, audit?: Array<{ ACTION: string, time?: number | null | undefined, by_user_id?: string | null | undefined, message?: string | null | undefined, by_user_profile?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, content_tags?: Array<{ title: string, tag_id: string } | null | undefined> | null | undefined };

export type ContentShareFragment = { content_id: string, share_count?: number | null | undefined, engagement_count?: number | null | undefined, engage_count?: number | null | undefined, reaction_count?: number | null | undefined, comment_count?: number | null | undefined, click_count?: number | null | undefined, publish_at: number, has_requesting_user_shared?: boolean | null | undefined, commentary?: Array<{ network: Network, commentary: string, mentions?: Array<{ provider: string, identifier: string, start: number, length: number } | null | undefined> | null | undefined } | null | undefined> | null | undefined, groups?: Array<{ id: string, title: string } | null | undefined> | null | undefined, content_object: { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id?: string | null | undefined } | null | undefined, instagram_metadata?: { id?: string | null | undefined, shortcode?: string | null | undefined } | null | undefined, reddit_metadata?: { url: string } | null | undefined } };

export type ContentAuditFragment = { ACTION: string, time?: number | null | undefined, by_user_id?: string | null | undefined, message?: string | null | undefined, by_user_profile?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined };

export type ContentDisclosuresFragment = { network: Network, disclosure_id: string };

export type ContentEmailHistoryFragment = { spec_id: string, sent_at: number, registered_user_count: number, unregistered_user_count: number, total_opened: number, total_emails: number, total_delivered: number, total_clicks: number, spec: { id: string, title: string, segment_ids: Array<string | null | undefined>, all_users: boolean, created_at?: number | null | undefined, send_at: number, delivery_interval?: number | null | undefined, grouping_interval?: number | null | undefined, banner_url?: string | null | undefined, intro?: string | null | undefined, footer?: string | null | undefined, email_from?: string | null | undefined, email_reply_to?: string | null | undefined, subject?: string | null | undefined, config_status?: GenericStatus | null | undefined, use_sto?: boolean | null | undefined, content_specs: Array<{ id?: string | null | undefined, content_type: ContentEmailType } | null | undefined>, banner?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined }, featured_content?: Array<{ approval?: ContentApproval | null | undefined, content_id: string, content_source_id?: string | null | undefined, is_branded?: boolean | null | undefined, is_shareable?: boolean | null | undefined, is_important?: boolean | null | undefined, is_important_message?: string | null | undefined, is_engage?: boolean | null | undefined, is_engageable?: boolean | null | undefined, is_pinned?: boolean | null | undefined, pinned_end_at?: number | null | undefined, important_to_share?: boolean | null | undefined, reaction_count?: number | null | undefined, comment_count?: number | null | undefined, share_count?: number | null | undefined, engage_count?: number | null | undefined, click_count?: number | null | undefined, publish_at: number, group_ids: Array<string | null | undefined>, primary_group_id?: string | null | undefined, has_requesting_user_shared?: boolean | null | undefined, lock_commentary?: boolean | null | undefined, submitter_role?: SubmitterRole | null | undefined, user_id?: string | null | undefined, slack_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, ms_teams_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, pinned_to_groups?: Array<{ group_id: string, pinned_end_at?: number | null | undefined } | null | undefined> | null | undefined, commentary?: Array<{ network: Network, commentary: string, mentions?: Array<{ provider: string, identifier: string, start: number, length: number } | null | undefined> | null | undefined } | null | undefined> | null | undefined, disclosures?: Array<{ network: Network, disclosure_id: string } | null | undefined> | null | undefined, group_id_approvals: Array<{ group_id?: string | null | undefined, approval?: ContentApproval | null | undefined } | null | undefined>, content_object: { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id?: string | null | undefined } | null | undefined, instagram_metadata?: { id?: string | null | undefined, shortcode?: string | null | undefined } | null | undefined, reddit_metadata?: { url: string } | null | undefined }, reactions?: { user_reactions?: Array<ReactionType | null | undefined> | null | undefined, reaction_count?: { total: number } | null | undefined, reaction_user_details?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined, groups?: Array<{ id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, url_param_values?: Array<{ key: string, value?: string | null | undefined } | null | undefined> | null | undefined, reacted_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, shared_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, commented_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, schedule?: { publish?: number | null | undefined, expire?: number | null | undefined } | null | undefined, audit?: Array<{ ACTION: string, time?: number | null | undefined, by_user_id?: string | null | undefined, message?: string | null | undefined, by_user_profile?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, content_tags?: Array<{ title: string, tag_id: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type ContentEmailSpecFragment = { id: string, title: string, segment_ids: Array<string | null | undefined>, all_users: boolean, created_at?: number | null | undefined, send_at: number, delivery_interval?: number | null | undefined, grouping_interval?: number | null | undefined, banner_url?: string | null | undefined, intro?: string | null | undefined, footer?: string | null | undefined, email_from?: string | null | undefined, email_reply_to?: string | null | undefined, subject?: string | null | undefined, config_status?: GenericStatus | null | undefined, use_sto?: boolean | null | undefined, content_specs: Array<{ id?: string | null | undefined, content_type: ContentEmailType } | null | undefined>, banner?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined };

export type ContentObjectFragment = { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id?: string | null | undefined } | null | undefined, instagram_metadata?: { id?: string | null | undefined, shortcode?: string | null | undefined } | null | undefined, reddit_metadata?: { url: string } | null | undefined };

export type ContentReactionsFragment = { user_reactions?: Array<ReactionType | null | undefined> | null | undefined, reaction_count?: { total: number } | null | undefined, reaction_user_details?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined };

export type ContentSharePreviewFragment = { suggested_share_time?: number | null | undefined, locked_commentary?: boolean | null | undefined, allowed_counts?: { twitter?: number | null | undefined, linkedin?: number | null | undefined, facebook?: number | null | undefined } | null | undefined, shortened_urls?: { email?: { short_link?: string | null | undefined } | null | undefined, direct?: { short_link?: string | null | undefined } | null | undefined, facebook?: { short_link?: string | null | undefined } | null | undefined } | null | undefined };

export type EbrProfilesCountFragment = { count: number, name: string, percentage: number };

export type ExpressActivatedUserNetworkFragment = { provider?: string | null | undefined, reach?: number | null | undefined, profile_image_url?: string | null | undefined, profile_name?: string | null | undefined, profile_url_suffix?: string | null | undefined };

export type ExpressActivatedUsersFragment = { email: string, access_key: string, created_at: number, status: string, registered_networks: Array<{ provider?: string | null | undefined, reach?: number | null | undefined, profile_image_url?: string | null | undefined, profile_name?: string | null | undefined, profile_url_suffix?: string | null | undefined } | null | undefined> };

export type GroupFragment = { id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined };

export type GetFeedGroupFragment = { id: string, title: string, color_map: { hex: string } };

export type UserFeedFollowGroupFragment = { id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined };

export type GroupModeratorFragment = { group_id: string, user_id: string, created_at: number, added_by_user_id: string, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined };

export type GroupSearchResultsFragment = { count: number, results_from: number, results?: Array<{ id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | {} | null | undefined> | null | undefined };

export type GroupSuggestionFragment = { id: string, title: string, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined };

export type InboxFragment = { id: string, created_at: number, updated_at: number, item_read: boolean, message: string, to_user_id: string, url?: string | null | undefined };

export type LeaderboardConfigFragment = { id: string, title: string, description?: string | null | undefined, leaderboard_status: GenericStatus, created_at: number, start_at?: number | null | undefined, end_at?: number | null | undefined, all_users: boolean, segment_ids?: Array<string | null | undefined> | null | undefined, segments?: Array<{ id: string, title: string, created_at?: number | null | undefined, segment_status: SegmentStatus, department_ids?: Array<string | null | undefined> | null | undefined, location_ids?: Array<string | null | undefined> | null | undefined, group_ids?: Array<string | null | undefined> | null | undefined, registered_count?: number | null | undefined, third_party_count?: number | null | undefined, departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, scoring_aggregate?: { everyonesocial?: { posting?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined, actions?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined, teammates?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, linkedin?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, twitter?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, facebook?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type LeaderboardEventAggregateFragment = { everyonesocial?: { posting?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined, actions?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined, teammates?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, linkedin?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, twitter?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, facebook?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined };

export type LeaderboardScoreFragment = { leaderboard_config_id: string, user_id: string, score: string, ranking: number, position_change?: number | null | undefined, user: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined }, events: Array<{ event: LeaderboardEventType, score: string } | null | undefined> };

export type LinkedInPageFragment = { id: string, identifier?: string | null | undefined, logo?: string | null | undefined, profile_name?: string | null | undefined, profile_url?: string | null | undefined, provider: Network, role?: string | null | undefined, urn?: string | null | undefined };

export type ManualNotificationsItemFragment = { id: string, notification_type?: ManualNotificationType | null | undefined, send_at: number, segment_ids: Array<string | null | undefined>, created_at: number, user_count?: number | null | undefined, email_count?: number | null | undefined, entire_company?: boolean | null | undefined, segments: Array<{ id: string, title: string } | null | undefined>, message: { body: string, url?: string | null | undefined }, email?: { subject: string, body: string, format?: ManualNotificationEmailFormat | null | undefined } | null | undefined };

export type MentionObjectFragment = { provider: string, identifier: string, start: number, length: number };

export type MinimalGroupFragment = { id: string, client_id: string, title: string, group_status: GroupStatus, is_private?: boolean | null | undefined, content_approval_type: GroupContentApprovalType, description?: string | null | undefined, allow_user_posts: boolean, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, created_at: number, updated_at?: number | null | undefined, follower_count?: number | null | undefined, read_only?: boolean | null | undefined, color_map: { label: string, hex: string, group_color?: GroupColor | null | undefined }, icon_color_map: { label: string, hex: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { label: string, bucket: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined };

export type MinimalPostFragment = { client_id: string, approval?: ContentApproval | null | undefined, content_id: string, created_at: number, publish_at: number, is_engage?: boolean | null | undefined, is_important?: boolean | null | undefined, is_branded?: boolean | null | undefined, is_shareable?: boolean | null | undefined, important_to_share?: boolean | null | undefined, is_engageable?: boolean | null | undefined, share_count?: number | null | undefined, engagement_count?: number | null | undefined, click_count?: number | null | undefined, comment_count?: number | null | undefined, reaction_count?: number | null | undefined, has_requesting_user_shared?: boolean | null | undefined, content_object: { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id?: string | null | undefined } | null | undefined, instagram_metadata?: { id?: string | null | undefined, shortcode?: string | null | undefined } | null | undefined, reddit_metadata?: { url: string } | null | undefined }, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, groups?: Array<{ id: string, client_id: string, title: string, group_status: GroupStatus, is_private?: boolean | null | undefined, content_approval_type: GroupContentApprovalType, description?: string | null | undefined, allow_user_posts: boolean, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, created_at: number, updated_at?: number | null | undefined, follower_count?: number | null | undefined, read_only?: boolean | null | undefined, color_map: { label: string, hex: string, group_color?: GroupColor | null | undefined }, icon_color_map: { label: string, hex: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { label: string, bucket: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, primary_group?: { id: string, client_id: string, title: string, group_status: GroupStatus, is_private?: boolean | null | undefined, content_approval_type: GroupContentApprovalType, description?: string | null | undefined, allow_user_posts: boolean, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, created_at: number, updated_at?: number | null | undefined, follower_count?: number | null | undefined, read_only?: boolean | null | undefined, color_map: { label: string, hex: string, group_color?: GroupColor | null | undefined }, icon_color_map: { label: string, hex: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { label: string, bucket: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined };

export type MinimalUserProfileFragment = { id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined };

export type ProfileSearchResultsFragment = { count: number, results_from: number, results?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | {} | null | undefined> | null | undefined };

export type ProfileSuggestionFragment = { id: string, title: string, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined };

export type PublicUserProfileFragment = { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined };

export type ReleaseToggleFragment = { release_id?: string | null | undefined, entity_type?: string | null | undefined, group?: string | null | undefined, description?: string | null | undefined, client_count?: number | null | undefined, clients?: Array<{ release_id?: string | null | undefined, client_id?: string | null | undefined, entity_type?: string | null | undefined, quota?: number | null | undefined, usage?: number | null | undefined, client_title?: string | null | undefined, client_subdomain?: string | null | undefined, active?: boolean | null | undefined } | null | undefined> | null | undefined };

export type RoiDailyStatFragment = { currency?: number | null | undefined, previous_currency?: number | null | undefined, calendar_day: string, previous_calendar_day?: string | null | undefined };

export type RoiIndividualStatFragment = { currency: number, change: number, facebook?: number | null | undefined, twitter?: number | null | undefined, linkedin?: number | null | undefined, facebook_count?: number | null | undefined, twitter_count?: number | null | undefined, linkedin_count?: number | null | undefined };

export type S3ObjectFragment = { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string };

export type S3VideoObjectFragment = { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, status?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined };

export type ScheduledShareItemFragment = { id: string, network: string, network_id: string, user_commentary: string, share_at: string, shared_at?: string | null | undefined, share_session_id: string };

export type ScimTokenFragment = { id: string, client_id: string, user_id: string, expires_at: number, not_valid_before: number, rate_limit_max_requests: number, rate_limit_window_duration: number };

export type SearchAggregatesFragment = { total: number, departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined };

export type SearchEveryoneSocialResultsFragment = { cursor?: string | null | undefined, posts?: Array<{ client_id: string, approval?: ContentApproval | null | undefined, content_id: string, created_at: number, publish_at: number, is_engage?: boolean | null | undefined, is_important?: boolean | null | undefined, is_branded?: boolean | null | undefined, is_shareable?: boolean | null | undefined, important_to_share?: boolean | null | undefined, is_engageable?: boolean | null | undefined, share_count?: number | null | undefined, engagement_count?: number | null | undefined, click_count?: number | null | undefined, comment_count?: number | null | undefined, reaction_count?: number | null | undefined, has_requesting_user_shared?: boolean | null | undefined, content_object: { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id?: string | null | undefined } | null | undefined, instagram_metadata?: { id?: string | null | undefined, shortcode?: string | null | undefined } | null | undefined, reddit_metadata?: { url: string } | null | undefined }, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, groups?: Array<{ id: string, client_id: string, title: string, group_status: GroupStatus, is_private?: boolean | null | undefined, content_approval_type: GroupContentApprovalType, description?: string | null | undefined, allow_user_posts: boolean, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, created_at: number, updated_at?: number | null | undefined, follower_count?: number | null | undefined, read_only?: boolean | null | undefined, color_map: { label: string, hex: string, group_color?: GroupColor | null | undefined }, icon_color_map: { label: string, hex: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { label: string, bucket: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, primary_group?: { id: string, client_id: string, title: string, group_status: GroupStatus, is_private?: boolean | null | undefined, content_approval_type: GroupContentApprovalType, description?: string | null | undefined, allow_user_posts: boolean, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, created_at: number, updated_at?: number | null | undefined, follower_count?: number | null | undefined, read_only?: boolean | null | undefined, color_map: { label: string, hex: string, group_color?: GroupColor | null | undefined }, icon_color_map: { label: string, hex: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { label: string, bucket: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, groups?: Array<{ id: string, client_id: string, title: string, group_status: GroupStatus, is_private?: boolean | null | undefined, content_approval_type: GroupContentApprovalType, description?: string | null | undefined, allow_user_posts: boolean, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, created_at: number, updated_at?: number | null | undefined, follower_count?: number | null | undefined, read_only?: boolean | null | undefined, color_map: { label: string, hex: string, group_color?: GroupColor | null | undefined }, icon_color_map: { label: string, hex: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { label: string, bucket: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, users?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined };

export type SegmentEventDetailsFragment = { event_name?: string | null | undefined, event_args?: string | null | undefined };

export type SharesItemFragment = { id: string, network: string, network_id?: string | null | undefined, identifier?: string | null | undefined, user_commentary?: string | null | undefined, share_at: number, shared_at?: number | null | undefined, share_session_id: string, clicks?: number | null | undefined, engagements?: number | null | undefined, impressions?: number | null | undefined, network_profile_name?: string | null | undefined, content?: { approval?: ContentApproval | null | undefined, content_id: string, content_source_id?: string | null | undefined, is_branded?: boolean | null | undefined, is_shareable?: boolean | null | undefined, is_important?: boolean | null | undefined, is_important_message?: string | null | undefined, is_engage?: boolean | null | undefined, is_engageable?: boolean | null | undefined, is_pinned?: boolean | null | undefined, pinned_end_at?: number | null | undefined, important_to_share?: boolean | null | undefined, reaction_count?: number | null | undefined, comment_count?: number | null | undefined, share_count?: number | null | undefined, engage_count?: number | null | undefined, click_count?: number | null | undefined, publish_at: number, group_ids: Array<string | null | undefined>, primary_group_id?: string | null | undefined, has_requesting_user_shared?: boolean | null | undefined, lock_commentary?: boolean | null | undefined, submitter_role?: SubmitterRole | null | undefined, user_id?: string | null | undefined, slack_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, ms_teams_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, pinned_to_groups?: Array<{ group_id: string, pinned_end_at?: number | null | undefined } | null | undefined> | null | undefined, commentary?: Array<{ network: Network, commentary: string, mentions?: Array<{ provider: string, identifier: string, start: number, length: number } | null | undefined> | null | undefined } | null | undefined> | null | undefined, disclosures?: Array<{ network: Network, disclosure_id: string } | null | undefined> | null | undefined, group_id_approvals: Array<{ group_id?: string | null | undefined, approval?: ContentApproval | null | undefined } | null | undefined>, content_object: { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id?: string | null | undefined } | null | undefined, instagram_metadata?: { id?: string | null | undefined, shortcode?: string | null | undefined } | null | undefined, reddit_metadata?: { url: string } | null | undefined }, reactions?: { user_reactions?: Array<ReactionType | null | undefined> | null | undefined, reaction_count?: { total: number } | null | undefined, reaction_user_details?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined, groups?: Array<{ id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, url_param_values?: Array<{ key: string, value?: string | null | undefined } | null | undefined> | null | undefined, reacted_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, shared_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, commented_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, schedule?: { publish?: number | null | undefined, expire?: number | null | undefined } | null | undefined, audit?: Array<{ ACTION: string, time?: number | null | undefined, by_user_id?: string | null | undefined, message?: string | null | undefined, by_user_profile?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, content_tags?: Array<{ title: string, tag_id: string } | null | undefined> | null | undefined } | null | undefined };

export type SocialAccountFragment = { id: string, provider: Network, identifier?: string | null | undefined, profile_name?: string | null | undefined, reach?: number | null | undefined, expires_soon: boolean, profile_url?: string | null | undefined, profile_picture?: string | null | undefined, smart_schedule?: boolean | null | undefined };

export type SocialAccountConnectionFragment = { item: { id: string, provider: Network, identifier?: string | null | undefined, profile_name?: string | null | undefined, reach?: number | null | undefined, expires_soon: boolean, profile_url?: string | null | undefined, profile_picture?: string | null | undefined, smart_schedule?: boolean | null | undefined }, pages?: Array<{ id: string, identifier?: string | null | undefined, logo?: string | null | undefined, profile_name?: string | null | undefined, profile_url?: string | null | undefined, provider: Network, role?: string | null | undefined, urn?: string | null | undefined } | null | undefined> | null | undefined };

export type TaggedContentMetaFragment = { title: string, tag_id: string };

export type TweetMetadataFragment = { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined };

export type UpdatedContentFragment = { user_id?: string | null | undefined, client_id: string, content_id: string, share_count?: number | null | undefined, click_count?: number | null | undefined, comment_count?: number | null | undefined, reaction_count?: number | null | undefined, shared_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, reacted_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, commented_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined };

export type UrlMetadataFragment = { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined };

export type UserFeedFollowFragment = { feed: FeedKey, user_id: string, created_at: number, postable: boolean, group_role?: GroupRole | null | undefined, required?: boolean | null | undefined, group?: { id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, followed_by_user: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } };

export type UserProfileFragment = { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, email_address_verified: boolean, user_type: UserType, user_status: UserStatus, user_pool_id: string, client_id: string, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, last_onboarding_step?: number | null | undefined, lang?: string | null | undefined, onboarding_completed?: boolean | null | undefined, last_accessed_at?: number | null | undefined, user_timezone?: string | null | undefined, created_at?: number | null | undefined, german_privacy?: boolean | null | undefined, reach?: number | null | undefined, notification_delivery_types?: Array<NotificationDeliveryType | null | undefined> | null | undefined, getstream_token?: string | null | undefined, setup_completed?: boolean | null | undefined, smart_schedule_acknowledgement?: boolean | null | undefined, smart_schedule_viewed?: boolean | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, group_moderator?: Array<{ group_id: string, user_id: string, created_at: number, added_by_user_id: string, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, push_notification_configuration?: Array<{ device_platform: string, token: string } | null | undefined> | null | undefined, push_notifications_status?: { paused: boolean, paused_at?: number | null | undefined } | null | undefined };

export type UserProfileSearchFragment = { id: string, client_id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, email_address: string, user_type: UserType, user_status: UserStatus, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, follower_count?: number | null | undefined, reach?: number | null | undefined, last_accessed_at?: number | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined };

export type UserSegmentFragment = { id: string, title: string, created_at?: number | null | undefined, segment_status: SegmentStatus, department_ids?: Array<string | null | undefined> | null | undefined, location_ids?: Array<string | null | undefined> | null | undefined, group_ids?: Array<string | null | undefined> | null | undefined, registered_count?: number | null | undefined, third_party_count?: number | null | undefined, departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined };

export type WebhookFragment = { callback_url?: string | null | undefined, webhook_status: GenericStatus, webhook_id: string, webhook_name: string, webhook_type: WebhookTypes, workvivo_org_id?: string | null | undefined, workvivo_workspace_id?: string | null | undefined, groups?: Array<string | null | undefined> | null | undefined };

export type AddReactionAnalyticsMutationVariables = Exact<{
  content_id: Scalars['String'];
  reaction_type: ReactionType;
}>;


export type AddReactionAnalyticsMutation = { addReactionAnalytics: boolean };

export type AdminUpdateClientMutationVariables = Exact<{
  data: AdminUpdateClientInput;
}>;


export type AdminUpdateClientMutation = { adminUpdateClient: { created_at: number, email_from_address?: string | null | undefined, allow_user_invites: boolean, content_domains?: Array<string | null | undefined> | null | undefined, allow_group_creation: boolean, disable_comments: boolean, allow_external_share: boolean, sort_mode?: SortMode | null | undefined, email_address?: string | null | undefined, sso_provider?: string | null | undefined, allow_sharing?: boolean | null | undefined, email_sending_domain?: string | null | undefined, compliance_notification_emails?: Array<string | null | undefined> | null | undefined, compliance_notification_enabled?: boolean | null | undefined, moderator_can_mark_as_important?: boolean | null | undefined, is_self_serve?: boolean | null | undefined, referral_headline?: string | null | undefined, referral_message?: string | null | undefined, stickers_enabled?: boolean | null | undefined, features?: Array<Feature | null | undefined> | null | undefined, setup_completed?: boolean | null | undefined, feature_plan_type?: FeaturePlanType | null | undefined, billing_status?: BillingStatusType | null | undefined, billing_type?: BillingTypeType | null | undefined, billing_teams_trial_start?: number | null | undefined, billing_teams_trial_end?: number | null | undefined, contract_committed_user_count?: number | null | undefined, contract_type?: ContractType | null | undefined, contract_end_at?: number | null | undefined, contract_start_at?: number | null | undefined, added_by_user_id: string, allow_group_discovery: boolean, allow_user_share_commentary: boolean, departments_in_signup: boolean, locations_in_signup: boolean, updated_at: number, menu_item_enabled?: boolean | null | undefined, yearly_enrichment_quota?: number | null | undefined, id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy_url?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, stickers?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, disclosures?: Array<{ id: string, disclosure: string, disclosure_status: ClientDisclosureStatus } | null | undefined> | null | undefined, social_config?: { twitter_shareable?: boolean | null | undefined, twitter_engageable?: boolean | null | undefined, linkedin_shareable?: boolean | null | undefined, linkedin_engageable?: boolean | null | undefined, facebook_shareable?: boolean | null | undefined, facebook_engageable?: boolean | null | undefined, youtube_shareable?: boolean | null | undefined, youtube_engageable?: boolean | null | undefined, instagram_shareable?: boolean | null | undefined, instagram_engageable?: boolean | null | undefined, reddit_shareable?: boolean | null | undefined, reddit_engageable?: boolean | null | undefined, tiktok_shareable?: boolean | null | undefined, tiktok_engageable?: boolean | null | undefined, weibo_shareable?: boolean | null | undefined, weibo_engageable?: boolean | null | undefined, wechat_shareable?: boolean | null | undefined, wechat_engageable?: boolean | null | undefined } | null | undefined, billing?: { billable_user_count: number, stripe_account_id: string, stripe_customer_id: string, stripe_price_id: string, stripe_product_id: string, stripe_subscription_id: string, stripe_subscription_item_id: string } | null | undefined, billing_address?: { address: string, address2?: string | null | undefined, city: string, state: string, zip: string, country: string } | null | undefined, menu_item?: { title: string, link: string } | null | undefined, icon?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, client_aliases?: Array<{ company_id: string, name: string } | null | undefined> | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } };

export type BatchCreateGroupsMutationVariables = Exact<{
  group_input_list?: Maybe<GroupInputList>;
}>;


export type BatchCreateGroupsMutation = { batchCreateGroups: { groups?: Array<{ id: string } | null | undefined> | null | undefined } };

export type BatchDeleteGroupsMutationVariables = Exact<{
  ids: Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>;
}>;


export type BatchDeleteGroupsMutation = { batchDeleteGroups: Array<{ id: string } | null | undefined> };

export type BatchUpdateSocialConnectionMutationVariables = Exact<{
  data: BatchUpdateSocialConnectionInput;
}>;


export type BatchUpdateSocialConnectionMutation = { batchUpdateSocialConnection: { items: Array<{ item: { id: string, provider: Network, identifier?: string | null | undefined, profile_name?: string | null | undefined, reach?: number | null | undefined, expires_soon: boolean, profile_url?: string | null | undefined, profile_picture?: string | null | undefined, smart_schedule?: boolean | null | undefined }, pages?: Array<{ id: string, identifier?: string | null | undefined, logo?: string | null | undefined, profile_name?: string | null | undefined, profile_url?: string | null | undefined, provider: Network, role?: string | null | undefined, urn?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> } };

export type BatchUpdateUserProfileStatusMutationVariables = Exact<{
  ids: Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>;
  user_status: UserStatus;
}>;


export type BatchUpdateUserProfileStatusMutation = { batchUpdateUserProfileStatus: Array<{ id: string, user_status: UserStatus } | null | undefined> };

export type BatchUpdateUserProfileTypeMutationVariables = Exact<{
  ids: Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>;
  user_type: UserType;
}>;


export type BatchUpdateUserProfileTypeMutation = { batchUpdateUserProfileUserType: Array<{ id: string, user_type: UserType } | null | undefined> };

export type BulkResendClientInvitationsMutationVariables = Exact<{
  invitation_ids?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  search_filter?: Maybe<ClientInvitationSearchFilter>;
}>;


export type BulkResendClientInvitationsMutation = { bulkResendClientInvitations: boolean };

export type BulkUpdateContentMutationVariables = Exact<{
  bulk_update: BulkUpdateContent;
}>;


export type BulkUpdateContentMutation = { bulkUpdateContent?: { error: number, success: number } | null | undefined };

export type CompleteMultiPartUploadMutationVariables = Exact<{
  bucket_name: Scalars['String'];
  multipart_upload: Array<MultiPartListInput> | MultiPartListInput;
  object_name: Scalars['String'];
  upload_id: Scalars['String'];
}>;


export type CompleteMultiPartUploadMutation = { completeMultiPartUpload?: { etag: string } | null | undefined };

export type CreateApiTokenMutationVariables = Exact<{
  data: CreateApiTokenInput;
}>;


export type CreateApiTokenMutation = { createAPIToken: { token_name: string, token_id: string, api_token: string } };

export type CreateAssignmentMutationVariables = Exact<{
  data: AssignmentInput;
}>;


export type CreateAssignmentMutation = { createAssignment: { id: string, title?: string | null | undefined, groups_required?: number | null | undefined, users_required?: number | null | undefined, groups_suggested?: number | null | undefined, users_suggested?: number | null | undefined, extracted_users?: number | null | undefined, active: boolean, target_user: AssignmentTargetUser, groups_required_objects?: Array<{ client_id: string, id: string, title: string, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, color_map: { hex: string, label: string, group_color?: GroupColor | null | undefined }, icon_color_map: { hex: string, label: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { bucket: string, label: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, groups_suggested_objects?: Array<{ client_id: string, id: string, title: string, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, color_map: { hex: string, label: string, group_color?: GroupColor | null | undefined }, icon_color_map: { hex: string, label: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { bucket: string, label: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, users_required_objects?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, users_suggested_objects?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, rule: { all_users: boolean, operator: AssignmentOperator, department_ids?: Array<string | null | undefined> | null | undefined, location_ids?: Array<string | null | undefined> | null | undefined } } };

export type CreateClientContentTagsMutationVariables = Exact<{
  tags: Array<Maybe<ContentTagMetaInput>> | Maybe<ContentTagMetaInput>;
}>;


export type CreateClientContentTagsMutation = { createClientContentTags?: Array<{ title: string, tag_id: string, warning?: string | null | undefined } | null | undefined> | null | undefined };

export type CreateClientDepartmentMutationVariables = Exact<{
  data: CreateClientDepartmentInput;
}>;


export type CreateClientDepartmentMutation = { createClientDepartment: { id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } };

export type CreateClientDisclosureMutationVariables = Exact<{
  data: CreateClientDisclosureInput;
  override?: Maybe<OverrideInput>;
}>;


export type CreateClientDisclosureMutation = { createClientDisclosure: { id: string, disclosure: string, disclosure_status: ClientDisclosureStatus } };

export type CreateClientFollowMappingMutationVariables = Exact<{
  data: CreateClientFollowMappingInput;
}>;


export type CreateClientFollowMappingMutation = { createClientFollowMapping: { id: string, title: string, mapping_status: ClientFollowMappingStatus, all_users?: boolean | null | undefined, follow_condition_conjunction?: boolean | null | undefined, required_groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, suggested_groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, required_users?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, suggested_users?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, follow_conditions?: { department_id?: Array<string | null | undefined> | null | undefined, location_id?: Array<string | null | undefined> | null | undefined, language?: Array<string | null | undefined> | null | undefined, email_domain?: Array<string | null | undefined> | null | undefined, departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } };

export type CreateClientInvitationMutationVariables = Exact<{
  data: CreateClientInvitationInput;
}>;


export type CreateClientInvitationMutation = { createClientInvitation: Array<{ id: string, client_id: string, email_address: string, invitation_status: ClientInvitationStatus, created_at: number, updated_at: number, accepted_at?: number | null | undefined, user_type?: UserType | null | undefined, accepted_by_user?: { id: string, full_name?: string | null | undefined, email_address: string, user_status: UserStatus, onboarding_completed?: boolean | null | undefined, user_type: UserType } | null | undefined, added_by_user?: { id: string, full_name?: string | null | undefined, email_address: string } | null | undefined } | null | undefined> };

export type CreateClientLocationMutationVariables = Exact<{
  data: CreateClientLocationInput;
}>;


export type CreateClientLocationMutation = { createClientLocation: { id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } };

export type CreateClientPageMappingMutationVariables = Exact<{
  data: CreateClientPageMappingInput;
  override?: Maybe<OverrideInput>;
}>;


export type CreateClientPageMappingMutation = { createClientPageMapping: boolean };

export type CreateClientSelfServeMutationVariables = Exact<{
  data: CreateClientSelfServeInput;
}>;


export type CreateClientSelfServeMutation = { createClientSelfServe: { client: { created_at: number, email_from_address?: string | null | undefined, allow_user_invites: boolean, content_domains?: Array<string | null | undefined> | null | undefined, allow_group_creation: boolean, disable_comments: boolean, allow_external_share: boolean, sort_mode?: SortMode | null | undefined, email_address?: string | null | undefined, sso_provider?: string | null | undefined, allow_sharing?: boolean | null | undefined, email_sending_domain?: string | null | undefined, compliance_notification_emails?: Array<string | null | undefined> | null | undefined, compliance_notification_enabled?: boolean | null | undefined, moderator_can_mark_as_important?: boolean | null | undefined, is_self_serve?: boolean | null | undefined, referral_headline?: string | null | undefined, referral_message?: string | null | undefined, stickers_enabled?: boolean | null | undefined, features?: Array<Feature | null | undefined> | null | undefined, setup_completed?: boolean | null | undefined, feature_plan_type?: FeaturePlanType | null | undefined, billing_status?: BillingStatusType | null | undefined, billing_type?: BillingTypeType | null | undefined, billing_teams_trial_start?: number | null | undefined, billing_teams_trial_end?: number | null | undefined, contract_committed_user_count?: number | null | undefined, contract_type?: ContractType | null | undefined, contract_end_at?: number | null | undefined, contract_start_at?: number | null | undefined, added_by_user_id: string, allow_group_discovery: boolean, allow_user_share_commentary: boolean, departments_in_signup: boolean, locations_in_signup: boolean, updated_at: number, menu_item_enabled?: boolean | null | undefined, yearly_enrichment_quota?: number | null | undefined, id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy_url?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, stickers?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, disclosures?: Array<{ id: string, disclosure: string, disclosure_status: ClientDisclosureStatus } | null | undefined> | null | undefined, social_config?: { twitter_shareable?: boolean | null | undefined, twitter_engageable?: boolean | null | undefined, linkedin_shareable?: boolean | null | undefined, linkedin_engageable?: boolean | null | undefined, facebook_shareable?: boolean | null | undefined, facebook_engageable?: boolean | null | undefined, youtube_shareable?: boolean | null | undefined, youtube_engageable?: boolean | null | undefined, instagram_shareable?: boolean | null | undefined, instagram_engageable?: boolean | null | undefined, reddit_shareable?: boolean | null | undefined, reddit_engageable?: boolean | null | undefined, tiktok_shareable?: boolean | null | undefined, tiktok_engageable?: boolean | null | undefined, weibo_shareable?: boolean | null | undefined, weibo_engageable?: boolean | null | undefined, wechat_shareable?: boolean | null | undefined, wechat_engageable?: boolean | null | undefined } | null | undefined, billing?: { billable_user_count: number, stripe_account_id: string, stripe_customer_id: string, stripe_price_id: string, stripe_product_id: string, stripe_subscription_id: string, stripe_subscription_item_id: string } | null | undefined, billing_address?: { address: string, address2?: string | null | undefined, city: string, state: string, zip: string, country: string } | null | undefined, menu_item?: { title: string, link: string } | null | undefined, icon?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, client_aliases?: Array<{ company_id: string, name: string } | null | undefined> | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined }, user: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, email_address_verified: boolean, user_type: UserType, user_status: UserStatus, user_pool_id: string, client_id: string, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, last_onboarding_step?: number | null | undefined, lang?: string | null | undefined, onboarding_completed?: boolean | null | undefined, last_accessed_at?: number | null | undefined, user_timezone?: string | null | undefined, created_at?: number | null | undefined, german_privacy?: boolean | null | undefined, reach?: number | null | undefined, notification_delivery_types?: Array<NotificationDeliveryType | null | undefined> | null | undefined, getstream_token?: string | null | undefined, setup_completed?: boolean | null | undefined, smart_schedule_acknowledgement?: boolean | null | undefined, smart_schedule_viewed?: boolean | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, group_moderator?: Array<{ group_id: string, user_id: string, created_at: number, added_by_user_id: string, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, push_notification_configuration?: Array<{ device_platform: string, token: string } | null | undefined> | null | undefined, push_notifications_status?: { paused: boolean, paused_at?: number | null | undefined } | null | undefined } } };

export type CreateClientStickerMutationVariables = Exact<{
  data: CreateClientStickerInput;
}>;


export type CreateClientStickerMutation = { createClientSticker: { success: boolean, client: { id: string, stickers?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined }, sticker: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } } };

export type CreateContentEmailMutationVariables = Exact<{
  data: ContentEmailSpecInput;
}>;


export type CreateContentEmailMutation = { createContentEmailSpec: { id: string, title: string, segment_ids: Array<string | null | undefined>, all_users: boolean, created_at?: number | null | undefined, send_at: number, delivery_interval?: number | null | undefined, grouping_interval?: number | null | undefined, banner_url?: string | null | undefined, intro?: string | null | undefined, footer?: string | null | undefined, email_from?: string | null | undefined, email_reply_to?: string | null | undefined, subject?: string | null | undefined, config_status?: GenericStatus | null | undefined, use_sto?: boolean | null | undefined, content_specs: Array<{ id?: string | null | undefined, content_type: ContentEmailType } | null | undefined>, banner?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } };

export type CreateGenericWebhookMutationVariables = Exact<{
  callback_url: Scalars['String'];
  secret_token: Scalars['String'];
  webhook_events: Array<Maybe<WebhookEvents>> | Maybe<WebhookEvents>;
  webhook_name: Scalars['String'];
  webhook_status: GenericStatus;
}>;


export type CreateGenericWebhookMutation = { createGenericWebhook: { callback_url?: string | null | undefined, webhook_status: GenericStatus, webhook_id: string, webhook_name: string, webhook_type: WebhookTypes, workvivo_org_id?: string | null | undefined, workvivo_workspace_id?: string | null | undefined, groups?: Array<string | null | undefined> | null | undefined } };

export type CreateGroupMutationVariables = Exact<{
  data: CreateGroupInput;
}>;


export type CreateGroupMutation = { createGroup: { id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } };

export type CreateGroupModeratorMutationVariables = Exact<{
  group_id: Scalars['ID'];
  user_id: Scalars['ID'];
}>;


export type CreateGroupModeratorMutation = { createGroupModerator: { group_id: string, user_id: string, created_at: number, added_by_user_id: string, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } };

export type CreateGroupSourceMutationVariables = Exact<{
  group_id: Scalars['ID'];
  source_status: SourceStatus;
  source_type: GroupSourceType;
  source_value: Scalars['String'];
  approval?: Maybe<ContentApproval>;
}>;


export type CreateGroupSourceMutation = { clientGroupSourceCreate: { id: string, group_id: string, source_status: SourceStatus, source_type: GroupSourceType, source_value: string, approval?: ContentApproval | null | undefined } };

export type CreateGroupWebhookWorkvivoMutationVariables = Exact<{
  group_id: Scalars['ID'];
  webhook_id: Scalars['String'];
  workvivo_workspace_id: Scalars['String'];
}>;


export type CreateGroupWebhookWorkvivoMutation = { createGroupWebhookWorkvivo: { callback_url?: string | null | undefined, webhook_status: GenericStatus, webhook_id: string, webhook_name: string, webhook_type: WebhookTypes, workvivo_org_id?: string | null | undefined, workvivo_workspace_id?: string | null | undefined, groups?: Array<string | null | undefined> | null | undefined } };

export type CreateLoginTokenForCurrentUserInClientMutationVariables = Exact<{
  client_id: Scalars['ID'];
}>;


export type CreateLoginTokenForCurrentUserInClientMutation = { createLoginTokenForCurrentUserInClient?: string | null | undefined };

export type CreateManualNotificationMutationVariables = Exact<{
  data: ManualNotificationsItemInput;
}>;


export type CreateManualNotificationMutation = { createManualNotification?: { id: string, notification_type?: ManualNotificationType | null | undefined, send_at: number, segment_ids: Array<string | null | undefined>, created_at: number, user_count?: number | null | undefined, email_count?: number | null | undefined, entire_company?: boolean | null | undefined, segments: Array<{ id: string, title: string } | null | undefined>, message: { body: string, url?: string | null | undefined }, email?: { subject: string, body: string, format?: ManualNotificationEmailFormat | null | undefined } | null | undefined } | null | undefined };

export type CreateMultiPartUploadMutationVariables = Exact<{
  bucket_name: Scalars['String'];
  object_name: Scalars['String'];
  total_parts: Scalars['Int'];
}>;


export type CreateMultiPartUploadMutation = { createMultiPartUpload?: { upload_id: string, upload_urls?: Array<string> | null | undefined } | null | undefined };

export type CreateReactionMutationVariables = Exact<{
  content_id: Scalars['String'];
  reaction_type: ReactionType;
}>;


export type CreateReactionMutation = { createReaction: { object_type: ObjectType, object_id: string, reaction_type: ReactionType, user_id: string, created_at: number } };

export type CreateReadmeLoginJwtMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateReadmeLoginJwtMutation = { createReadmeLoginJWT: { url: string, jwt: string } };

export type CreateUpdateLeaderboardConfigMutationVariables = Exact<{
  data: LeaderboardConfigInput;
}>;


export type CreateUpdateLeaderboardConfigMutation = { createUpdateLeaderboardConfig: { id: string, title: string, description?: string | null | undefined, leaderboard_status: GenericStatus, created_at: number, start_at?: number | null | undefined, end_at?: number | null | undefined, all_users: boolean, segment_ids?: Array<string | null | undefined> | null | undefined, segments?: Array<{ id: string, title: string, created_at?: number | null | undefined, segment_status: SegmentStatus, department_ids?: Array<string | null | undefined> | null | undefined, location_ids?: Array<string | null | undefined> | null | undefined, group_ids?: Array<string | null | undefined> | null | undefined, registered_count?: number | null | undefined, third_party_count?: number | null | undefined, departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, scoring_aggregate?: { everyonesocial?: { posting?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined, actions?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined, teammates?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, linkedin?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, twitter?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, facebook?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined } | null | undefined } };

export type CreateUserProfileForCurrentUserInClientMutationVariables = Exact<{
  client_id: Scalars['ID'];
}>;


export type CreateUserProfileForCurrentUserInClientMutation = { createUserProfileForCurrentUserInClient?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, email_address_verified: boolean, user_type: UserType, user_status: UserStatus, user_pool_id: string, client_id: string, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, last_onboarding_step?: number | null | undefined, lang?: string | null | undefined, onboarding_completed?: boolean | null | undefined, last_accessed_at?: number | null | undefined, user_timezone?: string | null | undefined, created_at?: number | null | undefined, german_privacy?: boolean | null | undefined, reach?: number | null | undefined, notification_delivery_types?: Array<NotificationDeliveryType | null | undefined> | null | undefined, getstream_token?: string | null | undefined, setup_completed?: boolean | null | undefined, smart_schedule_acknowledgement?: boolean | null | undefined, smart_schedule_viewed?: boolean | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, group_moderator?: Array<{ group_id: string, user_id: string, created_at: number, added_by_user_id: string, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, push_notification_configuration?: Array<{ device_platform: string, token: string } | null | undefined> | null | undefined, push_notifications_status?: { paused: boolean, paused_at?: number | null | undefined } | null | undefined } | null | undefined };

export type CreateUserSegmentMutationVariables = Exact<{
  data: CreateUserSegmentInput;
}>;


export type CreateUserSegmentMutation = { createUserSegment: { id: string, title: string, created_at?: number | null | undefined, segment_status: SegmentStatus, department_ids?: Array<string | null | undefined> | null | undefined, location_ids?: Array<string | null | undefined> | null | undefined, group_ids?: Array<string | null | undefined> | null | undefined, registered_count?: number | null | undefined, third_party_count?: number | null | undefined, departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } };

export type CreateWorkvivoWebhookMutationVariables = Exact<{
  workvivo_org_id: Scalars['String'];
  api_token: Scalars['String'];
  webhook_status: GenericStatus;
}>;


export type CreateWorkvivoWebhookMutation = { createWorkvivoWebhook: { callback_url?: string | null | undefined, webhook_status: GenericStatus, webhook_id: string, webhook_name: string, webhook_type: WebhookTypes, workvivo_org_id?: string | null | undefined, workvivo_workspace_id?: string | null | undefined, groups?: Array<string | null | undefined> | null | undefined } };

export type DeleteApiTokenMutationVariables = Exact<{
  data: DeleteTokenApiInput;
}>;


export type DeleteApiTokenMutation = { deleteAPIToken: { is_deleted: boolean, token_id?: string | null | undefined, token_name?: string | null | undefined } };

export type DeleteAssignmentMutationVariables = Exact<{
  id: Scalars['ID'];
  client_id: Scalars['ID'];
}>;


export type DeleteAssignmentMutation = { deleteAssignment: boolean };

export type DeleteClientInvitationsMutationVariables = Exact<{
  invitation_ids?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  search_filter?: Maybe<ClientInvitationSearchFilter>;
}>;


export type DeleteClientInvitationsMutation = { deleteClientInvitations: boolean };

export type DeleteClientPageMappingMutationVariables = Exact<{
  linkedin_page_id: Scalars['String'];
}>;


export type DeleteClientPageMappingMutation = { deleteClientPageMapping: boolean };

export type DeleteClientStickerMutationVariables = Exact<{
  client_id: Scalars['ID'];
  sticker_key: Scalars['String'];
}>;


export type DeleteClientStickerMutation = { deleteClientSticker: { success: boolean, client: { id: string, stickers?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined }, sticker: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } } };

export type DeleteGroupModeratorMutationVariables = Exact<{
  group_id: Scalars['ID'];
  user_id: Scalars['ID'];
}>;


export type DeleteGroupModeratorMutation = { deleteGroupModerator: boolean };

export type DeleteGroupSourceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteGroupSourceMutation = { clientGroupSourceDelete: { status: boolean } };

export type DeleteGroupWebhookMutationVariables = Exact<{
  group_id: Scalars['ID'];
  webhook_id: Scalars['String'];
}>;


export type DeleteGroupWebhookMutation = { deleteGroupWebhook?: { callback_url?: string | null | undefined, webhook_status: GenericStatus, webhook_id: string, webhook_name: string, webhook_type: WebhookTypes, workvivo_org_id?: string | null | undefined, workvivo_workspace_id?: string | null | undefined, groups?: Array<string | null | undefined> | null | undefined } | null | undefined };

export type DeleteManualNotificationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteManualNotificationMutation = { deleteManualNotification?: { id: string, notification_type?: ManualNotificationType | null | undefined, send_at: number, segment_ids: Array<string | null | undefined>, created_at: number, user_count?: number | null | undefined, email_count?: number | null | undefined, entire_company?: boolean | null | undefined, segments: Array<{ id: string, title: string } | null | undefined>, message: { body: string, url?: string | null | undefined }, email?: { subject: string, body: string, format?: ManualNotificationEmailFormat | null | undefined } | null | undefined } | null | undefined };

export type DeleteReactionMutationVariables = Exact<{
  content_id: Scalars['String'];
  reaction_type: ReactionType;
}>;


export type DeleteReactionMutation = { deleteReaction: { status: boolean } };

export type DeleteScheduledSharesMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteScheduledSharesMutation = { deleteScheduledShares: Array<{ id: string } | null | undefined> };

export type DeleteSocialConnectionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSocialConnectionMutation = { deleteSocialConnection: { status: boolean } };

export type DeleteUserManagementUserProfileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserManagementUserProfileMutation = { deleteUserManagementUserProfile: string };

export type DeleteWebhookMutationVariables = Exact<{
  webhook_id: Scalars['ID'];
}>;


export type DeleteWebhookMutation = { deleteWebhook?: { callback_url?: string | null | undefined, webhook_status: GenericStatus, webhook_id: string, webhook_name: string, webhook_type: WebhookTypes, workvivo_org_id?: string | null | undefined, workvivo_workspace_id?: string | null | undefined, groups?: Array<string | null | undefined> | null | undefined } | null | undefined };

export type DisableContentEmailMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DisableContentEmailMutation = { disableContentEmailSpec: { id: string, title: string, segment_ids: Array<string | null | undefined>, all_users: boolean, created_at?: number | null | undefined, send_at: number, delivery_interval?: number | null | undefined, grouping_interval?: number | null | undefined, banner_url?: string | null | undefined, intro?: string | null | undefined, footer?: string | null | undefined, email_from?: string | null | undefined, email_reply_to?: string | null | undefined, subject?: string | null | undefined, config_status?: GenericStatus | null | undefined, use_sto?: boolean | null | undefined, content_specs: Array<{ id?: string | null | undefined, content_type: ContentEmailType } | null | undefined>, banner?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } };

export type FollowMutationVariables = Exact<{
  id: Scalars['ID'];
  key: FeedKey;
  target_user_id?: Maybe<Scalars['String']>;
}>;


export type FollowMutation = { follow?: { feed: FeedKey, user_id: string, created_at: number, postable: boolean, group_role?: GroupRole | null | undefined, required?: boolean | null | undefined, group?: { id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, followed_by_user: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } } | null | undefined };

export type MarkInboxAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkInboxAsReadMutation = { markInboxAsRead: { status: boolean } };

export type MarkInboxItemAsReadMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarkInboxItemAsReadMutation = { markInboxItemAsRead?: { id: string, created_at: number, updated_at: number, item_read: boolean, message: string, to_user_id: string, url?: string | null | undefined } | null | undefined };

export type ModifyContentEmailMutationVariables = Exact<{
  data: ContentEmailSpecMutation;
}>;


export type ModifyContentEmailMutation = { modifyContentEmailSpec: { id: string, title: string, segment_ids: Array<string | null | undefined>, all_users: boolean, created_at?: number | null | undefined, send_at: number, delivery_interval?: number | null | undefined, grouping_interval?: number | null | undefined, banner_url?: string | null | undefined, intro?: string | null | undefined, footer?: string | null | undefined, email_from?: string | null | undefined, email_reply_to?: string | null | undefined, subject?: string | null | undefined, config_status?: GenericStatus | null | undefined, use_sto?: boolean | null | undefined, content_specs: Array<{ id?: string | null | undefined, content_type: ContentEmailType } | null | undefined>, banner?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } };

export type OauthSubmitAuthorizeMutationVariables = Exact<{
  data: OauthSubmitInput;
}>;


export type OauthSubmitAuthorizeMutation = { oauthSubmitAuthorize: { redirect_url: string } };

export type OauthUserRevokeMutationVariables = Exact<{
  data: OauthClientInput;
}>;


export type OauthUserRevokeMutation = { oauthUserRevoke?: { oauth_client_id: string, oauth_client_name: string, oauth_client_logo_url: string, oauth_client_description: string } | null | undefined };

export type PreviewContentEmailMutationVariables = Exact<{
  data: ContentEmailSpecInput;
}>;


export type PreviewContentEmailMutation = { previewContentEmailSpec: string };

export type ManualPostMutationVariables = Exact<{
  content: ContentInput;
}>;


export type ManualPostMutation = { processContent: { approval?: ContentApproval | null | undefined, content_id: string, content_source_id?: string | null | undefined, is_branded?: boolean | null | undefined, is_shareable?: boolean | null | undefined, is_important?: boolean | null | undefined, is_important_message?: string | null | undefined, is_engage?: boolean | null | undefined, is_engageable?: boolean | null | undefined, is_pinned?: boolean | null | undefined, pinned_end_at?: number | null | undefined, important_to_share?: boolean | null | undefined, reaction_count?: number | null | undefined, comment_count?: number | null | undefined, share_count?: number | null | undefined, engage_count?: number | null | undefined, click_count?: number | null | undefined, publish_at: number, group_ids: Array<string | null | undefined>, primary_group_id?: string | null | undefined, has_requesting_user_shared?: boolean | null | undefined, lock_commentary?: boolean | null | undefined, submitter_role?: SubmitterRole | null | undefined, user_id?: string | null | undefined, slack_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, ms_teams_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, pinned_to_groups?: Array<{ group_id: string, pinned_end_at?: number | null | undefined } | null | undefined> | null | undefined, commentary?: Array<{ network: Network, commentary: string, mentions?: Array<{ provider: string, identifier: string, start: number, length: number } | null | undefined> | null | undefined } | null | undefined> | null | undefined, disclosures?: Array<{ network: Network, disclosure_id: string } | null | undefined> | null | undefined, group_id_approvals: Array<{ group_id?: string | null | undefined, approval?: ContentApproval | null | undefined } | null | undefined>, content_object: { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id?: string | null | undefined } | null | undefined, instagram_metadata?: { id?: string | null | undefined, shortcode?: string | null | undefined } | null | undefined, reddit_metadata?: { url: string } | null | undefined }, reactions?: { user_reactions?: Array<ReactionType | null | undefined> | null | undefined, reaction_count?: { total: number } | null | undefined, reaction_user_details?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined, groups?: Array<{ id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, url_param_values?: Array<{ key: string, value?: string | null | undefined } | null | undefined> | null | undefined, reacted_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, shared_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, commented_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, schedule?: { publish?: number | null | undefined, expire?: number | null | undefined } | null | undefined, audit?: Array<{ ACTION: string, time?: number | null | undefined, by_user_id?: string | null | undefined, message?: string | null | undefined, by_user_profile?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, content_tags?: Array<{ title: string, tag_id: string } | null | undefined> | null | undefined } };

export type ProcessContentV2MutationVariables = Exact<{
  content: ContentInput;
}>;


export type ProcessContentV2Mutation = { processContentV2: { content?: { approval?: ContentApproval | null | undefined, content_id: string, content_source_id?: string | null | undefined, is_branded?: boolean | null | undefined, is_shareable?: boolean | null | undefined, is_important?: boolean | null | undefined, is_important_message?: string | null | undefined, is_engage?: boolean | null | undefined, is_engageable?: boolean | null | undefined, is_pinned?: boolean | null | undefined, pinned_end_at?: number | null | undefined, important_to_share?: boolean | null | undefined, reaction_count?: number | null | undefined, comment_count?: number | null | undefined, share_count?: number | null | undefined, engage_count?: number | null | undefined, click_count?: number | null | undefined, publish_at: number, group_ids: Array<string | null | undefined>, primary_group_id?: string | null | undefined, has_requesting_user_shared?: boolean | null | undefined, lock_commentary?: boolean | null | undefined, submitter_role?: SubmitterRole | null | undefined, user_id?: string | null | undefined, slack_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, ms_teams_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, pinned_to_groups?: Array<{ group_id: string, pinned_end_at?: number | null | undefined } | null | undefined> | null | undefined, commentary?: Array<{ network: Network, commentary: string, mentions?: Array<{ provider: string, identifier: string, start: number, length: number } | null | undefined> | null | undefined } | null | undefined> | null | undefined, disclosures?: Array<{ network: Network, disclosure_id: string } | null | undefined> | null | undefined, group_id_approvals: Array<{ group_id?: string | null | undefined, approval?: ContentApproval | null | undefined } | null | undefined>, content_object: { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id?: string | null | undefined } | null | undefined, instagram_metadata?: { id?: string | null | undefined, shortcode?: string | null | undefined } | null | undefined, reddit_metadata?: { url: string } | null | undefined }, reactions?: { user_reactions?: Array<ReactionType | null | undefined> | null | undefined, reaction_count?: { total: number } | null | undefined, reaction_user_details?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined, groups?: Array<{ id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, url_param_values?: Array<{ key: string, value?: string | null | undefined } | null | undefined> | null | undefined, reacted_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, shared_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, commented_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, schedule?: { publish?: number | null | undefined, expire?: number | null | undefined } | null | undefined, audit?: Array<{ ACTION: string, time?: number | null | undefined, by_user_id?: string | null | undefined, message?: string | null | undefined, by_user_profile?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, content_tags?: Array<{ title: string, tag_id: string } | null | undefined> | null | undefined } | null | undefined, warnings: Array<{ uuid: string, blocked_terms?: Array<{ term: string, start: number, end: number } | null | undefined> | null | undefined } | null | undefined> } };

export type ReconcileExpressActivatedUsersMutationVariables = Exact<{
  users: Array<Maybe<ReconcileExpressActivatedUsersInput>> | Maybe<ReconcileExpressActivatedUsersInput>;
}>;


export type ReconcileExpressActivatedUsersMutation = { reconcileExpressActivatedUsers: { message: string, results: Array<{ oauth_token_id?: string | null | undefined, user_id: string, access_key: string } | null | undefined> } };

export type SendBillingBillableUserEventQueueMutationVariables = Exact<{
  client_id: Scalars['ID'];
  user_id: Scalars['ID'];
  billable_user_event: BillableUserEventInput;
}>;


export type SendBillingBillableUserEventQueueMutation = { sendBillingBillableUserEventQueue: { status: boolean } };

export type SetBlocklistMutationVariables = Exact<{
  terms: Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>;
}>;


export type SetBlocklistMutation = { setBlockList: { terms: Array<string | null | undefined> } };

export type ShareContentMutationVariables = Exact<{
  share_session_id?: Maybe<Scalars['ID']>;
  content_id: Scalars['ID'];
  items: Array<Maybe<ShareContentInput>> | Maybe<ShareContentInput>;
  timezone?: Maybe<Scalars['String']>;
}>;


export type ShareContentMutation = { shareContent?: { results: Array<{ url?: string | null | undefined, status: SharedStatus, shortened_url?: { short_link?: string | null | undefined, id?: string | null | undefined } | null | undefined }>, warnings: Array<{ uuid: string, blocked_terms?: Array<{ term: string, start: number, end: number } | null | undefined> | null | undefined } | null | undefined> } | null | undefined };

export type SuspendUserManagementUserProfileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SuspendUserManagementUserProfileMutation = { suspendUserManagementUserProfile: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, email_address_verified: boolean, user_type: UserType, user_status: UserStatus, user_pool_id: string, client_id: string, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, last_onboarding_step?: number | null | undefined, lang?: string | null | undefined, onboarding_completed?: boolean | null | undefined, last_accessed_at?: number | null | undefined, user_timezone?: string | null | undefined, created_at?: number | null | undefined, german_privacy?: boolean | null | undefined, reach?: number | null | undefined, notification_delivery_types?: Array<NotificationDeliveryType | null | undefined> | null | undefined, getstream_token?: string | null | undefined, setup_completed?: boolean | null | undefined, smart_schedule_acknowledgement?: boolean | null | undefined, smart_schedule_viewed?: boolean | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, group_moderator?: Array<{ group_id: string, user_id: string, created_at: number, added_by_user_id: string, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, push_notification_configuration?: Array<{ device_platform: string, token: string } | null | undefined> | null | undefined, push_notifications_status?: { paused: boolean, paused_at?: number | null | undefined } | null | undefined } };

export type SyncBillingCustomerMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncBillingCustomerMutation = { syncBillingCustomer: { status: boolean } };

export type ToggleCapabilityGroupMutationVariables = Exact<{
  client_id?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  capability_group?: Maybe<CapabilityGroup>;
}>;


export type ToggleCapabilityGroupMutation = { toggleCapabilityGroup: { status: boolean } };

export type UnfollowMutationVariables = Exact<{
  id: Scalars['ID'];
  key: FeedKey;
  target_user_id?: Maybe<Scalars['String']>;
}>;


export type UnfollowMutation = { unfollow?: { feed: FeedKey, user_id: string, created_at: number, postable: boolean, group_role?: GroupRole | null | undefined, required?: boolean | null | undefined, group?: { id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, followed_by_user: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } } | null | undefined };

export type UnsuspendUserManagementUserProfileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnsuspendUserManagementUserProfileMutation = { unsuspendUserManagementUserProfile: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, email_address_verified: boolean, user_type: UserType, user_status: UserStatus, user_pool_id: string, client_id: string, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, last_onboarding_step?: number | null | undefined, lang?: string | null | undefined, onboarding_completed?: boolean | null | undefined, last_accessed_at?: number | null | undefined, user_timezone?: string | null | undefined, created_at?: number | null | undefined, german_privacy?: boolean | null | undefined, reach?: number | null | undefined, notification_delivery_types?: Array<NotificationDeliveryType | null | undefined> | null | undefined, getstream_token?: string | null | undefined, setup_completed?: boolean | null | undefined, smart_schedule_acknowledgement?: boolean | null | undefined, smart_schedule_viewed?: boolean | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, group_moderator?: Array<{ group_id: string, user_id: string, created_at: number, added_by_user_id: string, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, push_notification_configuration?: Array<{ device_platform: string, token: string } | null | undefined> | null | undefined, push_notifications_status?: { paused: boolean, paused_at?: number | null | undefined } | null | undefined } };

export type UpdateAssignmentMutationVariables = Exact<{
  client_id: Scalars['ID'];
  id: Scalars['ID'];
  data: AssignmentUpdateInput;
}>;


export type UpdateAssignmentMutation = { updateAssignment: { id: string, title?: string | null | undefined, groups_required?: number | null | undefined, users_required?: number | null | undefined, groups_suggested?: number | null | undefined, users_suggested?: number | null | undefined, extracted_users?: number | null | undefined, active: boolean, target_user: AssignmentTargetUser, groups_required_objects?: Array<{ client_id: string, id: string, title: string, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, color_map: { hex: string, label: string, group_color?: GroupColor | null | undefined }, icon_color_map: { hex: string, label: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { bucket: string, label: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, groups_suggested_objects?: Array<{ client_id: string, id: string, title: string, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, color_map: { hex: string, label: string, group_color?: GroupColor | null | undefined }, icon_color_map: { hex: string, label: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { bucket: string, label: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, users_required_objects?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, users_suggested_objects?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, rule: { all_users: boolean, operator: AssignmentOperator, department_ids?: Array<string | null | undefined> | null | undefined, location_ids?: Array<string | null | undefined> | null | undefined } } };

export type UpdateClientDepartmentMutationVariables = Exact<{
  data: UpdateClientDepartmentInput;
}>;


export type UpdateClientDepartmentMutation = { updateClientDepartment: { id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } };

export type UpdateClientDisclosureMutationVariables = Exact<{
  data: UpdateClientDisclosureInput;
  override?: Maybe<OverrideInput>;
}>;


export type UpdateClientDisclosureMutation = { updateClientDisclosure: { id: string, disclosure: string, disclosure_status: ClientDisclosureStatus } };

export type UpdateClientFollowMappingMutationVariables = Exact<{
  data: UpdateClientFollowMappingInput;
}>;


export type UpdateClientFollowMappingMutation = { updateClientFollowMapping: { id: string, title: string, mapping_status: ClientFollowMappingStatus, all_users?: boolean | null | undefined, follow_condition_conjunction?: boolean | null | undefined, required_groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, suggested_groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, required_users?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, suggested_users?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, follow_conditions?: { department_id?: Array<string | null | undefined> | null | undefined, location_id?: Array<string | null | undefined> | null | undefined, language?: Array<string | null | undefined> | null | undefined, email_domain?: Array<string | null | undefined> | null | undefined, departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } };

export type UpdateClientLocationMutationVariables = Exact<{
  data: UpdateClientLocationInput;
}>;


export type UpdateClientLocationMutation = { updateClientLocation: { id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } };

export type UpdateClientUrlParamsMutationVariables = Exact<{
  data: ClientUrlParamsUpdateInput;
}>;


export type UpdateClientUrlParamsMutation = { updateClientUrlParams: { id: string, params_status?: ParamsStatus | null | undefined, content_domain: string, configuration?: Array<{ key: string, value?: string | null | undefined, dynamic_value?: ClientUrlParamsDynamicValues | null | undefined, value_options?: Array<string | null | undefined> | null | undefined, default_option_value?: string | null | undefined } | null | undefined> | null | undefined } };

export type UpdateContentApprovalsMutationVariables = Exact<{
  content_id: Scalars['String'];
  group_id_approvals: Array<Maybe<GroupIdApprovalInput>> | Maybe<GroupIdApprovalInput>;
}>;


export type UpdateContentApprovalsMutation = { updateContentApprovals?: { content_id: string } | null | undefined };

export type UpdateExpressActivatedUsersMutationVariables = Exact<{
  users: Array<Maybe<UpdateExpressActivatedUsersInput>> | Maybe<UpdateExpressActivatedUsersInput>;
}>;


export type UpdateExpressActivatedUsersMutation = { updateExpressActivatedUsers: { message?: string | null | undefined, updated_users?: Array<{ email_address: string, status: string, updated: boolean } | null | undefined> | null | undefined } };

export type UpdateExternalShareMutationVariables = Exact<{
  data: ExternalShareUpdateInput;
  share_id: Scalars['ID'];
}>;


export type UpdateExternalShareMutation = { updateExternalShare: boolean };

export type UpdateGroupMutationVariables = Exact<{
  data: UpdateGroupInput;
}>;


export type UpdateGroupMutation = { updateGroup: { id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } };

export type UpdateGroupSourceMutationVariables = Exact<{
  data: ClientGroupSourceUpdate;
}>;


export type UpdateGroupSourceMutation = { clientGroupSourceUpdate: { id: string, group_id: string, source_status: SourceStatus, source_type: GroupSourceType, source_value: string, approval?: ContentApproval | null | undefined } };

export type UpdateManualNotificationMutationVariables = Exact<{
  data: ManualNotificationsItemUpdateInput;
}>;


export type UpdateManualNotificationMutation = { updateManualNotification?: { id: string, notification_type?: ManualNotificationType | null | undefined, send_at: number, segment_ids: Array<string | null | undefined>, created_at: number, user_count?: number | null | undefined, email_count?: number | null | undefined, entire_company?: boolean | null | undefined, segments: Array<{ id: string, title: string } | null | undefined>, message: { body: string, url?: string | null | undefined }, email?: { subject: string, body: string, format?: ManualNotificationEmailFormat | null | undefined } | null | undefined } | null | undefined };

export type UpdateScheduledSharesMutationVariables = Exact<{
  data: ScheduledShareContentInput;
}>;


export type UpdateScheduledSharesMutation = { updateScheduledShares: Array<{ id: string, network: string, network_id: string, user_commentary: string, share_at: string, shared_at?: string | null | undefined, share_session_id: string }> };

export type UpdateUserManagementUserProfileMutationVariables = Exact<{
  input: UpdateUserManagementUserProfileInput;
}>;


export type UpdateUserManagementUserProfileMutation = { updateUserManagementUserProfile: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, email_address_verified: boolean, user_type: UserType, user_status: UserStatus, user_pool_id: string, client_id: string, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, last_onboarding_step?: number | null | undefined, lang?: string | null | undefined, onboarding_completed?: boolean | null | undefined, last_accessed_at?: number | null | undefined, user_timezone?: string | null | undefined, created_at?: number | null | undefined, german_privacy?: boolean | null | undefined, reach?: number | null | undefined, notification_delivery_types?: Array<NotificationDeliveryType | null | undefined> | null | undefined, getstream_token?: string | null | undefined, setup_completed?: boolean | null | undefined, smart_schedule_acknowledgement?: boolean | null | undefined, smart_schedule_viewed?: boolean | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, group_moderator?: Array<{ group_id: string, user_id: string, created_at: number, added_by_user_id: string, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, push_notification_configuration?: Array<{ device_platform: string, token: string } | null | undefined> | null | undefined, push_notifications_status?: { paused: boolean, paused_at?: number | null | undefined } | null | undefined } };

export type UpdateUserProfileMutationVariables = Exact<{
  data: UserProfileInput;
  client_id?: Maybe<Scalars['ID']>;
}>;


export type UpdateUserProfileMutation = { updateUserProfile: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, email_address_verified: boolean, user_type: UserType, user_status: UserStatus, user_pool_id: string, client_id: string, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, last_onboarding_step?: number | null | undefined, lang?: string | null | undefined, onboarding_completed?: boolean | null | undefined, last_accessed_at?: number | null | undefined, user_timezone?: string | null | undefined, created_at?: number | null | undefined, german_privacy?: boolean | null | undefined, reach?: number | null | undefined, notification_delivery_types?: Array<NotificationDeliveryType | null | undefined> | null | undefined, getstream_token?: string | null | undefined, setup_completed?: boolean | null | undefined, smart_schedule_acknowledgement?: boolean | null | undefined, smart_schedule_viewed?: boolean | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, group_moderator?: Array<{ group_id: string, user_id: string, created_at: number, added_by_user_id: string, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, push_notification_configuration?: Array<{ device_platform: string, token: string } | null | undefined> | null | undefined, push_notifications_status?: { paused: boolean, paused_at?: number | null | undefined } | null | undefined } };

export type UpdateUserProfileOnboardingMutationVariables = Exact<{
  data: UserProfileOnboardingInput;
}>;


export type UpdateUserProfileOnboardingMutation = { updateUserProfileOnboarding: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, email_address_verified: boolean, user_type: UserType, user_status: UserStatus, user_pool_id: string, client_id: string, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, last_onboarding_step?: number | null | undefined, lang?: string | null | undefined, onboarding_completed?: boolean | null | undefined, last_accessed_at?: number | null | undefined, user_timezone?: string | null | undefined, created_at?: number | null | undefined, german_privacy?: boolean | null | undefined, reach?: number | null | undefined, notification_delivery_types?: Array<NotificationDeliveryType | null | undefined> | null | undefined, getstream_token?: string | null | undefined, setup_completed?: boolean | null | undefined, smart_schedule_acknowledgement?: boolean | null | undefined, smart_schedule_viewed?: boolean | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, group_moderator?: Array<{ group_id: string, user_id: string, created_at: number, added_by_user_id: string, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, push_notification_configuration?: Array<{ device_platform: string, token: string } | null | undefined> | null | undefined, push_notifications_status?: { paused: boolean, paused_at?: number | null | undefined } | null | undefined } };

export type UpdateUserRoiValuesMutationVariables = Exact<{
  user_id: Scalars['ID'];
  roi_currency_values: RoiCurrencyValuesInput;
}>;


export type UpdateUserRoiValuesMutation = { updateUserROIValues?: { status: boolean } | null | undefined };

export type UpdateUserSegmentMutationVariables = Exact<{
  data: UpdateUserSegmentInput;
}>;


export type UpdateUserSegmentMutation = { updateUserSegment: { id: string, title: string, created_at?: number | null | undefined, segment_status: SegmentStatus, department_ids?: Array<string | null | undefined> | null | undefined, location_ids?: Array<string | null | undefined> | null | undefined, group_ids?: Array<string | null | undefined> | null | undefined, registered_count?: number | null | undefined, third_party_count?: number | null | undefined, departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } };

export type UpsertBillingCustomerMutationVariables = Exact<{ [key: string]: never; }>;


export type UpsertBillingCustomerMutation = { upsertBillingCustomer: { status: boolean } };

export type BootstrapQueryVariables = Exact<{
  user_id: Scalars['ID'];
}>;


export type BootstrapQuery = { bootstrap: { release_toggles?: Array<string | null | undefined> | null | undefined, capabilities?: Array<string | null | undefined> | null | undefined, client: { created_at: number, email_from_address?: string | null | undefined, allow_user_invites: boolean, content_domains?: Array<string | null | undefined> | null | undefined, allow_group_creation: boolean, disable_comments: boolean, allow_external_share: boolean, sort_mode?: SortMode | null | undefined, email_address?: string | null | undefined, sso_provider?: string | null | undefined, allow_sharing?: boolean | null | undefined, email_sending_domain?: string | null | undefined, compliance_notification_emails?: Array<string | null | undefined> | null | undefined, compliance_notification_enabled?: boolean | null | undefined, moderator_can_mark_as_important?: boolean | null | undefined, is_self_serve?: boolean | null | undefined, referral_headline?: string | null | undefined, referral_message?: string | null | undefined, stickers_enabled?: boolean | null | undefined, features?: Array<Feature | null | undefined> | null | undefined, setup_completed?: boolean | null | undefined, feature_plan_type?: FeaturePlanType | null | undefined, billing_status?: BillingStatusType | null | undefined, billing_type?: BillingTypeType | null | undefined, billing_teams_trial_start?: number | null | undefined, billing_teams_trial_end?: number | null | undefined, contract_committed_user_count?: number | null | undefined, contract_type?: ContractType | null | undefined, contract_end_at?: number | null | undefined, contract_start_at?: number | null | undefined, added_by_user_id: string, allow_group_discovery: boolean, allow_user_share_commentary: boolean, departments_in_signup: boolean, locations_in_signup: boolean, updated_at: number, menu_item_enabled?: boolean | null | undefined, yearly_enrichment_quota?: number | null | undefined, id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy_url?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, stickers?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, disclosures?: Array<{ id: string, disclosure: string, disclosure_status: ClientDisclosureStatus } | null | undefined> | null | undefined, social_config?: { twitter_shareable?: boolean | null | undefined, twitter_engageable?: boolean | null | undefined, linkedin_shareable?: boolean | null | undefined, linkedin_engageable?: boolean | null | undefined, facebook_shareable?: boolean | null | undefined, facebook_engageable?: boolean | null | undefined, youtube_shareable?: boolean | null | undefined, youtube_engageable?: boolean | null | undefined, instagram_shareable?: boolean | null | undefined, instagram_engageable?: boolean | null | undefined, reddit_shareable?: boolean | null | undefined, reddit_engageable?: boolean | null | undefined, tiktok_shareable?: boolean | null | undefined, tiktok_engageable?: boolean | null | undefined, weibo_shareable?: boolean | null | undefined, weibo_engageable?: boolean | null | undefined, wechat_shareable?: boolean | null | undefined, wechat_engageable?: boolean | null | undefined } | null | undefined, billing?: { billable_user_count: number, stripe_account_id: string, stripe_customer_id: string, stripe_price_id: string, stripe_product_id: string, stripe_subscription_id: string, stripe_subscription_item_id: string } | null | undefined, billing_address?: { address: string, address2?: string | null | undefined, city: string, state: string, zip: string, country: string } | null | undefined, menu_item?: { title: string, link: string } | null | undefined, icon?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, client_aliases?: Array<{ company_id: string, name: string } | null | undefined> | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined }, user: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, email_address_verified: boolean, user_type: UserType, user_status: UserStatus, user_pool_id: string, client_id: string, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, last_onboarding_step?: number | null | undefined, lang?: string | null | undefined, onboarding_completed?: boolean | null | undefined, last_accessed_at?: number | null | undefined, user_timezone?: string | null | undefined, created_at?: number | null | undefined, german_privacy?: boolean | null | undefined, reach?: number | null | undefined, notification_delivery_types?: Array<NotificationDeliveryType | null | undefined> | null | undefined, getstream_token?: string | null | undefined, setup_completed?: boolean | null | undefined, smart_schedule_acknowledgement?: boolean | null | undefined, smart_schedule_viewed?: boolean | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, group_moderator?: Array<{ group_id: string, user_id: string, created_at: number, added_by_user_id: string, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, push_notification_configuration?: Array<{ device_platform: string, token: string } | null | undefined> | null | undefined, push_notifications_status?: { paused: boolean, paused_at?: number | null | undefined } | null | undefined } | {}, user_leaderboards?: Array<{ id: string, title: string, description?: string | null | undefined, leaderboard_status: GenericStatus, created_at: number, start_at?: number | null | undefined, end_at?: number | null | undefined, all_users: boolean, segment_ids?: Array<string | null | undefined> | null | undefined, segments?: Array<{ id: string, title: string, created_at?: number | null | undefined, segment_status: SegmentStatus, department_ids?: Array<string | null | undefined> | null | undefined, location_ids?: Array<string | null | undefined> | null | undefined, group_ids?: Array<string | null | undefined> | null | undefined, registered_count?: number | null | undefined, third_party_count?: number | null | undefined, departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, scoring_aggregate?: { everyonesocial?: { posting?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined, actions?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined, teammates?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, linkedin?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, twitter?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, facebook?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined } | null | undefined }> | null | undefined, user_social_accounts?: Array<{ id: string, provider: Network, identifier?: string | null | undefined, profile_name?: string | null | undefined, reach?: number | null | undefined, expires_soon: boolean, profile_url?: string | null | undefined, profile_picture?: string | null | undefined, smart_schedule?: boolean | null | undefined }> | null | undefined, user_pages?: Array<{ id: string, identifier?: string | null | undefined, logo?: string | null | undefined, profile_name?: string | null | undefined, profile_url?: string | null | undefined, provider: Network, role?: string | null | undefined, urn?: string | null | undefined }> | null | undefined } };

export type ClientDailyStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  grouping: StatsGrouping;
}>;


export type ClientDailyStatsQuery = { clientDailyStats?: { total_posts: number, total_shares: number, total_clicks: number, total_users: number, data: Array<{ posts: number, clicks: number, shares: number, users: number, calendar_day: string } | null | undefined> } | null | undefined };

export type ClientEngagementStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  grouping: StatsGrouping;
  value: Scalars['Int'];
}>;


export type ClientEngagementStatsQuery = { clientEngagementStats?: { comments: number, reactions: number, posts: number, groups: number, users: number } | null | undefined };

export type ClientReachStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  grouping: StatsGrouping;
  value: Scalars['Int'];
}>;


export type ClientReachStatsQuery = { clientReachStats?: Array<{ reach: number, previous_reach?: number | null | undefined, provider: string, profile_identifier?: string | null | undefined } | null | undefined> | null | undefined };

export type DailyGroupStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
  filter?: Maybe<ReportingFilter>;
}>;


export type DailyGroupStatsQuery = { dailyGroupStats?: { summary: { active_groups: number, inactive_groups: number, change: number }, data?: Array<{ active_groups: number, inactive_groups: number, calendar_day: string } | null | undefined> | null | undefined } | null | undefined };

export type DailyLeaderboardStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  leaderboard_config_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
}>;


export type DailyLeaderboardStatsQuery = { dailyLeaderboardStats?: { summary: { internal_points: number, external_points: number, change: number }, data?: Array<{ internal_points: number, external_points: number, calendar_day: string } | null | undefined> | null | undefined } | null | undefined };

export type DailyPostStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
  filter?: Maybe<ReportingFilter>;
}>;


export type DailyPostStatsQuery = { dailyPostStats?: { summary: { branded_posts: number, non_branded_posts: number, change: number }, data?: Array<{ branded_posts: number, non_branded_posts: number, calendar_day: string } | null | undefined> | null | undefined } | null | undefined };

export type DailyShareStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
  filter?: Maybe<ReportingFilter>;
}>;


export type DailyShareStatsQuery = { dailyShareStats?: { summary: { branded_shares: number, non_branded_shares: number, change: number }, data?: Array<{ branded_shares: number, non_branded_shares: number, calendar_day: string } | null | undefined> | null | undefined } | null | undefined };

export type DailyUserStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
  filter?: Maybe<ReportingFilter>;
}>;


export type DailyUserStatsQuery = { dailyUserStats?: { summary: { active_users: number, inactive_users: number, change: number }, data?: Array<{ active_users: number, inactive_users: number, calendar_day: string } | null | undefined> | null | undefined } | null | undefined };

export type ExternalOverviewStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
}>;


export type ExternalOverviewStatsQuery = { externalOverviewStats?: { summary: { shares: { count: number, change: number }, clicks: { count: number, change: number }, engagements: { count: number, change: number }, impressions?: { count: number, change: number } | null | undefined }, data?: Array<{ calendar_day: string, branded_shares: number, non_branded_shares: number, branded_clicks: number, non_branded_clicks: number, branded_engagements: number, non_branded_engagements: number, impressions?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ExternalSharesQueryVariables = Exact<{
  client_id: Scalars['ID'];
  timestamp_end: Scalars['Int'];
  timestamp_start: Scalars['Int'];
  user_id: Scalars['ID'];
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  sort?: Maybe<ExternalSharesSortFields>;
  sort_direction?: Maybe<SortDirections>;
}>;


export type ExternalSharesQuery = { externalShares?: { page?: number | null | undefined, per_page?: number | null | undefined, results?: Array<{ article_title?: string | null | undefined, engagement_count?: number | null | undefined, first_engaged_at?: number | null | undefined, network: Network, shared_image_url?: string | null | undefined, share_id: string, share_url?: string | null | undefined, user_commentary?: string | null | undefined, user_email?: string | null | undefined, user_reach?: number | null | undefined, linkedin_page_share: boolean } | null | undefined> | null | undefined } | null | undefined };

export type GetGroupFollowersQueryVariables = Exact<{
  data?: Maybe<FeedFollowingInput>;
}>;


export type GetGroupFollowersQuery = { feedFollowing?: { id: string, paginate: boolean, count?: number | null | undefined, user_id?: string | null | undefined, feed: FeedKey, start_key?: string | null | undefined, feed_follows?: Array<{ feed: FeedKey, user_id: string, created_at: number, postable: boolean, group_role?: GroupRole | null | undefined, required?: boolean | null | undefined, group?: { id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, followed_by_user: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } } | null | undefined> | null | undefined } | null | undefined };

export type GetUserFollowersQueryVariables = Exact<{
  data?: Maybe<FeedFollowingInput>;
}>;


export type GetUserFollowersQuery = { feedFollowing?: { id: string, paginate: boolean, count?: number | null | undefined, user_id?: string | null | undefined, feed: FeedKey, start_key?: string | null | undefined, feed_follows?: Array<{ feed: FeedKey, user_id: string, created_at: number, postable: boolean, group_role?: GroupRole | null | undefined, required?: boolean | null | undefined, group?: { id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, followed_by_user: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } } | null | undefined> | null | undefined } | null | undefined };

export type GetAllClientDepartmentsQueryVariables = Exact<{
  data: ClientDepartmentListInput;
  override?: Maybe<OverrideInput>;
}>;


export type GetAllClientDepartmentsQuery = { getAllClientDepartments: { count: number, paginate: boolean, title_lower?: string | null | undefined, id?: string | null | undefined, client_departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined } };

export type GetAllClientDisclosuresQueryVariables = Exact<{
  data: ClientDisclosureListInput;
  override?: Maybe<OverrideInput>;
}>;


export type GetAllClientDisclosuresQuery = { getAllClientDisclosures: { count: number, paginate: boolean, id?: string | null | undefined, client_disclosures?: Array<{ id: string, disclosure: string, disclosure_status: ClientDisclosureStatus } | null | undefined> | null | undefined } };

export type GetAllClientFollowMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllClientFollowMappingsQuery = { getAllClientFollowMappings: { client_follow_mappings?: Array<{ id: string, title: string, mapping_status: ClientFollowMappingStatus, all_users?: boolean | null | undefined, follow_condition_conjunction?: boolean | null | undefined, required_groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, suggested_groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, required_users?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, suggested_users?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, follow_conditions?: { department_id?: Array<string | null | undefined> | null | undefined, location_id?: Array<string | null | undefined> | null | undefined, language?: Array<string | null | undefined> | null | undefined, email_domain?: Array<string | null | undefined> | null | undefined, departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined> | null | undefined } };

export type GetAllClientLocationsQueryVariables = Exact<{
  data: ClientLocationListInput;
  override?: Maybe<OverrideInput>;
}>;


export type GetAllClientLocationsQuery = { getAllClientLocations: { count: number, paginate: boolean, title_lower?: string | null | undefined, id?: string | null | undefined, client_locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined } };

export type GetAllClientUrlParamsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllClientUrlParamsQuery = { getAllClientUrlParams?: Array<{ id: string, params_status?: ParamsStatus | null | undefined, content_domain: string, configuration?: Array<{ key: string, value?: string | null | undefined, dynamic_value?: ClientUrlParamsDynamicValues | null | undefined, value_options?: Array<string | null | undefined> | null | undefined, default_option_value?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type GetApiTokensQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApiTokensQuery = { getAPITokens?: Array<{ token_id: string, token_name: string, created_at: number }> | null | undefined };

export type GetAssignmentQueryVariables = Exact<{
  id: Scalars['ID'];
  client_id: Scalars['ID'];
}>;


export type GetAssignmentQuery = { getAssignment?: { id: string, title?: string | null | undefined, groups_required?: number | null | undefined, users_required?: number | null | undefined, groups_suggested?: number | null | undefined, users_suggested?: number | null | undefined, extracted_users?: number | null | undefined, active: boolean, target_user: AssignmentTargetUser, groups_required_objects?: Array<{ client_id: string, id: string, title: string, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, color_map: { hex: string, label: string, group_color?: GroupColor | null | undefined }, icon_color_map: { hex: string, label: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { bucket: string, label: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, groups_suggested_objects?: Array<{ client_id: string, id: string, title: string, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, color_map: { hex: string, label: string, group_color?: GroupColor | null | undefined }, icon_color_map: { hex: string, label: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { bucket: string, label: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, users_required_objects?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, users_suggested_objects?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, rule: { all_users: boolean, operator: AssignmentOperator, department_ids?: Array<string | null | undefined> | null | undefined, location_ids?: Array<string | null | undefined> | null | undefined } } | null | undefined };

export type GetAssignmentsQueryVariables = Exact<{
  active?: Maybe<Scalars['Boolean']>;
  client_id: Scalars['ID'];
}>;


export type GetAssignmentsQuery = { getAssignments?: { total_count: number, next_id?: string | null | undefined, results?: Array<{ id: string, title?: string | null | undefined, groups_required?: number | null | undefined, users_required?: number | null | undefined, groups_suggested?: number | null | undefined, users_suggested?: number | null | undefined, extracted_users?: number | null | undefined, active: boolean, target_user: AssignmentTargetUser, groups_required_objects?: Array<{ client_id: string, id: string, title: string, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, color_map: { hex: string, label: string, group_color?: GroupColor | null | undefined }, icon_color_map: { hex: string, label: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { bucket: string, label: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, groups_suggested_objects?: Array<{ client_id: string, id: string, title: string, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, color_map: { hex: string, label: string, group_color?: GroupColor | null | undefined }, icon_color_map: { hex: string, label: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { bucket: string, label: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, users_required_objects?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, users_suggested_objects?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, rule: { all_users: boolean, operator: AssignmentOperator, department_ids?: Array<string | null | undefined> | null | undefined, location_ids?: Array<string | null | undefined> | null | undefined } } | null | undefined> | null | undefined } | null | undefined };

export type GetBillingUrlQueryVariables = Exact<{
  client_id: Scalars['ID'];
  user_id: Scalars['ID'];
  return_url: Scalars['String'];
  plan_type?: Maybe<BillingPortalPlanType>;
  route?: Maybe<BillingPortalRoute>;
}>;


export type GetBillingUrlQuery = { getBillingCustomerPortalEphemeralUrl: { url: string } };

export type GetChatChannelsQueryVariables = Exact<{
  network: Network;
  team_id?: Maybe<Scalars['String']>;
}>;


export type GetChatChannelsQuery = { getChatChannels?: { msteams_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string } | null | undefined> | null | undefined, slack_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string } | null | undefined> | null | undefined } | null | undefined };

export type GetChatTeamsQueryVariables = Exact<{
  network: Network;
}>;


export type GetChatTeamsQuery = { getChatTeams?: { ms_teams?: Array<{ team_id: string, team_name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetClientBillingReportAggregateQueryVariables = Exact<{
  calendar_month__eq?: Maybe<Scalars['String']>;
}>;


export type GetClientBillingReportAggregateQuery = { getClientBillingReportAggregate?: { contract_end_at?: number | null | undefined, num_email_users: number, num_anonymous_users: number, num_registered_users: number, total_users: number, last_month_total_users?: number | null | undefined, two_months_ago_total_users?: number | null | undefined, usage_rate?: number | null | undefined, user_overage?: number | null | undefined, updated_at: string, created_at: string, contract_type?: ContractType | null | undefined, contract_start_at?: number | null | undefined, contract_committed_user_count?: number | null | undefined, client_subdomain: string, client_id: string, calendar_month: string } | null | undefined };

export type GetClientContentTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientContentTagsQuery = { getClientContentTags?: Array<{ tag_id: string, title: string } | null | undefined> | null | undefined };

export type GetClientDepartmentsByStatusQueryVariables = Exact<{
  override?: Maybe<OverrideInput>;
}>;


export type GetClientDepartmentsByStatusQuery = { getClientDepartmentsByStatus: { count: number, paginate: boolean, department_status?: ClientDepartmentStatus | null | undefined, title?: string | null | undefined, id?: string | null | undefined, client_departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined } };

export type GetClientInvitationsByClientQueryVariables = Exact<{
  count?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['Int']>;
  invitation_status: ClientInvitationStatus;
}>;


export type GetClientInvitationsByClientQuery = { getClientInvitationsByClient: { count: number, paginate: boolean, invitation_status: ClientInvitationStatus, created_at?: number | null | undefined, id?: string | null | undefined, client_id: string, client_invitations?: Array<{ id: string, client_id: string, email_address: string, invitation_status: ClientInvitationStatus, created_at: number, updated_at: number, accepted_at?: number | null | undefined, user_type?: UserType | null | undefined, accepted_by_user?: { id: string, full_name?: string | null | undefined, email_address: string, user_status: UserStatus, onboarding_completed?: boolean | null | undefined, user_type: UserType } | null | undefined, added_by_user?: { id: string, full_name?: string | null | undefined, email_address: string } | null | undefined } | null | undefined> | null | undefined } };

export type GetClientLocationsByStatusQueryVariables = Exact<{
  override?: Maybe<OverrideInput>;
}>;


export type GetClientLocationsByStatusQuery = { getClientLocationsByStatus: { count: number, paginate: boolean, location_status?: ClientLocationStatus | null | undefined, title?: string | null | undefined, id?: string | null | undefined, client_locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined } };

export type GetClientPageMappingsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetClientPageMappingsQuery = { getClientPageMappings?: Array<{ active: boolean, connected_count: number, linkedin_page_id: string, name: string, token_ids?: Array<string> | null | undefined } | null | undefined> | null | undefined };

export type GetCompaniesQueryVariables = Exact<{
  start: Scalars['Int'];
  end: Scalars['Int'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  hide_company: Scalars['Boolean'];
  sort_by?: Maybe<OrganicInsightsSortParam>;
  advanced_filters?: Maybe<OrganicInsightsAdvancedFilters>;
}>;


export type GetCompaniesQuery = { getCompanies?: { total: number, results: Array<{ rank?: number | null | undefined, total_engagers?: number | null | undefined, change?: number | null | undefined, company?: { company_logo?: string | null | undefined, job_company_name?: string | null | undefined } | null | undefined, engager_roles?: Array<{ role?: string | null | undefined } | null | undefined> | null | undefined, engager_titles?: Array<{ title?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> } | null | undefined };

export type GetContentQueryVariables = Exact<{
  content_id: Scalars['String'];
  display_only?: Maybe<Scalars['Boolean']>;
}>;


export type GetContentQuery = { getContent?: { approval?: ContentApproval | null | undefined, content_id: string, content_source_id?: string | null | undefined, is_branded?: boolean | null | undefined, is_shareable?: boolean | null | undefined, is_important?: boolean | null | undefined, is_important_message?: string | null | undefined, is_engage?: boolean | null | undefined, is_engageable?: boolean | null | undefined, is_pinned?: boolean | null | undefined, pinned_end_at?: number | null | undefined, important_to_share?: boolean | null | undefined, reaction_count?: number | null | undefined, comment_count?: number | null | undefined, share_count?: number | null | undefined, engage_count?: number | null | undefined, click_count?: number | null | undefined, publish_at: number, group_ids: Array<string | null | undefined>, primary_group_id?: string | null | undefined, has_requesting_user_shared?: boolean | null | undefined, lock_commentary?: boolean | null | undefined, submitter_role?: SubmitterRole | null | undefined, user_id?: string | null | undefined, slack_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, ms_teams_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, pinned_to_groups?: Array<{ group_id: string, pinned_end_at?: number | null | undefined } | null | undefined> | null | undefined, commentary?: Array<{ network: Network, commentary: string, mentions?: Array<{ provider: string, identifier: string, start: number, length: number } | null | undefined> | null | undefined } | null | undefined> | null | undefined, disclosures?: Array<{ network: Network, disclosure_id: string } | null | undefined> | null | undefined, group_id_approvals: Array<{ group_id?: string | null | undefined, approval?: ContentApproval | null | undefined } | null | undefined>, content_object: { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id?: string | null | undefined } | null | undefined, instagram_metadata?: { id?: string | null | undefined, shortcode?: string | null | undefined } | null | undefined, reddit_metadata?: { url: string } | null | undefined }, reactions?: { user_reactions?: Array<ReactionType | null | undefined> | null | undefined, reaction_count?: { total: number } | null | undefined, reaction_user_details?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined, groups?: Array<{ id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, url_param_values?: Array<{ key: string, value?: string | null | undefined } | null | undefined> | null | undefined, reacted_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, shared_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, commented_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, schedule?: { publish?: number | null | undefined, expire?: number | null | undefined } | null | undefined, audit?: Array<{ ACTION: string, time?: number | null | undefined, by_user_id?: string | null | undefined, message?: string | null | undefined, by_user_profile?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, content_tags?: Array<{ title: string, tag_id: string } | null | undefined> | null | undefined } | null | undefined };

export type GetContentEmailHistoryQueryVariables = Exact<{
  data: ContentEmailHistoryListInput;
}>;


export type GetContentEmailHistoryQuery = { getContentEmailHistory: { paginate: boolean, sent_at?: number | null | undefined, spec_id?: string | null | undefined, history?: Array<{ spec_id: string, sent_at: number, registered_user_count: number, unregistered_user_count: number, total_opened: number, total_emails: number, total_delivered: number, total_clicks: number, spec: { id: string, title: string, segment_ids: Array<string | null | undefined>, all_users: boolean, created_at?: number | null | undefined, send_at: number, delivery_interval?: number | null | undefined, grouping_interval?: number | null | undefined, banner_url?: string | null | undefined, intro?: string | null | undefined, footer?: string | null | undefined, email_from?: string | null | undefined, email_reply_to?: string | null | undefined, subject?: string | null | undefined, config_status?: GenericStatus | null | undefined, use_sto?: boolean | null | undefined, content_specs: Array<{ id?: string | null | undefined, content_type: ContentEmailType } | null | undefined>, banner?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined }, featured_content?: Array<{ approval?: ContentApproval | null | undefined, content_id: string, content_source_id?: string | null | undefined, is_branded?: boolean | null | undefined, is_shareable?: boolean | null | undefined, is_important?: boolean | null | undefined, is_important_message?: string | null | undefined, is_engage?: boolean | null | undefined, is_engageable?: boolean | null | undefined, is_pinned?: boolean | null | undefined, pinned_end_at?: number | null | undefined, important_to_share?: boolean | null | undefined, reaction_count?: number | null | undefined, comment_count?: number | null | undefined, share_count?: number | null | undefined, engage_count?: number | null | undefined, click_count?: number | null | undefined, publish_at: number, group_ids: Array<string | null | undefined>, primary_group_id?: string | null | undefined, has_requesting_user_shared?: boolean | null | undefined, lock_commentary?: boolean | null | undefined, submitter_role?: SubmitterRole | null | undefined, user_id?: string | null | undefined, slack_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, ms_teams_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, pinned_to_groups?: Array<{ group_id: string, pinned_end_at?: number | null | undefined } | null | undefined> | null | undefined, commentary?: Array<{ network: Network, commentary: string, mentions?: Array<{ provider: string, identifier: string, start: number, length: number } | null | undefined> | null | undefined } | null | undefined> | null | undefined, disclosures?: Array<{ network: Network, disclosure_id: string } | null | undefined> | null | undefined, group_id_approvals: Array<{ group_id?: string | null | undefined, approval?: ContentApproval | null | undefined } | null | undefined>, content_object: { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id?: string | null | undefined } | null | undefined, instagram_metadata?: { id?: string | null | undefined, shortcode?: string | null | undefined } | null | undefined, reddit_metadata?: { url: string } | null | undefined }, reactions?: { user_reactions?: Array<ReactionType | null | undefined> | null | undefined, reaction_count?: { total: number } | null | undefined, reaction_user_details?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined, groups?: Array<{ id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, url_param_values?: Array<{ key: string, value?: string | null | undefined } | null | undefined> | null | undefined, reacted_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, shared_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, commented_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, schedule?: { publish?: number | null | undefined, expire?: number | null | undefined } | null | undefined, audit?: Array<{ ACTION: string, time?: number | null | undefined, by_user_id?: string | null | undefined, message?: string | null | undefined, by_user_profile?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, content_tags?: Array<{ title: string, tag_id: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } };

export type GetContentEmailSpecQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetContentEmailSpecQuery = { getContentEmailSpec?: { id: string, title: string, segment_ids: Array<string | null | undefined>, all_users: boolean, created_at?: number | null | undefined, send_at: number, delivery_interval?: number | null | undefined, grouping_interval?: number | null | undefined, banner_url?: string | null | undefined, intro?: string | null | undefined, footer?: string | null | undefined, email_from?: string | null | undefined, email_reply_to?: string | null | undefined, subject?: string | null | undefined, config_status?: GenericStatus | null | undefined, use_sto?: boolean | null | undefined, content_specs: Array<{ id?: string | null | undefined, content_type: ContentEmailType } | null | undefined>, banner?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined };

export type GetContentEmailSpecsQueryVariables = Exact<{
  data: ContentEmailSpecListInput;
}>;


export type GetContentEmailSpecsQuery = { getContentEmailSpecs: { paginate: boolean, created_at?: number | null | undefined, id?: string | null | undefined, items: Array<{ id: string, title: string, segment_ids: Array<string | null | undefined>, all_users: boolean, created_at?: number | null | undefined, send_at: number, delivery_interval?: number | null | undefined, grouping_interval?: number | null | undefined, banner_url?: string | null | undefined, intro?: string | null | undefined, footer?: string | null | undefined, email_from?: string | null | undefined, email_reply_to?: string | null | undefined, subject?: string | null | undefined, config_status?: GenericStatus | null | undefined, use_sto?: boolean | null | undefined, content_specs: Array<{ id?: string | null | undefined, content_type: ContentEmailType } | null | undefined>, banner?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> } };

export type GetContentUrlParamOptionsQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type GetContentUrlParamOptionsQuery = { getContentUrlParamOptions?: Array<{ key: string, options: Array<string | null | undefined>, default_option_value?: string | null | undefined } | null | undefined> | null | undefined };

export type GetEbrIntroductionQueryVariables = Exact<{
  start: Scalars['Int'];
  end: Scalars['Int'];
  client_id: Scalars['ID'];
}>;


export type GetEbrIntroductionQuery = { getEbrIntroduction: { registered_users_count?: number | null | undefined, shares_count?: number | null | undefined, top_companies?: Array<{ company_logo?: string | null | undefined, job_company_name?: string | null | undefined } | null | undefined> | null | undefined, top_profiles?: Array<{ title?: string | null | undefined, role?: string | null | undefined, name?: string | null | undefined, network_profile_image?: string | null | undefined, network_profile_url?: string | null | undefined, company?: { company_logo?: string | null | undefined, job_company_name?: string | null | undefined } | null | undefined, engagement_summary?: { engagements?: number | null | undefined, first_engagement?: number | null | undefined, last_engagement?: number | null | undefined, last_engagement_detail?: { network?: Network | null | undefined, engagement_type?: InsightsEngagementType | null | undefined, share_url?: string | null | undefined, content_url?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined } };

export type GetEbrOrganicInsightsQueryVariables = Exact<{
  start: Scalars['Int'];
  end: Scalars['Int'];
  client_id: Scalars['ID'];
}>;


export type GetEbrOrganicInsightsQuery = { getEbrOrganicInsights: { key_insights?: string | null | undefined, top_companies?: Array<{ company_logo?: string | null | undefined, job_company_name?: string | null | undefined } | null | undefined> | null | undefined, countries?: Array<{ count: number, name: string, percentage: number } | null | undefined> | null | undefined, company_industries?: Array<{ count: number, name: string, percentage: number } | null | undefined> | null | undefined, company_sizes?: Array<{ count: number, name: string, percentage: number } | null | undefined> | null | undefined, job_titles?: Array<{ count: number, name: string, percentage: number } | null | undefined> | null | undefined, job_roles?: Array<{ count: number, name: string, percentage: number } | null | undefined> | null | undefined } };

export type GetEmployeesQueryVariables = Exact<{
  start: Scalars['Int'];
  end: Scalars['Int'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  registration_status: RegistrationStatus;
  sort_by?: Maybe<OrganicInsightsSortParam>;
  advanced_filters?: Maybe<OrganicInsightsAdvancedFilters>;
}>;


export type GetEmployeesQuery = { getEmployees?: { total: number, results: Array<{ profile_id?: string | null | undefined, rank?: number | null | undefined, name?: string | null | undefined, role?: string | null | undefined, network_bio?: string | null | undefined, network_profile_image?: string | null | undefined, email_address?: string | null | undefined, location?: string | null | undefined, registered?: boolean | null | undefined, engagement_summary?: { engagements?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type GetExpressActivatedUsersQueryVariables = Exact<{
  filters: ExpressActivationFiltersInput;
  last_evaluated_key: Scalars['String'];
}>;


export type GetExpressActivatedUsersQuery = { getExpressActivatedUsers?: { message: string, total: number, last_evaluated_key?: string | null | undefined, users: Array<{ email: string, access_key: string, created_at: number, status: string, registered_networks: Array<{ provider?: string | null | undefined, reach?: number | null | undefined, profile_image_url?: string | null | undefined, profile_name?: string | null | undefined, profile_url_suffix?: string | null | undefined } | null | undefined> } | null | undefined> } | null | undefined };

export type GetFeedQueryVariables = Exact<{
  key: Scalars['String'];
  id: Scalars['String'];
  limit: Scalars['Int'];
  id_lt?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  sort: Scalars['Boolean'];
}>;


export type GetFeedQuery = { getFeed: { id_lt?: string | null | undefined, offset?: number | null | undefined, results?: Array<{ approval?: ContentApproval | null | undefined, content_id: string, content_source_id?: string | null | undefined, is_branded?: boolean | null | undefined, is_shareable?: boolean | null | undefined, is_important?: boolean | null | undefined, is_important_message?: string | null | undefined, is_engage?: boolean | null | undefined, is_engageable?: boolean | null | undefined, is_pinned?: boolean | null | undefined, pinned_end_at?: number | null | undefined, important_to_share?: boolean | null | undefined, reaction_count?: number | null | undefined, comment_count?: number | null | undefined, share_count?: number | null | undefined, engage_count?: number | null | undefined, click_count?: number | null | undefined, publish_at: number, group_ids: Array<string | null | undefined>, primary_group_id?: string | null | undefined, has_requesting_user_shared?: boolean | null | undefined, lock_commentary?: boolean | null | undefined, submitter_role?: SubmitterRole | null | undefined, user_id?: string | null | undefined, slack_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, ms_teams_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, pinned_to_groups?: Array<{ group_id: string, pinned_end_at?: number | null | undefined } | null | undefined> | null | undefined, commentary?: Array<{ network: Network, commentary: string, mentions?: Array<{ provider: string, identifier: string, start: number, length: number } | null | undefined> | null | undefined } | null | undefined> | null | undefined, disclosures?: Array<{ network: Network, disclosure_id: string } | null | undefined> | null | undefined, group_id_approvals: Array<{ group_id?: string | null | undefined, approval?: ContentApproval | null | undefined } | null | undefined>, content_object: { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id?: string | null | undefined } | null | undefined, instagram_metadata?: { id?: string | null | undefined, shortcode?: string | null | undefined } | null | undefined, reddit_metadata?: { url: string } | null | undefined }, reactions?: { user_reactions?: Array<ReactionType | null | undefined> | null | undefined, reaction_count?: { total: number } | null | undefined, reaction_user_details?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined, groups?: Array<{ id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, url_param_values?: Array<{ key: string, value?: string | null | undefined } | null | undefined> | null | undefined, reacted_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, shared_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, commented_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, schedule?: { publish?: number | null | undefined, expire?: number | null | undefined } | null | undefined, audit?: Array<{ ACTION: string, time?: number | null | undefined, by_user_id?: string | null | undefined, message?: string | null | undefined, by_user_profile?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, content_tags?: Array<{ title: string, tag_id: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } };

export type GetFollowedQueryVariables = Exact<{
  data?: Maybe<PaginatedUserFeedFollowsInput>;
}>;


export type GetFollowedQuery = { getPaginatedUserFeedFollows: { count: number, title_lower?: string | null | undefined, client_id__feed__id?: string | null | undefined, feed_follows?: Array<{ feed: FeedKey, user_id: string, created_at: number, postable: boolean, group_role?: GroupRole | null | undefined, required?: boolean | null | undefined, group?: { id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, followed_by_user: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } }> | null | undefined } };

export type GetFollowersQueryVariables = Exact<{
  data?: Maybe<PaginatedFollowedByUsersInput>;
}>;


export type GetFollowersQuery = { getPaginatedFollowedByUsers: { count: number, username?: string | null | undefined, followed_by_user_id?: string | null | undefined, followed_by_users?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined }> | null | undefined } };

export type GetGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetGroupQuery = { getGroup?: { id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined };

export type GetGroupColorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupColorsQuery = { getGroupColors: Array<{ label: string, hex: string, group_color?: GroupColor | null | undefined } | null | undefined> };

export type GetGroupIconsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupIconsQuery = { getGroupIcons: Array<{ bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined, group_icon?: GroupIcon | null | undefined, label: string } | null | undefined> };

export type GetGroupModeratorsQueryVariables = Exact<{
  group_id: Scalars['ID'];
}>;


export type GetGroupModeratorsQuery = { getModeratorsByGroup?: Array<{ group_id: string, user_id: string, created_at: number, added_by_user_id: string, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type GetGroupSourcesQueryVariables = Exact<{
  group_id: Scalars['ID'];
}>;


export type GetGroupSourcesQuery = { getClientGroupSourcesByGroup?: Array<{ id: string, group_id: string, source_status: SourceStatus, source_type: GroupSourceType, source_value: string, approval?: ContentApproval | null | undefined } | null | undefined> | null | undefined };

export type GetGroupWebhookListQueryVariables = Exact<{
  group_id: Scalars['ID'];
}>;


export type GetGroupWebhookListQuery = { getGroupWebhookList?: { webhooks: Array<{ callback_url?: string | null | undefined, webhook_status: GenericStatus, webhook_id: string, webhook_name: string, webhook_type: WebhookTypes, workvivo_org_id?: string | null | undefined, workvivo_workspace_id?: string | null | undefined, groups?: Array<string | null | undefined> | null | undefined } | null | undefined>, workvivo_workspaces: Array<{ workvivo_workspace_id: string, workspace_name: string } | null | undefined> } | null | undefined };

export type GetInboxItemsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
}>;


export type GetInboxItemsQuery = { getInboxItems: { id?: string | null | undefined, created_at?: number | null | undefined, inbox?: Array<{ id: string, created_at: number, updated_at: number, item_read: boolean, message: string, to_user_id: string, url?: string | null | undefined } | null | undefined> | null | undefined } };

export type GetLeaderboardConfigQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLeaderboardConfigQuery = { getLeaderboardConfig: { id: string, title: string, description?: string | null | undefined, leaderboard_status: GenericStatus, created_at: number, start_at?: number | null | undefined, end_at?: number | null | undefined, all_users: boolean, segment_ids?: Array<string | null | undefined> | null | undefined, segments?: Array<{ id: string, title: string, created_at?: number | null | undefined, segment_status: SegmentStatus, department_ids?: Array<string | null | undefined> | null | undefined, location_ids?: Array<string | null | undefined> | null | undefined, group_ids?: Array<string | null | undefined> | null | undefined, registered_count?: number | null | undefined, third_party_count?: number | null | undefined, departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, scoring_aggregate?: { everyonesocial?: { posting?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined, actions?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined, teammates?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, linkedin?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, twitter?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, facebook?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined } | null | undefined } };

export type GetLeaderboardConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeaderboardConfigsQuery = { getLeaderboardConfigs: Array<{ id: string, title: string, description?: string | null | undefined, leaderboard_status: GenericStatus, created_at: number, start_at?: number | null | undefined, end_at?: number | null | undefined, all_users: boolean, segment_ids?: Array<string | null | undefined> | null | undefined, segments?: Array<{ id: string, title: string, created_at?: number | null | undefined, segment_status: SegmentStatus, department_ids?: Array<string | null | undefined> | null | undefined, location_ids?: Array<string | null | undefined> | null | undefined, group_ids?: Array<string | null | undefined> | null | undefined, registered_count?: number | null | undefined, third_party_count?: number | null | undefined, departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, scoring_aggregate?: { everyonesocial?: { posting?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined, actions?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined, teammates?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, linkedin?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, twitter?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, facebook?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> };

export type GetLeaderboardConfigAggregateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLeaderboardConfigAggregateQuery = { getLeaderboardConfigAggregate: { id: string, title: string, description?: string | null | undefined, leaderboard_status: GenericStatus, created_at: number, start_at?: number | null | undefined, end_at?: number | null | undefined, all_users: boolean, segment_ids?: Array<string | null | undefined> | null | undefined, segments?: Array<{ id: string, title: string, created_at?: number | null | undefined, segment_status: SegmentStatus, department_ids?: Array<string | null | undefined> | null | undefined, location_ids?: Array<string | null | undefined> | null | undefined, group_ids?: Array<string | null | undefined> | null | undefined, registered_count?: number | null | undefined, third_party_count?: number | null | undefined, departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, scoring_aggregate?: { everyonesocial?: { posting?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined, actions?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined, teammates?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, linkedin?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, twitter?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined, facebook?: { general?: Array<{ event: LeaderboardEventType, score: string } | null | undefined> | null | undefined } | null | undefined } | null | undefined } };

export type GetLeaderboardConfigScoresQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLeaderboardConfigScoresQuery = { getLeaderboardConfigScores: Array<{ event: LeaderboardEventType, score: string } | null | undefined> };

export type GetUserLeaderboardQueryVariables = Exact<{
  user_id?: Maybe<Scalars['ID']>;
  leaderboard_config_id?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetUserLeaderboardQuery = { getLeaderboardForUser?: { leaderboard_scores?: { paginate: boolean, leaderboard_config_id?: string | null | undefined, ranking?: number | null | undefined, user_id?: string | null | undefined, items?: Array<{ leaderboard_config_id: string, user_id: string, score: string, ranking: number, position_change?: number | null | undefined, user: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined }, events: Array<{ event: LeaderboardEventType, score: string } | null | undefined> } | null | undefined> | null | undefined } | null | undefined, user_score?: { leaderboard_config_id: string, user_id: string, score: string, ranking: number, position_change?: number | null | undefined, user: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined }, events: Array<{ event: LeaderboardEventType, score: string } | null | undefined> } | null | undefined } | null | undefined };

export type GetLeaderboardScoresQueryVariables = Exact<{
  leaderboard_config_id: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  ranking?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['ID']>;
}>;


export type GetLeaderboardScoresQuery = { getLeaderboardScores: { paginate: boolean, leaderboard_config_id?: string | null | undefined, ranking?: number | null | undefined, user_id?: string | null | undefined, items?: Array<{ leaderboard_config_id: string, user_id: string, score: string, ranking: number, position_change?: number | null | undefined, user: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined }, events: Array<{ event: LeaderboardEventType, score: string } | null | undefined> } | null | undefined> | null | undefined } };

export type GetLeaderboardScoreForUserQueryVariables = Exact<{
  leaderboard_config_id: Scalars['ID'];
  user_id?: Maybe<Scalars['ID']>;
}>;


export type GetLeaderboardScoreForUserQuery = { getLeaderboardScoreForUser: { leaderboard_config_id: string, user_id: string, score: string, ranking: number, position_change?: number | null | undefined, user: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined }, events: Array<{ event: LeaderboardEventType, score: string } | null | undefined> } };

export type GetManualNotificationsQueryVariables = Exact<{
  data: ItemsListInput;
  scheduled?: Maybe<Scalars['Boolean']>;
}>;


export type GetManualNotificationsQuery = { getManualNotificationItems?: { count: number, paginate: boolean, created_at?: number | null | undefined, id?: string | null | undefined, items?: Array<{ id: string, notification_type?: ManualNotificationType | null | undefined, send_at: number, segment_ids: Array<string | null | undefined>, created_at: number, user_count?: number | null | undefined, email_count?: number | null | undefined, entire_company?: boolean | null | undefined, segments: Array<{ id: string, title: string } | null | undefined>, message: { body: string, url?: string | null | undefined }, email?: { subject: string, body: string, format?: ManualNotificationEmailFormat | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMentionsQueryVariables = Exact<{
  token_id: Scalars['String'];
  query: Scalars['String'];
  page_key?: Maybe<Scalars['String']>;
}>;


export type GetMentionsQuery = { getMention: { count?: number | null | undefined, page_key?: string | null | undefined, items?: Array<{ identifier: string, logo?: string | null | undefined, name: string }> | null | undefined } };

export type GetOiCtaIntelQueryVariables = Exact<{
  client_id: Scalars['ID'];
  start: Scalars['Int'];
  end: Scalars['Int'];
}>;


export type GetOiCtaIntelQuery = { getIntelligence?: { distinct_user_engagements: number, intelligent_company_extrapolation: number } | null | undefined };

export type GetOiCtaPeopleQueryVariables = Exact<{
  start: Scalars['Int'];
  end: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetOiCtaPeopleQuery = { getPeople?: { total: number, results: Array<{ title?: string | null | undefined, role?: string | null | undefined, name?: string | null | undefined, network_profile_image?: string | null | undefined, network_profile_url?: string | null | undefined, company?: { company_logo?: string | null | undefined, job_company_name?: string | null | undefined } | null | undefined, engagement_summary?: { engagements?: number | null | undefined, first_engagement?: number | null | undefined, last_engagement?: number | null | undefined, last_engagement_detail?: { network?: Network | null | undefined, engagement_type?: InsightsEngagementType | null | undefined, share_url?: string | null | undefined, content_url?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type GetOrganicInsightsReportQueryVariables = Exact<{
  start: Scalars['Int'];
  end: Scalars['Int'];
  report: ReportNames;
  organic_insights_report_filter?: Maybe<OrganicInsightsReportFilter>;
  advanced_filters?: Maybe<OrganicInsightsAdvancedFilters>;
}>;


export type GetOrganicInsightsReportQuery = { getOrganicInsightReports?: boolean | null | undefined };

export type GetPartnerDetailsQueryVariables = Exact<{
  partner_name: Scalars['String'];
}>;


export type GetPartnerDetailsQuery = { getPartnerDetails?: { partner_name: string, redirect_uris?: Array<string | null | undefined> | null | undefined } | null | undefined };

export type GetPeopleNewestQueryVariables = Exact<{
  start: Scalars['Int'];
  end: Scalars['Int'];
  hide_teammates: Scalars['Boolean'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  ordering: Ordering;
  sort_by?: Maybe<OrganicInsightsSortParam>;
  advanced_filters?: Maybe<OrganicInsightsAdvancedFilters>;
}>;


export type GetPeopleNewestQuery = { getPeople?: { total: number, results: Array<{ title?: string | null | undefined, role?: string | null | undefined, email_address?: string | null | undefined, name?: string | null | undefined, network_profile_url?: string | null | undefined, network_profile_image?: string | null | undefined, company?: { company_logo?: string | null | undefined, job_company_name?: string | null | undefined } | null | undefined, engagement_summary?: { engagements?: number | null | undefined, first_engagement?: number | null | undefined, last_engagement?: number | null | undefined, last_engagement_detail?: { network?: Network | null | undefined, engagement_type?: InsightsEngagementType | null | undefined, share_url?: string | null | undefined, content_url?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type GetPeopleTopQueryVariables = Exact<{
  start: Scalars['Int'];
  end: Scalars['Int'];
  hide_teammates: Scalars['Boolean'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  ordering: Ordering;
  sort_by?: Maybe<OrganicInsightsSortParam>;
  advanced_filters?: Maybe<OrganicInsightsAdvancedFilters>;
}>;


export type GetPeopleTopQuery = { getPeople?: { total: number, results: Array<{ rank?: number | null | undefined, title?: string | null | undefined, role?: string | null | undefined, email_address?: string | null | undefined, name?: string | null | undefined, network_profile_url?: string | null | undefined, network_profile_image?: string | null | undefined, company?: { company_logo?: string | null | undefined, job_company_name?: string | null | undefined } | null | undefined, engagement_summary?: { engagements?: number | null | undefined, first_engagement?: number | null | undefined, last_engagement?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type GetPostedToGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPostedToGroupsQuery = { contextGetPostedToGroups?: Array<{ group_id: string, score: number } | null | undefined> | null | undefined };

export type GetPublicUserProfileQueryVariables = Exact<{
  user_id: Scalars['ID'];
}>;


export type GetPublicUserProfileQuery = { getPublicUserProfile?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined };

export type GetSharesItemsQueryVariables = Exact<{
  data: ItemsListInput;
  group_by_session?: Maybe<Scalars['Boolean']>;
  scheduled?: Maybe<Scalars['Boolean']>;
}>;


export type GetSharesItemsQuery = { getSharesItems: { count: number, paginate: boolean, created_at?: number | null | undefined, id?: string | null | undefined, items_by_session?: Array<Array<{ id: string, network: string, network_id?: string | null | undefined, identifier?: string | null | undefined, user_commentary?: string | null | undefined, share_at: number, shared_at?: number | null | undefined, share_session_id: string, clicks?: number | null | undefined, engagements?: number | null | undefined, impressions?: number | null | undefined, network_profile_name?: string | null | undefined, content?: { approval?: ContentApproval | null | undefined, content_id: string, content_source_id?: string | null | undefined, is_branded?: boolean | null | undefined, is_shareable?: boolean | null | undefined, is_important?: boolean | null | undefined, is_important_message?: string | null | undefined, is_engage?: boolean | null | undefined, is_engageable?: boolean | null | undefined, is_pinned?: boolean | null | undefined, pinned_end_at?: number | null | undefined, important_to_share?: boolean | null | undefined, reaction_count?: number | null | undefined, comment_count?: number | null | undefined, share_count?: number | null | undefined, engage_count?: number | null | undefined, click_count?: number | null | undefined, publish_at: number, group_ids: Array<string | null | undefined>, primary_group_id?: string | null | undefined, has_requesting_user_shared?: boolean | null | undefined, lock_commentary?: boolean | null | undefined, submitter_role?: SubmitterRole | null | undefined, user_id?: string | null | undefined, slack_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, ms_teams_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, pinned_to_groups?: Array<{ group_id: string, pinned_end_at?: number | null | undefined } | null | undefined> | null | undefined, commentary?: Array<{ network: Network, commentary: string, mentions?: Array<{ provider: string, identifier: string, start: number, length: number } | null | undefined> | null | undefined } | null | undefined> | null | undefined, disclosures?: Array<{ network: Network, disclosure_id: string } | null | undefined> | null | undefined, group_id_approvals: Array<{ group_id?: string | null | undefined, approval?: ContentApproval | null | undefined } | null | undefined>, content_object: { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id?: string | null | undefined } | null | undefined, instagram_metadata?: { id?: string | null | undefined, shortcode?: string | null | undefined } | null | undefined, reddit_metadata?: { url: string } | null | undefined }, reactions?: { user_reactions?: Array<ReactionType | null | undefined> | null | undefined, reaction_count?: { total: number } | null | undefined, reaction_user_details?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined, groups?: Array<{ id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, url_param_values?: Array<{ key: string, value?: string | null | undefined } | null | undefined> | null | undefined, reacted_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, shared_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, commented_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, schedule?: { publish?: number | null | undefined, expire?: number | null | undefined } | null | undefined, audit?: Array<{ ACTION: string, time?: number | null | undefined, by_user_id?: string | null | undefined, message?: string | null | undefined, by_user_profile?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, content_tags?: Array<{ title: string, tag_id: string } | null | undefined> | null | undefined } | null | undefined }>> | null | undefined, items: Array<{ id: string, network: string, network_id?: string | null | undefined, identifier?: string | null | undefined, user_commentary?: string | null | undefined, share_at: number, shared_at?: number | null | undefined, share_session_id: string, clicks?: number | null | undefined, engagements?: number | null | undefined, impressions?: number | null | undefined, network_profile_name?: string | null | undefined, content?: { approval?: ContentApproval | null | undefined, content_id: string, content_source_id?: string | null | undefined, is_branded?: boolean | null | undefined, is_shareable?: boolean | null | undefined, is_important?: boolean | null | undefined, is_important_message?: string | null | undefined, is_engage?: boolean | null | undefined, is_engageable?: boolean | null | undefined, is_pinned?: boolean | null | undefined, pinned_end_at?: number | null | undefined, important_to_share?: boolean | null | undefined, reaction_count?: number | null | undefined, comment_count?: number | null | undefined, share_count?: number | null | undefined, engage_count?: number | null | undefined, click_count?: number | null | undefined, publish_at: number, group_ids: Array<string | null | undefined>, primary_group_id?: string | null | undefined, has_requesting_user_shared?: boolean | null | undefined, lock_commentary?: boolean | null | undefined, submitter_role?: SubmitterRole | null | undefined, user_id?: string | null | undefined, slack_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, ms_teams_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, pinned_to_groups?: Array<{ group_id: string, pinned_end_at?: number | null | undefined } | null | undefined> | null | undefined, commentary?: Array<{ network: Network, commentary: string, mentions?: Array<{ provider: string, identifier: string, start: number, length: number } | null | undefined> | null | undefined } | null | undefined> | null | undefined, disclosures?: Array<{ network: Network, disclosure_id: string } | null | undefined> | null | undefined, group_id_approvals: Array<{ group_id?: string | null | undefined, approval?: ContentApproval | null | undefined } | null | undefined>, content_object: { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id?: string | null | undefined } | null | undefined, instagram_metadata?: { id?: string | null | undefined, shortcode?: string | null | undefined } | null | undefined, reddit_metadata?: { url: string } | null | undefined }, reactions?: { user_reactions?: Array<ReactionType | null | undefined> | null | undefined, reaction_count?: { total: number } | null | undefined, reaction_user_details?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined, groups?: Array<{ id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, url_param_values?: Array<{ key: string, value?: string | null | undefined } | null | undefined> | null | undefined, reacted_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, shared_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, commented_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, schedule?: { publish?: number | null | undefined, expire?: number | null | undefined } | null | undefined, audit?: Array<{ ACTION: string, time?: number | null | undefined, by_user_id?: string | null | undefined, message?: string | null | undefined, by_user_profile?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, content_tags?: Array<{ title: string, tag_id: string } | null | undefined> | null | undefined } | null | undefined }> } };

export type GetSharePreviewInfoQueryVariables = Exact<{
  content_id: Scalars['String'];
}>;


export type GetSharePreviewInfoQuery = { getSharePreviewInfo: { suggested_share_time?: number | null | undefined, locked_commentary?: boolean | null | undefined, allowed_counts?: { twitter?: number | null | undefined, linkedin?: number | null | undefined, facebook?: number | null | undefined } | null | undefined, shortened_urls?: { email?: { short_link?: string | null | undefined } | null | undefined, direct?: { short_link?: string | null | undefined } | null | undefined, facebook?: { short_link?: string | null | undefined } | null | undefined } | null | undefined } };

export type GetTrackingDetailsQueryVariables = Exact<{
  event_name: SegmentEventType;
  user_id: Scalars['ID'];
}>;


export type GetTrackingDetailsQuery = { getTrackingDetails?: { event_name?: string | null | undefined, event_args?: string | null | undefined } | null | undefined };

export type GetUsersByEmailAddressQueryVariables = Exact<{
  email_address_list: Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>;
}>;


export type GetUsersByEmailAddressQuery = { getUsersByEmailAddress?: Array<{ id: string, client_id: string, full_name?: string | null | undefined, email_address: string, image?: { bucket: string, key: string } | null | undefined } | null | undefined> | null | undefined };

export type GetUserClientsQueryVariables = Exact<{
  last_evaluated_key?: Maybe<Scalars['String']>;
}>;


export type GetUserClientsQuery = { getUserClients?: { last_evaluated_key?: string | null | undefined, count?: number | null | undefined, items?: Array<{ user_client_status: UserClientStatus, client: { created_at: number, email_from_address?: string | null | undefined, allow_user_invites: boolean, content_domains?: Array<string | null | undefined> | null | undefined, allow_group_creation: boolean, disable_comments: boolean, allow_external_share: boolean, sort_mode?: SortMode | null | undefined, email_address?: string | null | undefined, sso_provider?: string | null | undefined, allow_sharing?: boolean | null | undefined, email_sending_domain?: string | null | undefined, compliance_notification_emails?: Array<string | null | undefined> | null | undefined, compliance_notification_enabled?: boolean | null | undefined, moderator_can_mark_as_important?: boolean | null | undefined, is_self_serve?: boolean | null | undefined, referral_headline?: string | null | undefined, referral_message?: string | null | undefined, stickers_enabled?: boolean | null | undefined, features?: Array<Feature | null | undefined> | null | undefined, setup_completed?: boolean | null | undefined, feature_plan_type?: FeaturePlanType | null | undefined, billing_status?: BillingStatusType | null | undefined, billing_type?: BillingTypeType | null | undefined, billing_teams_trial_start?: number | null | undefined, billing_teams_trial_end?: number | null | undefined, contract_committed_user_count?: number | null | undefined, contract_type?: ContractType | null | undefined, contract_end_at?: number | null | undefined, contract_start_at?: number | null | undefined, added_by_user_id: string, allow_group_discovery: boolean, allow_user_share_commentary: boolean, departments_in_signup: boolean, locations_in_signup: boolean, updated_at: number, menu_item_enabled?: boolean | null | undefined, yearly_enrichment_quota?: number | null | undefined, id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy_url?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, stickers?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, disclosures?: Array<{ id: string, disclosure: string, disclosure_status: ClientDisclosureStatus } | null | undefined> | null | undefined, social_config?: { twitter_shareable?: boolean | null | undefined, twitter_engageable?: boolean | null | undefined, linkedin_shareable?: boolean | null | undefined, linkedin_engageable?: boolean | null | undefined, facebook_shareable?: boolean | null | undefined, facebook_engageable?: boolean | null | undefined, youtube_shareable?: boolean | null | undefined, youtube_engageable?: boolean | null | undefined, instagram_shareable?: boolean | null | undefined, instagram_engageable?: boolean | null | undefined, reddit_shareable?: boolean | null | undefined, reddit_engageable?: boolean | null | undefined, tiktok_shareable?: boolean | null | undefined, tiktok_engageable?: boolean | null | undefined, weibo_shareable?: boolean | null | undefined, weibo_engageable?: boolean | null | undefined, wechat_shareable?: boolean | null | undefined, wechat_engageable?: boolean | null | undefined } | null | undefined, billing?: { billable_user_count: number, stripe_account_id: string, stripe_customer_id: string, stripe_price_id: string, stripe_product_id: string, stripe_subscription_id: string, stripe_subscription_item_id: string } | null | undefined, billing_address?: { address: string, address2?: string | null | undefined, city: string, state: string, zip: string, country: string } | null | undefined, menu_item?: { title: string, link: string } | null | undefined, icon?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, client_aliases?: Array<{ company_id: string, name: string } | null | undefined> | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } }> | null | undefined } | null | undefined };

export type GetUserClientFollowMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserClientFollowMappingsQuery = { getUserClientFollowMappings: { suggested_groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, suggested_users?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } };

export type GetUserReachGraphDataQueryVariables = Exact<{
  start_date: Scalars['String'];
  end_date: Scalars['String'];
}>;


export type GetUserReachGraphDataQuery = { getUserReachGraphData?: { data?: Array<{ calendar_day: string, linkedin_reach: number, twitter_reach: number }> | null | undefined, summary: { linkedin_reach: { change: number, count: number }, total_reach: { change: number, count: number }, twitter_reach: { change: number, count: number } } } | null | undefined };

export type GetUserRoiValuesQueryVariables = Exact<{
  user_id: Scalars['ID'];
}>;


export type GetUserRoiValuesQuery = { getUserROIValues?: { reach_twitter?: number | null | undefined, reach_linkedin?: number | null | undefined, clicks_twitter?: number | null | undefined, clicks_linkedin?: number | null | undefined, clicks_facebook?: number | null | undefined, engagements_twitter?: number | null | undefined, engagements_linkedin?: number | null | undefined, engagements_facebook?: number | null | undefined, impressions_twitter?: number | null | undefined, impressions_linkedin?: number | null | undefined } | null | undefined };

export type GetUserSearchesQueryVariables = Exact<{
  limit: Scalars['Int'];
}>;


export type GetUserSearchesQuery = { getUserSearches?: Array<string | null | undefined> | null | undefined };

export type GetUserSearchesV2QueryVariables = Exact<{
  q?: Maybe<Scalars['String']>;
  user_status?: Maybe<UserStatus>;
  user_type?: Maybe<UserType>;
  size?: Maybe<Scalars['Int']>;
  next_id?: Maybe<Scalars['String']>;
  sort?: Maybe<SearchSortFieldsV2>;
  client_id?: Maybe<Scalars['String']>;
  department_ids?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  location_ids?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  active?: Maybe<Scalars['Boolean']>;
  onboarding_completed?: Maybe<Scalars['Boolean']>;
}>;


export type GetUserSearchesV2Query = { getUserSearchesV2?: { total_count: number, next_id?: string | null | undefined, results?: Array<{ id: string, client_id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, email_address: string, user_type: UserType, user_status: UserStatus, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, follower_count?: number | null | undefined, reach?: number | null | undefined, last_accessed_at?: number | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetUserSegmentsQueryVariables = Exact<{
  segment_status?: Maybe<SegmentStatus>;
}>;


export type GetUserSegmentsQuery = { getUserSegments?: Array<{ id: string, title: string, created_at?: number | null | undefined, segment_status: SegmentStatus, department_ids?: Array<string | null | undefined> | null | undefined, location_ids?: Array<string | null | undefined> | null | undefined, group_ids?: Array<string | null | undefined> | null | undefined, registered_count?: number | null | undefined, third_party_count?: number | null | undefined, departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, groups?: Array<{ id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type GetUserSegmentOthersPresignedUrlQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetUserSegmentOthersPresignedUrlQuery = { getUserSegmentOthersPresignedUrl?: { url: string } | null | undefined };

export type GetUserSocialConnectionsQueryVariables = Exact<{
  user_id: Scalars['String'];
}>;


export type GetUserSocialConnectionsQuery = { getUserSocialConnections: { count: number, items: Array<{ id: string, provider: Network, identifier?: string | null | undefined, profile_name?: string | null | undefined, reach?: number | null | undefined, expires_soon: boolean, profile_url?: string | null | undefined, profile_picture?: string | null | undefined, smart_schedule?: boolean | null | undefined }> } };

export type GetWebhookListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebhookListQuery = { getWebhookList?: { webhooks: Array<{ callback_url?: string | null | undefined, webhook_status: GenericStatus, webhook_id: string, webhook_name: string, webhook_type: WebhookTypes, workvivo_org_id?: string | null | undefined, workvivo_workspace_id?: string | null | undefined, groups?: Array<string | null | undefined> | null | undefined } | null | undefined> } | null | undefined };

export type GroupOverviewStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  snapshot?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<GroupsSortFields>;
  sort_direction?: Maybe<SortDirections>;
  report?: Maybe<ReportNames>;
  filter?: Maybe<ReportingFilter>;
}>;


export type GroupOverviewStatsQuery = { sortedGroups?: Array<{ title?: string | null | undefined, members?: number | null | undefined, created_at?: string | null | undefined, group_id: string, created_by?: string | null | undefined, posts?: number | null | undefined } | null | undefined> | null | undefined };

export type InternalOverviewStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
}>;


export type InternalOverviewStatsQuery = { internalOverviewStats?: { summary: { posts: { count: number, change: number }, users: { count: number, change: number }, comments: { count: number, change: number }, reactions: { count: number, change: number }, groups: { count: number, change: number } }, data?: Array<{ calendar_day: string, active_groups_count: number, inactive_groups_count: number, daily_active_users: number, daily_inactive_users: number, branded_posts: number, non_branded_posts: number, branded_comments_count: number, non_branded_comments_count: number, branded_reactions_count: number, non_branded_reactions_count: number } | null | undefined> | null | undefined } | null | undefined };

export type LeaderboardOverviewStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  leaderboard_config_id: Scalars['ID'];
  start_date: Scalars['String'];
  end_date: Scalars['String'];
  per_page?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  report?: Maybe<ReportNames>;
}>;


export type LeaderboardOverviewStatsQuery = { sortedLeaderboards?: Array<{ user_id: string, rank: number, name?: string | null | undefined, location?: string | null | undefined, department?: string | null | undefined, score?: number | null | undefined, last_seen_at?: string | null | undefined } | null | undefined> | null | undefined };

export type OauthClientDetailsQueryVariables = Exact<{
  data: OauthClientInput;
}>;


export type OauthClientDetailsQuery = { oauthClientDetails: { oauth_client_id: string, oauth_client_name: string, oauth_client_logo_url: string, oauth_client_description: string } };

export type OauthUserIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OauthUserIntegrationsQuery = { oauthUserIntegrations: Array<{ oauth_client_id: string, oauth_client_name: string, oauth_client_logo_url: string, oauth_client_description: string } | null | undefined> };

export type PostOverviewStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  snapshot?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<PostsSortFields>;
  sort_direction?: Maybe<SortDirections>;
  report?: Maybe<ReportNames>;
  filter?: Maybe<ReportingFilter>;
}>;


export type PostOverviewStatsQuery = { sortedPosts?: Array<{ content_id: string, title?: string | null | undefined, shares?: number | null | undefined, reactions?: number | null | undefined, comments?: number | null | undefined, created_at?: string | null | undefined, submitted_by?: string | null | undefined, approved_by?: string | null | undefined, branded?: boolean | null | undefined } | null | undefined> | null | undefined };

export type PreviewUrlQueryVariables = Exact<{
  url: Scalars['String'];
  group_id: Scalars['ID'];
  app_source: Scalars['String'];
}>;


export type PreviewUrlQuery = { previewURL: { is_engageable?: boolean | null | undefined, is_branded?: boolean | null | undefined, default_engageable?: boolean | null | undefined, default_shareable?: boolean | null | undefined, is_network?: boolean | null | undefined, disclosures?: Array<{ network: Network, disclosure_id: string } | null | undefined> | null | undefined, content_object: { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id?: string | null | undefined } | null | undefined, instagram_metadata?: { id?: string | null | undefined, shortcode?: string | null | undefined } | null | undefined, reddit_metadata?: { url: string } | null | undefined } } };

export type RoiClicksOverviewStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
  linkedin_currency_value?: Maybe<Scalars['Float']>;
  twitter_currency_value?: Maybe<Scalars['Float']>;
  facebook_currency_value?: Maybe<Scalars['Float']>;
}>;


export type RoiClicksOverviewStatsQuery = { roiClicksOverviewStats?: { summary: { currency: number, change: number, facebook?: number | null | undefined, twitter?: number | null | undefined, linkedin?: number | null | undefined, facebook_count?: number | null | undefined, twitter_count?: number | null | undefined, linkedin_count?: number | null | undefined }, data?: Array<{ currency?: number | null | undefined, previous_currency?: number | null | undefined, calendar_day: string, previous_calendar_day?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type RoiEngagementsOverviewStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
  linkedin_currency_value?: Maybe<Scalars['Float']>;
  twitter_currency_value?: Maybe<Scalars['Float']>;
  facebook_currency_value?: Maybe<Scalars['Float']>;
}>;


export type RoiEngagementsOverviewStatsQuery = { roiEngagementsOverviewStats?: { summary: { currency: number, change: number, facebook?: number | null | undefined, twitter?: number | null | undefined, linkedin?: number | null | undefined, facebook_count?: number | null | undefined, twitter_count?: number | null | undefined, linkedin_count?: number | null | undefined }, data?: Array<{ currency?: number | null | undefined, previous_currency?: number | null | undefined, calendar_day: string, previous_calendar_day?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type RoiImpressionsOverviewStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
  linkedin_currency_value?: Maybe<Scalars['Float']>;
  twitter_currency_value?: Maybe<Scalars['Float']>;
}>;


export type RoiImpressionsOverviewStatsQuery = { roiImpressionsOverviewStats?: { summary: { currency: number, change: number, facebook?: number | null | undefined, twitter?: number | null | undefined, linkedin?: number | null | undefined, facebook_count?: number | null | undefined, twitter_count?: number | null | undefined, linkedin_count?: number | null | undefined }, data?: Array<{ currency?: number | null | undefined, previous_currency?: number | null | undefined, calendar_day: string, previous_calendar_day?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type RoiReachOverviewStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
  linkedin_currency_value?: Maybe<Scalars['Float']>;
  twitter_currency_value?: Maybe<Scalars['Float']>;
}>;


export type RoiReachOverviewStatsQuery = { roiReachOverviewStats?: { summary: { currency: number, change: number, facebook?: number | null | undefined, twitter?: number | null | undefined, linkedin?: number | null | undefined, facebook_count?: number | null | undefined, twitter_count?: number | null | undefined, linkedin_count?: number | null | undefined }, data?: Array<{ currency?: number | null | undefined, previous_currency?: number | null | undefined, calendar_day: string, previous_calendar_day?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type SearchQueryVariables = Exact<{
  size: Scalars['Int'];
  results_from: Scalars['Int'];
  q?: Maybe<Scalars['String']>;
}>;


export type SearchQuery = { search: { count: number, results_from: number, results?: Array<{ content_id: string, publish_at: number, groups?: Array<{ id: string, title: string, color_map: { hex: string } } | null | undefined> | null | undefined, user?: { id: string, full_name?: string | null | undefined } | null | undefined, content_object: { body?: string | null | undefined, url?: string | null | undefined, url_metadata?: { provider_name?: string | null | undefined, title?: string | null | undefined, description?: string | null | undefined } | null | undefined, photos?: Array<{ bucket: string } | null | undefined> | null | undefined } } | { id: string, title: string, follower_count?: number | null | undefined, department_title?: string | null | undefined, location_title?: string | null | undefined } | { id: string, full_name?: string | null | undefined, follower_count?: number | null | undefined, department_title?: string | null | undefined, location_title?: string | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } };

export type SearchGroupsQueryVariables = Exact<{
  size: Scalars['Int'];
  results_from: Scalars['Int'];
  q?: Maybe<Scalars['String']>;
  auto_exclude?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<SearchSortFields>;
  sort_direction?: Maybe<SearchSortDirections>;
  required_location_id?: Maybe<Scalars['ID']>;
  required_department_id?: Maybe<Scalars['ID']>;
  exclude_group_ids?: Maybe<Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>>;
}>;


export type SearchGroupsQuery = { search: { count: number, results_from: number, results?: Array<{ id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | {} | null | undefined> | null | undefined } };

export type SearchPeopleQueryVariables = Exact<{
  size: Scalars['Int'];
  results_from: Scalars['Int'];
  q?: Maybe<Scalars['String']>;
  auto_exclude?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<SearchSortFields>;
  sort_direction?: Maybe<SearchSortDirections>;
  required_location_id?: Maybe<Scalars['ID']>;
  required_department_id?: Maybe<Scalars['ID']>;
  override?: Maybe<OverrideInput>;
}>;


export type SearchPeopleQuery = { search: { count: number, results_from: number, results?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | {} | null | undefined> | null | undefined } };

export type SearchAggregatesQueryVariables = Exact<{
  document: SearchDocuments;
}>;


export type SearchAggregatesQuery = { searchAggregates: { total: number, departments?: Array<{ id: string, client_id: string, title: string, department_status: ClientDepartmentStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined, locations?: Array<{ id: string, client_id: string, title: string, location_status: ClientLocationStatus, groups_total?: number | null | undefined, profiles_total?: number | null | undefined } | null | undefined> | null | undefined } };

export type SearchClientInvitationsQueryVariables = Exact<{
  search_filter?: Maybe<ClientInvitationSearchFilter>;
  count?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  last_evaluated_key?: Maybe<Scalars['String']>;
  report?: Maybe<Scalars['Boolean']>;
}>;


export type SearchClientInvitationsQuery = { searchClientInvitations?: { count?: number | null | undefined, last_evaluated_key?: string | null | undefined, items?: Array<{ id: string, client_id: string, email_address: string, invitation_status: ClientInvitationStatus, created_at: number, updated_at: number, accepted_at?: number | null | undefined, user_type?: UserType | null | undefined, accepted_by_user?: { id: string, full_name?: string | null | undefined, email_address: string, user_status: UserStatus, onboarding_completed?: boolean | null | undefined, user_type: UserType } | null | undefined, added_by_user?: { id: string, full_name?: string | null | undefined, email_address: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type SearchCompaniesQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchCompaniesQuery = { searchCompanies?: Array<{ company_id: string, name: string } | null | undefined> | null | undefined };

export type SearchCompanyFilterQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchCompanyFilterQuery = { searchCompanies?: Array<{ company_id: string, name: string, display_name?: string | null | undefined, icon?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined };

export type SearchContentQueryVariables = Exact<{
  search_content: SearchContentInput;
}>;


export type SearchContentQuery = { searchContent?: { next_id?: string | null | undefined, total_count: number, results?: Array<{ approval?: ContentApproval | null | undefined, content_id: string, content_source_id?: string | null | undefined, is_branded?: boolean | null | undefined, is_shareable?: boolean | null | undefined, is_important?: boolean | null | undefined, is_important_message?: string | null | undefined, is_engage?: boolean | null | undefined, is_engageable?: boolean | null | undefined, is_pinned?: boolean | null | undefined, pinned_end_at?: number | null | undefined, important_to_share?: boolean | null | undefined, reaction_count?: number | null | undefined, comment_count?: number | null | undefined, share_count?: number | null | undefined, engage_count?: number | null | undefined, click_count?: number | null | undefined, publish_at: number, group_ids: Array<string | null | undefined>, primary_group_id?: string | null | undefined, has_requesting_user_shared?: boolean | null | undefined, lock_commentary?: boolean | null | undefined, submitter_role?: SubmitterRole | null | undefined, user_id?: string | null | undefined, slack_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, ms_teams_channels?: Array<{ channel_name?: string | null | undefined, channel_id: string, team_id: string, status?: ChannelRepostStatus | null | undefined } | null | undefined> | null | undefined, pinned_to_groups?: Array<{ group_id: string, pinned_end_at?: number | null | undefined } | null | undefined> | null | undefined, commentary?: Array<{ network: Network, commentary: string, mentions?: Array<{ provider: string, identifier: string, start: number, length: number } | null | undefined> | null | undefined } | null | undefined> | null | undefined, disclosures?: Array<{ network: Network, disclosure_id: string } | null | undefined> | null | undefined, group_id_approvals: Array<{ group_id?: string | null | undefined, approval?: ContentApproval | null | undefined } | null | undefined>, content_object: { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id?: string | null | undefined } | null | undefined, instagram_metadata?: { id?: string | null | undefined, shortcode?: string | null | undefined } | null | undefined, reddit_metadata?: { url: string } | null | undefined }, reactions?: { user_reactions?: Array<ReactionType | null | undefined> | null | undefined, reaction_count?: { total: number } | null | undefined, reaction_user_details?: Array<{ id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined, groups?: Array<{ id: string, title: string, follower_count?: number | null | undefined, location_title?: string | null | undefined, department_title?: string | null | undefined, content_approval_type: GroupContentApprovalType, is_private?: boolean | null | undefined, read_only?: boolean | null | undefined, color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, url_param_values?: Array<{ key: string, value?: string | null | undefined } | null | undefined> | null | undefined, reacted_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, shared_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, commented_by?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, schedule?: { publish?: number | null | undefined, expire?: number | null | undefined } | null | undefined, audit?: Array<{ ACTION: string, time?: number | null | undefined, by_user_id?: string | null | undefined, message?: string | null | undefined, by_user_profile?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, content_tags?: Array<{ title: string, tag_id: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type SearchEveryoneSocialQueryVariables = Exact<{
  data: SearchEveryoneSocialInput;
}>;


export type SearchEveryoneSocialQuery = { searchEveryoneSocial: { cursor?: string | null | undefined, posts?: Array<{ client_id: string, approval?: ContentApproval | null | undefined, content_id: string, created_at: number, publish_at: number, is_engage?: boolean | null | undefined, is_important?: boolean | null | undefined, is_branded?: boolean | null | undefined, is_shareable?: boolean | null | undefined, important_to_share?: boolean | null | undefined, is_engageable?: boolean | null | undefined, share_count?: number | null | undefined, engagement_count?: number | null | undefined, click_count?: number | null | undefined, comment_count?: number | null | undefined, reaction_count?: number | null | undefined, has_requesting_user_shared?: boolean | null | undefined, content_object: { post_type: PostType, metadata_keys?: Array<MetadataKey | null | undefined> | null | undefined, title?: string | null | undefined, body?: string | null | undefined, url?: string | null | undefined, photos?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, media?: { video?: { bucket?: string | null | undefined, key?: string | null | undefined, region?: string | null | undefined, playlist?: string | null | undefined, poster?: string | null | undefined, thumbnails?: Array<string | null | undefined> | null | undefined, status?: string | null | undefined } | null | undefined } | null | undefined, url_metadata?: { provider_display?: string | null | undefined, provider_name?: string | null | undefined, provider_url?: string | null | undefined, title?: string | null | undefined, url?: string | null | undefined, original_url?: string | null | undefined, description?: string | null | undefined, images?: Array<{ url: string, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined, caption?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, size?: number | null | undefined, primary?: boolean | null | undefined } | null | undefined> | null | undefined, media?: { duration?: number | null | undefined, height?: number | null | undefined, width?: number | null | undefined, type: string, html?: string | null | undefined, url?: string | null | undefined, bucket?: string | null | undefined, file_key?: string | null | undefined, url_proxy?: boolean | null | undefined, url_original?: string | null | undefined } | null | undefined } | null | undefined, tweet_metadata?: { id_str: string, created_at?: string | null | undefined, text?: string | null | undefined, favorite_count?: number | null | undefined, retweet_count?: number | null | undefined, user: { name?: string | null | undefined, screen_name: string, profile_image_url_https?: string | null | undefined, verified?: boolean | null | undefined }, hashtags?: Array<{ text: string } | null | undefined> | null | undefined, urls?: Array<{ display_url?: string | null | undefined, expanded_url?: string | null | undefined } | null | undefined> | null | undefined, user_mentions?: Array<{ id_str?: string | null | undefined, name?: string | null | undefined, screen_name?: string | null | undefined } | null | undefined> | null | undefined, media?: Array<{ media_url_https?: string | null | undefined, type: string } | null | undefined> | null | undefined } | null | undefined, youtube_metadata?: { video_id?: string | null | undefined } | null | undefined, instagram_metadata?: { id?: string | null | undefined, shortcode?: string | null | undefined } | null | undefined, reddit_metadata?: { url: string } | null | undefined }, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, groups?: Array<{ id: string, client_id: string, title: string, group_status: GroupStatus, is_private?: boolean | null | undefined, content_approval_type: GroupContentApprovalType, description?: string | null | undefined, allow_user_posts: boolean, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, created_at: number, updated_at?: number | null | undefined, follower_count?: number | null | undefined, read_only?: boolean | null | undefined, color_map: { label: string, hex: string, group_color?: GroupColor | null | undefined }, icon_color_map: { label: string, hex: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { label: string, bucket: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, primary_group?: { id: string, client_id: string, title: string, group_status: GroupStatus, is_private?: boolean | null | undefined, content_approval_type: GroupContentApprovalType, description?: string | null | undefined, allow_user_posts: boolean, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, created_at: number, updated_at?: number | null | undefined, follower_count?: number | null | undefined, read_only?: boolean | null | undefined, color_map: { label: string, hex: string, group_color?: GroupColor | null | undefined }, icon_color_map: { label: string, hex: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { label: string, bucket: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, groups?: Array<{ id: string, client_id: string, title: string, group_status: GroupStatus, is_private?: boolean | null | undefined, content_approval_type: GroupContentApprovalType, description?: string | null | undefined, allow_user_posts: boolean, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, created_at: number, updated_at?: number | null | undefined, follower_count?: number | null | undefined, read_only?: boolean | null | undefined, color_map: { label: string, hex: string, group_color?: GroupColor | null | undefined }, icon_color_map: { label: string, hex: string, group_icon_color?: GroupIconColor | null | undefined }, icon_map: { label: string, bucket: string, file_key: string, group_icon?: GroupIcon | null | undefined, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined, users?: Array<{ id: string, full_name?: string | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> | null | undefined } };

export type ShareOverviewStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
  filter?: Maybe<ReportingFilter>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  snapshot?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<SharesSortFields>;
  sort_direction?: Maybe<SortDirections>;
  report?: Maybe<ReportNames>;
}>;


export type ShareOverviewStatsQuery = { sortedShares?: Array<{ title?: string | null | undefined, clicks?: number | null | undefined, engagements?: number | null | undefined, shares?: number | null | undefined, branded?: boolean | null | undefined, approved_by?: string | null | undefined, first_shared_at?: string | null | undefined, users?: Array<string | null | undefined> | null | undefined, content_id: string, impressions?: number | null | undefined } | null | undefined> | null | undefined };

export type SearchSuggestQueryVariables = Exact<{
  prefix: Scalars['String'];
}>;


export type SearchSuggestQuery = { suggest: { results?: Array<{ id: string, title: string, color: GroupColor } | { id: string, title: string } | null | undefined> | null | undefined } };

export type GroupSuggestQueryVariables = Exact<{
  prefix: Scalars['String'];
}>;


export type GroupSuggestQuery = { suggest: { results?: Array<{ id: string, title: string, color: GroupColor, icon_color: GroupIconColor, icon: GroupIcon, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | {} | null | undefined> | null | undefined } };

export type UserSuggestQueryVariables = Exact<{
  prefix: Scalars['String'];
}>;


export type UserSuggestQuery = { suggest: { results?: Array<{ id: string, title: string, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | {} | null | undefined> | null | undefined } };

export type TotalReachOverviewStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
}>;


export type TotalReachOverviewStatsQuery = { reachOverviewStats?: { summary: { twitter_reach: { count: number, change: number }, linkedin_reach: { count: number, change: number }, reach: { count: number, change: number } }, data?: Array<{ calendar_day: string, twitter_reach: number, linkedin_reach: number } | null | undefined> | null | undefined } | null | undefined };

export type UserActivityStatsQueryVariables = Exact<{
  user_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
}>;


export type UserActivityStatsQuery = { userActivityStats?: { daily_stats?: Array<{ comments: number, reactions: number, posts: number, shares: number, engagements: number, clicks: number, impressions: number, calendar_day?: string | null | undefined } | null | undefined> | null | undefined, summary_stats?: { comments: number, reactions: number, posts: number, shares: number, engagements: number, clicks: number, impressions: number, calendar_day?: string | null | undefined } | null | undefined, percent_change?: { comments: number, reactions: number, posts: number, shares: number, engagements: number, clicks: number, impressions: number, calendar_day?: string | null | undefined } | null | undefined } | null | undefined };

export type UserDailyStatsQueryVariables = Exact<{
  user_id: Scalars['ID'];
  grouping: StatsGrouping;
}>;


export type UserDailyStatsQuery = { userDailyStats?: { total_posts: number, total_shares: number, total_clicks: number, data: Array<{ clicks: number, posts: number, shares: number, calendar_day: string } | null | undefined> } | null | undefined };

export type UserEngagementComparisonQueryVariables = Exact<{
  user_id: Scalars['ID'];
}>;


export type UserEngagementComparisonQuery = { userEngagementComparison?: { engagements_per_share_client_max?: number | null | undefined, engagements_per_share_client_min?: number | null | undefined, engagements_per_share_user?: number | null | undefined, engagements_per_share_user_rank?: number | null | undefined, reach_growth_client_max?: number | null | undefined, reach_growth_client_min?: number | null | undefined, reach_growth_user?: number | null | undefined, reach_growth_user_rank?: number | null | undefined, reach_size_client_max?: number | null | undefined, reach_size_client_min?: number | null | undefined, reach_size_user?: number | null | undefined, reach_size_user_rank?: number | null | undefined } | null | undefined };

export type UserEngagementHistoryQueryVariables = Exact<{
  content_ids?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  exclude_internal?: Maybe<Scalars['Boolean']>;
  format?: Maybe<EngagementHistoryFormat>;
  limit?: Maybe<Scalars['Int']>;
  network_profile_id?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  reverse?: Maybe<Scalars['Boolean']>;
  timestamp_end?: Maybe<Scalars['Float']>;
  timestamp_start?: Maybe<Scalars['Float']>;
  user_id: Scalars['ID'];
}>;


export type UserEngagementHistoryQuery = { userEngagementHistory?: Array<{ content_id?: string | null | undefined, engagement_type?: EngagementType | null | undefined, followers_count?: number | null | undefined, following_count?: number | null | undefined, network_bio?: string | null | undefined, network_profile_id?: string | null | undefined, network_profile_handle?: string | null | undefined, network_profile_image?: string | null | undefined, network_profile_name?: string | null | undefined, network_profile_url?: string | null | undefined, network?: Network | null | undefined, share_url?: string | null | undefined, timestamp?: number | null | undefined, total_engagements?: number | null | undefined, content_id_times?: Array<{ content_id?: string | null | undefined, timestamps?: Array<number | null | undefined> | null | undefined } | null | undefined> | null | undefined, total_content_ids?: Array<{ content_id?: string | null | undefined, count?: number | null | undefined } | null | undefined> | null | undefined, total_engagement_types?: Array<{ engagement_type?: EngagementType | null | undefined, count?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type UserEngagementStatsQueryVariables = Exact<{
  user_id: Scalars['ID'];
  grouping: StatsGrouping;
  value: Scalars['Int'];
}>;


export type UserEngagementStatsQuery = { userEngagementStats?: { clicks: number, comments: number, reactions: number, posts: number, shares: number, engagements: number, groups: number } | null | undefined };

export type UserOverviewStatsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  snapshot?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<UsersSortFields>;
  sort_direction?: Maybe<SortDirections>;
  report?: Maybe<ReportNames>;
  filter?: Maybe<ReportingFilter>;
}>;


export type UserOverviewStatsQuery = { sortedUsers?: Array<{ user_id: string, name?: string | null | undefined, user_type?: UserType | null | undefined, user_status?: UserStatus | null | undefined, onboarding_completed?: boolean | null | undefined, created_at?: string | null | undefined, last_accessed_at?: string | null | undefined, clicks?: number | null | undefined, reach?: number | null | undefined, shares?: number | null | undefined, posts?: number | null | undefined } | null | undefined> | null | undefined };

export type UserReachStatsQueryVariables = Exact<{
  user_id: Scalars['ID'];
  grouping: StatsGrouping;
  value: Scalars['Int'];
}>;


export type UserReachStatsQuery = { userReachStats?: Array<{ reach: number, previous_reach?: number | null | undefined, provider: string, profile_identifier?: string | null | undefined } | null | undefined> | null | undefined };

export type GetCombinedGroupWebhookListQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCombinedGroupWebhookListQuery = { getGroup?: { id: string, created_at: number, title: string, follower_count?: number | null | undefined, color: GroupColor, allow_user_posts: boolean, content_approval_type: GroupContentApprovalType, group_status: GroupStatus, icon: GroupIcon, icon_color: GroupIconColor, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, read_only?: boolean | null | undefined, is_private?: boolean | null | undefined, color_map: { hex: string }, icon_color_map: { hex: string }, icon_map: { bucket: string, file_key: string, width?: number | null | undefined, height?: number | null | undefined }, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined, getGroupWebhookList?: { webhooks: Array<{ callback_url?: string | null | undefined, webhook_status: GenericStatus, webhook_id: string, webhook_name: string, webhook_type: WebhookTypes, workvivo_org_id?: string | null | undefined, workvivo_workspace_id?: string | null | undefined, groups?: Array<string | null | undefined> | null | undefined } | null | undefined>, workvivo_workspaces: Array<{ workvivo_workspace_id: string, workspace_name: string } | null | undefined> } | null | undefined };

export type GetFilterChipsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFilterChipsQuery = { getClientLocationsByStatus: { client_locations?: Array<{ id: string, title: string } | null | undefined> | null | undefined }, getClientDepartmentsByStatus: { client_departments?: Array<{ id: string, title: string } | null | undefined> | null | undefined }, getUserSegments?: Array<{ id: string, title: string } | null | undefined> | null | undefined };

export type AdminSetPasswordMutationVariables = Exact<{
  user_id: Scalars['ID'];
  password: Scalars['String'];
  permanent?: Maybe<Scalars['Boolean']>;
}>;


export type AdminSetPasswordMutation = { adminSetPassword: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, email_address_verified: boolean, user_type: UserType, user_status: UserStatus, user_pool_id: string, client_id: string, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, last_onboarding_step?: number | null | undefined, lang?: string | null | undefined, onboarding_completed?: boolean | null | undefined, last_accessed_at?: number | null | undefined, user_timezone?: string | null | undefined, created_at?: number | null | undefined, german_privacy?: boolean | null | undefined, reach?: number | null | undefined, notification_delivery_types?: Array<NotificationDeliveryType | null | undefined> | null | undefined, getstream_token?: string | null | undefined, setup_completed?: boolean | null | undefined, smart_schedule_acknowledgement?: boolean | null | undefined, smart_schedule_viewed?: boolean | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, group_moderator?: Array<{ group_id: string, user_id: string, created_at: number, added_by_user_id: string, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, push_notification_configuration?: Array<{ device_platform: string, token: string } | null | undefined> | null | undefined, push_notifications_status?: { paused: boolean, paused_at?: number | null | undefined } | null | undefined } };

export type CreateClientMutationVariables = Exact<{
  data: CreateClientInput;
}>;


export type CreateClientMutation = { createClient: { created_at: number, email_from_address?: string | null | undefined, allow_user_invites: boolean, content_domains?: Array<string | null | undefined> | null | undefined, allow_group_creation: boolean, disable_comments: boolean, allow_external_share: boolean, sort_mode?: SortMode | null | undefined, email_address?: string | null | undefined, sso_provider?: string | null | undefined, allow_sharing?: boolean | null | undefined, email_sending_domain?: string | null | undefined, compliance_notification_emails?: Array<string | null | undefined> | null | undefined, compliance_notification_enabled?: boolean | null | undefined, moderator_can_mark_as_important?: boolean | null | undefined, is_self_serve?: boolean | null | undefined, referral_headline?: string | null | undefined, referral_message?: string | null | undefined, stickers_enabled?: boolean | null | undefined, features?: Array<Feature | null | undefined> | null | undefined, setup_completed?: boolean | null | undefined, feature_plan_type?: FeaturePlanType | null | undefined, billing_status?: BillingStatusType | null | undefined, billing_type?: BillingTypeType | null | undefined, billing_teams_trial_start?: number | null | undefined, billing_teams_trial_end?: number | null | undefined, contract_committed_user_count?: number | null | undefined, contract_type?: ContractType | null | undefined, contract_end_at?: number | null | undefined, contract_start_at?: number | null | undefined, added_by_user_id: string, allow_group_discovery: boolean, allow_user_share_commentary: boolean, departments_in_signup: boolean, locations_in_signup: boolean, updated_at: number, menu_item_enabled?: boolean | null | undefined, yearly_enrichment_quota?: number | null | undefined, id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy_url?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, stickers?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, disclosures?: Array<{ id: string, disclosure: string, disclosure_status: ClientDisclosureStatus } | null | undefined> | null | undefined, social_config?: { twitter_shareable?: boolean | null | undefined, twitter_engageable?: boolean | null | undefined, linkedin_shareable?: boolean | null | undefined, linkedin_engageable?: boolean | null | undefined, facebook_shareable?: boolean | null | undefined, facebook_engageable?: boolean | null | undefined, youtube_shareable?: boolean | null | undefined, youtube_engageable?: boolean | null | undefined, instagram_shareable?: boolean | null | undefined, instagram_engageable?: boolean | null | undefined, reddit_shareable?: boolean | null | undefined, reddit_engageable?: boolean | null | undefined, tiktok_shareable?: boolean | null | undefined, tiktok_engageable?: boolean | null | undefined, weibo_shareable?: boolean | null | undefined, weibo_engageable?: boolean | null | undefined, wechat_shareable?: boolean | null | undefined, wechat_engageable?: boolean | null | undefined } | null | undefined, billing?: { billable_user_count: number, stripe_account_id: string, stripe_customer_id: string, stripe_price_id: string, stripe_product_id: string, stripe_subscription_id: string, stripe_subscription_item_id: string } | null | undefined, billing_address?: { address: string, address2?: string | null | undefined, city: string, state: string, zip: string, country: string } | null | undefined, menu_item?: { title: string, link: string } | null | undefined, icon?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, client_aliases?: Array<{ company_id: string, name: string } | null | undefined> | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } };

export type CreateScimTokenMutationVariables = Exact<{
  token: ScimTokenInput;
}>;


export type CreateScimTokenMutation = { createScimToken: { id: string, client_id: string, user_id: string, expires_at: number, not_valid_before: number, rate_limit_max_requests: number, rate_limit_window_duration: number } };

export type CsCreateUserMutationVariables = Exact<{
  client_id: Scalars['ID'];
  email_address: Scalars['String'];
  password: Scalars['String'];
}>;


export type CsCreateUserMutation = { csCreateUser: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, email_address_verified: boolean, user_type: UserType, user_status: UserStatus, user_pool_id: string, client_id: string, location_id?: string | null | undefined, location_title?: string | null | undefined, department_id?: string | null | undefined, department_title?: string | null | undefined, last_onboarding_step?: number | null | undefined, lang?: string | null | undefined, onboarding_completed?: boolean | null | undefined, last_accessed_at?: number | null | undefined, user_timezone?: string | null | undefined, created_at?: number | null | undefined, german_privacy?: boolean | null | undefined, reach?: number | null | undefined, notification_delivery_types?: Array<NotificationDeliveryType | null | undefined> | null | undefined, getstream_token?: string | null | undefined, setup_completed?: boolean | null | undefined, smart_schedule_acknowledgement?: boolean | null | undefined, smart_schedule_viewed?: boolean | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, group_moderator?: Array<{ group_id: string, user_id: string, created_at: number, added_by_user_id: string, user?: { id: string, full_name?: string | null | undefined, job_title?: string | null | undefined, follower_count?: number | null | undefined, email_address: string, location_title?: string | null | undefined, department_title?: string | null | undefined, user_type: UserType, user_status: UserStatus, reach?: number | null | undefined, location?: { id: string, title: string, block_message?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, push_notification_configuration?: Array<{ device_platform: string, token: string } | null | undefined> | null | undefined, push_notifications_status?: { paused: boolean, paused_at?: number | null | undefined } | null | undefined } };

export type DeleteScimTokenMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteScimTokenMutation = { deleteScimToken: boolean };

export type GenerateClientBillingReportAggregateDownloadMutationVariables = Exact<{
  search_filter: ClientBillingReportAggregateSearchFilter;
}>;


export type GenerateClientBillingReportAggregateDownloadMutation = { generateClientBillingReportAggregateDownload: boolean };

export type GenerateClientBillingUserReportDownloadMutationVariables = Exact<{
  calendar_month?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
}>;


export type GenerateClientBillingUserReportDownloadMutation = { generateClientBillingUserReportDownload: boolean };

export type SetImpersonationMutationVariables = Exact<{
  id: Scalars['ID'];
  impersonate_user_id?: Maybe<Scalars['ID']>;
}>;


export type SetImpersonationMutation = { updateUserProfile: { id: string } };

export type CsUpdateClientMutationVariables = Exact<{
  data: CsUpdateClientInput;
}>;


export type CsUpdateClientMutation = { csUpdateClient: { created_at: number, email_from_address?: string | null | undefined, allow_user_invites: boolean, content_domains?: Array<string | null | undefined> | null | undefined, allow_group_creation: boolean, disable_comments: boolean, allow_external_share: boolean, sort_mode?: SortMode | null | undefined, email_address?: string | null | undefined, sso_provider?: string | null | undefined, allow_sharing?: boolean | null | undefined, email_sending_domain?: string | null | undefined, compliance_notification_emails?: Array<string | null | undefined> | null | undefined, compliance_notification_enabled?: boolean | null | undefined, moderator_can_mark_as_important?: boolean | null | undefined, is_self_serve?: boolean | null | undefined, referral_headline?: string | null | undefined, referral_message?: string | null | undefined, stickers_enabled?: boolean | null | undefined, features?: Array<Feature | null | undefined> | null | undefined, setup_completed?: boolean | null | undefined, feature_plan_type?: FeaturePlanType | null | undefined, billing_status?: BillingStatusType | null | undefined, billing_type?: BillingTypeType | null | undefined, billing_teams_trial_start?: number | null | undefined, billing_teams_trial_end?: number | null | undefined, contract_committed_user_count?: number | null | undefined, contract_type?: ContractType | null | undefined, contract_end_at?: number | null | undefined, contract_start_at?: number | null | undefined, added_by_user_id: string, allow_group_discovery: boolean, allow_user_share_commentary: boolean, departments_in_signup: boolean, locations_in_signup: boolean, updated_at: number, menu_item_enabled?: boolean | null | undefined, yearly_enrichment_quota?: number | null | undefined, id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy_url?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, stickers?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, disclosures?: Array<{ id: string, disclosure: string, disclosure_status: ClientDisclosureStatus } | null | undefined> | null | undefined, social_config?: { twitter_shareable?: boolean | null | undefined, twitter_engageable?: boolean | null | undefined, linkedin_shareable?: boolean | null | undefined, linkedin_engageable?: boolean | null | undefined, facebook_shareable?: boolean | null | undefined, facebook_engageable?: boolean | null | undefined, youtube_shareable?: boolean | null | undefined, youtube_engageable?: boolean | null | undefined, instagram_shareable?: boolean | null | undefined, instagram_engageable?: boolean | null | undefined, reddit_shareable?: boolean | null | undefined, reddit_engageable?: boolean | null | undefined, tiktok_shareable?: boolean | null | undefined, tiktok_engageable?: boolean | null | undefined, weibo_shareable?: boolean | null | undefined, weibo_engageable?: boolean | null | undefined, wechat_shareable?: boolean | null | undefined, wechat_engageable?: boolean | null | undefined } | null | undefined, billing?: { billable_user_count: number, stripe_account_id: string, stripe_customer_id: string, stripe_price_id: string, stripe_product_id: string, stripe_subscription_id: string, stripe_subscription_item_id: string } | null | undefined, billing_address?: { address: string, address2?: string | null | undefined, city: string, state: string, zip: string, country: string } | null | undefined, menu_item?: { title: string, link: string } | null | undefined, icon?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, client_aliases?: Array<{ company_id: string, name: string } | null | undefined> | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } };

export type UpdateClientToCapabilitiesMutationVariables = Exact<{
  capability_ids: Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>;
  clients: Array<Maybe<ClientsFeatureToggleUpdateInput>> | Maybe<ClientsFeatureToggleUpdateInput>;
}>;


export type UpdateClientToCapabilitiesMutation = { updateClientsToCapabilities?: { capability_id?: string | null | undefined, entity_type?: string | null | undefined, group?: string | null | undefined, description?: string | null | undefined, client_count?: number | null | undefined, clients?: Array<{ capability_id?: string | null | undefined, client_id?: string | null | undefined, entity_type?: string | null | undefined, quota?: number | null | undefined, usage?: number | null | undefined, client_title?: string | null | undefined, client_subdomain?: string | null | undefined, active?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateClientToReleaseTogglesMutationVariables = Exact<{
  release_toggle_ids: Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>;
  clients: Array<Maybe<ClientsFeatureToggleUpdateInput>> | Maybe<ClientsFeatureToggleUpdateInput>;
}>;


export type UpdateClientToReleaseTogglesMutation = { updateClientsToReleaseToggles?: { release_id?: string | null | undefined, entity_type?: string | null | undefined, group?: string | null | undefined, description?: string | null | undefined, client_count?: number | null | undefined, clients?: Array<{ release_id?: string | null | undefined, client_id?: string | null | undefined, entity_type?: string | null | undefined, quota?: number | null | undefined, usage?: number | null | undefined, client_title?: string | null | undefined, client_subdomain?: string | null | undefined, active?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateProviderDetailsForClientMutationVariables = Exact<{
  client_id: Scalars['ID'];
  provider_details: ProviderDetailsInput;
  provider_type: ProviderType;
}>;


export type UpdateProviderDetailsForClientMutation = { updateProviderDetailsForClient: { created_at: number, email_from_address?: string | null | undefined, allow_user_invites: boolean, content_domains?: Array<string | null | undefined> | null | undefined, allow_group_creation: boolean, disable_comments: boolean, allow_external_share: boolean, sort_mode?: SortMode | null | undefined, email_address?: string | null | undefined, sso_provider?: string | null | undefined, allow_sharing?: boolean | null | undefined, email_sending_domain?: string | null | undefined, compliance_notification_emails?: Array<string | null | undefined> | null | undefined, compliance_notification_enabled?: boolean | null | undefined, moderator_can_mark_as_important?: boolean | null | undefined, is_self_serve?: boolean | null | undefined, referral_headline?: string | null | undefined, referral_message?: string | null | undefined, stickers_enabled?: boolean | null | undefined, features?: Array<Feature | null | undefined> | null | undefined, setup_completed?: boolean | null | undefined, feature_plan_type?: FeaturePlanType | null | undefined, billing_status?: BillingStatusType | null | undefined, billing_type?: BillingTypeType | null | undefined, billing_teams_trial_start?: number | null | undefined, billing_teams_trial_end?: number | null | undefined, contract_committed_user_count?: number | null | undefined, contract_type?: ContractType | null | undefined, contract_end_at?: number | null | undefined, contract_start_at?: number | null | undefined, added_by_user_id: string, allow_group_discovery: boolean, allow_user_share_commentary: boolean, departments_in_signup: boolean, locations_in_signup: boolean, updated_at: number, menu_item_enabled?: boolean | null | undefined, yearly_enrichment_quota?: number | null | undefined, id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy_url?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, stickers?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, disclosures?: Array<{ id: string, disclosure: string, disclosure_status: ClientDisclosureStatus } | null | undefined> | null | undefined, social_config?: { twitter_shareable?: boolean | null | undefined, twitter_engageable?: boolean | null | undefined, linkedin_shareable?: boolean | null | undefined, linkedin_engageable?: boolean | null | undefined, facebook_shareable?: boolean | null | undefined, facebook_engageable?: boolean | null | undefined, youtube_shareable?: boolean | null | undefined, youtube_engageable?: boolean | null | undefined, instagram_shareable?: boolean | null | undefined, instagram_engageable?: boolean | null | undefined, reddit_shareable?: boolean | null | undefined, reddit_engageable?: boolean | null | undefined, tiktok_shareable?: boolean | null | undefined, tiktok_engageable?: boolean | null | undefined, weibo_shareable?: boolean | null | undefined, weibo_engageable?: boolean | null | undefined, wechat_shareable?: boolean | null | undefined, wechat_engageable?: boolean | null | undefined } | null | undefined, billing?: { billable_user_count: number, stripe_account_id: string, stripe_customer_id: string, stripe_price_id: string, stripe_product_id: string, stripe_subscription_id: string, stripe_subscription_item_id: string } | null | undefined, billing_address?: { address: string, address2?: string | null | undefined, city: string, state: string, zip: string, country: string } | null | undefined, menu_item?: { title: string, link: string } | null | undefined, icon?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, client_aliases?: Array<{ company_id: string, name: string } | null | undefined> | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } };

export type UpdateUserMappingsForClientMutationVariables = Exact<{
  client_id: Scalars['ID'];
  user_mappings: UserMappingsInput;
}>;


export type UpdateUserMappingsForClientMutation = { updateUserMappingsForClient?: { email_attr: string, full_name_attr?: string | null | undefined, job_title_attr?: string | null | undefined, user_type_attr?: string | null | undefined, user_status_attr?: string | null | undefined, department_attr?: string | null | undefined, location_attr?: string | null | undefined, external_user_mappings?: { user_type?: Array<{ internal: string, external: string }> | null | undefined, user_status?: Array<{ internal: string, external: string }> | null | undefined, department?: Array<{ internal: string, external: string }> | null | undefined, location?: Array<{ internal: string, external: string }> | null | undefined } | null | undefined } | null | undefined };

export type GetCapabilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCapabilitiesQuery = { getCapabilities?: Array<{ capability_id?: string | null | undefined, entity_type?: string | null | undefined, group?: string | null | undefined, description?: string | null | undefined, client_count?: number | null | undefined, clients?: Array<{ capability_id?: string | null | undefined, client_id?: string | null | undefined, entity_type?: string | null | undefined, quota?: number | null | undefined, usage?: number | null | undefined, client_title?: string | null | undefined, client_subdomain?: string | null | undefined, active?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type GetCapabilityDetailsQueryVariables = Exact<{
  capability_id: Scalars['String'];
}>;


export type GetCapabilityDetailsQuery = { getCapabilityDetails?: { capability_id?: string | null | undefined, entity_type?: string | null | undefined, group?: string | null | undefined, description?: string | null | undefined, client_count?: number | null | undefined, clients?: Array<{ capability_id?: string | null | undefined, client_id?: string | null | undefined, entity_type?: string | null | undefined, quota?: number | null | undefined, usage?: number | null | undefined, client_title?: string | null | undefined, client_subdomain?: string | null | undefined, active?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetClientQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetClientQuery = { getClient?: { created_at: number, email_from_address?: string | null | undefined, allow_user_invites: boolean, content_domains?: Array<string | null | undefined> | null | undefined, allow_group_creation: boolean, disable_comments: boolean, allow_external_share: boolean, sort_mode?: SortMode | null | undefined, email_address?: string | null | undefined, sso_provider?: string | null | undefined, allow_sharing?: boolean | null | undefined, email_sending_domain?: string | null | undefined, compliance_notification_emails?: Array<string | null | undefined> | null | undefined, compliance_notification_enabled?: boolean | null | undefined, moderator_can_mark_as_important?: boolean | null | undefined, is_self_serve?: boolean | null | undefined, referral_headline?: string | null | undefined, referral_message?: string | null | undefined, stickers_enabled?: boolean | null | undefined, features?: Array<Feature | null | undefined> | null | undefined, setup_completed?: boolean | null | undefined, feature_plan_type?: FeaturePlanType | null | undefined, billing_status?: BillingStatusType | null | undefined, billing_type?: BillingTypeType | null | undefined, billing_teams_trial_start?: number | null | undefined, billing_teams_trial_end?: number | null | undefined, contract_committed_user_count?: number | null | undefined, contract_type?: ContractType | null | undefined, contract_end_at?: number | null | undefined, contract_start_at?: number | null | undefined, added_by_user_id: string, allow_group_discovery: boolean, allow_user_share_commentary: boolean, departments_in_signup: boolean, locations_in_signup: boolean, updated_at: number, menu_item_enabled?: boolean | null | undefined, yearly_enrichment_quota?: number | null | undefined, id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy_url?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, stickers?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, disclosures?: Array<{ id: string, disclosure: string, disclosure_status: ClientDisclosureStatus } | null | undefined> | null | undefined, social_config?: { twitter_shareable?: boolean | null | undefined, twitter_engageable?: boolean | null | undefined, linkedin_shareable?: boolean | null | undefined, linkedin_engageable?: boolean | null | undefined, facebook_shareable?: boolean | null | undefined, facebook_engageable?: boolean | null | undefined, youtube_shareable?: boolean | null | undefined, youtube_engageable?: boolean | null | undefined, instagram_shareable?: boolean | null | undefined, instagram_engageable?: boolean | null | undefined, reddit_shareable?: boolean | null | undefined, reddit_engageable?: boolean | null | undefined, tiktok_shareable?: boolean | null | undefined, tiktok_engageable?: boolean | null | undefined, weibo_shareable?: boolean | null | undefined, weibo_engageable?: boolean | null | undefined, wechat_shareable?: boolean | null | undefined, wechat_engageable?: boolean | null | undefined } | null | undefined, billing?: { billable_user_count: number, stripe_account_id: string, stripe_customer_id: string, stripe_price_id: string, stripe_product_id: string, stripe_subscription_id: string, stripe_subscription_item_id: string } | null | undefined, billing_address?: { address: string, address2?: string | null | undefined, city: string, state: string, zip: string, country: string } | null | undefined, menu_item?: { title: string, link: string } | null | undefined, icon?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, client_aliases?: Array<{ company_id: string, name: string } | null | undefined> | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined };

export type GetClientsQueryVariables = Exact<{
  client_status: ClientStatus;
}>;


export type GetClientsQuery = { getClients: Array<{ created_at: number, email_from_address?: string | null | undefined, allow_user_invites: boolean, content_domains?: Array<string | null | undefined> | null | undefined, allow_group_creation: boolean, disable_comments: boolean, allow_external_share: boolean, sort_mode?: SortMode | null | undefined, email_address?: string | null | undefined, sso_provider?: string | null | undefined, allow_sharing?: boolean | null | undefined, email_sending_domain?: string | null | undefined, compliance_notification_emails?: Array<string | null | undefined> | null | undefined, compliance_notification_enabled?: boolean | null | undefined, moderator_can_mark_as_important?: boolean | null | undefined, is_self_serve?: boolean | null | undefined, referral_headline?: string | null | undefined, referral_message?: string | null | undefined, stickers_enabled?: boolean | null | undefined, features?: Array<Feature | null | undefined> | null | undefined, setup_completed?: boolean | null | undefined, feature_plan_type?: FeaturePlanType | null | undefined, billing_status?: BillingStatusType | null | undefined, billing_type?: BillingTypeType | null | undefined, billing_teams_trial_start?: number | null | undefined, billing_teams_trial_end?: number | null | undefined, contract_committed_user_count?: number | null | undefined, contract_type?: ContractType | null | undefined, contract_end_at?: number | null | undefined, contract_start_at?: number | null | undefined, added_by_user_id: string, allow_group_discovery: boolean, allow_user_share_commentary: boolean, departments_in_signup: boolean, locations_in_signup: boolean, updated_at: number, menu_item_enabled?: boolean | null | undefined, yearly_enrichment_quota?: number | null | undefined, id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy_url?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, stickers?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, disclosures?: Array<{ id: string, disclosure: string, disclosure_status: ClientDisclosureStatus } | null | undefined> | null | undefined, social_config?: { twitter_shareable?: boolean | null | undefined, twitter_engageable?: boolean | null | undefined, linkedin_shareable?: boolean | null | undefined, linkedin_engageable?: boolean | null | undefined, facebook_shareable?: boolean | null | undefined, facebook_engageable?: boolean | null | undefined, youtube_shareable?: boolean | null | undefined, youtube_engageable?: boolean | null | undefined, instagram_shareable?: boolean | null | undefined, instagram_engageable?: boolean | null | undefined, reddit_shareable?: boolean | null | undefined, reddit_engageable?: boolean | null | undefined, tiktok_shareable?: boolean | null | undefined, tiktok_engageable?: boolean | null | undefined, weibo_shareable?: boolean | null | undefined, weibo_engageable?: boolean | null | undefined, wechat_shareable?: boolean | null | undefined, wechat_engageable?: boolean | null | undefined } | null | undefined, billing?: { billable_user_count: number, stripe_account_id: string, stripe_customer_id: string, stripe_price_id: string, stripe_product_id: string, stripe_subscription_id: string, stripe_subscription_item_id: string } | null | undefined, billing_address?: { address: string, address2?: string | null | undefined, city: string, state: string, zip: string, country: string } | null | undefined, menu_item?: { title: string, link: string } | null | undefined, icon?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, client_aliases?: Array<{ company_id: string, name: string } | null | undefined> | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined } | null | undefined> };

export type GetIdentityProviderForClientQueryVariables = Exact<{
  client_id: Scalars['ID'];
}>;


export type GetIdentityProviderForClientQuery = { getIdentityProviderForClient?: { provider_type: ProviderType, last_modified_date: string, provider_details?: { metadata_file?: string | null | undefined, metadata_u_r_l?: string | null | undefined } | null | undefined } | null | undefined };

export type IdentityProviderFragment = { provider_type: ProviderType, last_modified_date: string, provider_details?: { metadata_file?: string | null | undefined, metadata_u_r_l?: string | null | undefined } | null | undefined };

export type GetReleaseTogglesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReleaseTogglesQuery = { getReleaseToggles?: Array<{ release_id?: string | null | undefined, entity_type?: string | null | undefined, group?: string | null | undefined, description?: string | null | undefined, client_count?: number | null | undefined, clients?: Array<{ release_id?: string | null | undefined, client_id?: string | null | undefined, entity_type?: string | null | undefined, quota?: number | null | undefined, usage?: number | null | undefined, client_title?: string | null | undefined, client_subdomain?: string | null | undefined, active?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type GetReleaseToggleDetailsQueryVariables = Exact<{
  release_toggle_id: Scalars['String'];
}>;


export type GetReleaseToggleDetailsQuery = { getReleaseToggleDetails?: { release_id?: string | null | undefined, entity_type?: string | null | undefined, group?: string | null | undefined, description?: string | null | undefined, client_count?: number | null | undefined, clients?: Array<{ release_id?: string | null | undefined, client_id?: string | null | undefined, entity_type?: string | null | undefined, quota?: number | null | undefined, usage?: number | null | undefined, client_title?: string | null | undefined, client_subdomain?: string | null | undefined, active?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetUserMappingsForClientQueryVariables = Exact<{
  client_id: Scalars['ID'];
}>;


export type GetUserMappingsForClientQuery = { getUserMappingsForClient?: { email_attr: string, full_name_attr?: string | null | undefined, job_title_attr?: string | null | undefined, user_type_attr?: string | null | undefined, user_status_attr?: string | null | undefined, department_attr?: string | null | undefined, location_attr?: string | null | undefined, external_user_mappings?: { user_type?: Array<{ internal: string, external: string }> | null | undefined, user_status?: Array<{ internal: string, external: string }> | null | undefined, department?: Array<{ internal: string, external: string }> | null | undefined, location?: Array<{ internal: string, external: string }> | null | undefined } | null | undefined } | null | undefined };

export type UserMappingsFragment = { email_attr: string, full_name_attr?: string | null | undefined, job_title_attr?: string | null | undefined, user_type_attr?: string | null | undefined, user_status_attr?: string | null | undefined, department_attr?: string | null | undefined, location_attr?: string | null | undefined, external_user_mappings?: { user_type?: Array<{ internal: string, external: string }> | null | undefined, user_status?: Array<{ internal: string, external: string }> | null | undefined, department?: Array<{ internal: string, external: string }> | null | undefined, location?: Array<{ internal: string, external: string }> | null | undefined } | null | undefined };

export type SearchClientsQueryVariables = Exact<{
  search_filter?: Maybe<ClientSearchFilter>;
  count?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  last_evaluated_key?: Maybe<Scalars['String']>;
}>;


export type SearchClientsQuery = { searchClients?: { count?: number | null | undefined, last_evaluated_key?: string | null | undefined, items?: Array<{ created_at: number, email_from_address?: string | null | undefined, allow_user_invites: boolean, content_domains?: Array<string | null | undefined> | null | undefined, allow_group_creation: boolean, disable_comments: boolean, allow_external_share: boolean, sort_mode?: SortMode | null | undefined, email_address?: string | null | undefined, sso_provider?: string | null | undefined, allow_sharing?: boolean | null | undefined, email_sending_domain?: string | null | undefined, compliance_notification_emails?: Array<string | null | undefined> | null | undefined, compliance_notification_enabled?: boolean | null | undefined, moderator_can_mark_as_important?: boolean | null | undefined, is_self_serve?: boolean | null | undefined, referral_headline?: string | null | undefined, referral_message?: string | null | undefined, stickers_enabled?: boolean | null | undefined, features?: Array<Feature | null | undefined> | null | undefined, setup_completed?: boolean | null | undefined, feature_plan_type?: FeaturePlanType | null | undefined, billing_status?: BillingStatusType | null | undefined, billing_type?: BillingTypeType | null | undefined, billing_teams_trial_start?: number | null | undefined, billing_teams_trial_end?: number | null | undefined, contract_committed_user_count?: number | null | undefined, contract_type?: ContractType | null | undefined, contract_end_at?: number | null | undefined, contract_start_at?: number | null | undefined, added_by_user_id: string, allow_group_discovery: boolean, allow_user_share_commentary: boolean, departments_in_signup: boolean, locations_in_signup: boolean, updated_at: number, menu_item_enabled?: boolean | null | undefined, yearly_enrichment_quota?: number | null | undefined, id: string, title: string, subdomain?: string | null | undefined, email_domains?: Array<string | null | undefined> | null | undefined, client_status: ClientStatus, authentication_type: AuthenticationType, allow_user_signup: boolean, departments_in_signup_required: boolean, locations_in_signup_required: boolean, default_timezone?: string | null | undefined, default_language?: string | null | undefined, support_multiple_languages: boolean, social_media_policy_enabled?: boolean | null | undefined, social_media_policy_title?: string | null | undefined, social_media_policy_url?: string | null | undefined, social_media_policy?: string | null | undefined, public_post_page?: boolean | null | undefined, public_post_details?: boolean | null | undefined, stickers?: Array<{ bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined> | null | undefined, disclosures?: Array<{ id: string, disclosure: string, disclosure_status: ClientDisclosureStatus } | null | undefined> | null | undefined, social_config?: { twitter_shareable?: boolean | null | undefined, twitter_engageable?: boolean | null | undefined, linkedin_shareable?: boolean | null | undefined, linkedin_engageable?: boolean | null | undefined, facebook_shareable?: boolean | null | undefined, facebook_engageable?: boolean | null | undefined, youtube_shareable?: boolean | null | undefined, youtube_engageable?: boolean | null | undefined, instagram_shareable?: boolean | null | undefined, instagram_engageable?: boolean | null | undefined, reddit_shareable?: boolean | null | undefined, reddit_engageable?: boolean | null | undefined, tiktok_shareable?: boolean | null | undefined, tiktok_engageable?: boolean | null | undefined, weibo_shareable?: boolean | null | undefined, weibo_engageable?: boolean | null | undefined, wechat_shareable?: boolean | null | undefined, wechat_engageable?: boolean | null | undefined } | null | undefined, billing?: { billable_user_count: number, stripe_account_id: string, stripe_customer_id: string, stripe_price_id: string, stripe_product_id: string, stripe_subscription_id: string, stripe_subscription_item_id: string } | null | undefined, billing_address?: { address: string, address2?: string | null | undefined, city: string, state: string, zip: string, country: string } | null | undefined, menu_item?: { title: string, link: string } | null | undefined, icon?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined, client_aliases?: Array<{ company_id: string, name: string } | null | undefined> | null | undefined, sso_configuration?: { provider?: string | null | undefined, domain?: string | null | undefined, identity_pool_id?: string | null | undefined, user_pool_id?: string | null | undefined, region?: string | null | undefined, app_client_id?: string | null | undefined, redirect_sign_out?: string | null | undefined } | null | undefined, image?: { bucket: string, key: string, width?: number | null | undefined, height?: number | null | undefined, region: string } | null | undefined }> | null | undefined } | null | undefined };

export type SearchClientBillingReportAggregateQueryVariables = Exact<{
  search_filter?: Maybe<ClientBillingReportAggregateSearchFilter>;
  last_evaluated_key?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type SearchClientBillingReportAggregateQuery = { searchClientBillingReportAggregate: { count?: number | null | undefined, last_evaluated_key?: string | null | undefined, items?: Array<{ client_id: string, calendar_month: string, client_subdomain: string, created_at: string, updated_at: string, contract_committed_user_count?: number | null | undefined, contract_type?: ContractType | null | undefined, contract_end_at?: number | null | undefined, contract_start_at?: number | null | undefined, num_registered_users: number, num_anonymous_users: number, num_email_users: number, total_users: number, user_overage?: number | null | undefined, usage_rate?: number | null | undefined, last_month_total_users?: number | null | undefined, two_months_ago_total_users?: number | null | undefined, num_potential_users?: number | null | undefined, registered_rate?: number | null | undefined } | null | undefined> | null | undefined } };

export type SearchScimTokensQueryVariables = Exact<{
  search_filter?: Maybe<ScimTokenSearchFilter>;
  count?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  last_evaluated_key?: Maybe<Scalars['String']>;
}>;


export type SearchScimTokensQuery = { searchScimTokens?: { count?: number | null | undefined, last_evaluated_key?: string | null | undefined, items?: Array<{ rate_limit_window_end_at?: number | null | undefined, id: string, client_id: string, user_id: string, expires_at: number, not_valid_before: number, rate_limit_max_requests: number, rate_limit_window_duration: number } | null | undefined> | null | undefined } | null | undefined };

export const ActivityStatFragmentDoc = `
    fragment ActivityStat on ActivityStat {
  comments
  reactions
  posts
  shares
  engagements
  clicks
  impressions
  calendar_day
}
    `;
export const S3ObjectFragmentDoc = `
    fragment S3Object on S3Object {
  bucket
  key
  width
  height
  region
}
    `;
export const AssignmentFragmentDoc = `
    fragment Assignment on Assignment {
  id
  title
  groups_required
  users_required
  groups_suggested
  users_suggested
  extracted_users
  active
  groups_required_objects {
    client_id
    id
    title
    color
    icon_color
    icon
    color_map {
      hex
      label
      group_color
    }
    icon_color_map {
      hex
      label
      group_icon_color
    }
    icon_map {
      bucket
      label
      file_key
      group_icon
      width
      height
    }
    image {
      ...S3Object
    }
  }
  groups_suggested_objects {
    client_id
    id
    title
    color
    icon_color
    icon
    color_map {
      hex
      label
      group_color
    }
    icon_color_map {
      hex
      label
      group_icon_color
    }
    icon_map {
      bucket
      label
      file_key
      group_icon
      width
      height
    }
    image {
      ...S3Object
    }
  }
  users_required_objects {
    id
    full_name
    image {
      ...S3Object
    }
  }
  users_suggested_objects {
    id
    full_name
    image {
      ...S3Object
    }
  }
  target_user
  rule {
    all_users
    operator
    department_ids
    location_ids
  }
}
    ${S3ObjectFragmentDoc}`;
export const ClientCapabilityFragmentDoc = `
    fragment ClientCapability on ClientCapability {
  capability_id
  client_id
  entity_type
  quota
  usage
  client_title
  client_subdomain
  active
}
    `;
export const CapabilityFragmentDoc = `
    fragment Capability on Capability {
  capability_id
  entity_type
  group
  description
  client_count
  clients {
    ...ClientCapability
  }
}
    ${ClientCapabilityFragmentDoc}`;
export const ClientBillingReportAggregateFragmentDoc = `
    fragment ClientBillingReportAggregate on ClientBillingReportAggregate {
  client_id
  calendar_month
  client_subdomain
  created_at
  updated_at
  contract_committed_user_count
  contract_type
  contract_end_at
  contract_start_at
  num_registered_users
  num_anonymous_users
  num_email_users
  total_users
  user_overage
  usage_rate
  last_month_total_users
  two_months_ago_total_users
  num_potential_users
  registered_rate
}
    `;
export const ContentTagMetaResultsFragmentDoc = `
    fragment ContentTagMetaResults on ContentTagMetaResults {
  title
  tag_id
  warning
}
    `;
export const GroupFragmentDoc = `
    fragment Group on Group {
  id
  created_at
  title
  follower_count
  color
  color_map {
    hex
  }
  allow_user_posts
  content_approval_type
  group_status
  icon
  icon_color
  icon_color_map {
    hex
  }
  icon_map {
    bucket
    file_key
    width
    height
  }
  image {
    ...S3Object
  }
  location_id
  location_title
  department_id
  department_title
  read_only
  is_private
}
    ${S3ObjectFragmentDoc}`;
export const PublicUserProfileFragmentDoc = `
    fragment PublicUserProfile on PublicUserProfile {
  id
  full_name
  job_title
  follower_count
  email_address
  location_title
  location {
    id
    title
    block_message
  }
  department_title
  user_type
  user_status
  reach
  image {
    ...S3Object
  }
}
    ${S3ObjectFragmentDoc}`;
export const ClientDepartmentFragmentDoc = `
    fragment ClientDepartment on ClientDepartment {
  id
  client_id
  title
  department_status
  groups_total
  profiles_total
}
    `;
export const ClientLocationFragmentDoc = `
    fragment ClientLocation on ClientLocation {
  id
  client_id
  title
  location_status
  groups_total
  profiles_total
}
    `;
export const ClientFollowMappingFragmentDoc = `
    fragment ClientFollowMapping on ClientFollowMapping {
  id
  title
  mapping_status
  all_users
  follow_condition_conjunction
  required_groups {
    ...Group
  }
  suggested_groups {
    ...Group
  }
  required_users {
    ...PublicUserProfile
  }
  suggested_users {
    ...PublicUserProfile
  }
  follow_conditions {
    department_id
    departments {
      ...ClientDepartment
    }
    location_id
    locations {
      ...ClientLocation
    }
    language
    email_domain
  }
}
    ${GroupFragmentDoc}
${PublicUserProfileFragmentDoc}
${ClientDepartmentFragmentDoc}
${ClientLocationFragmentDoc}`;
export const ClientGroupSourceFragmentDoc = `
    fragment ClientGroupSource on ClientGroupSource {
  id
  group_id
  source_status
  source_type
  source_value
  approval
}
    `;
export const ClientInvitationFragmentDoc = `
    fragment ClientInvitation on ClientInvitation {
  id
  client_id
  email_address
  invitation_status
  created_at
  updated_at
  accepted_at
  accepted_by_user {
    id
    full_name
    email_address
    user_status
    onboarding_completed
    user_type
  }
  added_by_user {
    id
    full_name
    email_address
  }
  user_type
}
    `;
export const ClientPageMappingFragmentDoc = `
    fragment ClientPageMapping on ClientPageMapping {
  active
  connected_count
  linkedin_page_id
  name
  token_ids
}
    `;
export const ClientDisclosureFragmentDoc = `
    fragment ClientDisclosure on ClientDisclosure {
  id
  disclosure
  disclosure_status
}
    `;
export const ClientCommonFragmentDoc = `
    fragment ClientCommon on Client {
  id
  title
  subdomain
  email_domains
  content_domains
  client_status
  authentication_type
  allow_user_signup
  departments_in_signup_required
  locations_in_signup_required
  default_timezone
  default_language
  support_multiple_languages
  social_media_policy_enabled
  social_media_policy_title
  social_media_policy_url
  social_media_policy
  public_post_page
  public_post_details
  disclosures {
    id
    disclosure
    disclosure_status
  }
  sso_configuration {
    provider
    domain
    identity_pool_id
    user_pool_id
    region
    app_client_id
    redirect_sign_out
  }
  image {
    bucket
    key
    width
    height
    region
  }
}
    `;
export const ClientProtectedFragmentDoc = `
    fragment ClientProtected on Client {
  created_at
  email_from_address
  allow_user_invites
  content_domains
  allow_group_creation
  disable_comments
  allow_external_share
  sort_mode
  email_address
  sso_provider
  allow_sharing
  email_sending_domain
  compliance_notification_emails
  compliance_notification_enabled
  moderator_can_mark_as_important
  is_self_serve
  stickers {
    ...S3Object
  }
  referral_headline
  referral_message
  stickers_enabled
  features
  disclosures {
    ...ClientDisclosure
  }
  social_config {
    twitter_shareable
    twitter_engageable
    linkedin_shareable
    linkedin_engageable
    facebook_shareable
    facebook_engageable
    youtube_shareable
    youtube_engageable
    instagram_shareable
    instagram_engageable
    reddit_shareable
    reddit_engageable
    tiktok_shareable
    tiktok_engageable
    weibo_shareable
    weibo_engageable
    wechat_shareable
    wechat_engageable
  }
  setup_completed
  feature_plan_type
  disclosures {
    id
    disclosure
  }
  billing {
    billable_user_count
    stripe_account_id
    stripe_customer_id
    stripe_price_id
    stripe_product_id
    stripe_subscription_id
    stripe_subscription_item_id
  }
  billing_address {
    address
    address2
    city
    state
    zip
    country
  }
  billing_status
  billing_type
  billing_teams_trial_start
  billing_teams_trial_end
  contract_committed_user_count
  contract_type
  contract_end_at
  contract_start_at
  added_by_user_id
  allow_group_discovery
  allow_user_share_commentary
  departments_in_signup
  locations_in_signup
  updated_at
  menu_item_enabled
  menu_item {
    title
    link
  }
  icon {
    ...S3Object
  }
  yearly_enrichment_quota
  client_aliases {
    company_id
    name
  }
  ...ClientCommon
}
    ${S3ObjectFragmentDoc}
${ClientDisclosureFragmentDoc}
${ClientCommonFragmentDoc}`;
export const ClientPublicFragmentDoc = `
    fragment ClientPublic on Client {
  ...ClientCommon
}
    ${ClientCommonFragmentDoc}`;
export const ClientUrlParamsFragmentDoc = `
    fragment ClientUrlParams on ClientUrlParams {
  id
  params_status
  content_domain
  configuration {
    key
    value
    dynamic_value
    value_options
    default_option_value
  }
}
    `;
export const MentionObjectFragmentDoc = `
    fragment MentionObject on MentionObject {
  provider
  identifier
  start
  length
}
    `;
export const UrlMetadataFragmentDoc = `
    fragment UrlMetadata on UrlMetadata {
  provider_display
  provider_name
  provider_url
  title
  url
  original_url
  description
  images {
    url
    bucket
    file_key
    url_proxy
    url_original
    caption
    height
    width
    size
    primary
  }
  media {
    duration
    height
    width
    type
    html
    url
    bucket
    file_key
    url_proxy
    url_original
  }
}
    `;
export const TweetMetadataFragmentDoc = `
    fragment TweetMetadata on TweetMetadata {
  id_str
  created_at
  text
  favorite_count
  retweet_count
  user {
    name
    screen_name
    profile_image_url_https
    verified
  }
  hashtags {
    text
  }
  urls {
    display_url
    expanded_url
  }
  user_mentions {
    id_str
    name
    screen_name
  }
  media {
    media_url_https
    type
  }
}
    `;
export const ContentObjectFragmentDoc = `
    fragment ContentObject on ContentObject {
  post_type
  metadata_keys
  title
  body
  url
  photos {
    ...S3Object
  }
  media {
    video {
      bucket
      key
      region
      playlist
      poster
      thumbnails
      status
    }
  }
  url_metadata {
    ...UrlMetadata
  }
  tweet_metadata {
    ...TweetMetadata
  }
  youtube_metadata {
    video_id
  }
  instagram_metadata {
    id
    shortcode
  }
  reddit_metadata {
    url
  }
}
    ${S3ObjectFragmentDoc}
${UrlMetadataFragmentDoc}
${TweetMetadataFragmentDoc}`;
export const ContentShareFragmentDoc = `
    fragment ContentShare on Content {
  content_id
  share_count
  engagement_count
  engage_count
  reaction_count
  comment_count
  click_count
  publish_at
  has_requesting_user_shared
  commentary {
    network
    commentary
    mentions {
      ...MentionObject
    }
  }
  groups {
    id
    title
  }
  content_object {
    ...ContentObject
  }
}
    ${MentionObjectFragmentDoc}
${ContentObjectFragmentDoc}`;
export const ContentEmailSpecFragmentDoc = `
    fragment ContentEmailSpec on ContentEmailSpec {
  id
  title
  segment_ids
  all_users
  created_at
  content_specs {
    id
    content_type
  }
  send_at
  delivery_interval
  grouping_interval
  banner {
    ...S3Object
  }
  banner_url
  intro
  footer
  email_from
  email_reply_to
  subject
  config_status
  use_sto
}
    ${S3ObjectFragmentDoc}`;
export const ChannelInfoFragmentDoc = `
    fragment ChannelInfo on ChannelInfo {
  channel_name
  channel_id
  team_id
  status
}
    `;
export const ContentDisclosuresFragmentDoc = `
    fragment ContentDisclosures on ContentDisclosures {
  network
  disclosure_id
}
    `;
export const ContentReactionsFragmentDoc = `
    fragment ContentReactions on ContentReactions {
  reaction_count {
    total
  }
  user_reactions
  reaction_user_details {
    ...PublicUserProfile
  }
}
    ${PublicUserProfileFragmentDoc}`;
export const UserFeedFollowGroupFragmentDoc = `
    fragment UserFeedFollowGroup on Group {
  id
  title
  follower_count
  location_title
  department_title
  content_approval_type
  color_map {
    hex
  }
  icon_map {
    bucket
    file_key
    width
    height
  }
  image {
    ...S3Object
  }
  is_private
  read_only
}
    ${S3ObjectFragmentDoc}`;
export const MinimalUserProfileFragmentDoc = `
    fragment MinimalUserProfile on MinimalUserProfile {
  id
  full_name
  image {
    ...S3Object
  }
}
    ${S3ObjectFragmentDoc}`;
export const ContentAuditFragmentDoc = `
    fragment ContentAudit on ContentAudit {
  ACTION
  time
  by_user_id
  by_user_profile {
    ...PublicUserProfile
  }
  message
}
    ${PublicUserProfileFragmentDoc}`;
export const TaggedContentMetaFragmentDoc = `
    fragment TaggedContentMeta on TaggedContentMeta {
  title
  tag_id
}
    `;
export const ContentFragmentDoc = `
    fragment Content on Content {
  approval
  content_id
  content_source_id
  is_branded
  is_shareable
  is_important
  is_important_message
  is_engage
  is_shareable
  is_engageable
  is_pinned
  pinned_end_at
  important_to_share
  reaction_count
  comment_count
  share_count
  engage_count
  reaction_count
  comment_count
  click_count
  publish_at
  group_ids
  primary_group_id
  has_requesting_user_shared
  lock_commentary
  slack_channels {
    ...ChannelInfo
  }
  ms_teams_channels {
    ...ChannelInfo
  }
  pinned_to_groups {
    group_id
    pinned_end_at
  }
  commentary {
    network
    commentary
    mentions {
      ...MentionObject
    }
  }
  disclosures {
    ...ContentDisclosures
  }
  group_id_approvals {
    group_id
    approval
  }
  content_object {
    ...ContentObject
  }
  reactions {
    ...ContentReactions
  }
  groups {
    ...UserFeedFollowGroup
  }
  group_ids
  user {
    ...PublicUserProfile
  }
  url_param_values {
    key
    value
  }
  reacted_by {
    ...MinimalUserProfile
  }
  shared_by {
    ...MinimalUserProfile
  }
  commented_by {
    ...MinimalUserProfile
  }
  schedule {
    publish
    expire
  }
  submitter_role
  audit {
    ...ContentAudit
  }
  content_tags {
    ...TaggedContentMeta
  }
  user_id
}
    ${ChannelInfoFragmentDoc}
${MentionObjectFragmentDoc}
${ContentDisclosuresFragmentDoc}
${ContentObjectFragmentDoc}
${ContentReactionsFragmentDoc}
${UserFeedFollowGroupFragmentDoc}
${PublicUserProfileFragmentDoc}
${MinimalUserProfileFragmentDoc}
${ContentAuditFragmentDoc}
${TaggedContentMetaFragmentDoc}`;
export const ContentEmailHistoryFragmentDoc = `
    fragment ContentEmailHistory on ContentEmailHistory {
  spec_id
  sent_at
  spec {
    ...ContentEmailSpec
  }
  registered_user_count
  unregistered_user_count
  total_opened
  total_emails
  total_delivered
  total_clicks
  featured_content {
    ...Content
  }
}
    ${ContentEmailSpecFragmentDoc}
${ContentFragmentDoc}`;
export const ContentSharePreviewFragmentDoc = `
    fragment ContentSharePreview on ContentSharePreview {
  allowed_counts {
    twitter
    linkedin
    facebook
  }
  suggested_share_time
  shortened_urls {
    email {
      short_link
    }
    direct {
      short_link
    }
    facebook {
      short_link
    }
  }
  locked_commentary
}
    `;
export const EbrProfilesCountFragmentDoc = `
    fragment EbrProfilesCount on EbrProfilesCount {
  count
  name
  percentage
}
    `;
export const ExpressActivatedUserNetworkFragmentDoc = `
    fragment ExpressActivatedUserNetwork on ExpressActivatedUserNetwork {
  provider
  reach
  profile_image_url
  profile_name
  profile_url_suffix
}
    `;
export const ExpressActivatedUsersFragmentDoc = `
    fragment ExpressActivatedUsers on ExpressActivatedUsers {
  email
  access_key
  registered_networks {
    ...ExpressActivatedUserNetwork
  }
  created_at
  status
}
    ${ExpressActivatedUserNetworkFragmentDoc}`;
export const GetFeedGroupFragmentDoc = `
    fragment GetFeedGroup on Group {
  id
  title
  color_map {
    hex
  }
}
    `;
export const GroupSearchResultsFragmentDoc = `
    fragment GroupSearchResults on SearchResults {
  count
  results_from
  results {
    ... on Group {
      ...UserFeedFollowGroup
    }
  }
}
    ${UserFeedFollowGroupFragmentDoc}`;
export const GroupSuggestionFragmentDoc = `
    fragment GroupSuggestion on GroupSuggestion {
  id
  title
  color
  icon_color
  icon
  color_map {
    hex
  }
  icon_color_map {
    hex
  }
  icon_map {
    bucket
    file_key
    width
    height
  }
  image {
    ...S3Object
  }
}
    ${S3ObjectFragmentDoc}`;
export const InboxFragmentDoc = `
    fragment Inbox on Inbox {
  id
  created_at
  updated_at
  item_read
  message
  to_user_id
  url
}
    `;
export const UserSegmentFragmentDoc = `
    fragment UserSegment on UserSegment {
  id
  title
  created_at
  segment_status
  department_ids
  departments {
    ...ClientDepartment
  }
  location_ids
  locations {
    ...ClientLocation
  }
  group_ids
  groups {
    ...Group
  }
  registered_count
  third_party_count
}
    ${ClientDepartmentFragmentDoc}
${ClientLocationFragmentDoc}
${GroupFragmentDoc}`;
export const LeaderboardEventAggregateFragmentDoc = `
    fragment LeaderboardEventAggregate on LeaderboardEventAggregate {
  everyonesocial {
    posting {
      event
      score
    }
    actions {
      event
      score
    }
    teammates {
      event
      score
    }
  }
  linkedin {
    general {
      event
      score
    }
  }
  twitter {
    general {
      event
      score
    }
  }
  facebook {
    general {
      event
      score
    }
  }
}
    `;
export const LeaderboardConfigFragmentDoc = `
    fragment LeaderboardConfig on LeaderboardConfig {
  id
  title
  description
  leaderboard_status
  created_at
  start_at
  end_at
  all_users
  segment_ids
  segments {
    ...UserSegment
  }
  scoring_aggregate {
    ...LeaderboardEventAggregate
  }
}
    ${UserSegmentFragmentDoc}
${LeaderboardEventAggregateFragmentDoc}`;
export const LeaderboardScoreFragmentDoc = `
    fragment LeaderboardScore on LeaderboardScore {
  leaderboard_config_id
  user_id
  user {
    ...PublicUserProfile
  }
  score
  ranking
  position_change
  events {
    event
    score
  }
}
    ${PublicUserProfileFragmentDoc}`;
export const ManualNotificationsItemFragmentDoc = `
    fragment ManualNotificationsItem on ManualNotificationsItem {
  id
  notification_type
  send_at
  segment_ids
  segments {
    id
    title
  }
  created_at
  user_count
  email_count
  entire_company
  message {
    body
    url
  }
  email {
    subject
    body
    format
  }
}
    `;
export const ProfileSearchResultsFragmentDoc = `
    fragment ProfileSearchResults on SearchResults {
  count
  results_from
  results {
    ... on PublicUserProfile {
      ...PublicUserProfile
    }
  }
}
    ${PublicUserProfileFragmentDoc}`;
export const ProfileSuggestionFragmentDoc = `
    fragment ProfileSuggestion on ProfileSuggestion {
  id
  title
  image {
    ...S3Object
  }
}
    ${S3ObjectFragmentDoc}`;
export const ClientReleaseToggleFragmentDoc = `
    fragment ClientReleaseToggle on ClientReleaseToggle {
  release_id
  client_id
  entity_type
  quota
  usage
  client_title
  client_subdomain
  active
}
    `;
export const ReleaseToggleFragmentDoc = `
    fragment ReleaseToggle on ReleaseToggle {
  release_id
  entity_type
  group
  description
  client_count
  clients {
    ...ClientReleaseToggle
  }
}
    ${ClientReleaseToggleFragmentDoc}`;
export const RoiDailyStatFragmentDoc = `
    fragment ROIDailyStat on ROIDailyStat {
  currency
  previous_currency
  calendar_day
  previous_calendar_day
}
    `;
export const RoiIndividualStatFragmentDoc = `
    fragment ROIIndividualStat on ROIIndividualStat {
  currency
  change
  facebook
  twitter
  linkedin
  facebook_count
  twitter_count
  linkedin_count
}
    `;
export const S3VideoObjectFragmentDoc = `
    fragment S3VideoObject on S3VideoObject {
  bucket
  key
  region
  status
  playlist
  poster
  thumbnails
}
    `;
export const ScheduledShareItemFragmentDoc = `
    fragment ScheduledShareItem on ScheduledShareItem {
  id
  network
  network_id
  user_commentary
  share_at
  shared_at
  share_session_id
}
    `;
export const ScimTokenFragmentDoc = `
    fragment ScimToken on ScimToken {
  id
  client_id
  user_id
  expires_at
  not_valid_before
  rate_limit_max_requests
  rate_limit_window_duration
}
    `;
export const SearchAggregatesFragmentDoc = `
    fragment SearchAggregates on SearchAggregates {
  total
  departments {
    ...ClientDepartment
  }
  locations {
    ...ClientLocation
  }
}
    ${ClientDepartmentFragmentDoc}
${ClientLocationFragmentDoc}`;
export const MinimalGroupFragmentDoc = `
    fragment MinimalGroup on MinimalGroup {
  id
  client_id
  title
  group_status
  is_private
  content_approval_type
  description
  allow_user_posts
  color
  icon_color
  icon
  color_map {
    label
    hex
    group_color
  }
  icon_color_map {
    label
    hex
    group_icon_color
  }
  icon_map {
    label
    bucket
    file_key
    group_icon
    width
    height
  }
  created_at
  updated_at
  image {
    ...S3Object
  }
  follower_count
  read_only
}
    ${S3ObjectFragmentDoc}`;
export const MinimalPostFragmentDoc = `
    fragment MinimalPost on MinimalPost {
  client_id
  approval
  content_id
  created_at
  publish_at
  content_object {
    ...ContentObject
  }
  user {
    ...PublicUserProfile
  }
  groups {
    ...MinimalGroup
  }
  is_engage
  is_important
  is_branded
  is_shareable
  important_to_share
  is_engageable
  share_count
  engagement_count
  click_count
  comment_count
  reaction_count
  primary_group {
    ...MinimalGroup
  }
  has_requesting_user_shared
}
    ${ContentObjectFragmentDoc}
${PublicUserProfileFragmentDoc}
${MinimalGroupFragmentDoc}`;
export const SearchEveryoneSocialResultsFragmentDoc = `
    fragment SearchEveryoneSocialResults on SearchEveryoneSocialResults {
  posts {
    ...MinimalPost
  }
  groups {
    ...MinimalGroup
  }
  users {
    ...MinimalUserProfile
  }
  cursor
}
    ${MinimalPostFragmentDoc}
${MinimalGroupFragmentDoc}
${MinimalUserProfileFragmentDoc}`;
export const SegmentEventDetailsFragmentDoc = `
    fragment SegmentEventDetails on SegmentEventDetails {
  event_name
  event_args
}
    `;
export const SharesItemFragmentDoc = `
    fragment SharesItem on SharesItem {
  id
  network
  network_id
  identifier
  user_commentary
  share_at
  shared_at
  share_session_id
  clicks
  engagements
  impressions
  content {
    ...Content
  }
  network_profile_name
}
    ${ContentFragmentDoc}`;
export const SocialAccountFragmentDoc = `
    fragment SocialAccount on SocialAccount {
  id
  provider
  identifier
  profile_name
  reach
  expires_soon
  profile_url
  profile_picture
  smart_schedule
}
    `;
export const LinkedInPageFragmentDoc = `
    fragment LinkedInPage on LinkedInPage {
  id
  identifier
  logo
  profile_name
  profile_url
  provider
  role
  urn
}
    `;
export const SocialAccountConnectionFragmentDoc = `
    fragment SocialAccountConnection on SocialAccountConnection {
  item {
    ...SocialAccount
  }
  pages {
    ...LinkedInPage
  }
}
    ${SocialAccountFragmentDoc}
${LinkedInPageFragmentDoc}`;
export const UpdatedContentFragmentDoc = `
    fragment UpdatedContent on UpdatedContent {
  user_id
  client_id
  content_id
  share_count
  click_count
  comment_count
  reaction_count
  shared_by {
    ...MinimalUserProfile
  }
  reacted_by {
    ...MinimalUserProfile
  }
  commented_by {
    ...MinimalUserProfile
  }
}
    ${MinimalUserProfileFragmentDoc}`;
export const UserFeedFollowFragmentDoc = `
    fragment UserFeedFollow on UserFeedFollow {
  feed
  user_id
  created_at
  postable
  group_role
  group {
    ...UserFeedFollowGroup
  }
  user {
    ...PublicUserProfile
  }
  followed_by_user {
    ...PublicUserProfile
  }
  required
}
    ${UserFeedFollowGroupFragmentDoc}
${PublicUserProfileFragmentDoc}`;
export const GroupModeratorFragmentDoc = `
    fragment GroupModerator on GroupModerator {
  group_id
  user_id
  created_at
  added_by_user_id
  user {
    ...PublicUserProfile
  }
}
    ${PublicUserProfileFragmentDoc}`;
export const UserProfileFragmentDoc = `
    fragment UserProfile on UserProfile {
  id
  full_name
  job_title
  follower_count
  image {
    ...S3Object
  }
  email_address
  email_address_verified
  user_type
  user_status
  user_pool_id
  client_id
  location_id
  location_title
  location {
    id
    title
    block_message
  }
  department_id
  department_title
  last_onboarding_step
  lang
  onboarding_completed
  last_accessed_at
  user_timezone
  created_at
  german_privacy
  reach
  group_moderator {
    ...GroupModerator
  }
  notification_delivery_types
  getstream_token
  push_notification_configuration {
    device_platform
    token
  }
  push_notifications_status {
    paused
    paused_at
  }
  setup_completed
  smart_schedule_acknowledgement
  smart_schedule_viewed
}
    ${S3ObjectFragmentDoc}
${GroupModeratorFragmentDoc}`;
export const UserProfileSearchFragmentDoc = `
    fragment UserProfileSearch on UserProfile {
  id
  client_id
  full_name
  job_title
  email_address
  user_type
  user_status
  location_id
  location_title
  department_id
  department_title
  follower_count
  reach
  last_accessed_at
  image {
    ...S3Object
  }
}
    ${S3ObjectFragmentDoc}`;
export const WebhookFragmentDoc = `
    fragment Webhook on Webhook {
  callback_url
  webhook_status
  webhook_id
  webhook_name
  webhook_type
  workvivo_org_id
  workvivo_workspace_id
  groups
}
    `;
export const IdentityProviderFragmentDoc = `
    fragment IdentityProvider on IdentityProvider {
  provider_type
  provider_details {
    metadata_file
    metadata_u_r_l
  }
  last_modified_date
}
    `;
export const UserMappingsFragmentDoc = `
    fragment UserMappings on UserMappings {
  external_user_mappings {
    user_type {
      internal
      external
    }
    user_status {
      internal
      external
    }
    department {
      internal
      external
    }
    location {
      internal
      external
    }
  }
  email_attr
  full_name_attr
  job_title_attr
  user_type_attr
  user_status_attr
  department_attr
  location_attr
}
    `;
export const AddReactionAnalyticsDocument = `
    mutation ADD_REACTION_ANALYTICS($content_id: String!, $reaction_type: ReactionType!) {
  addReactionAnalytics(
    data: {object_type: content, object_id: $content_id, reaction_type: $reaction_type}
  )
}
    `;
export const useAddReactionAnalyticsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddReactionAnalyticsMutation, TError, AddReactionAnalyticsMutationVariables, TContext>) =>
    useMutation<AddReactionAnalyticsMutation, TError, AddReactionAnalyticsMutationVariables, TContext>(
      'ADD_REACTION_ANALYTICS',
      (variables?: AddReactionAnalyticsMutationVariables) => transport<AddReactionAnalyticsMutation, AddReactionAnalyticsMutationVariables>(AddReactionAnalyticsDocument, variables)(),
      options
    );
export const AdminUpdateClientDocument = `
    mutation ADMIN_UPDATE_CLIENT($data: AdminUpdateClientInput!) {
  adminUpdateClient(data: $data) {
    ...ClientProtected
  }
}
    ${ClientProtectedFragmentDoc}`;
export const useAdminUpdateClientMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AdminUpdateClientMutation, TError, AdminUpdateClientMutationVariables, TContext>) =>
    useMutation<AdminUpdateClientMutation, TError, AdminUpdateClientMutationVariables, TContext>(
      'ADMIN_UPDATE_CLIENT',
      (variables?: AdminUpdateClientMutationVariables) => transport<AdminUpdateClientMutation, AdminUpdateClientMutationVariables>(AdminUpdateClientDocument, variables)(),
      options
    );
export const BatchCreateGroupsDocument = `
    mutation BATCH_CREATE_GROUPS($group_input_list: GroupInputList) {
  batchCreateGroups(group_input_list: $group_input_list) {
    groups {
      id
    }
  }
}
    `;
export const useBatchCreateGroupsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BatchCreateGroupsMutation, TError, BatchCreateGroupsMutationVariables, TContext>) =>
    useMutation<BatchCreateGroupsMutation, TError, BatchCreateGroupsMutationVariables, TContext>(
      'BATCH_CREATE_GROUPS',
      (variables?: BatchCreateGroupsMutationVariables) => transport<BatchCreateGroupsMutation, BatchCreateGroupsMutationVariables>(BatchCreateGroupsDocument, variables)(),
      options
    );
export const BatchDeleteGroupsDocument = `
    mutation BATCH_DELETE_GROUPS($ids: [ID]!) {
  batchDeleteGroups(ids: $ids) {
    id
  }
}
    `;
export const useBatchDeleteGroupsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BatchDeleteGroupsMutation, TError, BatchDeleteGroupsMutationVariables, TContext>) =>
    useMutation<BatchDeleteGroupsMutation, TError, BatchDeleteGroupsMutationVariables, TContext>(
      'BATCH_DELETE_GROUPS',
      (variables?: BatchDeleteGroupsMutationVariables) => transport<BatchDeleteGroupsMutation, BatchDeleteGroupsMutationVariables>(BatchDeleteGroupsDocument, variables)(),
      options
    );
export const BatchUpdateSocialConnectionDocument = `
    mutation BATCH_UPDATE_SOCIAL_CONNECTION($data: BatchUpdateSocialConnectionInput!) {
  batchUpdateSocialConnection(data: $data) {
    items {
      ...SocialAccountConnection
    }
  }
}
    ${SocialAccountConnectionFragmentDoc}`;
export const useBatchUpdateSocialConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BatchUpdateSocialConnectionMutation, TError, BatchUpdateSocialConnectionMutationVariables, TContext>) =>
    useMutation<BatchUpdateSocialConnectionMutation, TError, BatchUpdateSocialConnectionMutationVariables, TContext>(
      'BATCH_UPDATE_SOCIAL_CONNECTION',
      (variables?: BatchUpdateSocialConnectionMutationVariables) => transport<BatchUpdateSocialConnectionMutation, BatchUpdateSocialConnectionMutationVariables>(BatchUpdateSocialConnectionDocument, variables)(),
      options
    );
export const BatchUpdateUserProfileStatusDocument = `
    mutation BATCH_UPDATE_USER_PROFILE_STATUS($ids: [ID]!, $user_status: UserStatus!) {
  batchUpdateUserProfileStatus(ids: $ids, user_status: $user_status) {
    id
    user_status
  }
}
    `;
export const useBatchUpdateUserProfileStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BatchUpdateUserProfileStatusMutation, TError, BatchUpdateUserProfileStatusMutationVariables, TContext>) =>
    useMutation<BatchUpdateUserProfileStatusMutation, TError, BatchUpdateUserProfileStatusMutationVariables, TContext>(
      'BATCH_UPDATE_USER_PROFILE_STATUS',
      (variables?: BatchUpdateUserProfileStatusMutationVariables) => transport<BatchUpdateUserProfileStatusMutation, BatchUpdateUserProfileStatusMutationVariables>(BatchUpdateUserProfileStatusDocument, variables)(),
      options
    );
export const BatchUpdateUserProfileTypeDocument = `
    mutation BATCH_UPDATE_USER_PROFILE_TYPE($ids: [ID]!, $user_type: UserType!) {
  batchUpdateUserProfileUserType(ids: $ids, user_type: $user_type) {
    id
    user_type
  }
}
    `;
export const useBatchUpdateUserProfileTypeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BatchUpdateUserProfileTypeMutation, TError, BatchUpdateUserProfileTypeMutationVariables, TContext>) =>
    useMutation<BatchUpdateUserProfileTypeMutation, TError, BatchUpdateUserProfileTypeMutationVariables, TContext>(
      'BATCH_UPDATE_USER_PROFILE_TYPE',
      (variables?: BatchUpdateUserProfileTypeMutationVariables) => transport<BatchUpdateUserProfileTypeMutation, BatchUpdateUserProfileTypeMutationVariables>(BatchUpdateUserProfileTypeDocument, variables)(),
      options
    );
export const BulkResendClientInvitationsDocument = `
    mutation BULK_RESEND_CLIENT_INVITATIONS($invitation_ids: [ID!], $search_filter: ClientInvitationSearchFilter) {
  bulkResendClientInvitations(
    invitation_ids: $invitation_ids
    search_filter: $search_filter
  )
}
    `;
export const useBulkResendClientInvitationsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BulkResendClientInvitationsMutation, TError, BulkResendClientInvitationsMutationVariables, TContext>) =>
    useMutation<BulkResendClientInvitationsMutation, TError, BulkResendClientInvitationsMutationVariables, TContext>(
      'BULK_RESEND_CLIENT_INVITATIONS',
      (variables?: BulkResendClientInvitationsMutationVariables) => transport<BulkResendClientInvitationsMutation, BulkResendClientInvitationsMutationVariables>(BulkResendClientInvitationsDocument, variables)(),
      options
    );
export const BulkUpdateContentDocument = `
    mutation BULK_UPDATE_CONTENT($bulk_update: BulkUpdateContent!) {
  bulkUpdateContent(bulk_update: $bulk_update) {
    error
    success
  }
}
    `;
export const useBulkUpdateContentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BulkUpdateContentMutation, TError, BulkUpdateContentMutationVariables, TContext>) =>
    useMutation<BulkUpdateContentMutation, TError, BulkUpdateContentMutationVariables, TContext>(
      'BULK_UPDATE_CONTENT',
      (variables?: BulkUpdateContentMutationVariables) => transport<BulkUpdateContentMutation, BulkUpdateContentMutationVariables>(BulkUpdateContentDocument, variables)(),
      options
    );
export const CompleteMultiPartUploadDocument = `
    mutation COMPLETE_MULTI_PART_UPLOAD($bucket_name: String!, $multipart_upload: [MultiPartListInput!]!, $object_name: String!, $upload_id: String!) {
  completeMultiPartUpload(
    bucket_name: $bucket_name
    multipart_upload: $multipart_upload
    object_name: $object_name
    upload_id: $upload_id
  ) {
    etag
  }
}
    `;
export const useCompleteMultiPartUploadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CompleteMultiPartUploadMutation, TError, CompleteMultiPartUploadMutationVariables, TContext>) =>
    useMutation<CompleteMultiPartUploadMutation, TError, CompleteMultiPartUploadMutationVariables, TContext>(
      'COMPLETE_MULTI_PART_UPLOAD',
      (variables?: CompleteMultiPartUploadMutationVariables) => transport<CompleteMultiPartUploadMutation, CompleteMultiPartUploadMutationVariables>(CompleteMultiPartUploadDocument, variables)(),
      options
    );
export const CreateApiTokenDocument = `
    mutation CREATE_API_TOKEN($data: CreateAPITokenInput!) {
  createAPIToken(data: $data) {
    token_name
    token_id
    api_token
  }
}
    `;
export const useCreateApiTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateApiTokenMutation, TError, CreateApiTokenMutationVariables, TContext>) =>
    useMutation<CreateApiTokenMutation, TError, CreateApiTokenMutationVariables, TContext>(
      'CREATE_API_TOKEN',
      (variables?: CreateApiTokenMutationVariables) => transport<CreateApiTokenMutation, CreateApiTokenMutationVariables>(CreateApiTokenDocument, variables)(),
      options
    );
export const CreateAssignmentDocument = `
    mutation CREATE_ASSIGNMENT($data: AssignmentInput!) {
  createAssignment(data: $data) {
    ...Assignment
  }
}
    ${AssignmentFragmentDoc}`;
export const useCreateAssignmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateAssignmentMutation, TError, CreateAssignmentMutationVariables, TContext>) =>
    useMutation<CreateAssignmentMutation, TError, CreateAssignmentMutationVariables, TContext>(
      'CREATE_ASSIGNMENT',
      (variables?: CreateAssignmentMutationVariables) => transport<CreateAssignmentMutation, CreateAssignmentMutationVariables>(CreateAssignmentDocument, variables)(),
      options
    );
export const CreateClientContentTagsDocument = `
    mutation CREATE_CLIENT_CONTENT_TAGS($tags: [ContentTagMetaInput]!) {
  createClientContentTags(tags: $tags) {
    ...ContentTagMetaResults
  }
}
    ${ContentTagMetaResultsFragmentDoc}`;
export const useCreateClientContentTagsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateClientContentTagsMutation, TError, CreateClientContentTagsMutationVariables, TContext>) =>
    useMutation<CreateClientContentTagsMutation, TError, CreateClientContentTagsMutationVariables, TContext>(
      'CREATE_CLIENT_CONTENT_TAGS',
      (variables?: CreateClientContentTagsMutationVariables) => transport<CreateClientContentTagsMutation, CreateClientContentTagsMutationVariables>(CreateClientContentTagsDocument, variables)(),
      options
    );
export const CreateClientDepartmentDocument = `
    mutation CREATE_CLIENT_DEPARTMENT($data: CreateClientDepartmentInput!) {
  createClientDepartment(data: $data) {
    ...ClientDepartment
  }
}
    ${ClientDepartmentFragmentDoc}`;
export const useCreateClientDepartmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateClientDepartmentMutation, TError, CreateClientDepartmentMutationVariables, TContext>) =>
    useMutation<CreateClientDepartmentMutation, TError, CreateClientDepartmentMutationVariables, TContext>(
      'CREATE_CLIENT_DEPARTMENT',
      (variables?: CreateClientDepartmentMutationVariables) => transport<CreateClientDepartmentMutation, CreateClientDepartmentMutationVariables>(CreateClientDepartmentDocument, variables)(),
      options
    );
export const CreateClientDisclosureDocument = `
    mutation CREATE_CLIENT_DISCLOSURE($data: CreateClientDisclosureInput!, $override: OverrideInput) {
  createClientDisclosure(data: $data, override: $override) {
    ...ClientDisclosure
  }
}
    ${ClientDisclosureFragmentDoc}`;
export const useCreateClientDisclosureMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateClientDisclosureMutation, TError, CreateClientDisclosureMutationVariables, TContext>) =>
    useMutation<CreateClientDisclosureMutation, TError, CreateClientDisclosureMutationVariables, TContext>(
      'CREATE_CLIENT_DISCLOSURE',
      (variables?: CreateClientDisclosureMutationVariables) => transport<CreateClientDisclosureMutation, CreateClientDisclosureMutationVariables>(CreateClientDisclosureDocument, variables)(),
      options
    );
export const CreateClientFollowMappingDocument = `
    mutation CREATE_CLIENT_FOLLOW_MAPPING($data: CreateClientFollowMappingInput!) {
  createClientFollowMapping(data: $data) {
    ...ClientFollowMapping
  }
}
    ${ClientFollowMappingFragmentDoc}`;
export const useCreateClientFollowMappingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateClientFollowMappingMutation, TError, CreateClientFollowMappingMutationVariables, TContext>) =>
    useMutation<CreateClientFollowMappingMutation, TError, CreateClientFollowMappingMutationVariables, TContext>(
      'CREATE_CLIENT_FOLLOW_MAPPING',
      (variables?: CreateClientFollowMappingMutationVariables) => transport<CreateClientFollowMappingMutation, CreateClientFollowMappingMutationVariables>(CreateClientFollowMappingDocument, variables)(),
      options
    );
export const CreateClientInvitationDocument = `
    mutation CREATE_CLIENT_INVITATION($data: CreateClientInvitationInput!) {
  createClientInvitation(data: $data) {
    ...ClientInvitation
  }
}
    ${ClientInvitationFragmentDoc}`;
export const useCreateClientInvitationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateClientInvitationMutation, TError, CreateClientInvitationMutationVariables, TContext>) =>
    useMutation<CreateClientInvitationMutation, TError, CreateClientInvitationMutationVariables, TContext>(
      'CREATE_CLIENT_INVITATION',
      (variables?: CreateClientInvitationMutationVariables) => transport<CreateClientInvitationMutation, CreateClientInvitationMutationVariables>(CreateClientInvitationDocument, variables)(),
      options
    );
export const CreateClientLocationDocument = `
    mutation CREATE_CLIENT_LOCATION($data: CreateClientLocationInput!) {
  createClientLocation(data: $data) {
    ...ClientLocation
  }
}
    ${ClientLocationFragmentDoc}`;
export const useCreateClientLocationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateClientLocationMutation, TError, CreateClientLocationMutationVariables, TContext>) =>
    useMutation<CreateClientLocationMutation, TError, CreateClientLocationMutationVariables, TContext>(
      'CREATE_CLIENT_LOCATION',
      (variables?: CreateClientLocationMutationVariables) => transport<CreateClientLocationMutation, CreateClientLocationMutationVariables>(CreateClientLocationDocument, variables)(),
      options
    );
export const CreateClientPageMappingDocument = `
    mutation CREATE_CLIENT_PAGE_MAPPING($data: CreateClientPageMappingInput!, $override: OverrideInput) {
  createClientPageMapping(data: $data, override: $override)
}
    `;
export const useCreateClientPageMappingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateClientPageMappingMutation, TError, CreateClientPageMappingMutationVariables, TContext>) =>
    useMutation<CreateClientPageMappingMutation, TError, CreateClientPageMappingMutationVariables, TContext>(
      'CREATE_CLIENT_PAGE_MAPPING',
      (variables?: CreateClientPageMappingMutationVariables) => transport<CreateClientPageMappingMutation, CreateClientPageMappingMutationVariables>(CreateClientPageMappingDocument, variables)(),
      options
    );
export const CreateClientSelfServeDocument = `
    mutation CREATE_CLIENT_SELF_SERVE($data: CreateClientSelfServeInput!) {
  createClientSelfServe(data: $data) {
    client {
      ...ClientProtected
    }
    user {
      ...UserProfile
    }
  }
}
    ${ClientProtectedFragmentDoc}
${UserProfileFragmentDoc}`;
export const useCreateClientSelfServeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateClientSelfServeMutation, TError, CreateClientSelfServeMutationVariables, TContext>) =>
    useMutation<CreateClientSelfServeMutation, TError, CreateClientSelfServeMutationVariables, TContext>(
      'CREATE_CLIENT_SELF_SERVE',
      (variables?: CreateClientSelfServeMutationVariables) => transport<CreateClientSelfServeMutation, CreateClientSelfServeMutationVariables>(CreateClientSelfServeDocument, variables)(),
      options
    );
export const CreateClientStickerDocument = `
    mutation CREATE_CLIENT_STICKER($data: CreateClientStickerInput!) {
  createClientSticker(data: $data) {
    success
    client {
      id
      stickers {
        ...S3Object
      }
    }
    sticker {
      ...S3Object
    }
  }
}
    ${S3ObjectFragmentDoc}`;
export const useCreateClientStickerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateClientStickerMutation, TError, CreateClientStickerMutationVariables, TContext>) =>
    useMutation<CreateClientStickerMutation, TError, CreateClientStickerMutationVariables, TContext>(
      'CREATE_CLIENT_STICKER',
      (variables?: CreateClientStickerMutationVariables) => transport<CreateClientStickerMutation, CreateClientStickerMutationVariables>(CreateClientStickerDocument, variables)(),
      options
    );
export const CreateContentEmailDocument = `
    mutation CREATE_CONTENT_EMAIL($data: ContentEmailSpecInput!) {
  createContentEmailSpec(data: $data) {
    ...ContentEmailSpec
  }
}
    ${ContentEmailSpecFragmentDoc}`;
export const useCreateContentEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateContentEmailMutation, TError, CreateContentEmailMutationVariables, TContext>) =>
    useMutation<CreateContentEmailMutation, TError, CreateContentEmailMutationVariables, TContext>(
      'CREATE_CONTENT_EMAIL',
      (variables?: CreateContentEmailMutationVariables) => transport<CreateContentEmailMutation, CreateContentEmailMutationVariables>(CreateContentEmailDocument, variables)(),
      options
    );
export const CreateGenericWebhookDocument = `
    mutation CREATE_GENERIC_WEBHOOK($callback_url: String!, $secret_token: String!, $webhook_events: [WebhookEvents]!, $webhook_name: String!, $webhook_status: GenericStatus!) {
  createGenericWebhook(
    callback_url: $callback_url
    secret_token: $secret_token
    webhook_events: $webhook_events
    webhook_name: $webhook_name
    webhook_status: $webhook_status
  ) {
    ...Webhook
  }
}
    ${WebhookFragmentDoc}`;
export const useCreateGenericWebhookMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateGenericWebhookMutation, TError, CreateGenericWebhookMutationVariables, TContext>) =>
    useMutation<CreateGenericWebhookMutation, TError, CreateGenericWebhookMutationVariables, TContext>(
      'CREATE_GENERIC_WEBHOOK',
      (variables?: CreateGenericWebhookMutationVariables) => transport<CreateGenericWebhookMutation, CreateGenericWebhookMutationVariables>(CreateGenericWebhookDocument, variables)(),
      options
    );
export const CreateGroupDocument = `
    mutation CREATE_GROUP($data: CreateGroupInput!) {
  createGroup(data: $data) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export const useCreateGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateGroupMutation, TError, CreateGroupMutationVariables, TContext>) =>
    useMutation<CreateGroupMutation, TError, CreateGroupMutationVariables, TContext>(
      'CREATE_GROUP',
      (variables?: CreateGroupMutationVariables) => transport<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, variables)(),
      options
    );
export const CreateGroupModeratorDocument = `
    mutation CREATE_GROUP_MODERATOR($group_id: ID!, $user_id: ID!) {
  createGroupModerator(group_id: $group_id, user_id: $user_id) {
    ...GroupModerator
  }
}
    ${GroupModeratorFragmentDoc}`;
export const useCreateGroupModeratorMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateGroupModeratorMutation, TError, CreateGroupModeratorMutationVariables, TContext>) =>
    useMutation<CreateGroupModeratorMutation, TError, CreateGroupModeratorMutationVariables, TContext>(
      'CREATE_GROUP_MODERATOR',
      (variables?: CreateGroupModeratorMutationVariables) => transport<CreateGroupModeratorMutation, CreateGroupModeratorMutationVariables>(CreateGroupModeratorDocument, variables)(),
      options
    );
export const CreateGroupSourceDocument = `
    mutation CREATE_GROUP_SOURCE($group_id: ID!, $source_status: SourceStatus!, $source_type: GroupSourceType!, $source_value: String!, $approval: ContentApproval) {
  clientGroupSourceCreate(
    group_id: $group_id
    source_status: $source_status
    source_type: $source_type
    source_value: $source_value
    approval: $approval
  ) {
    ...ClientGroupSource
  }
}
    ${ClientGroupSourceFragmentDoc}`;
export const useCreateGroupSourceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateGroupSourceMutation, TError, CreateGroupSourceMutationVariables, TContext>) =>
    useMutation<CreateGroupSourceMutation, TError, CreateGroupSourceMutationVariables, TContext>(
      'CREATE_GROUP_SOURCE',
      (variables?: CreateGroupSourceMutationVariables) => transport<CreateGroupSourceMutation, CreateGroupSourceMutationVariables>(CreateGroupSourceDocument, variables)(),
      options
    );
export const CreateGroupWebhookWorkvivoDocument = `
    mutation CREATE_GROUP_WEBHOOK_WORKVIVO($group_id: ID!, $webhook_id: String!, $workvivo_workspace_id: String!) {
  createGroupWebhookWorkvivo(
    group_id: $group_id
    webhook_id: $webhook_id
    workvivo_workspace_id: $workvivo_workspace_id
  ) {
    ...Webhook
  }
}
    ${WebhookFragmentDoc}`;
export const useCreateGroupWebhookWorkvivoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateGroupWebhookWorkvivoMutation, TError, CreateGroupWebhookWorkvivoMutationVariables, TContext>) =>
    useMutation<CreateGroupWebhookWorkvivoMutation, TError, CreateGroupWebhookWorkvivoMutationVariables, TContext>(
      'CREATE_GROUP_WEBHOOK_WORKVIVO',
      (variables?: CreateGroupWebhookWorkvivoMutationVariables) => transport<CreateGroupWebhookWorkvivoMutation, CreateGroupWebhookWorkvivoMutationVariables>(CreateGroupWebhookWorkvivoDocument, variables)(),
      options
    );
export const CreateLoginTokenForCurrentUserInClientDocument = `
    mutation CREATE_LOGIN_TOKEN_FOR_CURRENT_USER_IN_CLIENT($client_id: ID!) {
  createLoginTokenForCurrentUserInClient(client_id: $client_id)
}
    `;
export const useCreateLoginTokenForCurrentUserInClientMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateLoginTokenForCurrentUserInClientMutation, TError, CreateLoginTokenForCurrentUserInClientMutationVariables, TContext>) =>
    useMutation<CreateLoginTokenForCurrentUserInClientMutation, TError, CreateLoginTokenForCurrentUserInClientMutationVariables, TContext>(
      'CREATE_LOGIN_TOKEN_FOR_CURRENT_USER_IN_CLIENT',
      (variables?: CreateLoginTokenForCurrentUserInClientMutationVariables) => transport<CreateLoginTokenForCurrentUserInClientMutation, CreateLoginTokenForCurrentUserInClientMutationVariables>(CreateLoginTokenForCurrentUserInClientDocument, variables)(),
      options
    );
export const CreateManualNotificationDocument = `
    mutation CREATE_MANUAL_NOTIFICATION($data: ManualNotificationsItemInput!) {
  createManualNotification(data: $data) {
    ...ManualNotificationsItem
  }
}
    ${ManualNotificationsItemFragmentDoc}`;
export const useCreateManualNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateManualNotificationMutation, TError, CreateManualNotificationMutationVariables, TContext>) =>
    useMutation<CreateManualNotificationMutation, TError, CreateManualNotificationMutationVariables, TContext>(
      'CREATE_MANUAL_NOTIFICATION',
      (variables?: CreateManualNotificationMutationVariables) => transport<CreateManualNotificationMutation, CreateManualNotificationMutationVariables>(CreateManualNotificationDocument, variables)(),
      options
    );
export const CreateMultiPartUploadDocument = `
    mutation CREATE_MULTI_PART_UPLOAD($bucket_name: String!, $object_name: String!, $total_parts: Int!) {
  createMultiPartUpload(
    bucket_name: $bucket_name
    object_name: $object_name
    total_parts: $total_parts
  ) {
    upload_id
    upload_urls
  }
}
    `;
export const useCreateMultiPartUploadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateMultiPartUploadMutation, TError, CreateMultiPartUploadMutationVariables, TContext>) =>
    useMutation<CreateMultiPartUploadMutation, TError, CreateMultiPartUploadMutationVariables, TContext>(
      'CREATE_MULTI_PART_UPLOAD',
      (variables?: CreateMultiPartUploadMutationVariables) => transport<CreateMultiPartUploadMutation, CreateMultiPartUploadMutationVariables>(CreateMultiPartUploadDocument, variables)(),
      options
    );
export const CreateReactionDocument = `
    mutation CREATE_REACTION($content_id: String!, $reaction_type: ReactionType!) {
  createReaction(
    data: {object_type: content, object_id: $content_id, reaction_type: $reaction_type}
  ) {
    object_type
    object_id
    reaction_type
    user_id
    created_at
  }
}
    `;
export const useCreateReactionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReactionMutation, TError, CreateReactionMutationVariables, TContext>) =>
    useMutation<CreateReactionMutation, TError, CreateReactionMutationVariables, TContext>(
      'CREATE_REACTION',
      (variables?: CreateReactionMutationVariables) => transport<CreateReactionMutation, CreateReactionMutationVariables>(CreateReactionDocument, variables)(),
      options
    );
export const CreateReadmeLoginJwtDocument = `
    mutation CREATE_README_LOGIN_JWT {
  createReadmeLoginJWT {
    url
    jwt
  }
}
    `;
export const useCreateReadmeLoginJwtMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReadmeLoginJwtMutation, TError, CreateReadmeLoginJwtMutationVariables, TContext>) =>
    useMutation<CreateReadmeLoginJwtMutation, TError, CreateReadmeLoginJwtMutationVariables, TContext>(
      'CREATE_README_LOGIN_JWT',
      (variables?: CreateReadmeLoginJwtMutationVariables) => transport<CreateReadmeLoginJwtMutation, CreateReadmeLoginJwtMutationVariables>(CreateReadmeLoginJwtDocument, variables)(),
      options
    );
export const CreateUpdateLeaderboardConfigDocument = `
    mutation CREATE_UPDATE_LEADERBOARD_CONFIG($data: LeaderboardConfigInput!) {
  createUpdateLeaderboardConfig(data: $data) {
    ...LeaderboardConfig
  }
}
    ${LeaderboardConfigFragmentDoc}`;
export const useCreateUpdateLeaderboardConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateUpdateLeaderboardConfigMutation, TError, CreateUpdateLeaderboardConfigMutationVariables, TContext>) =>
    useMutation<CreateUpdateLeaderboardConfigMutation, TError, CreateUpdateLeaderboardConfigMutationVariables, TContext>(
      'CREATE_UPDATE_LEADERBOARD_CONFIG',
      (variables?: CreateUpdateLeaderboardConfigMutationVariables) => transport<CreateUpdateLeaderboardConfigMutation, CreateUpdateLeaderboardConfigMutationVariables>(CreateUpdateLeaderboardConfigDocument, variables)(),
      options
    );
export const CreateUserProfileForCurrentUserInClientDocument = `
    mutation CREATE_USER_PROFILE_FOR_CURRENT_USER_IN_CLIENT($client_id: ID!) {
  createUserProfileForCurrentUserInClient(client_id: $client_id) {
    ...UserProfile
  }
}
    ${UserProfileFragmentDoc}`;
export const useCreateUserProfileForCurrentUserInClientMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateUserProfileForCurrentUserInClientMutation, TError, CreateUserProfileForCurrentUserInClientMutationVariables, TContext>) =>
    useMutation<CreateUserProfileForCurrentUserInClientMutation, TError, CreateUserProfileForCurrentUserInClientMutationVariables, TContext>(
      'CREATE_USER_PROFILE_FOR_CURRENT_USER_IN_CLIENT',
      (variables?: CreateUserProfileForCurrentUserInClientMutationVariables) => transport<CreateUserProfileForCurrentUserInClientMutation, CreateUserProfileForCurrentUserInClientMutationVariables>(CreateUserProfileForCurrentUserInClientDocument, variables)(),
      options
    );
export const CreateUserSegmentDocument = `
    mutation CREATE_USER_SEGMENT($data: CreateUserSegmentInput!) {
  createUserSegment(data: $data) {
    ...UserSegment
  }
}
    ${UserSegmentFragmentDoc}`;
export const useCreateUserSegmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateUserSegmentMutation, TError, CreateUserSegmentMutationVariables, TContext>) =>
    useMutation<CreateUserSegmentMutation, TError, CreateUserSegmentMutationVariables, TContext>(
      'CREATE_USER_SEGMENT',
      (variables?: CreateUserSegmentMutationVariables) => transport<CreateUserSegmentMutation, CreateUserSegmentMutationVariables>(CreateUserSegmentDocument, variables)(),
      options
    );
export const CreateWorkvivoWebhookDocument = `
    mutation CREATE_WORKVIVO_WEBHOOK($workvivo_org_id: String!, $api_token: String!, $webhook_status: GenericStatus!) {
  createWorkvivoWebhook(
    workvivo_org_id: $workvivo_org_id
    api_token: $api_token
    webhook_status: $webhook_status
  ) {
    ...Webhook
  }
}
    ${WebhookFragmentDoc}`;
export const useCreateWorkvivoWebhookMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateWorkvivoWebhookMutation, TError, CreateWorkvivoWebhookMutationVariables, TContext>) =>
    useMutation<CreateWorkvivoWebhookMutation, TError, CreateWorkvivoWebhookMutationVariables, TContext>(
      'CREATE_WORKVIVO_WEBHOOK',
      (variables?: CreateWorkvivoWebhookMutationVariables) => transport<CreateWorkvivoWebhookMutation, CreateWorkvivoWebhookMutationVariables>(CreateWorkvivoWebhookDocument, variables)(),
      options
    );
export const DeleteApiTokenDocument = `
    mutation DELETE_API_TOKEN($data: DeleteTokenAPIInput!) {
  deleteAPIToken(data: $data) {
    is_deleted
    token_id
    token_name
  }
}
    `;
export const useDeleteApiTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteApiTokenMutation, TError, DeleteApiTokenMutationVariables, TContext>) =>
    useMutation<DeleteApiTokenMutation, TError, DeleteApiTokenMutationVariables, TContext>(
      'DELETE_API_TOKEN',
      (variables?: DeleteApiTokenMutationVariables) => transport<DeleteApiTokenMutation, DeleteApiTokenMutationVariables>(DeleteApiTokenDocument, variables)(),
      options
    );
export const DeleteAssignmentDocument = `
    mutation DELETE_ASSIGNMENT($id: ID!, $client_id: ID!) {
  deleteAssignment(id: $id, client_id: $client_id)
}
    `;
export const useDeleteAssignmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteAssignmentMutation, TError, DeleteAssignmentMutationVariables, TContext>) =>
    useMutation<DeleteAssignmentMutation, TError, DeleteAssignmentMutationVariables, TContext>(
      'DELETE_ASSIGNMENT',
      (variables?: DeleteAssignmentMutationVariables) => transport<DeleteAssignmentMutation, DeleteAssignmentMutationVariables>(DeleteAssignmentDocument, variables)(),
      options
    );
export const DeleteClientInvitationsDocument = `
    mutation DELETE_CLIENT_INVITATIONS($invitation_ids: [ID!], $search_filter: ClientInvitationSearchFilter) {
  deleteClientInvitations(
    invitation_ids: $invitation_ids
    search_filter: $search_filter
  )
}
    `;
export const useDeleteClientInvitationsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteClientInvitationsMutation, TError, DeleteClientInvitationsMutationVariables, TContext>) =>
    useMutation<DeleteClientInvitationsMutation, TError, DeleteClientInvitationsMutationVariables, TContext>(
      'DELETE_CLIENT_INVITATIONS',
      (variables?: DeleteClientInvitationsMutationVariables) => transport<DeleteClientInvitationsMutation, DeleteClientInvitationsMutationVariables>(DeleteClientInvitationsDocument, variables)(),
      options
    );
export const DeleteClientPageMappingDocument = `
    mutation DELETE_CLIENT_PAGE_MAPPING($linkedin_page_id: String!) {
  deleteClientPageMapping(linkedin_page_id: $linkedin_page_id)
}
    `;
export const useDeleteClientPageMappingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteClientPageMappingMutation, TError, DeleteClientPageMappingMutationVariables, TContext>) =>
    useMutation<DeleteClientPageMappingMutation, TError, DeleteClientPageMappingMutationVariables, TContext>(
      'DELETE_CLIENT_PAGE_MAPPING',
      (variables?: DeleteClientPageMappingMutationVariables) => transport<DeleteClientPageMappingMutation, DeleteClientPageMappingMutationVariables>(DeleteClientPageMappingDocument, variables)(),
      options
    );
export const DeleteClientStickerDocument = `
    mutation DELETE_CLIENT_STICKER($client_id: ID!, $sticker_key: String!) {
  deleteClientSticker(client_id: $client_id, sticker_key: $sticker_key) {
    success
    client {
      id
      stickers {
        ...S3Object
      }
    }
    sticker {
      ...S3Object
    }
  }
}
    ${S3ObjectFragmentDoc}`;
export const useDeleteClientStickerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteClientStickerMutation, TError, DeleteClientStickerMutationVariables, TContext>) =>
    useMutation<DeleteClientStickerMutation, TError, DeleteClientStickerMutationVariables, TContext>(
      'DELETE_CLIENT_STICKER',
      (variables?: DeleteClientStickerMutationVariables) => transport<DeleteClientStickerMutation, DeleteClientStickerMutationVariables>(DeleteClientStickerDocument, variables)(),
      options
    );
export const DeleteGroupModeratorDocument = `
    mutation DELETE_GROUP_MODERATOR($group_id: ID!, $user_id: ID!) {
  deleteGroupModerator(group_id: $group_id, user_id: $user_id)
}
    `;
export const useDeleteGroupModeratorMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteGroupModeratorMutation, TError, DeleteGroupModeratorMutationVariables, TContext>) =>
    useMutation<DeleteGroupModeratorMutation, TError, DeleteGroupModeratorMutationVariables, TContext>(
      'DELETE_GROUP_MODERATOR',
      (variables?: DeleteGroupModeratorMutationVariables) => transport<DeleteGroupModeratorMutation, DeleteGroupModeratorMutationVariables>(DeleteGroupModeratorDocument, variables)(),
      options
    );
export const DeleteGroupSourceDocument = `
    mutation DELETE_GROUP_SOURCE($id: ID!) {
  clientGroupSourceDelete(id: $id) {
    status
  }
}
    `;
export const useDeleteGroupSourceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteGroupSourceMutation, TError, DeleteGroupSourceMutationVariables, TContext>) =>
    useMutation<DeleteGroupSourceMutation, TError, DeleteGroupSourceMutationVariables, TContext>(
      'DELETE_GROUP_SOURCE',
      (variables?: DeleteGroupSourceMutationVariables) => transport<DeleteGroupSourceMutation, DeleteGroupSourceMutationVariables>(DeleteGroupSourceDocument, variables)(),
      options
    );
export const DeleteGroupWebhookDocument = `
    mutation DELETE_GROUP_WEBHOOK($group_id: ID!, $webhook_id: String!) {
  deleteGroupWebhook(group_id: $group_id, webhook_id: $webhook_id) {
    ...Webhook
  }
}
    ${WebhookFragmentDoc}`;
export const useDeleteGroupWebhookMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteGroupWebhookMutation, TError, DeleteGroupWebhookMutationVariables, TContext>) =>
    useMutation<DeleteGroupWebhookMutation, TError, DeleteGroupWebhookMutationVariables, TContext>(
      'DELETE_GROUP_WEBHOOK',
      (variables?: DeleteGroupWebhookMutationVariables) => transport<DeleteGroupWebhookMutation, DeleteGroupWebhookMutationVariables>(DeleteGroupWebhookDocument, variables)(),
      options
    );
export const DeleteManualNotificationDocument = `
    mutation DELETE_MANUAL_NOTIFICATION($id: ID!) {
  deleteManualNotification(id: $id) {
    ...ManualNotificationsItem
  }
}
    ${ManualNotificationsItemFragmentDoc}`;
export const useDeleteManualNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteManualNotificationMutation, TError, DeleteManualNotificationMutationVariables, TContext>) =>
    useMutation<DeleteManualNotificationMutation, TError, DeleteManualNotificationMutationVariables, TContext>(
      'DELETE_MANUAL_NOTIFICATION',
      (variables?: DeleteManualNotificationMutationVariables) => transport<DeleteManualNotificationMutation, DeleteManualNotificationMutationVariables>(DeleteManualNotificationDocument, variables)(),
      options
    );
export const DeleteReactionDocument = `
    mutation DELETE_REACTION($content_id: String!, $reaction_type: ReactionType!) {
  deleteReaction(
    data: {object_type: content, object_id: $content_id, reaction_type: $reaction_type}
  ) {
    status
  }
}
    `;
export const useDeleteReactionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteReactionMutation, TError, DeleteReactionMutationVariables, TContext>) =>
    useMutation<DeleteReactionMutation, TError, DeleteReactionMutationVariables, TContext>(
      'DELETE_REACTION',
      (variables?: DeleteReactionMutationVariables) => transport<DeleteReactionMutation, DeleteReactionMutationVariables>(DeleteReactionDocument, variables)(),
      options
    );
export const DeleteScheduledSharesDocument = `
    mutation DELETE_SCHEDULED_SHARES($ids: [ID!]!) {
  deleteScheduledShares(ids: $ids) {
    id
  }
}
    `;
export const useDeleteScheduledSharesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteScheduledSharesMutation, TError, DeleteScheduledSharesMutationVariables, TContext>) =>
    useMutation<DeleteScheduledSharesMutation, TError, DeleteScheduledSharesMutationVariables, TContext>(
      'DELETE_SCHEDULED_SHARES',
      (variables?: DeleteScheduledSharesMutationVariables) => transport<DeleteScheduledSharesMutation, DeleteScheduledSharesMutationVariables>(DeleteScheduledSharesDocument, variables)(),
      options
    );
export const DeleteSocialConnectionDocument = `
    mutation DELETE_SOCIAL_CONNECTION($id: ID!) {
  deleteSocialConnection(id: $id) {
    status
  }
}
    `;
export const useDeleteSocialConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSocialConnectionMutation, TError, DeleteSocialConnectionMutationVariables, TContext>) =>
    useMutation<DeleteSocialConnectionMutation, TError, DeleteSocialConnectionMutationVariables, TContext>(
      'DELETE_SOCIAL_CONNECTION',
      (variables?: DeleteSocialConnectionMutationVariables) => transport<DeleteSocialConnectionMutation, DeleteSocialConnectionMutationVariables>(DeleteSocialConnectionDocument, variables)(),
      options
    );
export const DeleteUserManagementUserProfileDocument = `
    mutation DELETE_USER_MANAGEMENT_USER_PROFILE($id: ID!) {
  deleteUserManagementUserProfile(id: $id)
}
    `;
export const useDeleteUserManagementUserProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteUserManagementUserProfileMutation, TError, DeleteUserManagementUserProfileMutationVariables, TContext>) =>
    useMutation<DeleteUserManagementUserProfileMutation, TError, DeleteUserManagementUserProfileMutationVariables, TContext>(
      'DELETE_USER_MANAGEMENT_USER_PROFILE',
      (variables?: DeleteUserManagementUserProfileMutationVariables) => transport<DeleteUserManagementUserProfileMutation, DeleteUserManagementUserProfileMutationVariables>(DeleteUserManagementUserProfileDocument, variables)(),
      options
    );
export const DeleteWebhookDocument = `
    mutation DELETE_WEBHOOK($webhook_id: ID!) {
  deleteWebhook(webhook_id: $webhook_id) {
    ...Webhook
  }
}
    ${WebhookFragmentDoc}`;
export const useDeleteWebhookMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteWebhookMutation, TError, DeleteWebhookMutationVariables, TContext>) =>
    useMutation<DeleteWebhookMutation, TError, DeleteWebhookMutationVariables, TContext>(
      'DELETE_WEBHOOK',
      (variables?: DeleteWebhookMutationVariables) => transport<DeleteWebhookMutation, DeleteWebhookMutationVariables>(DeleteWebhookDocument, variables)(),
      options
    );
export const DisableContentEmailDocument = `
    mutation DISABLE_CONTENT_EMAIL($id: ID!) {
  disableContentEmailSpec(id: $id) {
    ...ContentEmailSpec
  }
}
    ${ContentEmailSpecFragmentDoc}`;
export const useDisableContentEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DisableContentEmailMutation, TError, DisableContentEmailMutationVariables, TContext>) =>
    useMutation<DisableContentEmailMutation, TError, DisableContentEmailMutationVariables, TContext>(
      'DISABLE_CONTENT_EMAIL',
      (variables?: DisableContentEmailMutationVariables) => transport<DisableContentEmailMutation, DisableContentEmailMutationVariables>(DisableContentEmailDocument, variables)(),
      options
    );
export const FollowDocument = `
    mutation FOLLOW($id: ID!, $key: FeedKey!, $target_user_id: String) {
  follow(id: $id, key: $key, target_user_id: $target_user_id) {
    ...UserFeedFollow
  }
}
    ${UserFeedFollowFragmentDoc}`;
export const useFollowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FollowMutation, TError, FollowMutationVariables, TContext>) =>
    useMutation<FollowMutation, TError, FollowMutationVariables, TContext>(
      'FOLLOW',
      (variables?: FollowMutationVariables) => transport<FollowMutation, FollowMutationVariables>(FollowDocument, variables)(),
      options
    );
export const MarkInboxAsReadDocument = `
    mutation MARK_INBOX_AS_READ {
  markInboxAsRead {
    status
  }
}
    `;
export const useMarkInboxAsReadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MarkInboxAsReadMutation, TError, MarkInboxAsReadMutationVariables, TContext>) =>
    useMutation<MarkInboxAsReadMutation, TError, MarkInboxAsReadMutationVariables, TContext>(
      'MARK_INBOX_AS_READ',
      (variables?: MarkInboxAsReadMutationVariables) => transport<MarkInboxAsReadMutation, MarkInboxAsReadMutationVariables>(MarkInboxAsReadDocument, variables)(),
      options
    );
export const MarkInboxItemAsReadDocument = `
    mutation MARK_INBOX_ITEM_AS_READ($id: ID!) {
  markInboxItemAsRead(id: $id) {
    ...Inbox
  }
}
    ${InboxFragmentDoc}`;
export const useMarkInboxItemAsReadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MarkInboxItemAsReadMutation, TError, MarkInboxItemAsReadMutationVariables, TContext>) =>
    useMutation<MarkInboxItemAsReadMutation, TError, MarkInboxItemAsReadMutationVariables, TContext>(
      'MARK_INBOX_ITEM_AS_READ',
      (variables?: MarkInboxItemAsReadMutationVariables) => transport<MarkInboxItemAsReadMutation, MarkInboxItemAsReadMutationVariables>(MarkInboxItemAsReadDocument, variables)(),
      options
    );
export const ModifyContentEmailDocument = `
    mutation MODIFY_CONTENT_EMAIL($data: ContentEmailSpecMutation!) {
  modifyContentEmailSpec(data: $data) {
    ...ContentEmailSpec
  }
}
    ${ContentEmailSpecFragmentDoc}`;
export const useModifyContentEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ModifyContentEmailMutation, TError, ModifyContentEmailMutationVariables, TContext>) =>
    useMutation<ModifyContentEmailMutation, TError, ModifyContentEmailMutationVariables, TContext>(
      'MODIFY_CONTENT_EMAIL',
      (variables?: ModifyContentEmailMutationVariables) => transport<ModifyContentEmailMutation, ModifyContentEmailMutationVariables>(ModifyContentEmailDocument, variables)(),
      options
    );
export const OauthSubmitAuthorizeDocument = `
    mutation OAUTH_SUBMIT_AUTHORIZE($data: OauthSubmitInput!) {
  oauthSubmitAuthorize(data: $data) {
    redirect_url
  }
}
    `;
export const useOauthSubmitAuthorizeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OauthSubmitAuthorizeMutation, TError, OauthSubmitAuthorizeMutationVariables, TContext>) =>
    useMutation<OauthSubmitAuthorizeMutation, TError, OauthSubmitAuthorizeMutationVariables, TContext>(
      'OAUTH_SUBMIT_AUTHORIZE',
      (variables?: OauthSubmitAuthorizeMutationVariables) => transport<OauthSubmitAuthorizeMutation, OauthSubmitAuthorizeMutationVariables>(OauthSubmitAuthorizeDocument, variables)(),
      options
    );
export const OauthUserRevokeDocument = `
    mutation OAUTH_USER_REVOKE($data: OauthClientInput!) {
  oauthUserRevoke(data: $data) {
    oauth_client_id
    oauth_client_name
    oauth_client_logo_url
    oauth_client_description
  }
}
    `;
export const useOauthUserRevokeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OauthUserRevokeMutation, TError, OauthUserRevokeMutationVariables, TContext>) =>
    useMutation<OauthUserRevokeMutation, TError, OauthUserRevokeMutationVariables, TContext>(
      'OAUTH_USER_REVOKE',
      (variables?: OauthUserRevokeMutationVariables) => transport<OauthUserRevokeMutation, OauthUserRevokeMutationVariables>(OauthUserRevokeDocument, variables)(),
      options
    );
export const PreviewContentEmailDocument = `
    mutation PREVIEW_CONTENT_EMAIL($data: ContentEmailSpecInput!) {
  previewContentEmailSpec(data: $data)
}
    `;
export const usePreviewContentEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PreviewContentEmailMutation, TError, PreviewContentEmailMutationVariables, TContext>) =>
    useMutation<PreviewContentEmailMutation, TError, PreviewContentEmailMutationVariables, TContext>(
      'PREVIEW_CONTENT_EMAIL',
      (variables?: PreviewContentEmailMutationVariables) => transport<PreviewContentEmailMutation, PreviewContentEmailMutationVariables>(PreviewContentEmailDocument, variables)(),
      options
    );
export const ManualPostDocument = `
    mutation MANUAL_POST($content: ContentInput!) {
  processContent(process_metadata: true, save: true, content: $content) {
    ...Content
  }
}
    ${ContentFragmentDoc}`;
export const useManualPostMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ManualPostMutation, TError, ManualPostMutationVariables, TContext>) =>
    useMutation<ManualPostMutation, TError, ManualPostMutationVariables, TContext>(
      'MANUAL_POST',
      (variables?: ManualPostMutationVariables) => transport<ManualPostMutation, ManualPostMutationVariables>(ManualPostDocument, variables)(),
      options
    );
export const ProcessContentV2Document = `
    mutation PROCESS_CONTENT_V2($content: ContentInput!) {
  processContentV2(process_metadata: true, save: true, content: $content) {
    content {
      ...Content
    }
    warnings {
      uuid
      blocked_terms {
        term
        start
        end
      }
    }
  }
}
    ${ContentFragmentDoc}`;
export const useProcessContentV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ProcessContentV2Mutation, TError, ProcessContentV2MutationVariables, TContext>) =>
    useMutation<ProcessContentV2Mutation, TError, ProcessContentV2MutationVariables, TContext>(
      'PROCESS_CONTENT_V2',
      (variables?: ProcessContentV2MutationVariables) => transport<ProcessContentV2Mutation, ProcessContentV2MutationVariables>(ProcessContentV2Document, variables)(),
      options
    );
export const ReconcileExpressActivatedUsersDocument = `
    mutation RECONCILE_EXPRESS_ACTIVATED_USERS($users: [ReconcileExpressActivatedUsersInput]!) {
  reconcileExpressActivatedUsers(users: $users) {
    message
    results {
      oauth_token_id
      user_id
      access_key
    }
  }
}
    `;
export const useReconcileExpressActivatedUsersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReconcileExpressActivatedUsersMutation, TError, ReconcileExpressActivatedUsersMutationVariables, TContext>) =>
    useMutation<ReconcileExpressActivatedUsersMutation, TError, ReconcileExpressActivatedUsersMutationVariables, TContext>(
      'RECONCILE_EXPRESS_ACTIVATED_USERS',
      (variables?: ReconcileExpressActivatedUsersMutationVariables) => transport<ReconcileExpressActivatedUsersMutation, ReconcileExpressActivatedUsersMutationVariables>(ReconcileExpressActivatedUsersDocument, variables)(),
      options
    );
export const SendBillingBillableUserEventQueueDocument = `
    mutation SEND_BILLING_BILLABLE_USER_EVENT_QUEUE($client_id: ID!, $user_id: ID!, $billable_user_event: BillableUserEventInput!) {
  sendBillingBillableUserEventQueue(
    client_id: $client_id
    user_id: $user_id
    billable_user_event: $billable_user_event
  ) {
    status
  }
}
    `;
export const useSendBillingBillableUserEventQueueMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendBillingBillableUserEventQueueMutation, TError, SendBillingBillableUserEventQueueMutationVariables, TContext>) =>
    useMutation<SendBillingBillableUserEventQueueMutation, TError, SendBillingBillableUserEventQueueMutationVariables, TContext>(
      'SEND_BILLING_BILLABLE_USER_EVENT_QUEUE',
      (variables?: SendBillingBillableUserEventQueueMutationVariables) => transport<SendBillingBillableUserEventQueueMutation, SendBillingBillableUserEventQueueMutationVariables>(SendBillingBillableUserEventQueueDocument, variables)(),
      options
    );
export const SetBlocklistDocument = `
    mutation SET_BLOCKLIST($terms: [String]!) {
  setBlockList(terms: $terms) {
    terms
  }
}
    `;
export const useSetBlocklistMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetBlocklistMutation, TError, SetBlocklistMutationVariables, TContext>) =>
    useMutation<SetBlocklistMutation, TError, SetBlocklistMutationVariables, TContext>(
      'SET_BLOCKLIST',
      (variables?: SetBlocklistMutationVariables) => transport<SetBlocklistMutation, SetBlocklistMutationVariables>(SetBlocklistDocument, variables)(),
      options
    );
export const ShareContentDocument = `
    mutation SHARE_CONTENT($share_session_id: ID, $content_id: ID!, $items: [ShareContentInput]!, $timezone: String) {
  shareContent(
    share_session_id: $share_session_id
    content_id: $content_id
    items: $items
    timezone: $timezone
  ) {
    results {
      url
      shortened_url {
        short_link
        id
      }
      status
    }
    warnings {
      uuid
      blocked_terms {
        term
        start
        end
      }
    }
  }
}
    `;
export const useShareContentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ShareContentMutation, TError, ShareContentMutationVariables, TContext>) =>
    useMutation<ShareContentMutation, TError, ShareContentMutationVariables, TContext>(
      'SHARE_CONTENT',
      (variables?: ShareContentMutationVariables) => transport<ShareContentMutation, ShareContentMutationVariables>(ShareContentDocument, variables)(),
      options
    );
export const SuspendUserManagementUserProfileDocument = `
    mutation SUSPEND_USER_MANAGEMENT_USER_PROFILE($id: ID!) {
  suspendUserManagementUserProfile(id: $id) {
    ...UserProfile
  }
}
    ${UserProfileFragmentDoc}`;
export const useSuspendUserManagementUserProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuspendUserManagementUserProfileMutation, TError, SuspendUserManagementUserProfileMutationVariables, TContext>) =>
    useMutation<SuspendUserManagementUserProfileMutation, TError, SuspendUserManagementUserProfileMutationVariables, TContext>(
      'SUSPEND_USER_MANAGEMENT_USER_PROFILE',
      (variables?: SuspendUserManagementUserProfileMutationVariables) => transport<SuspendUserManagementUserProfileMutation, SuspendUserManagementUserProfileMutationVariables>(SuspendUserManagementUserProfileDocument, variables)(),
      options
    );
export const SyncBillingCustomerDocument = `
    mutation SYNC_BILLING_CUSTOMER {
  syncBillingCustomer {
    status
  }
}
    `;
export const useSyncBillingCustomerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SyncBillingCustomerMutation, TError, SyncBillingCustomerMutationVariables, TContext>) =>
    useMutation<SyncBillingCustomerMutation, TError, SyncBillingCustomerMutationVariables, TContext>(
      'SYNC_BILLING_CUSTOMER',
      (variables?: SyncBillingCustomerMutationVariables) => transport<SyncBillingCustomerMutation, SyncBillingCustomerMutationVariables>(SyncBillingCustomerDocument, variables)(),
      options
    );
export const ToggleCapabilityGroupDocument = `
    mutation TOGGLE_CAPABILITY_GROUP($client_id: String, $active: Boolean, $capability_group: CapabilityGroup) {
  toggleCapabilityGroup(
    client_id: $client_id
    active: $active
    capability_group: $capability_group
  ) {
    status
  }
}
    `;
export const useToggleCapabilityGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ToggleCapabilityGroupMutation, TError, ToggleCapabilityGroupMutationVariables, TContext>) =>
    useMutation<ToggleCapabilityGroupMutation, TError, ToggleCapabilityGroupMutationVariables, TContext>(
      'TOGGLE_CAPABILITY_GROUP',
      (variables?: ToggleCapabilityGroupMutationVariables) => transport<ToggleCapabilityGroupMutation, ToggleCapabilityGroupMutationVariables>(ToggleCapabilityGroupDocument, variables)(),
      options
    );
export const UnfollowDocument = `
    mutation UNFOLLOW($id: ID!, $key: FeedKey!, $target_user_id: String) {
  unfollow(id: $id, key: $key, target_user_id: $target_user_id) {
    ...UserFeedFollow
  }
}
    ${UserFeedFollowFragmentDoc}`;
export const useUnfollowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnfollowMutation, TError, UnfollowMutationVariables, TContext>) =>
    useMutation<UnfollowMutation, TError, UnfollowMutationVariables, TContext>(
      'UNFOLLOW',
      (variables?: UnfollowMutationVariables) => transport<UnfollowMutation, UnfollowMutationVariables>(UnfollowDocument, variables)(),
      options
    );
export const UnsuspendUserManagementUserProfileDocument = `
    mutation UNSUSPEND_USER_MANAGEMENT_USER_PROFILE($id: ID!) {
  unsuspendUserManagementUserProfile(id: $id) {
    ...UserProfile
  }
}
    ${UserProfileFragmentDoc}`;
export const useUnsuspendUserManagementUserProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnsuspendUserManagementUserProfileMutation, TError, UnsuspendUserManagementUserProfileMutationVariables, TContext>) =>
    useMutation<UnsuspendUserManagementUserProfileMutation, TError, UnsuspendUserManagementUserProfileMutationVariables, TContext>(
      'UNSUSPEND_USER_MANAGEMENT_USER_PROFILE',
      (variables?: UnsuspendUserManagementUserProfileMutationVariables) => transport<UnsuspendUserManagementUserProfileMutation, UnsuspendUserManagementUserProfileMutationVariables>(UnsuspendUserManagementUserProfileDocument, variables)(),
      options
    );
export const UpdateAssignmentDocument = `
    mutation UPDATE_ASSIGNMENT($client_id: ID!, $id: ID!, $data: AssignmentUpdateInput!) {
  updateAssignment(client_id: $client_id, id: $id, data: $data) {
    ...Assignment
  }
}
    ${AssignmentFragmentDoc}`;
export const useUpdateAssignmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAssignmentMutation, TError, UpdateAssignmentMutationVariables, TContext>) =>
    useMutation<UpdateAssignmentMutation, TError, UpdateAssignmentMutationVariables, TContext>(
      'UPDATE_ASSIGNMENT',
      (variables?: UpdateAssignmentMutationVariables) => transport<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>(UpdateAssignmentDocument, variables)(),
      options
    );
export const UpdateClientDepartmentDocument = `
    mutation UPDATE_CLIENT_DEPARTMENT($data: UpdateClientDepartmentInput!) {
  updateClientDepartment(data: $data) {
    ...ClientDepartment
  }
}
    ${ClientDepartmentFragmentDoc}`;
export const useUpdateClientDepartmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateClientDepartmentMutation, TError, UpdateClientDepartmentMutationVariables, TContext>) =>
    useMutation<UpdateClientDepartmentMutation, TError, UpdateClientDepartmentMutationVariables, TContext>(
      'UPDATE_CLIENT_DEPARTMENT',
      (variables?: UpdateClientDepartmentMutationVariables) => transport<UpdateClientDepartmentMutation, UpdateClientDepartmentMutationVariables>(UpdateClientDepartmentDocument, variables)(),
      options
    );
export const UpdateClientDisclosureDocument = `
    mutation UPDATE_CLIENT_DISCLOSURE($data: UpdateClientDisclosureInput!, $override: OverrideInput) {
  updateClientDisclosure(data: $data, override: $override) {
    ...ClientDisclosure
  }
}
    ${ClientDisclosureFragmentDoc}`;
export const useUpdateClientDisclosureMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateClientDisclosureMutation, TError, UpdateClientDisclosureMutationVariables, TContext>) =>
    useMutation<UpdateClientDisclosureMutation, TError, UpdateClientDisclosureMutationVariables, TContext>(
      'UPDATE_CLIENT_DISCLOSURE',
      (variables?: UpdateClientDisclosureMutationVariables) => transport<UpdateClientDisclosureMutation, UpdateClientDisclosureMutationVariables>(UpdateClientDisclosureDocument, variables)(),
      options
    );
export const UpdateClientFollowMappingDocument = `
    mutation UPDATE_CLIENT_FOLLOW_MAPPING($data: UpdateClientFollowMappingInput!) {
  updateClientFollowMapping(data: $data) {
    ...ClientFollowMapping
  }
}
    ${ClientFollowMappingFragmentDoc}`;
export const useUpdateClientFollowMappingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateClientFollowMappingMutation, TError, UpdateClientFollowMappingMutationVariables, TContext>) =>
    useMutation<UpdateClientFollowMappingMutation, TError, UpdateClientFollowMappingMutationVariables, TContext>(
      'UPDATE_CLIENT_FOLLOW_MAPPING',
      (variables?: UpdateClientFollowMappingMutationVariables) => transport<UpdateClientFollowMappingMutation, UpdateClientFollowMappingMutationVariables>(UpdateClientFollowMappingDocument, variables)(),
      options
    );
export const UpdateClientLocationDocument = `
    mutation UPDATE_CLIENT_LOCATION($data: UpdateClientLocationInput!) {
  updateClientLocation(data: $data) {
    ...ClientLocation
  }
}
    ${ClientLocationFragmentDoc}`;
export const useUpdateClientLocationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateClientLocationMutation, TError, UpdateClientLocationMutationVariables, TContext>) =>
    useMutation<UpdateClientLocationMutation, TError, UpdateClientLocationMutationVariables, TContext>(
      'UPDATE_CLIENT_LOCATION',
      (variables?: UpdateClientLocationMutationVariables) => transport<UpdateClientLocationMutation, UpdateClientLocationMutationVariables>(UpdateClientLocationDocument, variables)(),
      options
    );
export const UpdateClientUrlParamsDocument = `
    mutation UPDATE_CLIENT_URL_PARAMS($data: ClientUrlParamsUpdateInput!) {
  updateClientUrlParams(data: $data) {
    ...ClientUrlParams
  }
}
    ${ClientUrlParamsFragmentDoc}`;
export const useUpdateClientUrlParamsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateClientUrlParamsMutation, TError, UpdateClientUrlParamsMutationVariables, TContext>) =>
    useMutation<UpdateClientUrlParamsMutation, TError, UpdateClientUrlParamsMutationVariables, TContext>(
      'UPDATE_CLIENT_URL_PARAMS',
      (variables?: UpdateClientUrlParamsMutationVariables) => transport<UpdateClientUrlParamsMutation, UpdateClientUrlParamsMutationVariables>(UpdateClientUrlParamsDocument, variables)(),
      options
    );
export const UpdateContentApprovalsDocument = `
    mutation UPDATE_CONTENT_APPROVALS($content_id: String!, $group_id_approvals: [GroupIdApprovalInput]!) {
  updateContentApprovals(
    content_id: $content_id
    content_approvals: {group_id_approvals: $group_id_approvals}
  ) {
    content_id
  }
}
    `;
export const useUpdateContentApprovalsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateContentApprovalsMutation, TError, UpdateContentApprovalsMutationVariables, TContext>) =>
    useMutation<UpdateContentApprovalsMutation, TError, UpdateContentApprovalsMutationVariables, TContext>(
      'UPDATE_CONTENT_APPROVALS',
      (variables?: UpdateContentApprovalsMutationVariables) => transport<UpdateContentApprovalsMutation, UpdateContentApprovalsMutationVariables>(UpdateContentApprovalsDocument, variables)(),
      options
    );
export const UpdateExpressActivatedUsersDocument = `
    mutation UPDATE_EXPRESS_ACTIVATED_USERS($users: [UpdateExpressActivatedUsersInput]!) {
  updateExpressActivatedUsers(users: $users) {
    updated_users {
      email_address
      status
      updated
    }
    message
  }
}
    `;
export const useUpdateExpressActivatedUsersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateExpressActivatedUsersMutation, TError, UpdateExpressActivatedUsersMutationVariables, TContext>) =>
    useMutation<UpdateExpressActivatedUsersMutation, TError, UpdateExpressActivatedUsersMutationVariables, TContext>(
      'UPDATE_EXPRESS_ACTIVATED_USERS',
      (variables?: UpdateExpressActivatedUsersMutationVariables) => transport<UpdateExpressActivatedUsersMutation, UpdateExpressActivatedUsersMutationVariables>(UpdateExpressActivatedUsersDocument, variables)(),
      options
    );
export const UpdateExternalShareDocument = `
    mutation UPDATE_EXTERNAL_SHARE($data: ExternalShareUpdateInput!, $share_id: ID!) {
  updateExternalShare(data: $data, share_id: $share_id)
}
    `;
export const useUpdateExternalShareMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateExternalShareMutation, TError, UpdateExternalShareMutationVariables, TContext>) =>
    useMutation<UpdateExternalShareMutation, TError, UpdateExternalShareMutationVariables, TContext>(
      'UPDATE_EXTERNAL_SHARE',
      (variables?: UpdateExternalShareMutationVariables) => transport<UpdateExternalShareMutation, UpdateExternalShareMutationVariables>(UpdateExternalShareDocument, variables)(),
      options
    );
export const UpdateGroupDocument = `
    mutation UPDATE_GROUP($data: UpdateGroupInput!) {
  updateGroup(data: $data) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export const useUpdateGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateGroupMutation, TError, UpdateGroupMutationVariables, TContext>) =>
    useMutation<UpdateGroupMutation, TError, UpdateGroupMutationVariables, TContext>(
      'UPDATE_GROUP',
      (variables?: UpdateGroupMutationVariables) => transport<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, variables)(),
      options
    );
export const UpdateGroupSourceDocument = `
    mutation UPDATE_GROUP_SOURCE($data: ClientGroupSourceUpdate!) {
  clientGroupSourceUpdate(data: $data) {
    ...ClientGroupSource
  }
}
    ${ClientGroupSourceFragmentDoc}`;
export const useUpdateGroupSourceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateGroupSourceMutation, TError, UpdateGroupSourceMutationVariables, TContext>) =>
    useMutation<UpdateGroupSourceMutation, TError, UpdateGroupSourceMutationVariables, TContext>(
      'UPDATE_GROUP_SOURCE',
      (variables?: UpdateGroupSourceMutationVariables) => transport<UpdateGroupSourceMutation, UpdateGroupSourceMutationVariables>(UpdateGroupSourceDocument, variables)(),
      options
    );
export const UpdateManualNotificationDocument = `
    mutation UPDATE_MANUAL_NOTIFICATION($data: ManualNotificationsItemUpdateInput!) {
  updateManualNotification(data: $data) {
    ...ManualNotificationsItem
  }
}
    ${ManualNotificationsItemFragmentDoc}`;
export const useUpdateManualNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateManualNotificationMutation, TError, UpdateManualNotificationMutationVariables, TContext>) =>
    useMutation<UpdateManualNotificationMutation, TError, UpdateManualNotificationMutationVariables, TContext>(
      'UPDATE_MANUAL_NOTIFICATION',
      (variables?: UpdateManualNotificationMutationVariables) => transport<UpdateManualNotificationMutation, UpdateManualNotificationMutationVariables>(UpdateManualNotificationDocument, variables)(),
      options
    );
export const UpdateScheduledSharesDocument = `
    mutation UPDATE_SCHEDULED_SHARES($data: ScheduledShareContentInput!) {
  updateScheduledShares(data: $data) {
    ...ScheduledShareItem
  }
}
    ${ScheduledShareItemFragmentDoc}`;
export const useUpdateScheduledSharesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateScheduledSharesMutation, TError, UpdateScheduledSharesMutationVariables, TContext>) =>
    useMutation<UpdateScheduledSharesMutation, TError, UpdateScheduledSharesMutationVariables, TContext>(
      'UPDATE_SCHEDULED_SHARES',
      (variables?: UpdateScheduledSharesMutationVariables) => transport<UpdateScheduledSharesMutation, UpdateScheduledSharesMutationVariables>(UpdateScheduledSharesDocument, variables)(),
      options
    );
export const UpdateUserManagementUserProfileDocument = `
    mutation UPDATE_USER_MANAGEMENT_USER_PROFILE($input: UpdateUserManagementUserProfileInput!) {
  updateUserManagementUserProfile(input: $input) {
    ...UserProfile
  }
}
    ${UserProfileFragmentDoc}`;
export const useUpdateUserManagementUserProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserManagementUserProfileMutation, TError, UpdateUserManagementUserProfileMutationVariables, TContext>) =>
    useMutation<UpdateUserManagementUserProfileMutation, TError, UpdateUserManagementUserProfileMutationVariables, TContext>(
      'UPDATE_USER_MANAGEMENT_USER_PROFILE',
      (variables?: UpdateUserManagementUserProfileMutationVariables) => transport<UpdateUserManagementUserProfileMutation, UpdateUserManagementUserProfileMutationVariables>(UpdateUserManagementUserProfileDocument, variables)(),
      options
    );
export const UpdateUserProfileDocument = `
    mutation UPDATE_USER_PROFILE($data: UserProfileInput!, $client_id: ID) {
  updateUserProfile(data: $data, override: {client_id: $client_id}) {
    ...UserProfile
  }
}
    ${UserProfileFragmentDoc}`;
export const useUpdateUserProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserProfileMutation, TError, UpdateUserProfileMutationVariables, TContext>) =>
    useMutation<UpdateUserProfileMutation, TError, UpdateUserProfileMutationVariables, TContext>(
      'UPDATE_USER_PROFILE',
      (variables?: UpdateUserProfileMutationVariables) => transport<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, variables)(),
      options
    );
export const UpdateUserProfileOnboardingDocument = `
    mutation UPDATE_USER_PROFILE_ONBOARDING($data: UserProfileOnboardingInput!) {
  updateUserProfileOnboarding(data: $data) {
    ...UserProfile
  }
}
    ${UserProfileFragmentDoc}`;
export const useUpdateUserProfileOnboardingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserProfileOnboardingMutation, TError, UpdateUserProfileOnboardingMutationVariables, TContext>) =>
    useMutation<UpdateUserProfileOnboardingMutation, TError, UpdateUserProfileOnboardingMutationVariables, TContext>(
      'UPDATE_USER_PROFILE_ONBOARDING',
      (variables?: UpdateUserProfileOnboardingMutationVariables) => transport<UpdateUserProfileOnboardingMutation, UpdateUserProfileOnboardingMutationVariables>(UpdateUserProfileOnboardingDocument, variables)(),
      options
    );
export const UpdateUserRoiValuesDocument = `
    mutation UPDATE_USER_ROI_VALUES($user_id: ID!, $roi_currency_values: ROICurrencyValuesInput!) {
  updateUserROIValues(
    user_id: $user_id
    roi_currency_values: $roi_currency_values
  ) {
    status
  }
}
    `;
export const useUpdateUserRoiValuesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserRoiValuesMutation, TError, UpdateUserRoiValuesMutationVariables, TContext>) =>
    useMutation<UpdateUserRoiValuesMutation, TError, UpdateUserRoiValuesMutationVariables, TContext>(
      'UPDATE_USER_ROI_VALUES',
      (variables?: UpdateUserRoiValuesMutationVariables) => transport<UpdateUserRoiValuesMutation, UpdateUserRoiValuesMutationVariables>(UpdateUserRoiValuesDocument, variables)(),
      options
    );
export const UpdateUserSegmentDocument = `
    mutation UPDATE_USER_SEGMENT($data: UpdateUserSegmentInput!) {
  updateUserSegment(data: $data) {
    ...UserSegment
  }
}
    ${UserSegmentFragmentDoc}`;
export const useUpdateUserSegmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserSegmentMutation, TError, UpdateUserSegmentMutationVariables, TContext>) =>
    useMutation<UpdateUserSegmentMutation, TError, UpdateUserSegmentMutationVariables, TContext>(
      'UPDATE_USER_SEGMENT',
      (variables?: UpdateUserSegmentMutationVariables) => transport<UpdateUserSegmentMutation, UpdateUserSegmentMutationVariables>(UpdateUserSegmentDocument, variables)(),
      options
    );
export const UpsertBillingCustomerDocument = `
    mutation UPSERT_BILLING_CUSTOMER {
  upsertBillingCustomer {
    status
  }
}
    `;
export const useUpsertBillingCustomerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertBillingCustomerMutation, TError, UpsertBillingCustomerMutationVariables, TContext>) =>
    useMutation<UpsertBillingCustomerMutation, TError, UpsertBillingCustomerMutationVariables, TContext>(
      'UPSERT_BILLING_CUSTOMER',
      (variables?: UpsertBillingCustomerMutationVariables) => transport<UpsertBillingCustomerMutation, UpsertBillingCustomerMutationVariables>(UpsertBillingCustomerDocument, variables)(),
      options
    );
export const BootstrapDocument = `
    query BOOTSTRAP($user_id: ID!) {
  bootstrap(data: {user_id: $user_id}) {
    client {
      ...ClientProtected
    }
    user {
      ...UserProfile
    }
    release_toggles
    capabilities
    user_leaderboards {
      ...LeaderboardConfig
    }
    user_social_accounts {
      ...SocialAccount
    }
    user_pages {
      ...LinkedInPage
    }
  }
}
    ${ClientProtectedFragmentDoc}
${UserProfileFragmentDoc}
${LeaderboardConfigFragmentDoc}
${SocialAccountFragmentDoc}
${LinkedInPageFragmentDoc}`;
export const useBootstrapQuery = <
      TData = BootstrapQuery,
      TError = unknown
    >(
      variables: BootstrapQueryVariables,
      options?: UseQueryOptions<BootstrapQuery, TError, TData>
    ) =>
    useQuery<BootstrapQuery, TError, TData>(
      ['BOOTSTRAP', variables],
      transport<BootstrapQuery, BootstrapQueryVariables>(BootstrapDocument, variables),
      options
    );
useBootstrapQuery.document = BootstrapDocument;


useBootstrapQuery.getKey = (variables: BootstrapQueryVariables) => ['BOOTSTRAP', variables];
;

export const ClientDailyStatsDocument = `
    query CLIENT_DAILY_STATS($client_id: ID!, $grouping: StatsGrouping!) {
  clientDailyStats(client_id: $client_id, grouping: $grouping) {
    total_posts
    total_shares
    total_clicks
    total_users
    data {
      posts
      clicks
      shares
      users
      calendar_day
    }
  }
}
    `;
export const useClientDailyStatsQuery = <
      TData = ClientDailyStatsQuery,
      TError = unknown
    >(
      variables: ClientDailyStatsQueryVariables,
      options?: UseQueryOptions<ClientDailyStatsQuery, TError, TData>
    ) =>
    useQuery<ClientDailyStatsQuery, TError, TData>(
      ['CLIENT_DAILY_STATS', variables],
      transport<ClientDailyStatsQuery, ClientDailyStatsQueryVariables>(ClientDailyStatsDocument, variables),
      options
    );
useClientDailyStatsQuery.document = ClientDailyStatsDocument;


useClientDailyStatsQuery.getKey = (variables: ClientDailyStatsQueryVariables) => ['CLIENT_DAILY_STATS', variables];
;

export const ClientEngagementStatsDocument = `
    query CLIENT_ENGAGEMENT_STATS($client_id: ID!, $grouping: StatsGrouping!, $value: Int!) {
  clientEngagementStats(client_id: $client_id, grouping: $grouping, value: $value) {
    comments
    reactions
    posts
    groups
    users
  }
}
    `;
export const useClientEngagementStatsQuery = <
      TData = ClientEngagementStatsQuery,
      TError = unknown
    >(
      variables: ClientEngagementStatsQueryVariables,
      options?: UseQueryOptions<ClientEngagementStatsQuery, TError, TData>
    ) =>
    useQuery<ClientEngagementStatsQuery, TError, TData>(
      ['CLIENT_ENGAGEMENT_STATS', variables],
      transport<ClientEngagementStatsQuery, ClientEngagementStatsQueryVariables>(ClientEngagementStatsDocument, variables),
      options
    );
useClientEngagementStatsQuery.document = ClientEngagementStatsDocument;


useClientEngagementStatsQuery.getKey = (variables: ClientEngagementStatsQueryVariables) => ['CLIENT_ENGAGEMENT_STATS', variables];
;

export const ClientReachStatsDocument = `
    query CLIENT_REACH_STATS($client_id: ID!, $grouping: StatsGrouping!, $value: Int!) {
  clientReachStats(client_id: $client_id, grouping: $grouping, value: $value) {
    reach
    previous_reach
    provider
    profile_identifier
  }
}
    `;
export const useClientReachStatsQuery = <
      TData = ClientReachStatsQuery,
      TError = unknown
    >(
      variables: ClientReachStatsQueryVariables,
      options?: UseQueryOptions<ClientReachStatsQuery, TError, TData>
    ) =>
    useQuery<ClientReachStatsQuery, TError, TData>(
      ['CLIENT_REACH_STATS', variables],
      transport<ClientReachStatsQuery, ClientReachStatsQueryVariables>(ClientReachStatsDocument, variables),
      options
    );
useClientReachStatsQuery.document = ClientReachStatsDocument;


useClientReachStatsQuery.getKey = (variables: ClientReachStatsQueryVariables) => ['CLIENT_REACH_STATS', variables];
;

export const DailyGroupStatsDocument = `
    query DAILY_GROUP_STATS($client_id: ID!, $end_date: String!, $start_date: String!, $filter: ReportingFilter) {
  dailyGroupStats(
    client_id: $client_id
    end_date: $end_date
    start_date: $start_date
    filter: $filter
  ) {
    summary {
      active_groups
      inactive_groups
      change
    }
    data {
      active_groups
      inactive_groups
      calendar_day
    }
  }
}
    `;
export const useDailyGroupStatsQuery = <
      TData = DailyGroupStatsQuery,
      TError = unknown
    >(
      variables: DailyGroupStatsQueryVariables,
      options?: UseQueryOptions<DailyGroupStatsQuery, TError, TData>
    ) =>
    useQuery<DailyGroupStatsQuery, TError, TData>(
      ['DAILY_GROUP_STATS', variables],
      transport<DailyGroupStatsQuery, DailyGroupStatsQueryVariables>(DailyGroupStatsDocument, variables),
      options
    );
useDailyGroupStatsQuery.document = DailyGroupStatsDocument;


useDailyGroupStatsQuery.getKey = (variables: DailyGroupStatsQueryVariables) => ['DAILY_GROUP_STATS', variables];
;

export const DailyLeaderboardStatsDocument = `
    query DAILY_LEADERBOARD_STATS($client_id: ID!, $leaderboard_config_id: ID!, $end_date: String!, $start_date: String!) {
  dailyLeaderboardStats(
    client_id: $client_id
    leaderboard_config_id: $leaderboard_config_id
    end_date: $end_date
    start_date: $start_date
  ) {
    summary {
      internal_points
      external_points
      change
    }
    data {
      internal_points
      external_points
      calendar_day
    }
  }
}
    `;
export const useDailyLeaderboardStatsQuery = <
      TData = DailyLeaderboardStatsQuery,
      TError = unknown
    >(
      variables: DailyLeaderboardStatsQueryVariables,
      options?: UseQueryOptions<DailyLeaderboardStatsQuery, TError, TData>
    ) =>
    useQuery<DailyLeaderboardStatsQuery, TError, TData>(
      ['DAILY_LEADERBOARD_STATS', variables],
      transport<DailyLeaderboardStatsQuery, DailyLeaderboardStatsQueryVariables>(DailyLeaderboardStatsDocument, variables),
      options
    );
useDailyLeaderboardStatsQuery.document = DailyLeaderboardStatsDocument;


useDailyLeaderboardStatsQuery.getKey = (variables: DailyLeaderboardStatsQueryVariables) => ['DAILY_LEADERBOARD_STATS', variables];
;

export const DailyPostStatsDocument = `
    query DAILY_POST_STATS($client_id: ID!, $end_date: String!, $start_date: String!, $filter: ReportingFilter) {
  dailyPostStats(
    client_id: $client_id
    end_date: $end_date
    start_date: $start_date
    filter: $filter
  ) {
    summary {
      branded_posts
      non_branded_posts
      change
    }
    data {
      branded_posts
      non_branded_posts
      calendar_day
    }
  }
}
    `;
export const useDailyPostStatsQuery = <
      TData = DailyPostStatsQuery,
      TError = unknown
    >(
      variables: DailyPostStatsQueryVariables,
      options?: UseQueryOptions<DailyPostStatsQuery, TError, TData>
    ) =>
    useQuery<DailyPostStatsQuery, TError, TData>(
      ['DAILY_POST_STATS', variables],
      transport<DailyPostStatsQuery, DailyPostStatsQueryVariables>(DailyPostStatsDocument, variables),
      options
    );
useDailyPostStatsQuery.document = DailyPostStatsDocument;


useDailyPostStatsQuery.getKey = (variables: DailyPostStatsQueryVariables) => ['DAILY_POST_STATS', variables];
;

export const DailyShareStatsDocument = `
    query DAILY_SHARE_STATS($client_id: ID!, $end_date: String!, $start_date: String!, $filter: ReportingFilter) {
  dailyShareStats(
    client_id: $client_id
    end_date: $end_date
    start_date: $start_date
    filter: $filter
  ) {
    summary {
      branded_shares
      non_branded_shares
      change
    }
    data {
      branded_shares
      non_branded_shares
      calendar_day
    }
  }
}
    `;
export const useDailyShareStatsQuery = <
      TData = DailyShareStatsQuery,
      TError = unknown
    >(
      variables: DailyShareStatsQueryVariables,
      options?: UseQueryOptions<DailyShareStatsQuery, TError, TData>
    ) =>
    useQuery<DailyShareStatsQuery, TError, TData>(
      ['DAILY_SHARE_STATS', variables],
      transport<DailyShareStatsQuery, DailyShareStatsQueryVariables>(DailyShareStatsDocument, variables),
      options
    );
useDailyShareStatsQuery.document = DailyShareStatsDocument;


useDailyShareStatsQuery.getKey = (variables: DailyShareStatsQueryVariables) => ['DAILY_SHARE_STATS', variables];
;

export const DailyUserStatsDocument = `
    query DAILY_USER_STATS($client_id: ID!, $end_date: String!, $start_date: String!, $filter: ReportingFilter) {
  dailyUserStats(
    client_id: $client_id
    end_date: $end_date
    start_date: $start_date
    filter: $filter
  ) {
    summary {
      active_users
      inactive_users
      change
    }
    data {
      active_users
      inactive_users
      calendar_day
    }
  }
}
    `;
export const useDailyUserStatsQuery = <
      TData = DailyUserStatsQuery,
      TError = unknown
    >(
      variables: DailyUserStatsQueryVariables,
      options?: UseQueryOptions<DailyUserStatsQuery, TError, TData>
    ) =>
    useQuery<DailyUserStatsQuery, TError, TData>(
      ['DAILY_USER_STATS', variables],
      transport<DailyUserStatsQuery, DailyUserStatsQueryVariables>(DailyUserStatsDocument, variables),
      options
    );
useDailyUserStatsQuery.document = DailyUserStatsDocument;


useDailyUserStatsQuery.getKey = (variables: DailyUserStatsQueryVariables) => ['DAILY_USER_STATS', variables];
;

export const ExternalOverviewStatsDocument = `
    query EXTERNAL_OVERVIEW_STATS($client_id: ID!, $end_date: String!, $start_date: String!) {
  externalOverviewStats(
    client_id: $client_id
    end_date: $end_date
    start_date: $start_date
  ) {
    summary {
      shares {
        count
        change
      }
      clicks {
        count
        change
      }
      engagements {
        count
        change
      }
      impressions {
        count
        change
      }
    }
    data {
      calendar_day
      branded_shares
      non_branded_shares
      branded_clicks
      non_branded_clicks
      branded_engagements
      non_branded_engagements
      impressions
    }
  }
}
    `;
export const useExternalOverviewStatsQuery = <
      TData = ExternalOverviewStatsQuery,
      TError = unknown
    >(
      variables: ExternalOverviewStatsQueryVariables,
      options?: UseQueryOptions<ExternalOverviewStatsQuery, TError, TData>
    ) =>
    useQuery<ExternalOverviewStatsQuery, TError, TData>(
      ['EXTERNAL_OVERVIEW_STATS', variables],
      transport<ExternalOverviewStatsQuery, ExternalOverviewStatsQueryVariables>(ExternalOverviewStatsDocument, variables),
      options
    );
useExternalOverviewStatsQuery.document = ExternalOverviewStatsDocument;


useExternalOverviewStatsQuery.getKey = (variables: ExternalOverviewStatsQueryVariables) => ['EXTERNAL_OVERVIEW_STATS', variables];
;

export const ExternalSharesDocument = `
    query EXTERNAL_SHARES($client_id: ID!, $timestamp_end: Int!, $timestamp_start: Int!, $user_id: ID!, $page: Int, $per_page: Int, $sort: ExternalSharesSortFields, $sort_direction: SortDirections) {
  externalShares(
    client_id: $client_id
    timestamp_end: $timestamp_end
    timestamp_start: $timestamp_start
    user_id: $user_id
    page: $page
    per_page: $per_page
    sort: $sort
    sort_direction: $sort_direction
  ) {
    results {
      article_title
      engagement_count
      first_engaged_at
      network
      shared_image_url
      share_id
      share_url
      user_commentary
      user_email
      user_reach
      linkedin_page_share
    }
    page
    per_page
  }
}
    `;
export const useExternalSharesQuery = <
      TData = ExternalSharesQuery,
      TError = unknown
    >(
      variables: ExternalSharesQueryVariables,
      options?: UseQueryOptions<ExternalSharesQuery, TError, TData>
    ) =>
    useQuery<ExternalSharesQuery, TError, TData>(
      ['EXTERNAL_SHARES', variables],
      transport<ExternalSharesQuery, ExternalSharesQueryVariables>(ExternalSharesDocument, variables),
      options
    );
useExternalSharesQuery.document = ExternalSharesDocument;


useExternalSharesQuery.getKey = (variables: ExternalSharesQueryVariables) => ['EXTERNAL_SHARES', variables];
;

export const GetGroupFollowersDocument = `
    query GET_GROUP_FOLLOWERS($data: FeedFollowingInput) {
  feedFollowing(data: $data) {
    feed_follows {
      ...UserFeedFollow
    }
    id
    paginate
    count
    user_id
    feed
    start_key
  }
}
    ${UserFeedFollowFragmentDoc}`;
export const useGetGroupFollowersQuery = <
      TData = GetGroupFollowersQuery,
      TError = unknown
    >(
      variables?: GetGroupFollowersQueryVariables,
      options?: UseQueryOptions<GetGroupFollowersQuery, TError, TData>
    ) =>
    useQuery<GetGroupFollowersQuery, TError, TData>(
      variables === undefined ? ['GET_GROUP_FOLLOWERS'] : ['GET_GROUP_FOLLOWERS', variables],
      transport<GetGroupFollowersQuery, GetGroupFollowersQueryVariables>(GetGroupFollowersDocument, variables),
      options
    );
useGetGroupFollowersQuery.document = GetGroupFollowersDocument;


useGetGroupFollowersQuery.getKey = (variables?: GetGroupFollowersQueryVariables) => variables === undefined ? ['GET_GROUP_FOLLOWERS'] : ['GET_GROUP_FOLLOWERS', variables];
;

export const GetUserFollowersDocument = `
    query GET_USER_FOLLOWERS($data: FeedFollowingInput) {
  feedFollowing(data: $data) {
    feed_follows {
      ...UserFeedFollow
    }
    id
    paginate
    count
    user_id
    feed
    start_key
  }
}
    ${UserFeedFollowFragmentDoc}`;
export const useGetUserFollowersQuery = <
      TData = GetUserFollowersQuery,
      TError = unknown
    >(
      variables?: GetUserFollowersQueryVariables,
      options?: UseQueryOptions<GetUserFollowersQuery, TError, TData>
    ) =>
    useQuery<GetUserFollowersQuery, TError, TData>(
      variables === undefined ? ['GET_USER_FOLLOWERS'] : ['GET_USER_FOLLOWERS', variables],
      transport<GetUserFollowersQuery, GetUserFollowersQueryVariables>(GetUserFollowersDocument, variables),
      options
    );
useGetUserFollowersQuery.document = GetUserFollowersDocument;


useGetUserFollowersQuery.getKey = (variables?: GetUserFollowersQueryVariables) => variables === undefined ? ['GET_USER_FOLLOWERS'] : ['GET_USER_FOLLOWERS', variables];
;

export const GetAllClientDepartmentsDocument = `
    query GET_ALL_CLIENT_DEPARTMENTS($data: ClientDepartmentListInput!, $override: OverrideInput) {
  getAllClientDepartments(data: $data, override: $override) {
    client_departments {
      ...ClientDepartment
    }
    count
    paginate
    title_lower
    id
  }
}
    ${ClientDepartmentFragmentDoc}`;
export const useGetAllClientDepartmentsQuery = <
      TData = GetAllClientDepartmentsQuery,
      TError = unknown
    >(
      variables: GetAllClientDepartmentsQueryVariables,
      options?: UseQueryOptions<GetAllClientDepartmentsQuery, TError, TData>
    ) =>
    useQuery<GetAllClientDepartmentsQuery, TError, TData>(
      ['GET_ALL_CLIENT_DEPARTMENTS', variables],
      transport<GetAllClientDepartmentsQuery, GetAllClientDepartmentsQueryVariables>(GetAllClientDepartmentsDocument, variables),
      options
    );
useGetAllClientDepartmentsQuery.document = GetAllClientDepartmentsDocument;


useGetAllClientDepartmentsQuery.getKey = (variables: GetAllClientDepartmentsQueryVariables) => ['GET_ALL_CLIENT_DEPARTMENTS', variables];
;

export const GetAllClientDisclosuresDocument = `
    query GET_ALL_CLIENT_DISCLOSURES($data: ClientDisclosureListInput!, $override: OverrideInput) {
  getAllClientDisclosures(data: $data, override: $override) {
    client_disclosures {
      ...ClientDisclosure
    }
    count
    paginate
    id
  }
}
    ${ClientDisclosureFragmentDoc}`;
export const useGetAllClientDisclosuresQuery = <
      TData = GetAllClientDisclosuresQuery,
      TError = unknown
    >(
      variables: GetAllClientDisclosuresQueryVariables,
      options?: UseQueryOptions<GetAllClientDisclosuresQuery, TError, TData>
    ) =>
    useQuery<GetAllClientDisclosuresQuery, TError, TData>(
      ['GET_ALL_CLIENT_DISCLOSURES', variables],
      transport<GetAllClientDisclosuresQuery, GetAllClientDisclosuresQueryVariables>(GetAllClientDisclosuresDocument, variables),
      options
    );
useGetAllClientDisclosuresQuery.document = GetAllClientDisclosuresDocument;


useGetAllClientDisclosuresQuery.getKey = (variables: GetAllClientDisclosuresQueryVariables) => ['GET_ALL_CLIENT_DISCLOSURES', variables];
;

export const GetAllClientFollowMappingsDocument = `
    query GET_ALL_CLIENT_FOLLOW_MAPPINGS {
  getAllClientFollowMappings(data: {}) {
    client_follow_mappings {
      ...ClientFollowMapping
    }
  }
}
    ${ClientFollowMappingFragmentDoc}`;
export const useGetAllClientFollowMappingsQuery = <
      TData = GetAllClientFollowMappingsQuery,
      TError = unknown
    >(
      variables?: GetAllClientFollowMappingsQueryVariables,
      options?: UseQueryOptions<GetAllClientFollowMappingsQuery, TError, TData>
    ) =>
    useQuery<GetAllClientFollowMappingsQuery, TError, TData>(
      variables === undefined ? ['GET_ALL_CLIENT_FOLLOW_MAPPINGS'] : ['GET_ALL_CLIENT_FOLLOW_MAPPINGS', variables],
      transport<GetAllClientFollowMappingsQuery, GetAllClientFollowMappingsQueryVariables>(GetAllClientFollowMappingsDocument, variables),
      options
    );
useGetAllClientFollowMappingsQuery.document = GetAllClientFollowMappingsDocument;


useGetAllClientFollowMappingsQuery.getKey = (variables?: GetAllClientFollowMappingsQueryVariables) => variables === undefined ? ['GET_ALL_CLIENT_FOLLOW_MAPPINGS'] : ['GET_ALL_CLIENT_FOLLOW_MAPPINGS', variables];
;

export const GetAllClientLocationsDocument = `
    query GET_ALL_CLIENT_LOCATIONS($data: ClientLocationListInput!, $override: OverrideInput) {
  getAllClientLocations(data: $data, override: $override) {
    client_locations {
      ...ClientLocation
    }
    count
    paginate
    title_lower
    id
  }
}
    ${ClientLocationFragmentDoc}`;
export const useGetAllClientLocationsQuery = <
      TData = GetAllClientLocationsQuery,
      TError = unknown
    >(
      variables: GetAllClientLocationsQueryVariables,
      options?: UseQueryOptions<GetAllClientLocationsQuery, TError, TData>
    ) =>
    useQuery<GetAllClientLocationsQuery, TError, TData>(
      ['GET_ALL_CLIENT_LOCATIONS', variables],
      transport<GetAllClientLocationsQuery, GetAllClientLocationsQueryVariables>(GetAllClientLocationsDocument, variables),
      options
    );
useGetAllClientLocationsQuery.document = GetAllClientLocationsDocument;


useGetAllClientLocationsQuery.getKey = (variables: GetAllClientLocationsQueryVariables) => ['GET_ALL_CLIENT_LOCATIONS', variables];
;

export const GetAllClientUrlParamsDocument = `
    query GET_ALL_CLIENT_URL_PARAMS {
  getAllClientUrlParams {
    ...ClientUrlParams
  }
}
    ${ClientUrlParamsFragmentDoc}`;
export const useGetAllClientUrlParamsQuery = <
      TData = GetAllClientUrlParamsQuery,
      TError = unknown
    >(
      variables?: GetAllClientUrlParamsQueryVariables,
      options?: UseQueryOptions<GetAllClientUrlParamsQuery, TError, TData>
    ) =>
    useQuery<GetAllClientUrlParamsQuery, TError, TData>(
      variables === undefined ? ['GET_ALL_CLIENT_URL_PARAMS'] : ['GET_ALL_CLIENT_URL_PARAMS', variables],
      transport<GetAllClientUrlParamsQuery, GetAllClientUrlParamsQueryVariables>(GetAllClientUrlParamsDocument, variables),
      options
    );
useGetAllClientUrlParamsQuery.document = GetAllClientUrlParamsDocument;


useGetAllClientUrlParamsQuery.getKey = (variables?: GetAllClientUrlParamsQueryVariables) => variables === undefined ? ['GET_ALL_CLIENT_URL_PARAMS'] : ['GET_ALL_CLIENT_URL_PARAMS', variables];
;

export const GetApiTokensDocument = `
    query GET_API_TOKENS {
  getAPITokens {
    token_id
    token_name
    created_at
  }
}
    `;
export const useGetApiTokensQuery = <
      TData = GetApiTokensQuery,
      TError = unknown
    >(
      variables?: GetApiTokensQueryVariables,
      options?: UseQueryOptions<GetApiTokensQuery, TError, TData>
    ) =>
    useQuery<GetApiTokensQuery, TError, TData>(
      variables === undefined ? ['GET_API_TOKENS'] : ['GET_API_TOKENS', variables],
      transport<GetApiTokensQuery, GetApiTokensQueryVariables>(GetApiTokensDocument, variables),
      options
    );
useGetApiTokensQuery.document = GetApiTokensDocument;


useGetApiTokensQuery.getKey = (variables?: GetApiTokensQueryVariables) => variables === undefined ? ['GET_API_TOKENS'] : ['GET_API_TOKENS', variables];
;

export const GetAssignmentDocument = `
    query GET_ASSIGNMENT($id: ID!, $client_id: ID!) {
  getAssignment(id: $id, client_id: $client_id) {
    ...Assignment
  }
}
    ${AssignmentFragmentDoc}`;
export const useGetAssignmentQuery = <
      TData = GetAssignmentQuery,
      TError = unknown
    >(
      variables: GetAssignmentQueryVariables,
      options?: UseQueryOptions<GetAssignmentQuery, TError, TData>
    ) =>
    useQuery<GetAssignmentQuery, TError, TData>(
      ['GET_ASSIGNMENT', variables],
      transport<GetAssignmentQuery, GetAssignmentQueryVariables>(GetAssignmentDocument, variables),
      options
    );
useGetAssignmentQuery.document = GetAssignmentDocument;


useGetAssignmentQuery.getKey = (variables: GetAssignmentQueryVariables) => ['GET_ASSIGNMENT', variables];
;

export const GetAssignmentsDocument = `
    query GET_ASSIGNMENTS($active: Boolean, $client_id: ID!) {
  getAssignments(active: $active, client_id: $client_id) {
    results {
      ...Assignment
    }
    total_count
    next_id
  }
}
    ${AssignmentFragmentDoc}`;
export const useGetAssignmentsQuery = <
      TData = GetAssignmentsQuery,
      TError = unknown
    >(
      variables: GetAssignmentsQueryVariables,
      options?: UseQueryOptions<GetAssignmentsQuery, TError, TData>
    ) =>
    useQuery<GetAssignmentsQuery, TError, TData>(
      ['GET_ASSIGNMENTS', variables],
      transport<GetAssignmentsQuery, GetAssignmentsQueryVariables>(GetAssignmentsDocument, variables),
      options
    );
useGetAssignmentsQuery.document = GetAssignmentsDocument;


useGetAssignmentsQuery.getKey = (variables: GetAssignmentsQueryVariables) => ['GET_ASSIGNMENTS', variables];
;

export const GetBillingUrlDocument = `
    query GET_BILLING_URL($client_id: ID!, $user_id: ID!, $return_url: String!, $plan_type: BillingPortalPlanType, $route: BillingPortalRoute) {
  getBillingCustomerPortalEphemeralUrl(
    plan_type: $plan_type
    route: $route
    client_id: $client_id
    user_id: $user_id
    return_url: $return_url
  ) {
    url
  }
}
    `;
export const useGetBillingUrlQuery = <
      TData = GetBillingUrlQuery,
      TError = unknown
    >(
      variables: GetBillingUrlQueryVariables,
      options?: UseQueryOptions<GetBillingUrlQuery, TError, TData>
    ) =>
    useQuery<GetBillingUrlQuery, TError, TData>(
      ['GET_BILLING_URL', variables],
      transport<GetBillingUrlQuery, GetBillingUrlQueryVariables>(GetBillingUrlDocument, variables),
      options
    );
useGetBillingUrlQuery.document = GetBillingUrlDocument;


useGetBillingUrlQuery.getKey = (variables: GetBillingUrlQueryVariables) => ['GET_BILLING_URL', variables];
;

export const GetChatChannelsDocument = `
    query GET_CHAT_CHANNELS($network: Network!, $team_id: String) {
  getChatChannels(network: $network, team_id: $team_id) {
    msteams_channels {
      channel_name
      channel_id
      team_id
    }
    slack_channels {
      channel_name
      channel_id
      team_id
    }
  }
}
    `;
export const useGetChatChannelsQuery = <
      TData = GetChatChannelsQuery,
      TError = unknown
    >(
      variables: GetChatChannelsQueryVariables,
      options?: UseQueryOptions<GetChatChannelsQuery, TError, TData>
    ) =>
    useQuery<GetChatChannelsQuery, TError, TData>(
      ['GET_CHAT_CHANNELS', variables],
      transport<GetChatChannelsQuery, GetChatChannelsQueryVariables>(GetChatChannelsDocument, variables),
      options
    );
useGetChatChannelsQuery.document = GetChatChannelsDocument;


useGetChatChannelsQuery.getKey = (variables: GetChatChannelsQueryVariables) => ['GET_CHAT_CHANNELS', variables];
;

export const GetChatTeamsDocument = `
    query GET_CHAT_TEAMS($network: Network!) {
  getChatTeams(network: $network) {
    ms_teams {
      team_id
      team_name
    }
  }
}
    `;
export const useGetChatTeamsQuery = <
      TData = GetChatTeamsQuery,
      TError = unknown
    >(
      variables: GetChatTeamsQueryVariables,
      options?: UseQueryOptions<GetChatTeamsQuery, TError, TData>
    ) =>
    useQuery<GetChatTeamsQuery, TError, TData>(
      ['GET_CHAT_TEAMS', variables],
      transport<GetChatTeamsQuery, GetChatTeamsQueryVariables>(GetChatTeamsDocument, variables),
      options
    );
useGetChatTeamsQuery.document = GetChatTeamsDocument;


useGetChatTeamsQuery.getKey = (variables: GetChatTeamsQueryVariables) => ['GET_CHAT_TEAMS', variables];
;

export const GetClientBillingReportAggregateDocument = `
    query GET_CLIENT_BILLING_REPORT_AGGREGATE($calendar_month__eq: String) {
  getClientBillingReportAggregate(calendar_month__eq: $calendar_month__eq) {
    contract_end_at
    num_email_users
    num_anonymous_users
    num_registered_users
    total_users
    last_month_total_users
    two_months_ago_total_users
    usage_rate
    user_overage
    updated_at
    created_at
    contract_type
    contract_start_at
    contract_committed_user_count
    client_subdomain
    client_id
    calendar_month
  }
}
    `;
export const useGetClientBillingReportAggregateQuery = <
      TData = GetClientBillingReportAggregateQuery,
      TError = unknown
    >(
      variables?: GetClientBillingReportAggregateQueryVariables,
      options?: UseQueryOptions<GetClientBillingReportAggregateQuery, TError, TData>
    ) =>
    useQuery<GetClientBillingReportAggregateQuery, TError, TData>(
      variables === undefined ? ['GET_CLIENT_BILLING_REPORT_AGGREGATE'] : ['GET_CLIENT_BILLING_REPORT_AGGREGATE', variables],
      transport<GetClientBillingReportAggregateQuery, GetClientBillingReportAggregateQueryVariables>(GetClientBillingReportAggregateDocument, variables),
      options
    );
useGetClientBillingReportAggregateQuery.document = GetClientBillingReportAggregateDocument;


useGetClientBillingReportAggregateQuery.getKey = (variables?: GetClientBillingReportAggregateQueryVariables) => variables === undefined ? ['GET_CLIENT_BILLING_REPORT_AGGREGATE'] : ['GET_CLIENT_BILLING_REPORT_AGGREGATE', variables];
;

export const GetClientContentTagsDocument = `
    query GET_CLIENT_CONTENT_TAGS {
  getClientContentTags {
    tag_id
    title
  }
}
    `;
export const useGetClientContentTagsQuery = <
      TData = GetClientContentTagsQuery,
      TError = unknown
    >(
      variables?: GetClientContentTagsQueryVariables,
      options?: UseQueryOptions<GetClientContentTagsQuery, TError, TData>
    ) =>
    useQuery<GetClientContentTagsQuery, TError, TData>(
      variables === undefined ? ['GET_CLIENT_CONTENT_TAGS'] : ['GET_CLIENT_CONTENT_TAGS', variables],
      transport<GetClientContentTagsQuery, GetClientContentTagsQueryVariables>(GetClientContentTagsDocument, variables),
      options
    );
useGetClientContentTagsQuery.document = GetClientContentTagsDocument;


useGetClientContentTagsQuery.getKey = (variables?: GetClientContentTagsQueryVariables) => variables === undefined ? ['GET_CLIENT_CONTENT_TAGS'] : ['GET_CLIENT_CONTENT_TAGS', variables];
;

export const GetClientDepartmentsByStatusDocument = `
    query GET_CLIENT_DEPARTMENTS_BY_STATUS($override: OverrideInput) {
  getClientDepartmentsByStatus(
    data: {department_status: active}
    override: $override
  ) {
    client_departments {
      ...ClientDepartment
    }
    count
    paginate
    department_status
    title
    id
  }
}
    ${ClientDepartmentFragmentDoc}`;
export const useGetClientDepartmentsByStatusQuery = <
      TData = GetClientDepartmentsByStatusQuery,
      TError = unknown
    >(
      variables?: GetClientDepartmentsByStatusQueryVariables,
      options?: UseQueryOptions<GetClientDepartmentsByStatusQuery, TError, TData>
    ) =>
    useQuery<GetClientDepartmentsByStatusQuery, TError, TData>(
      variables === undefined ? ['GET_CLIENT_DEPARTMENTS_BY_STATUS'] : ['GET_CLIENT_DEPARTMENTS_BY_STATUS', variables],
      transport<GetClientDepartmentsByStatusQuery, GetClientDepartmentsByStatusQueryVariables>(GetClientDepartmentsByStatusDocument, variables),
      options
    );
useGetClientDepartmentsByStatusQuery.document = GetClientDepartmentsByStatusDocument;


useGetClientDepartmentsByStatusQuery.getKey = (variables?: GetClientDepartmentsByStatusQueryVariables) => variables === undefined ? ['GET_CLIENT_DEPARTMENTS_BY_STATUS'] : ['GET_CLIENT_DEPARTMENTS_BY_STATUS', variables];
;

export const GetClientInvitationsByClientDocument = `
    query GET_CLIENT_INVITATIONS_BY_CLIENT($count: Boolean, $id: ID, $limit: Int, $created_at: Int, $invitation_status: ClientInvitationStatus!) {
  getClientInvitationsByClient(
    data: {count: $count, id: $id, created_at: $created_at, invitation_status: $invitation_status, limit: $limit}
  ) {
    client_invitations {
      ...ClientInvitation
    }
    count
    paginate
    invitation_status
    created_at
    id
    client_id
  }
}
    ${ClientInvitationFragmentDoc}`;
export const useGetClientInvitationsByClientQuery = <
      TData = GetClientInvitationsByClientQuery,
      TError = unknown
    >(
      variables: GetClientInvitationsByClientQueryVariables,
      options?: UseQueryOptions<GetClientInvitationsByClientQuery, TError, TData>
    ) =>
    useQuery<GetClientInvitationsByClientQuery, TError, TData>(
      ['GET_CLIENT_INVITATIONS_BY_CLIENT', variables],
      transport<GetClientInvitationsByClientQuery, GetClientInvitationsByClientQueryVariables>(GetClientInvitationsByClientDocument, variables),
      options
    );
useGetClientInvitationsByClientQuery.document = GetClientInvitationsByClientDocument;


useGetClientInvitationsByClientQuery.getKey = (variables: GetClientInvitationsByClientQueryVariables) => ['GET_CLIENT_INVITATIONS_BY_CLIENT', variables];
;

export const GetClientLocationsByStatusDocument = `
    query GET_CLIENT_LOCATIONS_BY_STATUS($override: OverrideInput) {
  getClientLocationsByStatus(data: {location_status: active}, override: $override) {
    client_locations {
      ...ClientLocation
    }
    count
    paginate
    location_status
    title
    id
  }
}
    ${ClientLocationFragmentDoc}`;
export const useGetClientLocationsByStatusQuery = <
      TData = GetClientLocationsByStatusQuery,
      TError = unknown
    >(
      variables?: GetClientLocationsByStatusQueryVariables,
      options?: UseQueryOptions<GetClientLocationsByStatusQuery, TError, TData>
    ) =>
    useQuery<GetClientLocationsByStatusQuery, TError, TData>(
      variables === undefined ? ['GET_CLIENT_LOCATIONS_BY_STATUS'] : ['GET_CLIENT_LOCATIONS_BY_STATUS', variables],
      transport<GetClientLocationsByStatusQuery, GetClientLocationsByStatusQueryVariables>(GetClientLocationsByStatusDocument, variables),
      options
    );
useGetClientLocationsByStatusQuery.document = GetClientLocationsByStatusDocument;


useGetClientLocationsByStatusQuery.getKey = (variables?: GetClientLocationsByStatusQueryVariables) => variables === undefined ? ['GET_CLIENT_LOCATIONS_BY_STATUS'] : ['GET_CLIENT_LOCATIONS_BY_STATUS', variables];
;

export const GetClientPageMappingsDocument = `
    query GET_CLIENT_PAGE_MAPPINGS($id: ID!) {
  getClientPageMappings(id: $id) {
    ...ClientPageMapping
  }
}
    ${ClientPageMappingFragmentDoc}`;
export const useGetClientPageMappingsQuery = <
      TData = GetClientPageMappingsQuery,
      TError = unknown
    >(
      variables: GetClientPageMappingsQueryVariables,
      options?: UseQueryOptions<GetClientPageMappingsQuery, TError, TData>
    ) =>
    useQuery<GetClientPageMappingsQuery, TError, TData>(
      ['GET_CLIENT_PAGE_MAPPINGS', variables],
      transport<GetClientPageMappingsQuery, GetClientPageMappingsQueryVariables>(GetClientPageMappingsDocument, variables),
      options
    );
useGetClientPageMappingsQuery.document = GetClientPageMappingsDocument;


useGetClientPageMappingsQuery.getKey = (variables: GetClientPageMappingsQueryVariables) => ['GET_CLIENT_PAGE_MAPPINGS', variables];
;

export const GetCompaniesDocument = `
    query GET_COMPANIES($start: Int!, $end: Int!, $limit: Int, $offset: Int, $hide_company: Boolean!, $sort_by: OrganicInsightsSortParam, $advanced_filters: OrganicInsightsAdvancedFilters) {
  getCompanies(
    start: $start
    end: $end
    limit: $limit
    offset: $offset
    hide_company: $hide_company
    sort_by: $sort_by
    advanced_filters: $advanced_filters
  ) {
    total
    results {
      rank
      company {
        company_logo
        job_company_name
      }
      total_engagers
      change
      engager_roles {
        role
      }
      engager_titles {
        title
      }
    }
  }
}
    `;
export const useGetCompaniesQuery = <
      TData = GetCompaniesQuery,
      TError = unknown
    >(
      variables: GetCompaniesQueryVariables,
      options?: UseQueryOptions<GetCompaniesQuery, TError, TData>
    ) =>
    useQuery<GetCompaniesQuery, TError, TData>(
      ['GET_COMPANIES', variables],
      transport<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, variables),
      options
    );
useGetCompaniesQuery.document = GetCompaniesDocument;


useGetCompaniesQuery.getKey = (variables: GetCompaniesQueryVariables) => ['GET_COMPANIES', variables];
;

export const GetContentDocument = `
    query GET_CONTENT($content_id: String!, $display_only: Boolean) {
  getContent(content_id: $content_id, display_only: $display_only) {
    ...Content
  }
}
    ${ContentFragmentDoc}`;
export const useGetContentQuery = <
      TData = GetContentQuery,
      TError = unknown
    >(
      variables: GetContentQueryVariables,
      options?: UseQueryOptions<GetContentQuery, TError, TData>
    ) =>
    useQuery<GetContentQuery, TError, TData>(
      ['GET_CONTENT', variables],
      transport<GetContentQuery, GetContentQueryVariables>(GetContentDocument, variables),
      options
    );
useGetContentQuery.document = GetContentDocument;


useGetContentQuery.getKey = (variables: GetContentQueryVariables) => ['GET_CONTENT', variables];
;

export const GetContentEmailHistoryDocument = `
    query GET_CONTENT_EMAIL_HISTORY($data: ContentEmailHistoryListInput!) {
  getContentEmailHistory(data: $data) {
    paginate
    sent_at
    spec_id
    history {
      ...ContentEmailHistory
    }
  }
}
    ${ContentEmailHistoryFragmentDoc}`;
export const useGetContentEmailHistoryQuery = <
      TData = GetContentEmailHistoryQuery,
      TError = unknown
    >(
      variables: GetContentEmailHistoryQueryVariables,
      options?: UseQueryOptions<GetContentEmailHistoryQuery, TError, TData>
    ) =>
    useQuery<GetContentEmailHistoryQuery, TError, TData>(
      ['GET_CONTENT_EMAIL_HISTORY', variables],
      transport<GetContentEmailHistoryQuery, GetContentEmailHistoryQueryVariables>(GetContentEmailHistoryDocument, variables),
      options
    );
useGetContentEmailHistoryQuery.document = GetContentEmailHistoryDocument;


useGetContentEmailHistoryQuery.getKey = (variables: GetContentEmailHistoryQueryVariables) => ['GET_CONTENT_EMAIL_HISTORY', variables];
;

export const GetContentEmailSpecDocument = `
    query GET_CONTENT_EMAIL_SPEC($id: ID!) {
  getContentEmailSpec(id: $id) {
    ...ContentEmailSpec
  }
}
    ${ContentEmailSpecFragmentDoc}`;
export const useGetContentEmailSpecQuery = <
      TData = GetContentEmailSpecQuery,
      TError = unknown
    >(
      variables: GetContentEmailSpecQueryVariables,
      options?: UseQueryOptions<GetContentEmailSpecQuery, TError, TData>
    ) =>
    useQuery<GetContentEmailSpecQuery, TError, TData>(
      ['GET_CONTENT_EMAIL_SPEC', variables],
      transport<GetContentEmailSpecQuery, GetContentEmailSpecQueryVariables>(GetContentEmailSpecDocument, variables),
      options
    );
useGetContentEmailSpecQuery.document = GetContentEmailSpecDocument;


useGetContentEmailSpecQuery.getKey = (variables: GetContentEmailSpecQueryVariables) => ['GET_CONTENT_EMAIL_SPEC', variables];
;

export const GetContentEmailSpecsDocument = `
    query GET_CONTENT_EMAIL_SPECS($data: ContentEmailSpecListInput!) {
  getContentEmailSpecs(data: $data) {
    paginate
    created_at
    id
    items {
      ...ContentEmailSpec
    }
  }
}
    ${ContentEmailSpecFragmentDoc}`;
export const useGetContentEmailSpecsQuery = <
      TData = GetContentEmailSpecsQuery,
      TError = unknown
    >(
      variables: GetContentEmailSpecsQueryVariables,
      options?: UseQueryOptions<GetContentEmailSpecsQuery, TError, TData>
    ) =>
    useQuery<GetContentEmailSpecsQuery, TError, TData>(
      ['GET_CONTENT_EMAIL_SPECS', variables],
      transport<GetContentEmailSpecsQuery, GetContentEmailSpecsQueryVariables>(GetContentEmailSpecsDocument, variables),
      options
    );
useGetContentEmailSpecsQuery.document = GetContentEmailSpecsDocument;


useGetContentEmailSpecsQuery.getKey = (variables: GetContentEmailSpecsQueryVariables) => ['GET_CONTENT_EMAIL_SPECS', variables];
;

export const GetContentUrlParamOptionsDocument = `
    query GET_CONTENT_URL_PARAM_OPTIONS($url: String!) {
  getContentUrlParamOptions(url: $url) {
    key
    options
    default_option_value
  }
}
    `;
export const useGetContentUrlParamOptionsQuery = <
      TData = GetContentUrlParamOptionsQuery,
      TError = unknown
    >(
      variables: GetContentUrlParamOptionsQueryVariables,
      options?: UseQueryOptions<GetContentUrlParamOptionsQuery, TError, TData>
    ) =>
    useQuery<GetContentUrlParamOptionsQuery, TError, TData>(
      ['GET_CONTENT_URL_PARAM_OPTIONS', variables],
      transport<GetContentUrlParamOptionsQuery, GetContentUrlParamOptionsQueryVariables>(GetContentUrlParamOptionsDocument, variables),
      options
    );
useGetContentUrlParamOptionsQuery.document = GetContentUrlParamOptionsDocument;


useGetContentUrlParamOptionsQuery.getKey = (variables: GetContentUrlParamOptionsQueryVariables) => ['GET_CONTENT_URL_PARAM_OPTIONS', variables];
;

export const GetEbrIntroductionDocument = `
    query GET_EBR_INTRODUCTION($start: Int!, $end: Int!, $client_id: ID!) {
  getEbrIntroduction(start: $start, end: $end, client_id: $client_id) {
    registered_users_count
    shares_count
    top_companies {
      company_logo
      job_company_name
    }
    top_profiles {
      title
      role
      name
      network_profile_image
      network_profile_url
      company {
        company_logo
        job_company_name
      }
      engagement_summary {
        engagements
        first_engagement
        last_engagement
        last_engagement_detail {
          network
          engagement_type
          share_url
          content_url
        }
      }
    }
  }
}
    `;
export const useGetEbrIntroductionQuery = <
      TData = GetEbrIntroductionQuery,
      TError = unknown
    >(
      variables: GetEbrIntroductionQueryVariables,
      options?: UseQueryOptions<GetEbrIntroductionQuery, TError, TData>
    ) =>
    useQuery<GetEbrIntroductionQuery, TError, TData>(
      ['GET_EBR_INTRODUCTION', variables],
      transport<GetEbrIntroductionQuery, GetEbrIntroductionQueryVariables>(GetEbrIntroductionDocument, variables),
      options
    );
useGetEbrIntroductionQuery.document = GetEbrIntroductionDocument;


useGetEbrIntroductionQuery.getKey = (variables: GetEbrIntroductionQueryVariables) => ['GET_EBR_INTRODUCTION', variables];
;

export const GetEbrOrganicInsightsDocument = `
    query GET_EBR_ORGANIC_INSIGHTS($start: Int!, $end: Int!, $client_id: ID!) {
  getEbrOrganicInsights(start: $start, end: $end, client_id: $client_id) {
    key_insights
    top_companies {
      company_logo
      job_company_name
    }
    countries {
      ...EbrProfilesCount
    }
    company_industries {
      ...EbrProfilesCount
    }
    company_sizes {
      ...EbrProfilesCount
    }
    job_titles {
      ...EbrProfilesCount
    }
    job_roles {
      ...EbrProfilesCount
    }
  }
}
    ${EbrProfilesCountFragmentDoc}`;
export const useGetEbrOrganicInsightsQuery = <
      TData = GetEbrOrganicInsightsQuery,
      TError = unknown
    >(
      variables: GetEbrOrganicInsightsQueryVariables,
      options?: UseQueryOptions<GetEbrOrganicInsightsQuery, TError, TData>
    ) =>
    useQuery<GetEbrOrganicInsightsQuery, TError, TData>(
      ['GET_EBR_ORGANIC_INSIGHTS', variables],
      transport<GetEbrOrganicInsightsQuery, GetEbrOrganicInsightsQueryVariables>(GetEbrOrganicInsightsDocument, variables),
      options
    );
useGetEbrOrganicInsightsQuery.document = GetEbrOrganicInsightsDocument;


useGetEbrOrganicInsightsQuery.getKey = (variables: GetEbrOrganicInsightsQueryVariables) => ['GET_EBR_ORGANIC_INSIGHTS', variables];
;

export const GetEmployeesDocument = `
    query GET_EMPLOYEES($start: Int!, $end: Int!, $limit: Int, $offset: Int, $registration_status: RegistrationStatus!, $sort_by: OrganicInsightsSortParam, $advanced_filters: OrganicInsightsAdvancedFilters) {
  getEmployees(
    start: $start
    end: $end
    limit: $limit
    offset: $offset
    registration_status: $registration_status
    sort_by: $sort_by
    advanced_filters: $advanced_filters
  ) {
    total
    results {
      profile_id
      rank
      name
      role
      network_bio
      network_profile_image
      email_address
      location
      registered
      engagement_summary {
        engagements
      }
    }
  }
}
    `;
export const useGetEmployeesQuery = <
      TData = GetEmployeesQuery,
      TError = unknown
    >(
      variables: GetEmployeesQueryVariables,
      options?: UseQueryOptions<GetEmployeesQuery, TError, TData>
    ) =>
    useQuery<GetEmployeesQuery, TError, TData>(
      ['GET_EMPLOYEES', variables],
      transport<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, variables),
      options
    );
useGetEmployeesQuery.document = GetEmployeesDocument;


useGetEmployeesQuery.getKey = (variables: GetEmployeesQueryVariables) => ['GET_EMPLOYEES', variables];
;

export const GetExpressActivatedUsersDocument = `
    query GET_EXPRESS_ACTIVATED_USERS($filters: ExpressActivationFiltersInput!, $last_evaluated_key: String!) {
  getExpressActivatedUsers(
    filters: $filters
    last_evaluated_key: $last_evaluated_key
  ) {
    message
    total
    users {
      ...ExpressActivatedUsers
    }
    last_evaluated_key
  }
}
    ${ExpressActivatedUsersFragmentDoc}`;
export const useGetExpressActivatedUsersQuery = <
      TData = GetExpressActivatedUsersQuery,
      TError = unknown
    >(
      variables: GetExpressActivatedUsersQueryVariables,
      options?: UseQueryOptions<GetExpressActivatedUsersQuery, TError, TData>
    ) =>
    useQuery<GetExpressActivatedUsersQuery, TError, TData>(
      ['GET_EXPRESS_ACTIVATED_USERS', variables],
      transport<GetExpressActivatedUsersQuery, GetExpressActivatedUsersQueryVariables>(GetExpressActivatedUsersDocument, variables),
      options
    );
useGetExpressActivatedUsersQuery.document = GetExpressActivatedUsersDocument;


useGetExpressActivatedUsersQuery.getKey = (variables: GetExpressActivatedUsersQueryVariables) => ['GET_EXPRESS_ACTIVATED_USERS', variables];
;

export const GetFeedDocument = `
    query GET_FEED($key: String!, $id: String!, $limit: Int!, $id_lt: String, $offset: Int, $sort: Boolean!) {
  getFeed(
    key: $key
    id: $id
    limit: $limit
    id_lt: $id_lt
    offset: $offset
    sort: $sort
  ) {
    id_lt
    offset
    results {
      ...Content
    }
  }
}
    ${ContentFragmentDoc}`;
export const useGetFeedQuery = <
      TData = GetFeedQuery,
      TError = unknown
    >(
      variables: GetFeedQueryVariables,
      options?: UseQueryOptions<GetFeedQuery, TError, TData>
    ) =>
    useQuery<GetFeedQuery, TError, TData>(
      ['GET_FEED', variables],
      transport<GetFeedQuery, GetFeedQueryVariables>(GetFeedDocument, variables),
      options
    );
useGetFeedQuery.document = GetFeedDocument;


useGetFeedQuery.getKey = (variables: GetFeedQueryVariables) => ['GET_FEED', variables];
;

export const GetFollowedDocument = `
    query GET_FOLLOWED($data: PaginatedUserFeedFollowsInput) {
  getPaginatedUserFeedFollows(data: $data) {
    count
    title_lower
    client_id__feed__id
    feed_follows {
      ...UserFeedFollow
    }
  }
}
    ${UserFeedFollowFragmentDoc}`;
export const useGetFollowedQuery = <
      TData = GetFollowedQuery,
      TError = unknown
    >(
      variables?: GetFollowedQueryVariables,
      options?: UseQueryOptions<GetFollowedQuery, TError, TData>
    ) =>
    useQuery<GetFollowedQuery, TError, TData>(
      variables === undefined ? ['GET_FOLLOWED'] : ['GET_FOLLOWED', variables],
      transport<GetFollowedQuery, GetFollowedQueryVariables>(GetFollowedDocument, variables),
      options
    );
useGetFollowedQuery.document = GetFollowedDocument;


useGetFollowedQuery.getKey = (variables?: GetFollowedQueryVariables) => variables === undefined ? ['GET_FOLLOWED'] : ['GET_FOLLOWED', variables];
;

export const GetFollowersDocument = `
    query GET_FOLLOWERS($data: PaginatedFollowedByUsersInput) {
  getPaginatedFollowedByUsers(data: $data) {
    count
    username
    followed_by_user_id
    followed_by_users {
      ...PublicUserProfile
    }
  }
}
    ${PublicUserProfileFragmentDoc}`;
export const useGetFollowersQuery = <
      TData = GetFollowersQuery,
      TError = unknown
    >(
      variables?: GetFollowersQueryVariables,
      options?: UseQueryOptions<GetFollowersQuery, TError, TData>
    ) =>
    useQuery<GetFollowersQuery, TError, TData>(
      variables === undefined ? ['GET_FOLLOWERS'] : ['GET_FOLLOWERS', variables],
      transport<GetFollowersQuery, GetFollowersQueryVariables>(GetFollowersDocument, variables),
      options
    );
useGetFollowersQuery.document = GetFollowersDocument;


useGetFollowersQuery.getKey = (variables?: GetFollowersQueryVariables) => variables === undefined ? ['GET_FOLLOWERS'] : ['GET_FOLLOWERS', variables];
;

export const GetGroupDocument = `
    query GET_GROUP($id: ID!) {
  getGroup(id: $id) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export const useGetGroupQuery = <
      TData = GetGroupQuery,
      TError = unknown
    >(
      variables: GetGroupQueryVariables,
      options?: UseQueryOptions<GetGroupQuery, TError, TData>
    ) =>
    useQuery<GetGroupQuery, TError, TData>(
      ['GET_GROUP', variables],
      transport<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, variables),
      options
    );
useGetGroupQuery.document = GetGroupDocument;


useGetGroupQuery.getKey = (variables: GetGroupQueryVariables) => ['GET_GROUP', variables];
;

export const GetGroupColorsDocument = `
    query GET_GROUP_COLORS {
  getGroupColors {
    label
    hex
    group_color
  }
}
    `;
export const useGetGroupColorsQuery = <
      TData = GetGroupColorsQuery,
      TError = unknown
    >(
      variables?: GetGroupColorsQueryVariables,
      options?: UseQueryOptions<GetGroupColorsQuery, TError, TData>
    ) =>
    useQuery<GetGroupColorsQuery, TError, TData>(
      variables === undefined ? ['GET_GROUP_COLORS'] : ['GET_GROUP_COLORS', variables],
      transport<GetGroupColorsQuery, GetGroupColorsQueryVariables>(GetGroupColorsDocument, variables),
      options
    );
useGetGroupColorsQuery.document = GetGroupColorsDocument;


useGetGroupColorsQuery.getKey = (variables?: GetGroupColorsQueryVariables) => variables === undefined ? ['GET_GROUP_COLORS'] : ['GET_GROUP_COLORS', variables];
;

export const GetGroupIconsDocument = `
    query GET_GROUP_ICONS {
  getGroupIcons {
    bucket
    file_key
    width
    height
    group_icon
    label
  }
}
    `;
export const useGetGroupIconsQuery = <
      TData = GetGroupIconsQuery,
      TError = unknown
    >(
      variables?: GetGroupIconsQueryVariables,
      options?: UseQueryOptions<GetGroupIconsQuery, TError, TData>
    ) =>
    useQuery<GetGroupIconsQuery, TError, TData>(
      variables === undefined ? ['GET_GROUP_ICONS'] : ['GET_GROUP_ICONS', variables],
      transport<GetGroupIconsQuery, GetGroupIconsQueryVariables>(GetGroupIconsDocument, variables),
      options
    );
useGetGroupIconsQuery.document = GetGroupIconsDocument;


useGetGroupIconsQuery.getKey = (variables?: GetGroupIconsQueryVariables) => variables === undefined ? ['GET_GROUP_ICONS'] : ['GET_GROUP_ICONS', variables];
;

export const GetGroupModeratorsDocument = `
    query GET_GROUP_MODERATORS($group_id: ID!) {
  getModeratorsByGroup(group_id: $group_id) {
    ...GroupModerator
  }
}
    ${GroupModeratorFragmentDoc}`;
export const useGetGroupModeratorsQuery = <
      TData = GetGroupModeratorsQuery,
      TError = unknown
    >(
      variables: GetGroupModeratorsQueryVariables,
      options?: UseQueryOptions<GetGroupModeratorsQuery, TError, TData>
    ) =>
    useQuery<GetGroupModeratorsQuery, TError, TData>(
      ['GET_GROUP_MODERATORS', variables],
      transport<GetGroupModeratorsQuery, GetGroupModeratorsQueryVariables>(GetGroupModeratorsDocument, variables),
      options
    );
useGetGroupModeratorsQuery.document = GetGroupModeratorsDocument;


useGetGroupModeratorsQuery.getKey = (variables: GetGroupModeratorsQueryVariables) => ['GET_GROUP_MODERATORS', variables];
;

export const GetGroupSourcesDocument = `
    query GET_GROUP_SOURCES($group_id: ID!) {
  getClientGroupSourcesByGroup(group_id: $group_id) {
    ...ClientGroupSource
  }
}
    ${ClientGroupSourceFragmentDoc}`;
export const useGetGroupSourcesQuery = <
      TData = GetGroupSourcesQuery,
      TError = unknown
    >(
      variables: GetGroupSourcesQueryVariables,
      options?: UseQueryOptions<GetGroupSourcesQuery, TError, TData>
    ) =>
    useQuery<GetGroupSourcesQuery, TError, TData>(
      ['GET_GROUP_SOURCES', variables],
      transport<GetGroupSourcesQuery, GetGroupSourcesQueryVariables>(GetGroupSourcesDocument, variables),
      options
    );
useGetGroupSourcesQuery.document = GetGroupSourcesDocument;


useGetGroupSourcesQuery.getKey = (variables: GetGroupSourcesQueryVariables) => ['GET_GROUP_SOURCES', variables];
;

export const GetGroupWebhookListDocument = `
    query GET_GROUP_WEBHOOK_LIST($group_id: ID!) {
  getGroupWebhookList(group_id: $group_id) {
    webhooks {
      ...Webhook
    }
    workvivo_workspaces {
      workvivo_workspace_id
      workspace_name
    }
  }
}
    ${WebhookFragmentDoc}`;
export const useGetGroupWebhookListQuery = <
      TData = GetGroupWebhookListQuery,
      TError = unknown
    >(
      variables: GetGroupWebhookListQueryVariables,
      options?: UseQueryOptions<GetGroupWebhookListQuery, TError, TData>
    ) =>
    useQuery<GetGroupWebhookListQuery, TError, TData>(
      ['GET_GROUP_WEBHOOK_LIST', variables],
      transport<GetGroupWebhookListQuery, GetGroupWebhookListQueryVariables>(GetGroupWebhookListDocument, variables),
      options
    );
useGetGroupWebhookListQuery.document = GetGroupWebhookListDocument;


useGetGroupWebhookListQuery.getKey = (variables: GetGroupWebhookListQueryVariables) => ['GET_GROUP_WEBHOOK_LIST', variables];
;

export const GetInboxItemsDocument = `
    query GET_INBOX_ITEMS($limit: Int, $created_at: Int, $id: ID) {
  getInboxItems(data: {limit: $limit, created_at: $created_at, id: $id}) {
    id
    created_at
    inbox {
      ...Inbox
    }
  }
}
    ${InboxFragmentDoc}`;
export const useGetInboxItemsQuery = <
      TData = GetInboxItemsQuery,
      TError = unknown
    >(
      variables?: GetInboxItemsQueryVariables,
      options?: UseQueryOptions<GetInboxItemsQuery, TError, TData>
    ) =>
    useQuery<GetInboxItemsQuery, TError, TData>(
      variables === undefined ? ['GET_INBOX_ITEMS'] : ['GET_INBOX_ITEMS', variables],
      transport<GetInboxItemsQuery, GetInboxItemsQueryVariables>(GetInboxItemsDocument, variables),
      options
    );
useGetInboxItemsQuery.document = GetInboxItemsDocument;


useGetInboxItemsQuery.getKey = (variables?: GetInboxItemsQueryVariables) => variables === undefined ? ['GET_INBOX_ITEMS'] : ['GET_INBOX_ITEMS', variables];
;

export const GetLeaderboardConfigDocument = `
    query GET_LEADERBOARD_CONFIG($id: ID!) {
  getLeaderboardConfig(id: $id) {
    ...LeaderboardConfig
  }
}
    ${LeaderboardConfigFragmentDoc}`;
export const useGetLeaderboardConfigQuery = <
      TData = GetLeaderboardConfigQuery,
      TError = unknown
    >(
      variables: GetLeaderboardConfigQueryVariables,
      options?: UseQueryOptions<GetLeaderboardConfigQuery, TError, TData>
    ) =>
    useQuery<GetLeaderboardConfigQuery, TError, TData>(
      ['GET_LEADERBOARD_CONFIG', variables],
      transport<GetLeaderboardConfigQuery, GetLeaderboardConfigQueryVariables>(GetLeaderboardConfigDocument, variables),
      options
    );
useGetLeaderboardConfigQuery.document = GetLeaderboardConfigDocument;


useGetLeaderboardConfigQuery.getKey = (variables: GetLeaderboardConfigQueryVariables) => ['GET_LEADERBOARD_CONFIG', variables];
;

export const GetLeaderboardConfigsDocument = `
    query GET_LEADERBOARD_CONFIGS {
  getLeaderboardConfigs {
    ...LeaderboardConfig
  }
}
    ${LeaderboardConfigFragmentDoc}`;
export const useGetLeaderboardConfigsQuery = <
      TData = GetLeaderboardConfigsQuery,
      TError = unknown
    >(
      variables?: GetLeaderboardConfigsQueryVariables,
      options?: UseQueryOptions<GetLeaderboardConfigsQuery, TError, TData>
    ) =>
    useQuery<GetLeaderboardConfigsQuery, TError, TData>(
      variables === undefined ? ['GET_LEADERBOARD_CONFIGS'] : ['GET_LEADERBOARD_CONFIGS', variables],
      transport<GetLeaderboardConfigsQuery, GetLeaderboardConfigsQueryVariables>(GetLeaderboardConfigsDocument, variables),
      options
    );
useGetLeaderboardConfigsQuery.document = GetLeaderboardConfigsDocument;


useGetLeaderboardConfigsQuery.getKey = (variables?: GetLeaderboardConfigsQueryVariables) => variables === undefined ? ['GET_LEADERBOARD_CONFIGS'] : ['GET_LEADERBOARD_CONFIGS', variables];
;

export const GetLeaderboardConfigAggregateDocument = `
    query GET_LEADERBOARD_CONFIG_AGGREGATE($id: ID!) {
  getLeaderboardConfigAggregate(id: $id) {
    id
    title
    description
    leaderboard_status
    created_at
    start_at
    end_at
    all_users
    segment_ids
    segments {
      ...UserSegment
    }
    scoring_aggregate {
      ...LeaderboardEventAggregate
    }
  }
}
    ${UserSegmentFragmentDoc}
${LeaderboardEventAggregateFragmentDoc}`;
export const useGetLeaderboardConfigAggregateQuery = <
      TData = GetLeaderboardConfigAggregateQuery,
      TError = unknown
    >(
      variables: GetLeaderboardConfigAggregateQueryVariables,
      options?: UseQueryOptions<GetLeaderboardConfigAggregateQuery, TError, TData>
    ) =>
    useQuery<GetLeaderboardConfigAggregateQuery, TError, TData>(
      ['GET_LEADERBOARD_CONFIG_AGGREGATE', variables],
      transport<GetLeaderboardConfigAggregateQuery, GetLeaderboardConfigAggregateQueryVariables>(GetLeaderboardConfigAggregateDocument, variables),
      options
    );
useGetLeaderboardConfigAggregateQuery.document = GetLeaderboardConfigAggregateDocument;


useGetLeaderboardConfigAggregateQuery.getKey = (variables: GetLeaderboardConfigAggregateQueryVariables) => ['GET_LEADERBOARD_CONFIG_AGGREGATE', variables];
;

export const GetLeaderboardConfigScoresDocument = `
    query GET_LEADERBOARD_CONFIG_SCORES($id: ID!) {
  getLeaderboardConfigScores(id: $id) {
    event
    score
  }
}
    `;
export const useGetLeaderboardConfigScoresQuery = <
      TData = GetLeaderboardConfigScoresQuery,
      TError = unknown
    >(
      variables: GetLeaderboardConfigScoresQueryVariables,
      options?: UseQueryOptions<GetLeaderboardConfigScoresQuery, TError, TData>
    ) =>
    useQuery<GetLeaderboardConfigScoresQuery, TError, TData>(
      ['GET_LEADERBOARD_CONFIG_SCORES', variables],
      transport<GetLeaderboardConfigScoresQuery, GetLeaderboardConfigScoresQueryVariables>(GetLeaderboardConfigScoresDocument, variables),
      options
    );
useGetLeaderboardConfigScoresQuery.document = GetLeaderboardConfigScoresDocument;


useGetLeaderboardConfigScoresQuery.getKey = (variables: GetLeaderboardConfigScoresQueryVariables) => ['GET_LEADERBOARD_CONFIG_SCORES', variables];
;

export const GetUserLeaderboardDocument = `
    query GET_USER_LEADERBOARD($user_id: ID, $leaderboard_config_id: ID, $limit: Int) {
  getLeaderboardForUser(
    user_id: $user_id
    leaderboard_config_id: $leaderboard_config_id
    limit: $limit
  ) {
    leaderboard_scores {
      paginate
      leaderboard_config_id
      ranking
      user_id
      items {
        ...LeaderboardScore
      }
    }
    user_score {
      ...LeaderboardScore
    }
  }
}
    ${LeaderboardScoreFragmentDoc}`;
export const useGetUserLeaderboardQuery = <
      TData = GetUserLeaderboardQuery,
      TError = unknown
    >(
      variables?: GetUserLeaderboardQueryVariables,
      options?: UseQueryOptions<GetUserLeaderboardQuery, TError, TData>
    ) =>
    useQuery<GetUserLeaderboardQuery, TError, TData>(
      variables === undefined ? ['GET_USER_LEADERBOARD'] : ['GET_USER_LEADERBOARD', variables],
      transport<GetUserLeaderboardQuery, GetUserLeaderboardQueryVariables>(GetUserLeaderboardDocument, variables),
      options
    );
useGetUserLeaderboardQuery.document = GetUserLeaderboardDocument;


useGetUserLeaderboardQuery.getKey = (variables?: GetUserLeaderboardQueryVariables) => variables === undefined ? ['GET_USER_LEADERBOARD'] : ['GET_USER_LEADERBOARD', variables];
;

export const GetLeaderboardScoresDocument = `
    query GET_LEADERBOARD_SCORES($leaderboard_config_id: ID!, $limit: Int, $ranking: Int, $user_id: ID) {
  getLeaderboardScores(
    leaderboard_config_id: $leaderboard_config_id
    limit: $limit
    ranking: $ranking
    user_id: $user_id
  ) {
    paginate
    leaderboard_config_id
    ranking
    user_id
    items {
      ...LeaderboardScore
    }
  }
}
    ${LeaderboardScoreFragmentDoc}`;
export const useGetLeaderboardScoresQuery = <
      TData = GetLeaderboardScoresQuery,
      TError = unknown
    >(
      variables: GetLeaderboardScoresQueryVariables,
      options?: UseQueryOptions<GetLeaderboardScoresQuery, TError, TData>
    ) =>
    useQuery<GetLeaderboardScoresQuery, TError, TData>(
      ['GET_LEADERBOARD_SCORES', variables],
      transport<GetLeaderboardScoresQuery, GetLeaderboardScoresQueryVariables>(GetLeaderboardScoresDocument, variables),
      options
    );
useGetLeaderboardScoresQuery.document = GetLeaderboardScoresDocument;


useGetLeaderboardScoresQuery.getKey = (variables: GetLeaderboardScoresQueryVariables) => ['GET_LEADERBOARD_SCORES', variables];
;

export const GetLeaderboardScoreForUserDocument = `
    query GET_LEADERBOARD_SCORE_FOR_USER($leaderboard_config_id: ID!, $user_id: ID) {
  getLeaderboardScoreForUser(
    leaderboard_config_id: $leaderboard_config_id
    user_id: $user_id
  ) {
    ...LeaderboardScore
  }
}
    ${LeaderboardScoreFragmentDoc}`;
export const useGetLeaderboardScoreForUserQuery = <
      TData = GetLeaderboardScoreForUserQuery,
      TError = unknown
    >(
      variables: GetLeaderboardScoreForUserQueryVariables,
      options?: UseQueryOptions<GetLeaderboardScoreForUserQuery, TError, TData>
    ) =>
    useQuery<GetLeaderboardScoreForUserQuery, TError, TData>(
      ['GET_LEADERBOARD_SCORE_FOR_USER', variables],
      transport<GetLeaderboardScoreForUserQuery, GetLeaderboardScoreForUserQueryVariables>(GetLeaderboardScoreForUserDocument, variables),
      options
    );
useGetLeaderboardScoreForUserQuery.document = GetLeaderboardScoreForUserDocument;


useGetLeaderboardScoreForUserQuery.getKey = (variables: GetLeaderboardScoreForUserQueryVariables) => ['GET_LEADERBOARD_SCORE_FOR_USER', variables];
;

export const GetManualNotificationsDocument = `
    query GET_MANUAL_NOTIFICATIONS($data: ItemsListInput!, $scheduled: Boolean) {
  getManualNotificationItems(data: $data, scheduled: $scheduled) {
    count
    paginate
    created_at
    id
    items {
      ...ManualNotificationsItem
    }
  }
}
    ${ManualNotificationsItemFragmentDoc}`;
export const useGetManualNotificationsQuery = <
      TData = GetManualNotificationsQuery,
      TError = unknown
    >(
      variables: GetManualNotificationsQueryVariables,
      options?: UseQueryOptions<GetManualNotificationsQuery, TError, TData>
    ) =>
    useQuery<GetManualNotificationsQuery, TError, TData>(
      ['GET_MANUAL_NOTIFICATIONS', variables],
      transport<GetManualNotificationsQuery, GetManualNotificationsQueryVariables>(GetManualNotificationsDocument, variables),
      options
    );
useGetManualNotificationsQuery.document = GetManualNotificationsDocument;


useGetManualNotificationsQuery.getKey = (variables: GetManualNotificationsQueryVariables) => ['GET_MANUAL_NOTIFICATIONS', variables];
;

export const GetMentionsDocument = `
    query GET_MENTIONS($token_id: String!, $query: String!, $page_key: String) {
  getMention(token_id: $token_id, query: $query, page_key: $page_key) {
    count
    items {
      identifier
      logo
      name
    }
    page_key
  }
}
    `;
export const useGetMentionsQuery = <
      TData = GetMentionsQuery,
      TError = unknown
    >(
      variables: GetMentionsQueryVariables,
      options?: UseQueryOptions<GetMentionsQuery, TError, TData>
    ) =>
    useQuery<GetMentionsQuery, TError, TData>(
      ['GET_MENTIONS', variables],
      transport<GetMentionsQuery, GetMentionsQueryVariables>(GetMentionsDocument, variables),
      options
    );
useGetMentionsQuery.document = GetMentionsDocument;


useGetMentionsQuery.getKey = (variables: GetMentionsQueryVariables) => ['GET_MENTIONS', variables];
;

export const GetOiCtaIntelDocument = `
    query GET_OI_CTA_INTEL($client_id: ID!, $start: Int!, $end: Int!) {
  getIntelligence(client_id: $client_id, start: $start, end: $end) {
    distinct_user_engagements
    intelligent_company_extrapolation
  }
}
    `;
export const useGetOiCtaIntelQuery = <
      TData = GetOiCtaIntelQuery,
      TError = unknown
    >(
      variables: GetOiCtaIntelQueryVariables,
      options?: UseQueryOptions<GetOiCtaIntelQuery, TError, TData>
    ) =>
    useQuery<GetOiCtaIntelQuery, TError, TData>(
      ['GET_OI_CTA_INTEL', variables],
      transport<GetOiCtaIntelQuery, GetOiCtaIntelQueryVariables>(GetOiCtaIntelDocument, variables),
      options
    );
useGetOiCtaIntelQuery.document = GetOiCtaIntelDocument;


useGetOiCtaIntelQuery.getKey = (variables: GetOiCtaIntelQueryVariables) => ['GET_OI_CTA_INTEL', variables];
;

export const GetOiCtaPeopleDocument = `
    query GET_OI_CTA_PEOPLE($start: Int!, $end: Int!, $limit: Int!) {
  getPeople(
    start: $start
    end: $end
    hide_teammates: true
    limit: $limit
    offset: 0
    ordering: newest
    sort_by: {field: engagement_date, direction: desc}
    advanced_filters: {remove_duplicates: true, filter_out_incomplete_profiles: true}
  ) {
    total
    results {
      title
      role
      name
      network_profile_image
      network_profile_url
      company {
        company_logo
        job_company_name
      }
      engagement_summary {
        engagements
        first_engagement
        last_engagement
        last_engagement_detail {
          network
          engagement_type
          share_url
          content_url
        }
      }
    }
  }
}
    `;
export const useGetOiCtaPeopleQuery = <
      TData = GetOiCtaPeopleQuery,
      TError = unknown
    >(
      variables: GetOiCtaPeopleQueryVariables,
      options?: UseQueryOptions<GetOiCtaPeopleQuery, TError, TData>
    ) =>
    useQuery<GetOiCtaPeopleQuery, TError, TData>(
      ['GET_OI_CTA_PEOPLE', variables],
      transport<GetOiCtaPeopleQuery, GetOiCtaPeopleQueryVariables>(GetOiCtaPeopleDocument, variables),
      options
    );
useGetOiCtaPeopleQuery.document = GetOiCtaPeopleDocument;


useGetOiCtaPeopleQuery.getKey = (variables: GetOiCtaPeopleQueryVariables) => ['GET_OI_CTA_PEOPLE', variables];
;

export const GetOrganicInsightsReportDocument = `
    query GET_ORGANIC_INSIGHTS_REPORT($start: Int!, $end: Int!, $report: ReportNames!, $organic_insights_report_filter: OrganicInsightsReportFilter, $advanced_filters: OrganicInsightsAdvancedFilters) {
  getOrganicInsightReports(
    start: $start
    end: $end
    report: $report
    organic_insights_report_filter: $organic_insights_report_filter
    advanced_filters: $advanced_filters
  )
}
    `;
export const useGetOrganicInsightsReportQuery = <
      TData = GetOrganicInsightsReportQuery,
      TError = unknown
    >(
      variables: GetOrganicInsightsReportQueryVariables,
      options?: UseQueryOptions<GetOrganicInsightsReportQuery, TError, TData>
    ) =>
    useQuery<GetOrganicInsightsReportQuery, TError, TData>(
      ['GET_ORGANIC_INSIGHTS_REPORT', variables],
      transport<GetOrganicInsightsReportQuery, GetOrganicInsightsReportQueryVariables>(GetOrganicInsightsReportDocument, variables),
      options
    );
useGetOrganicInsightsReportQuery.document = GetOrganicInsightsReportDocument;


useGetOrganicInsightsReportQuery.getKey = (variables: GetOrganicInsightsReportQueryVariables) => ['GET_ORGANIC_INSIGHTS_REPORT', variables];
;

export const GetPartnerDetailsDocument = `
    query GET_PARTNER_DETAILS($partner_name: String!) {
  getPartnerDetails(partner_name: $partner_name) {
    partner_name
    redirect_uris
  }
}
    `;
export const useGetPartnerDetailsQuery = <
      TData = GetPartnerDetailsQuery,
      TError = unknown
    >(
      variables: GetPartnerDetailsQueryVariables,
      options?: UseQueryOptions<GetPartnerDetailsQuery, TError, TData>
    ) =>
    useQuery<GetPartnerDetailsQuery, TError, TData>(
      ['GET_PARTNER_DETAILS', variables],
      transport<GetPartnerDetailsQuery, GetPartnerDetailsQueryVariables>(GetPartnerDetailsDocument, variables),
      options
    );
useGetPartnerDetailsQuery.document = GetPartnerDetailsDocument;


useGetPartnerDetailsQuery.getKey = (variables: GetPartnerDetailsQueryVariables) => ['GET_PARTNER_DETAILS', variables];
;

export const GetPeopleNewestDocument = `
    query GET_PEOPLE_NEWEST($start: Int!, $end: Int!, $hide_teammates: Boolean!, $limit: Int, $offset: Int, $ordering: Ordering!, $sort_by: OrganicInsightsSortParam, $advanced_filters: OrganicInsightsAdvancedFilters) {
  getPeople(
    start: $start
    end: $end
    hide_teammates: $hide_teammates
    limit: $limit
    offset: $offset
    ordering: $ordering
    sort_by: $sort_by
    advanced_filters: $advanced_filters
  ) {
    total
    results {
      title
      role
      email_address
      name
      network_profile_url
      network_profile_image
      company {
        company_logo
        job_company_name
      }
      engagement_summary {
        engagements
        first_engagement
        last_engagement
        last_engagement_detail {
          network
          engagement_type
          share_url
          content_url
        }
      }
    }
  }
}
    `;
export const useGetPeopleNewestQuery = <
      TData = GetPeopleNewestQuery,
      TError = unknown
    >(
      variables: GetPeopleNewestQueryVariables,
      options?: UseQueryOptions<GetPeopleNewestQuery, TError, TData>
    ) =>
    useQuery<GetPeopleNewestQuery, TError, TData>(
      ['GET_PEOPLE_NEWEST', variables],
      transport<GetPeopleNewestQuery, GetPeopleNewestQueryVariables>(GetPeopleNewestDocument, variables),
      options
    );
useGetPeopleNewestQuery.document = GetPeopleNewestDocument;


useGetPeopleNewestQuery.getKey = (variables: GetPeopleNewestQueryVariables) => ['GET_PEOPLE_NEWEST', variables];
;

export const GetPeopleTopDocument = `
    query GET_PEOPLE_TOP($start: Int!, $end: Int!, $hide_teammates: Boolean!, $limit: Int, $offset: Int, $ordering: Ordering!, $sort_by: OrganicInsightsSortParam, $advanced_filters: OrganicInsightsAdvancedFilters) {
  getPeople(
    start: $start
    end: $end
    hide_teammates: $hide_teammates
    limit: $limit
    offset: $offset
    ordering: $ordering
    sort_by: $sort_by
    advanced_filters: $advanced_filters
  ) {
    total
    results {
      rank
      title
      role
      email_address
      name
      network_profile_url
      network_profile_image
      company {
        company_logo
        job_company_name
      }
      engagement_summary {
        engagements
        first_engagement
        last_engagement
      }
    }
  }
}
    `;
export const useGetPeopleTopQuery = <
      TData = GetPeopleTopQuery,
      TError = unknown
    >(
      variables: GetPeopleTopQueryVariables,
      options?: UseQueryOptions<GetPeopleTopQuery, TError, TData>
    ) =>
    useQuery<GetPeopleTopQuery, TError, TData>(
      ['GET_PEOPLE_TOP', variables],
      transport<GetPeopleTopQuery, GetPeopleTopQueryVariables>(GetPeopleTopDocument, variables),
      options
    );
useGetPeopleTopQuery.document = GetPeopleTopDocument;


useGetPeopleTopQuery.getKey = (variables: GetPeopleTopQueryVariables) => ['GET_PEOPLE_TOP', variables];
;

export const GetPostedToGroupsDocument = `
    query GET_POSTED_TO_GROUPS {
  contextGetPostedToGroups {
    group_id
    score
  }
}
    `;
export const useGetPostedToGroupsQuery = <
      TData = GetPostedToGroupsQuery,
      TError = unknown
    >(
      variables?: GetPostedToGroupsQueryVariables,
      options?: UseQueryOptions<GetPostedToGroupsQuery, TError, TData>
    ) =>
    useQuery<GetPostedToGroupsQuery, TError, TData>(
      variables === undefined ? ['GET_POSTED_TO_GROUPS'] : ['GET_POSTED_TO_GROUPS', variables],
      transport<GetPostedToGroupsQuery, GetPostedToGroupsQueryVariables>(GetPostedToGroupsDocument, variables),
      options
    );
useGetPostedToGroupsQuery.document = GetPostedToGroupsDocument;


useGetPostedToGroupsQuery.getKey = (variables?: GetPostedToGroupsQueryVariables) => variables === undefined ? ['GET_POSTED_TO_GROUPS'] : ['GET_POSTED_TO_GROUPS', variables];
;

export const GetPublicUserProfileDocument = `
    query GET_PUBLIC_USER_PROFILE($user_id: ID!) {
  getPublicUserProfile(user_id: $user_id) {
    ...PublicUserProfile
  }
}
    ${PublicUserProfileFragmentDoc}`;
export const useGetPublicUserProfileQuery = <
      TData = GetPublicUserProfileQuery,
      TError = unknown
    >(
      variables: GetPublicUserProfileQueryVariables,
      options?: UseQueryOptions<GetPublicUserProfileQuery, TError, TData>
    ) =>
    useQuery<GetPublicUserProfileQuery, TError, TData>(
      ['GET_PUBLIC_USER_PROFILE', variables],
      transport<GetPublicUserProfileQuery, GetPublicUserProfileQueryVariables>(GetPublicUserProfileDocument, variables),
      options
    );
useGetPublicUserProfileQuery.document = GetPublicUserProfileDocument;


useGetPublicUserProfileQuery.getKey = (variables: GetPublicUserProfileQueryVariables) => ['GET_PUBLIC_USER_PROFILE', variables];
;

export const GetSharesItemsDocument = `
    query GET_SHARES_ITEMS($data: ItemsListInput!, $group_by_session: Boolean, $scheduled: Boolean) {
  getSharesItems(
    data: $data
    group_by_session: $group_by_session
    scheduled: $scheduled
  ) {
    count
    paginate
    created_at
    id
    items_by_session {
      ...SharesItem
    }
    items {
      ...SharesItem
    }
  }
}
    ${SharesItemFragmentDoc}`;
export const useGetSharesItemsQuery = <
      TData = GetSharesItemsQuery,
      TError = unknown
    >(
      variables: GetSharesItemsQueryVariables,
      options?: UseQueryOptions<GetSharesItemsQuery, TError, TData>
    ) =>
    useQuery<GetSharesItemsQuery, TError, TData>(
      ['GET_SHARES_ITEMS', variables],
      transport<GetSharesItemsQuery, GetSharesItemsQueryVariables>(GetSharesItemsDocument, variables),
      options
    );
useGetSharesItemsQuery.document = GetSharesItemsDocument;


useGetSharesItemsQuery.getKey = (variables: GetSharesItemsQueryVariables) => ['GET_SHARES_ITEMS', variables];
;

export const GetSharePreviewInfoDocument = `
    query GET_SHARE_PREVIEW_INFO($content_id: String!) {
  getSharePreviewInfo(content_id: $content_id) {
    allowed_counts {
      twitter
      linkedin
      facebook
    }
    suggested_share_time
    shortened_urls {
      email {
        short_link
      }
      direct {
        short_link
      }
      facebook {
        short_link
      }
    }
    locked_commentary
  }
}
    `;
export const useGetSharePreviewInfoQuery = <
      TData = GetSharePreviewInfoQuery,
      TError = unknown
    >(
      variables: GetSharePreviewInfoQueryVariables,
      options?: UseQueryOptions<GetSharePreviewInfoQuery, TError, TData>
    ) =>
    useQuery<GetSharePreviewInfoQuery, TError, TData>(
      ['GET_SHARE_PREVIEW_INFO', variables],
      transport<GetSharePreviewInfoQuery, GetSharePreviewInfoQueryVariables>(GetSharePreviewInfoDocument, variables),
      options
    );
useGetSharePreviewInfoQuery.document = GetSharePreviewInfoDocument;


useGetSharePreviewInfoQuery.getKey = (variables: GetSharePreviewInfoQueryVariables) => ['GET_SHARE_PREVIEW_INFO', variables];
;

export const GetTrackingDetailsDocument = `
    query GET_TRACKING_DETAILS($event_name: SegmentEventType!, $user_id: ID!) {
  getTrackingDetails(event_name: $event_name, user_id: $user_id) {
    ...SegmentEventDetails
  }
}
    ${SegmentEventDetailsFragmentDoc}`;
export const useGetTrackingDetailsQuery = <
      TData = GetTrackingDetailsQuery,
      TError = unknown
    >(
      variables: GetTrackingDetailsQueryVariables,
      options?: UseQueryOptions<GetTrackingDetailsQuery, TError, TData>
    ) =>
    useQuery<GetTrackingDetailsQuery, TError, TData>(
      ['GET_TRACKING_DETAILS', variables],
      transport<GetTrackingDetailsQuery, GetTrackingDetailsQueryVariables>(GetTrackingDetailsDocument, variables),
      options
    );
useGetTrackingDetailsQuery.document = GetTrackingDetailsDocument;


useGetTrackingDetailsQuery.getKey = (variables: GetTrackingDetailsQueryVariables) => ['GET_TRACKING_DETAILS', variables];
;

export const GetUsersByEmailAddressDocument = `
    query GET_USERS_BY_EMAIL_ADDRESS($email_address_list: [String]!) {
  getUsersByEmailAddress(email_address_list: $email_address_list) {
    id
    client_id
    full_name
    email_address
    image {
      bucket
      key
    }
  }
}
    `;
export const useGetUsersByEmailAddressQuery = <
      TData = GetUsersByEmailAddressQuery,
      TError = unknown
    >(
      variables: GetUsersByEmailAddressQueryVariables,
      options?: UseQueryOptions<GetUsersByEmailAddressQuery, TError, TData>
    ) =>
    useQuery<GetUsersByEmailAddressQuery, TError, TData>(
      ['GET_USERS_BY_EMAIL_ADDRESS', variables],
      transport<GetUsersByEmailAddressQuery, GetUsersByEmailAddressQueryVariables>(GetUsersByEmailAddressDocument, variables),
      options
    );
useGetUsersByEmailAddressQuery.document = GetUsersByEmailAddressDocument;


useGetUsersByEmailAddressQuery.getKey = (variables: GetUsersByEmailAddressQueryVariables) => ['GET_USERS_BY_EMAIL_ADDRESS', variables];
;

export const GetUserClientsDocument = `
    query GET_USER_CLIENTS($last_evaluated_key: String) {
  getUserClients(last_evaluated_key: $last_evaluated_key) {
    last_evaluated_key
    count
    items {
      user_client_status
      client {
        ...ClientProtected
      }
    }
  }
}
    ${ClientProtectedFragmentDoc}`;
export const useGetUserClientsQuery = <
      TData = GetUserClientsQuery,
      TError = unknown
    >(
      variables?: GetUserClientsQueryVariables,
      options?: UseQueryOptions<GetUserClientsQuery, TError, TData>
    ) =>
    useQuery<GetUserClientsQuery, TError, TData>(
      variables === undefined ? ['GET_USER_CLIENTS'] : ['GET_USER_CLIENTS', variables],
      transport<GetUserClientsQuery, GetUserClientsQueryVariables>(GetUserClientsDocument, variables),
      options
    );
useGetUserClientsQuery.document = GetUserClientsDocument;


useGetUserClientsQuery.getKey = (variables?: GetUserClientsQueryVariables) => variables === undefined ? ['GET_USER_CLIENTS'] : ['GET_USER_CLIENTS', variables];
;

export const GetUserClientFollowMappingsDocument = `
    query GET_USER_CLIENT_FOLLOW_MAPPINGS {
  getUserClientFollowMappings {
    suggested_groups {
      ...Group
    }
    suggested_users {
      ...PublicUserProfile
    }
  }
}
    ${GroupFragmentDoc}
${PublicUserProfileFragmentDoc}`;
export const useGetUserClientFollowMappingsQuery = <
      TData = GetUserClientFollowMappingsQuery,
      TError = unknown
    >(
      variables?: GetUserClientFollowMappingsQueryVariables,
      options?: UseQueryOptions<GetUserClientFollowMappingsQuery, TError, TData>
    ) =>
    useQuery<GetUserClientFollowMappingsQuery, TError, TData>(
      variables === undefined ? ['GET_USER_CLIENT_FOLLOW_MAPPINGS'] : ['GET_USER_CLIENT_FOLLOW_MAPPINGS', variables],
      transport<GetUserClientFollowMappingsQuery, GetUserClientFollowMappingsQueryVariables>(GetUserClientFollowMappingsDocument, variables),
      options
    );
useGetUserClientFollowMappingsQuery.document = GetUserClientFollowMappingsDocument;


useGetUserClientFollowMappingsQuery.getKey = (variables?: GetUserClientFollowMappingsQueryVariables) => variables === undefined ? ['GET_USER_CLIENT_FOLLOW_MAPPINGS'] : ['GET_USER_CLIENT_FOLLOW_MAPPINGS', variables];
;

export const GetUserReachGraphDataDocument = `
    query GET_USER_REACH_GRAPH_DATA($start_date: String!, $end_date: String!) {
  getUserReachGraphData(start_date: $start_date, end_date: $end_date) {
    data {
      calendar_day
      linkedin_reach
      twitter_reach
    }
    summary {
      linkedin_reach {
        change
        count
      }
      total_reach {
        change
        count
      }
      twitter_reach {
        change
        count
      }
    }
  }
}
    `;
export const useGetUserReachGraphDataQuery = <
      TData = GetUserReachGraphDataQuery,
      TError = unknown
    >(
      variables: GetUserReachGraphDataQueryVariables,
      options?: UseQueryOptions<GetUserReachGraphDataQuery, TError, TData>
    ) =>
    useQuery<GetUserReachGraphDataQuery, TError, TData>(
      ['GET_USER_REACH_GRAPH_DATA', variables],
      transport<GetUserReachGraphDataQuery, GetUserReachGraphDataQueryVariables>(GetUserReachGraphDataDocument, variables),
      options
    );
useGetUserReachGraphDataQuery.document = GetUserReachGraphDataDocument;


useGetUserReachGraphDataQuery.getKey = (variables: GetUserReachGraphDataQueryVariables) => ['GET_USER_REACH_GRAPH_DATA', variables];
;

export const GetUserRoiValuesDocument = `
    query GET_USER_ROI_VALUES($user_id: ID!) {
  getUserROIValues(user_id: $user_id) {
    reach_twitter
    reach_linkedin
    clicks_twitter
    clicks_linkedin
    clicks_facebook
    engagements_twitter
    engagements_linkedin
    engagements_facebook
    impressions_twitter
    impressions_linkedin
  }
}
    `;
export const useGetUserRoiValuesQuery = <
      TData = GetUserRoiValuesQuery,
      TError = unknown
    >(
      variables: GetUserRoiValuesQueryVariables,
      options?: UseQueryOptions<GetUserRoiValuesQuery, TError, TData>
    ) =>
    useQuery<GetUserRoiValuesQuery, TError, TData>(
      ['GET_USER_ROI_VALUES', variables],
      transport<GetUserRoiValuesQuery, GetUserRoiValuesQueryVariables>(GetUserRoiValuesDocument, variables),
      options
    );
useGetUserRoiValuesQuery.document = GetUserRoiValuesDocument;


useGetUserRoiValuesQuery.getKey = (variables: GetUserRoiValuesQueryVariables) => ['GET_USER_ROI_VALUES', variables];
;

export const GetUserSearchesDocument = `
    query GET_USER_SEARCHES($limit: Int!) {
  getUserSearches(limit: $limit)
}
    `;
export const useGetUserSearchesQuery = <
      TData = GetUserSearchesQuery,
      TError = unknown
    >(
      variables: GetUserSearchesQueryVariables,
      options?: UseQueryOptions<GetUserSearchesQuery, TError, TData>
    ) =>
    useQuery<GetUserSearchesQuery, TError, TData>(
      ['GET_USER_SEARCHES', variables],
      transport<GetUserSearchesQuery, GetUserSearchesQueryVariables>(GetUserSearchesDocument, variables),
      options
    );
useGetUserSearchesQuery.document = GetUserSearchesDocument;


useGetUserSearchesQuery.getKey = (variables: GetUserSearchesQueryVariables) => ['GET_USER_SEARCHES', variables];
;

export const GetUserSearchesV2Document = `
    query GET_USER_SEARCHES_V2($q: String, $user_status: UserStatus, $user_type: UserType, $size: Int, $next_id: String, $sort: SearchSortFieldsV2, $client_id: String, $department_ids: [ID!], $location_ids: [ID!], $active: Boolean, $onboarding_completed: Boolean) {
  getUserSearchesV2(
    q: $q
    user_status: $user_status
    user_type: $user_type
    size: $size
    next_id: $next_id
    sort: $sort
    client_id: $client_id
    department_ids: $department_ids
    location_ids: $location_ids
    active: $active
    onboarding_completed: $onboarding_completed
  ) {
    total_count
    next_id
    results {
      ...UserProfileSearch
    }
  }
}
    ${UserProfileSearchFragmentDoc}`;
export const useGetUserSearchesV2Query = <
      TData = GetUserSearchesV2Query,
      TError = unknown
    >(
      variables?: GetUserSearchesV2QueryVariables,
      options?: UseQueryOptions<GetUserSearchesV2Query, TError, TData>
    ) =>
    useQuery<GetUserSearchesV2Query, TError, TData>(
      variables === undefined ? ['GET_USER_SEARCHES_V2'] : ['GET_USER_SEARCHES_V2', variables],
      transport<GetUserSearchesV2Query, GetUserSearchesV2QueryVariables>(GetUserSearchesV2Document, variables),
      options
    );
useGetUserSearchesV2Query.document = GetUserSearchesV2Document;


useGetUserSearchesV2Query.getKey = (variables?: GetUserSearchesV2QueryVariables) => variables === undefined ? ['GET_USER_SEARCHES_V2'] : ['GET_USER_SEARCHES_V2', variables];
;

export const GetUserSegmentsDocument = `
    query GET_USER_SEGMENTS($segment_status: SegmentStatus) {
  getUserSegments(segment_status: $segment_status) {
    ...UserSegment
  }
}
    ${UserSegmentFragmentDoc}`;
export const useGetUserSegmentsQuery = <
      TData = GetUserSegmentsQuery,
      TError = unknown
    >(
      variables?: GetUserSegmentsQueryVariables,
      options?: UseQueryOptions<GetUserSegmentsQuery, TError, TData>
    ) =>
    useQuery<GetUserSegmentsQuery, TError, TData>(
      variables === undefined ? ['GET_USER_SEGMENTS'] : ['GET_USER_SEGMENTS', variables],
      transport<GetUserSegmentsQuery, GetUserSegmentsQueryVariables>(GetUserSegmentsDocument, variables),
      options
    );
useGetUserSegmentsQuery.document = GetUserSegmentsDocument;


useGetUserSegmentsQuery.getKey = (variables?: GetUserSegmentsQueryVariables) => variables === undefined ? ['GET_USER_SEGMENTS'] : ['GET_USER_SEGMENTS', variables];
;

export const GetUserSegmentOthersPresignedUrlDocument = `
    query GET_USER_SEGMENT_OTHERS_PRESIGNED_URL($id: ID!) {
  getUserSegmentOthersPresignedUrl(id: $id) {
    url
  }
}
    `;
export const useGetUserSegmentOthersPresignedUrlQuery = <
      TData = GetUserSegmentOthersPresignedUrlQuery,
      TError = unknown
    >(
      variables: GetUserSegmentOthersPresignedUrlQueryVariables,
      options?: UseQueryOptions<GetUserSegmentOthersPresignedUrlQuery, TError, TData>
    ) =>
    useQuery<GetUserSegmentOthersPresignedUrlQuery, TError, TData>(
      ['GET_USER_SEGMENT_OTHERS_PRESIGNED_URL', variables],
      transport<GetUserSegmentOthersPresignedUrlQuery, GetUserSegmentOthersPresignedUrlQueryVariables>(GetUserSegmentOthersPresignedUrlDocument, variables),
      options
    );
useGetUserSegmentOthersPresignedUrlQuery.document = GetUserSegmentOthersPresignedUrlDocument;


useGetUserSegmentOthersPresignedUrlQuery.getKey = (variables: GetUserSegmentOthersPresignedUrlQueryVariables) => ['GET_USER_SEGMENT_OTHERS_PRESIGNED_URL', variables];
;

export const GetUserSocialConnectionsDocument = `
    query GET_USER_SOCIAL_CONNECTIONS($user_id: String!) {
  getUserSocialConnections(user_id: $user_id) {
    count
    items {
      ...SocialAccount
    }
  }
}
    ${SocialAccountFragmentDoc}`;
export const useGetUserSocialConnectionsQuery = <
      TData = GetUserSocialConnectionsQuery,
      TError = unknown
    >(
      variables: GetUserSocialConnectionsQueryVariables,
      options?: UseQueryOptions<GetUserSocialConnectionsQuery, TError, TData>
    ) =>
    useQuery<GetUserSocialConnectionsQuery, TError, TData>(
      ['GET_USER_SOCIAL_CONNECTIONS', variables],
      transport<GetUserSocialConnectionsQuery, GetUserSocialConnectionsQueryVariables>(GetUserSocialConnectionsDocument, variables),
      options
    );
useGetUserSocialConnectionsQuery.document = GetUserSocialConnectionsDocument;


useGetUserSocialConnectionsQuery.getKey = (variables: GetUserSocialConnectionsQueryVariables) => ['GET_USER_SOCIAL_CONNECTIONS', variables];
;

export const GetWebhookListDocument = `
    query GET_WEBHOOK_LIST {
  getWebhookList {
    webhooks {
      ...Webhook
    }
  }
}
    ${WebhookFragmentDoc}`;
export const useGetWebhookListQuery = <
      TData = GetWebhookListQuery,
      TError = unknown
    >(
      variables?: GetWebhookListQueryVariables,
      options?: UseQueryOptions<GetWebhookListQuery, TError, TData>
    ) =>
    useQuery<GetWebhookListQuery, TError, TData>(
      variables === undefined ? ['GET_WEBHOOK_LIST'] : ['GET_WEBHOOK_LIST', variables],
      transport<GetWebhookListQuery, GetWebhookListQueryVariables>(GetWebhookListDocument, variables),
      options
    );
useGetWebhookListQuery.document = GetWebhookListDocument;


useGetWebhookListQuery.getKey = (variables?: GetWebhookListQueryVariables) => variables === undefined ? ['GET_WEBHOOK_LIST'] : ['GET_WEBHOOK_LIST', variables];
;

export const GroupOverviewStatsDocument = `
    query GROUP_OVERVIEW_STATS($client_id: ID!, $end_date: String!, $start_date: String!, $page: Int, $per_page: Int, $snapshot: Boolean, $sort: GroupsSortFields, $sort_direction: SortDirections, $report: ReportNames, $filter: ReportingFilter) {
  sortedGroups(
    client_id: $client_id
    end_date: $end_date
    start_date: $start_date
    page: $page
    per_page: $per_page
    snapshot: $snapshot
    sort: $sort
    sort_direction: $sort_direction
    report: $report
    filter: $filter
  ) {
    title
    members
    created_at
    group_id
    created_by
    posts
  }
}
    `;
export const useGroupOverviewStatsQuery = <
      TData = GroupOverviewStatsQuery,
      TError = unknown
    >(
      variables: GroupOverviewStatsQueryVariables,
      options?: UseQueryOptions<GroupOverviewStatsQuery, TError, TData>
    ) =>
    useQuery<GroupOverviewStatsQuery, TError, TData>(
      ['GROUP_OVERVIEW_STATS', variables],
      transport<GroupOverviewStatsQuery, GroupOverviewStatsQueryVariables>(GroupOverviewStatsDocument, variables),
      options
    );
useGroupOverviewStatsQuery.document = GroupOverviewStatsDocument;


useGroupOverviewStatsQuery.getKey = (variables: GroupOverviewStatsQueryVariables) => ['GROUP_OVERVIEW_STATS', variables];
;

export const InternalOverviewStatsDocument = `
    query INTERNAL_OVERVIEW_STATS($client_id: ID!, $end_date: String!, $start_date: String!) {
  internalOverviewStats(
    client_id: $client_id
    end_date: $end_date
    start_date: $start_date
  ) {
    summary {
      posts {
        count
        change
      }
      users {
        count
        change
      }
      comments {
        count
        change
      }
      reactions {
        count
        change
      }
      groups {
        count
        change
      }
    }
    data {
      calendar_day
      active_groups_count
      inactive_groups_count
      daily_active_users
      daily_inactive_users
      branded_posts
      non_branded_posts
      branded_comments_count
      non_branded_comments_count
      branded_reactions_count
      non_branded_reactions_count
    }
  }
}
    `;
export const useInternalOverviewStatsQuery = <
      TData = InternalOverviewStatsQuery,
      TError = unknown
    >(
      variables: InternalOverviewStatsQueryVariables,
      options?: UseQueryOptions<InternalOverviewStatsQuery, TError, TData>
    ) =>
    useQuery<InternalOverviewStatsQuery, TError, TData>(
      ['INTERNAL_OVERVIEW_STATS', variables],
      transport<InternalOverviewStatsQuery, InternalOverviewStatsQueryVariables>(InternalOverviewStatsDocument, variables),
      options
    );
useInternalOverviewStatsQuery.document = InternalOverviewStatsDocument;


useInternalOverviewStatsQuery.getKey = (variables: InternalOverviewStatsQueryVariables) => ['INTERNAL_OVERVIEW_STATS', variables];
;

export const LeaderboardOverviewStatsDocument = `
    query LEADERBOARD_OVERVIEW_STATS($client_id: ID!, $leaderboard_config_id: ID!, $start_date: String!, $end_date: String!, $per_page: Int, $page: Int, $report: ReportNames) {
  sortedLeaderboards(
    client_id: $client_id
    leaderboard_config_id: $leaderboard_config_id
    start_date: $start_date
    end_date: $end_date
    per_page: $per_page
    page: $page
    report: $report
  ) {
    user_id
    rank
    name
    location
    department
    score
    last_seen_at
  }
}
    `;
export const useLeaderboardOverviewStatsQuery = <
      TData = LeaderboardOverviewStatsQuery,
      TError = unknown
    >(
      variables: LeaderboardOverviewStatsQueryVariables,
      options?: UseQueryOptions<LeaderboardOverviewStatsQuery, TError, TData>
    ) =>
    useQuery<LeaderboardOverviewStatsQuery, TError, TData>(
      ['LEADERBOARD_OVERVIEW_STATS', variables],
      transport<LeaderboardOverviewStatsQuery, LeaderboardOverviewStatsQueryVariables>(LeaderboardOverviewStatsDocument, variables),
      options
    );
useLeaderboardOverviewStatsQuery.document = LeaderboardOverviewStatsDocument;


useLeaderboardOverviewStatsQuery.getKey = (variables: LeaderboardOverviewStatsQueryVariables) => ['LEADERBOARD_OVERVIEW_STATS', variables];
;

export const OauthClientDetailsDocument = `
    query OAUTH_CLIENT_DETAILS($data: OauthClientInput!) {
  oauthClientDetails(data: $data) {
    oauth_client_id
    oauth_client_name
    oauth_client_logo_url
    oauth_client_description
  }
}
    `;
export const useOauthClientDetailsQuery = <
      TData = OauthClientDetailsQuery,
      TError = unknown
    >(
      variables: OauthClientDetailsQueryVariables,
      options?: UseQueryOptions<OauthClientDetailsQuery, TError, TData>
    ) =>
    useQuery<OauthClientDetailsQuery, TError, TData>(
      ['OAUTH_CLIENT_DETAILS', variables],
      transport<OauthClientDetailsQuery, OauthClientDetailsQueryVariables>(OauthClientDetailsDocument, variables),
      options
    );
useOauthClientDetailsQuery.document = OauthClientDetailsDocument;


useOauthClientDetailsQuery.getKey = (variables: OauthClientDetailsQueryVariables) => ['OAUTH_CLIENT_DETAILS', variables];
;

export const OauthUserIntegrationsDocument = `
    query OAUTH_USER_INTEGRATIONS {
  oauthUserIntegrations {
    oauth_client_id
    oauth_client_name
    oauth_client_logo_url
    oauth_client_description
  }
}
    `;
export const useOauthUserIntegrationsQuery = <
      TData = OauthUserIntegrationsQuery,
      TError = unknown
    >(
      variables?: OauthUserIntegrationsQueryVariables,
      options?: UseQueryOptions<OauthUserIntegrationsQuery, TError, TData>
    ) =>
    useQuery<OauthUserIntegrationsQuery, TError, TData>(
      variables === undefined ? ['OAUTH_USER_INTEGRATIONS'] : ['OAUTH_USER_INTEGRATIONS', variables],
      transport<OauthUserIntegrationsQuery, OauthUserIntegrationsQueryVariables>(OauthUserIntegrationsDocument, variables),
      options
    );
useOauthUserIntegrationsQuery.document = OauthUserIntegrationsDocument;


useOauthUserIntegrationsQuery.getKey = (variables?: OauthUserIntegrationsQueryVariables) => variables === undefined ? ['OAUTH_USER_INTEGRATIONS'] : ['OAUTH_USER_INTEGRATIONS', variables];
;

export const PostOverviewStatsDocument = `
    query POST_OVERVIEW_STATS($client_id: ID!, $end_date: String!, $start_date: String!, $page: Int, $per_page: Int, $snapshot: Boolean, $sort: PostsSortFields, $sort_direction: SortDirections, $report: ReportNames, $filter: ReportingFilter) {
  sortedPosts(
    client_id: $client_id
    end_date: $end_date
    start_date: $start_date
    page: $page
    per_page: $per_page
    snapshot: $snapshot
    sort: $sort
    sort_direction: $sort_direction
    report: $report
    filter: $filter
  ) {
    content_id
    title
    shares
    reactions
    comments
    created_at
    submitted_by
    approved_by
    branded
  }
}
    `;
export const usePostOverviewStatsQuery = <
      TData = PostOverviewStatsQuery,
      TError = unknown
    >(
      variables: PostOverviewStatsQueryVariables,
      options?: UseQueryOptions<PostOverviewStatsQuery, TError, TData>
    ) =>
    useQuery<PostOverviewStatsQuery, TError, TData>(
      ['POST_OVERVIEW_STATS', variables],
      transport<PostOverviewStatsQuery, PostOverviewStatsQueryVariables>(PostOverviewStatsDocument, variables),
      options
    );
usePostOverviewStatsQuery.document = PostOverviewStatsDocument;


usePostOverviewStatsQuery.getKey = (variables: PostOverviewStatsQueryVariables) => ['POST_OVERVIEW_STATS', variables];
;

export const PreviewUrlDocument = `
    query PREVIEW_URL($url: String!, $group_id: ID!, $app_source: String!) {
  previewURL(
    content: {group_ids: [$group_id], content_source_id: "manual", content_object: {url: $url, post_type: url}}
    app_source: $app_source
  ) {
    is_engageable
    is_branded
    disclosures {
      ...ContentDisclosures
    }
    content_object {
      ...ContentObject
    }
    default_engageable
    default_shareable
    is_network
  }
}
    ${ContentDisclosuresFragmentDoc}
${ContentObjectFragmentDoc}`;
export const usePreviewUrlQuery = <
      TData = PreviewUrlQuery,
      TError = unknown
    >(
      variables: PreviewUrlQueryVariables,
      options?: UseQueryOptions<PreviewUrlQuery, TError, TData>
    ) =>
    useQuery<PreviewUrlQuery, TError, TData>(
      ['PREVIEW_URL', variables],
      transport<PreviewUrlQuery, PreviewUrlQueryVariables>(PreviewUrlDocument, variables),
      options
    );
usePreviewUrlQuery.document = PreviewUrlDocument;


usePreviewUrlQuery.getKey = (variables: PreviewUrlQueryVariables) => ['PREVIEW_URL', variables];
;

export const RoiClicksOverviewStatsDocument = `
    query ROI_CLICKS_OVERVIEW_STATS($client_id: ID!, $end_date: String!, $start_date: String!, $linkedin_currency_value: Float, $twitter_currency_value: Float, $facebook_currency_value: Float) {
  roiClicksOverviewStats(
    client_id: $client_id
    end_date: $end_date
    start_date: $start_date
    linkedin_currency_value: $linkedin_currency_value
    twitter_currency_value: $twitter_currency_value
    facebook_currency_value: $facebook_currency_value
  ) {
    summary {
      ...ROIIndividualStat
    }
    data {
      ...ROIDailyStat
    }
  }
}
    ${RoiIndividualStatFragmentDoc}
${RoiDailyStatFragmentDoc}`;
export const useRoiClicksOverviewStatsQuery = <
      TData = RoiClicksOverviewStatsQuery,
      TError = unknown
    >(
      variables: RoiClicksOverviewStatsQueryVariables,
      options?: UseQueryOptions<RoiClicksOverviewStatsQuery, TError, TData>
    ) =>
    useQuery<RoiClicksOverviewStatsQuery, TError, TData>(
      ['ROI_CLICKS_OVERVIEW_STATS', variables],
      transport<RoiClicksOverviewStatsQuery, RoiClicksOverviewStatsQueryVariables>(RoiClicksOverviewStatsDocument, variables),
      options
    );
useRoiClicksOverviewStatsQuery.document = RoiClicksOverviewStatsDocument;


useRoiClicksOverviewStatsQuery.getKey = (variables: RoiClicksOverviewStatsQueryVariables) => ['ROI_CLICKS_OVERVIEW_STATS', variables];
;

export const RoiEngagementsOverviewStatsDocument = `
    query ROI_ENGAGEMENTS_OVERVIEW_STATS($client_id: ID!, $end_date: String!, $start_date: String!, $linkedin_currency_value: Float, $twitter_currency_value: Float, $facebook_currency_value: Float) {
  roiEngagementsOverviewStats(
    client_id: $client_id
    end_date: $end_date
    start_date: $start_date
    linkedin_currency_value: $linkedin_currency_value
    twitter_currency_value: $twitter_currency_value
    facebook_currency_value: $facebook_currency_value
  ) {
    summary {
      ...ROIIndividualStat
    }
    data {
      ...ROIDailyStat
    }
  }
}
    ${RoiIndividualStatFragmentDoc}
${RoiDailyStatFragmentDoc}`;
export const useRoiEngagementsOverviewStatsQuery = <
      TData = RoiEngagementsOverviewStatsQuery,
      TError = unknown
    >(
      variables: RoiEngagementsOverviewStatsQueryVariables,
      options?: UseQueryOptions<RoiEngagementsOverviewStatsQuery, TError, TData>
    ) =>
    useQuery<RoiEngagementsOverviewStatsQuery, TError, TData>(
      ['ROI_ENGAGEMENTS_OVERVIEW_STATS', variables],
      transport<RoiEngagementsOverviewStatsQuery, RoiEngagementsOverviewStatsQueryVariables>(RoiEngagementsOverviewStatsDocument, variables),
      options
    );
useRoiEngagementsOverviewStatsQuery.document = RoiEngagementsOverviewStatsDocument;


useRoiEngagementsOverviewStatsQuery.getKey = (variables: RoiEngagementsOverviewStatsQueryVariables) => ['ROI_ENGAGEMENTS_OVERVIEW_STATS', variables];
;

export const RoiImpressionsOverviewStatsDocument = `
    query ROI_IMPRESSIONS_OVERVIEW_STATS($client_id: ID!, $end_date: String!, $start_date: String!, $linkedin_currency_value: Float, $twitter_currency_value: Float) {
  roiImpressionsOverviewStats(
    client_id: $client_id
    end_date: $end_date
    start_date: $start_date
    linkedin_currency_value: $linkedin_currency_value
    twitter_currency_value: $twitter_currency_value
  ) {
    summary {
      ...ROIIndividualStat
    }
    data {
      ...ROIDailyStat
    }
  }
}
    ${RoiIndividualStatFragmentDoc}
${RoiDailyStatFragmentDoc}`;
export const useRoiImpressionsOverviewStatsQuery = <
      TData = RoiImpressionsOverviewStatsQuery,
      TError = unknown
    >(
      variables: RoiImpressionsOverviewStatsQueryVariables,
      options?: UseQueryOptions<RoiImpressionsOverviewStatsQuery, TError, TData>
    ) =>
    useQuery<RoiImpressionsOverviewStatsQuery, TError, TData>(
      ['ROI_IMPRESSIONS_OVERVIEW_STATS', variables],
      transport<RoiImpressionsOverviewStatsQuery, RoiImpressionsOverviewStatsQueryVariables>(RoiImpressionsOverviewStatsDocument, variables),
      options
    );
useRoiImpressionsOverviewStatsQuery.document = RoiImpressionsOverviewStatsDocument;


useRoiImpressionsOverviewStatsQuery.getKey = (variables: RoiImpressionsOverviewStatsQueryVariables) => ['ROI_IMPRESSIONS_OVERVIEW_STATS', variables];
;

export const RoiReachOverviewStatsDocument = `
    query ROI_REACH_OVERVIEW_STATS($client_id: ID!, $end_date: String!, $start_date: String!, $linkedin_currency_value: Float, $twitter_currency_value: Float) {
  roiReachOverviewStats(
    client_id: $client_id
    end_date: $end_date
    start_date: $start_date
    linkedin_currency_value: $linkedin_currency_value
    twitter_currency_value: $twitter_currency_value
  ) {
    summary {
      ...ROIIndividualStat
    }
    data {
      ...ROIDailyStat
    }
  }
}
    ${RoiIndividualStatFragmentDoc}
${RoiDailyStatFragmentDoc}`;
export const useRoiReachOverviewStatsQuery = <
      TData = RoiReachOverviewStatsQuery,
      TError = unknown
    >(
      variables: RoiReachOverviewStatsQueryVariables,
      options?: UseQueryOptions<RoiReachOverviewStatsQuery, TError, TData>
    ) =>
    useQuery<RoiReachOverviewStatsQuery, TError, TData>(
      ['ROI_REACH_OVERVIEW_STATS', variables],
      transport<RoiReachOverviewStatsQuery, RoiReachOverviewStatsQueryVariables>(RoiReachOverviewStatsDocument, variables),
      options
    );
useRoiReachOverviewStatsQuery.document = RoiReachOverviewStatsDocument;


useRoiReachOverviewStatsQuery.getKey = (variables: RoiReachOverviewStatsQueryVariables) => ['ROI_REACH_OVERVIEW_STATS', variables];
;

export const SearchDocument = `
    query SEARCH($size: Int!, $results_from: Int!, $q: String) {
  search(
    documents: [groups, profiles, content]
    size: $size
    results_from: $results_from
    q: $q
    q_documents_must_match: [groups, profiles, content]
    auto_exclude: true
  ) {
    count
    results_from
    results {
      ... on Group {
        id
        title
        follower_count
        department_title
        location_title
      }
      ... on PublicUserProfile {
        id
        full_name
        follower_count
        department_title
        location_title
        location {
          id
          title
          block_message
        }
      }
      ... on Content {
        content_id
        publish_at
        groups {
          ...GetFeedGroup
        }
        user {
          id
          full_name
        }
        content_object {
          body
          url
          url_metadata {
            provider_name
            title
            description
          }
          photos {
            bucket
          }
        }
      }
    }
  }
}
    ${GetFeedGroupFragmentDoc}`;
export const useSearchQuery = <
      TData = SearchQuery,
      TError = unknown
    >(
      variables: SearchQueryVariables,
      options?: UseQueryOptions<SearchQuery, TError, TData>
    ) =>
    useQuery<SearchQuery, TError, TData>(
      ['SEARCH', variables],
      transport<SearchQuery, SearchQueryVariables>(SearchDocument, variables),
      options
    );
useSearchQuery.document = SearchDocument;


useSearchQuery.getKey = (variables: SearchQueryVariables) => ['SEARCH', variables];
;

export const SearchGroupsDocument = `
    query SEARCH_GROUPS($size: Int!, $results_from: Int!, $q: String, $auto_exclude: Boolean, $sort: SearchSortFields, $sort_direction: SearchSortDirections, $required_location_id: ID, $required_department_id: ID, $exclude_group_ids: [ID]) {
  search(
    documents: [groups]
    size: $size
    results_from: $results_from
    q: $q
    q_documents_must_match: [groups]
    auto_exclude: $auto_exclude
    sort: $sort
    sort_direction: $sort_direction
    required_location_id: $required_location_id
    required_department_id: $required_department_id
    exclude_group_ids: $exclude_group_ids
  ) {
    ...GroupSearchResults
  }
}
    ${GroupSearchResultsFragmentDoc}`;
export const useSearchGroupsQuery = <
      TData = SearchGroupsQuery,
      TError = unknown
    >(
      variables: SearchGroupsQueryVariables,
      options?: UseQueryOptions<SearchGroupsQuery, TError, TData>
    ) =>
    useQuery<SearchGroupsQuery, TError, TData>(
      ['SEARCH_GROUPS', variables],
      transport<SearchGroupsQuery, SearchGroupsQueryVariables>(SearchGroupsDocument, variables),
      options
    );
useSearchGroupsQuery.document = SearchGroupsDocument;


useSearchGroupsQuery.getKey = (variables: SearchGroupsQueryVariables) => ['SEARCH_GROUPS', variables];
;

export const SearchPeopleDocument = `
    query SEARCH_PEOPLE($size: Int!, $results_from: Int!, $q: String, $auto_exclude: Boolean, $sort: SearchSortFields, $sort_direction: SearchSortDirections, $required_location_id: ID, $required_department_id: ID, $override: OverrideInput) {
  search(
    documents: [profiles]
    size: $size
    results_from: $results_from
    q: $q
    q_documents_must_match: [profiles]
    auto_exclude: $auto_exclude
    sort: $sort
    sort_direction: $sort_direction
    required_location_id: $required_location_id
    required_department_id: $required_department_id
    override: $override
  ) {
    ...ProfileSearchResults
  }
}
    ${ProfileSearchResultsFragmentDoc}`;
export const useSearchPeopleQuery = <
      TData = SearchPeopleQuery,
      TError = unknown
    >(
      variables: SearchPeopleQueryVariables,
      options?: UseQueryOptions<SearchPeopleQuery, TError, TData>
    ) =>
    useQuery<SearchPeopleQuery, TError, TData>(
      ['SEARCH_PEOPLE', variables],
      transport<SearchPeopleQuery, SearchPeopleQueryVariables>(SearchPeopleDocument, variables),
      options
    );
useSearchPeopleQuery.document = SearchPeopleDocument;


useSearchPeopleQuery.getKey = (variables: SearchPeopleQueryVariables) => ['SEARCH_PEOPLE', variables];
;

export const SearchAggregatesDocument = `
    query SEARCH_AGGREGATES($document: SearchDocuments!) {
  searchAggregates(document: $document) {
    ...SearchAggregates
  }
}
    ${SearchAggregatesFragmentDoc}`;
export const useSearchAggregatesQuery = <
      TData = SearchAggregatesQuery,
      TError = unknown
    >(
      variables: SearchAggregatesQueryVariables,
      options?: UseQueryOptions<SearchAggregatesQuery, TError, TData>
    ) =>
    useQuery<SearchAggregatesQuery, TError, TData>(
      ['SEARCH_AGGREGATES', variables],
      transport<SearchAggregatesQuery, SearchAggregatesQueryVariables>(SearchAggregatesDocument, variables),
      options
    );
useSearchAggregatesQuery.document = SearchAggregatesDocument;


useSearchAggregatesQuery.getKey = (variables: SearchAggregatesQueryVariables) => ['SEARCH_AGGREGATES', variables];
;

export const SearchClientInvitationsDocument = `
    query SEARCH_CLIENT_INVITATIONS($search_filter: ClientInvitationSearchFilter, $count: Boolean, $limit: Int, $last_evaluated_key: String, $report: Boolean) {
  searchClientInvitations(
    search_filter: $search_filter
    count: $count
    limit: $limit
    last_evaluated_key: $last_evaluated_key
    report: $report
  ) {
    count
    items {
      ...ClientInvitation
    }
    last_evaluated_key
  }
}
    ${ClientInvitationFragmentDoc}`;
export const useSearchClientInvitationsQuery = <
      TData = SearchClientInvitationsQuery,
      TError = unknown
    >(
      variables?: SearchClientInvitationsQueryVariables,
      options?: UseQueryOptions<SearchClientInvitationsQuery, TError, TData>
    ) =>
    useQuery<SearchClientInvitationsQuery, TError, TData>(
      variables === undefined ? ['SEARCH_CLIENT_INVITATIONS'] : ['SEARCH_CLIENT_INVITATIONS', variables],
      transport<SearchClientInvitationsQuery, SearchClientInvitationsQueryVariables>(SearchClientInvitationsDocument, variables),
      options
    );
useSearchClientInvitationsQuery.document = SearchClientInvitationsDocument;


useSearchClientInvitationsQuery.getKey = (variables?: SearchClientInvitationsQueryVariables) => variables === undefined ? ['SEARCH_CLIENT_INVITATIONS'] : ['SEARCH_CLIENT_INVITATIONS', variables];
;

export const SearchCompaniesDocument = `
    query SEARCH_COMPANIES($query: String!) {
  searchCompanies(query: $query) {
    company_id
    name
  }
}
    `;
export const useSearchCompaniesQuery = <
      TData = SearchCompaniesQuery,
      TError = unknown
    >(
      variables: SearchCompaniesQueryVariables,
      options?: UseQueryOptions<SearchCompaniesQuery, TError, TData>
    ) =>
    useQuery<SearchCompaniesQuery, TError, TData>(
      ['SEARCH_COMPANIES', variables],
      transport<SearchCompaniesQuery, SearchCompaniesQueryVariables>(SearchCompaniesDocument, variables),
      options
    );
useSearchCompaniesQuery.document = SearchCompaniesDocument;


useSearchCompaniesQuery.getKey = (variables: SearchCompaniesQueryVariables) => ['SEARCH_COMPANIES', variables];
;

export const SearchCompanyFilterDocument = `
    query SEARCH_COMPANY_FILTER($query: String!) {
  searchCompanies(query: $query) {
    company_id
    name
    icon {
      ...S3Object
    }
    display_name
  }
}
    ${S3ObjectFragmentDoc}`;
export const useSearchCompanyFilterQuery = <
      TData = SearchCompanyFilterQuery,
      TError = unknown
    >(
      variables: SearchCompanyFilterQueryVariables,
      options?: UseQueryOptions<SearchCompanyFilterQuery, TError, TData>
    ) =>
    useQuery<SearchCompanyFilterQuery, TError, TData>(
      ['SEARCH_COMPANY_FILTER', variables],
      transport<SearchCompanyFilterQuery, SearchCompanyFilterQueryVariables>(SearchCompanyFilterDocument, variables),
      options
    );
useSearchCompanyFilterQuery.document = SearchCompanyFilterDocument;


useSearchCompanyFilterQuery.getKey = (variables: SearchCompanyFilterQueryVariables) => ['SEARCH_COMPANY_FILTER', variables];
;

export const SearchContentDocument = `
    query SEARCH_CONTENT($search_content: SearchContentInput!) {
  searchContent(search_content: $search_content) {
    results {
      ...Content
    }
    next_id
    total_count
  }
}
    ${ContentFragmentDoc}`;
export const useSearchContentQuery = <
      TData = SearchContentQuery,
      TError = unknown
    >(
      variables: SearchContentQueryVariables,
      options?: UseQueryOptions<SearchContentQuery, TError, TData>
    ) =>
    useQuery<SearchContentQuery, TError, TData>(
      ['SEARCH_CONTENT', variables],
      transport<SearchContentQuery, SearchContentQueryVariables>(SearchContentDocument, variables),
      options
    );
useSearchContentQuery.document = SearchContentDocument;


useSearchContentQuery.getKey = (variables: SearchContentQueryVariables) => ['SEARCH_CONTENT', variables];
;

export const SearchEveryoneSocialDocument = `
    query SEARCH_EVERYONE_SOCIAL($data: SearchEveryoneSocialInput!) {
  searchEveryoneSocial(data: $data) {
    ...SearchEveryoneSocialResults
  }
}
    ${SearchEveryoneSocialResultsFragmentDoc}`;
export const useSearchEveryoneSocialQuery = <
      TData = SearchEveryoneSocialQuery,
      TError = unknown
    >(
      variables: SearchEveryoneSocialQueryVariables,
      options?: UseQueryOptions<SearchEveryoneSocialQuery, TError, TData>
    ) =>
    useQuery<SearchEveryoneSocialQuery, TError, TData>(
      ['SEARCH_EVERYONE_SOCIAL', variables],
      transport<SearchEveryoneSocialQuery, SearchEveryoneSocialQueryVariables>(SearchEveryoneSocialDocument, variables),
      options
    );
useSearchEveryoneSocialQuery.document = SearchEveryoneSocialDocument;


useSearchEveryoneSocialQuery.getKey = (variables: SearchEveryoneSocialQueryVariables) => ['SEARCH_EVERYONE_SOCIAL', variables];
;

export const ShareOverviewStatsDocument = `
    query SHARE_OVERVIEW_STATS($client_id: ID!, $end_date: String!, $start_date: String!, $filter: ReportingFilter, $page: Int, $per_page: Int, $snapshot: Boolean, $sort: SharesSortFields, $sort_direction: SortDirections, $report: ReportNames) {
  sortedShares(
    client_id: $client_id
    end_date: $end_date
    start_date: $start_date
    filter: $filter
    page: $page
    per_page: $per_page
    snapshot: $snapshot
    sort: $sort
    sort_direction: $sort_direction
    report: $report
  ) {
    title
    clicks
    engagements
    shares
    branded
    approved_by
    first_shared_at
    users
    content_id
    impressions
  }
}
    `;
export const useShareOverviewStatsQuery = <
      TData = ShareOverviewStatsQuery,
      TError = unknown
    >(
      variables: ShareOverviewStatsQueryVariables,
      options?: UseQueryOptions<ShareOverviewStatsQuery, TError, TData>
    ) =>
    useQuery<ShareOverviewStatsQuery, TError, TData>(
      ['SHARE_OVERVIEW_STATS', variables],
      transport<ShareOverviewStatsQuery, ShareOverviewStatsQueryVariables>(ShareOverviewStatsDocument, variables),
      options
    );
useShareOverviewStatsQuery.document = ShareOverviewStatsDocument;


useShareOverviewStatsQuery.getKey = (variables: ShareOverviewStatsQueryVariables) => ['SHARE_OVERVIEW_STATS', variables];
;

export const SearchSuggestDocument = `
    query SEARCH_SUGGEST($prefix: String!) {
  suggest(prefix: $prefix) {
    results {
      ... on GroupSuggestion {
        id
        title
        color
      }
      ... on ProfileSuggestion {
        id
        title
      }
    }
  }
}
    `;
export const useSearchSuggestQuery = <
      TData = SearchSuggestQuery,
      TError = unknown
    >(
      variables: SearchSuggestQueryVariables,
      options?: UseQueryOptions<SearchSuggestQuery, TError, TData>
    ) =>
    useQuery<SearchSuggestQuery, TError, TData>(
      ['SEARCH_SUGGEST', variables],
      transport<SearchSuggestQuery, SearchSuggestQueryVariables>(SearchSuggestDocument, variables),
      options
    );
useSearchSuggestQuery.document = SearchSuggestDocument;


useSearchSuggestQuery.getKey = (variables: SearchSuggestQueryVariables) => ['SEARCH_SUGGEST', variables];
;

export const GroupSuggestDocument = `
    query GROUP_SUGGEST($prefix: String!) {
  suggest(prefix: $prefix, index: suggestedgroups) {
    results {
      ... on GroupSuggestion {
        ...GroupSuggestion
      }
    }
  }
}
    ${GroupSuggestionFragmentDoc}`;
export const useGroupSuggestQuery = <
      TData = GroupSuggestQuery,
      TError = unknown
    >(
      variables: GroupSuggestQueryVariables,
      options?: UseQueryOptions<GroupSuggestQuery, TError, TData>
    ) =>
    useQuery<GroupSuggestQuery, TError, TData>(
      ['GROUP_SUGGEST', variables],
      transport<GroupSuggestQuery, GroupSuggestQueryVariables>(GroupSuggestDocument, variables),
      options
    );
useGroupSuggestQuery.document = GroupSuggestDocument;


useGroupSuggestQuery.getKey = (variables: GroupSuggestQueryVariables) => ['GROUP_SUGGEST', variables];
;

export const UserSuggestDocument = `
    query USER_SUGGEST($prefix: String!) {
  suggest(prefix: $prefix, index: suggestedprofiles) {
    results {
      ... on ProfileSuggestion {
        ...ProfileSuggestion
      }
    }
  }
}
    ${ProfileSuggestionFragmentDoc}`;
export const useUserSuggestQuery = <
      TData = UserSuggestQuery,
      TError = unknown
    >(
      variables: UserSuggestQueryVariables,
      options?: UseQueryOptions<UserSuggestQuery, TError, TData>
    ) =>
    useQuery<UserSuggestQuery, TError, TData>(
      ['USER_SUGGEST', variables],
      transport<UserSuggestQuery, UserSuggestQueryVariables>(UserSuggestDocument, variables),
      options
    );
useUserSuggestQuery.document = UserSuggestDocument;


useUserSuggestQuery.getKey = (variables: UserSuggestQueryVariables) => ['USER_SUGGEST', variables];
;

export const TotalReachOverviewStatsDocument = `
    query TOTAL_REACH_OVERVIEW_STATS($client_id: ID!, $end_date: String!, $start_date: String!) {
  reachOverviewStats(
    client_id: $client_id
    end_date: $end_date
    start_date: $start_date
  ) {
    summary {
      twitter_reach {
        count
        change
      }
      linkedin_reach {
        count
        change
      }
      reach {
        count
        change
      }
    }
    data {
      calendar_day
      twitter_reach
      linkedin_reach
    }
  }
}
    `;
export const useTotalReachOverviewStatsQuery = <
      TData = TotalReachOverviewStatsQuery,
      TError = unknown
    >(
      variables: TotalReachOverviewStatsQueryVariables,
      options?: UseQueryOptions<TotalReachOverviewStatsQuery, TError, TData>
    ) =>
    useQuery<TotalReachOverviewStatsQuery, TError, TData>(
      ['TOTAL_REACH_OVERVIEW_STATS', variables],
      transport<TotalReachOverviewStatsQuery, TotalReachOverviewStatsQueryVariables>(TotalReachOverviewStatsDocument, variables),
      options
    );
useTotalReachOverviewStatsQuery.document = TotalReachOverviewStatsDocument;


useTotalReachOverviewStatsQuery.getKey = (variables: TotalReachOverviewStatsQueryVariables) => ['TOTAL_REACH_OVERVIEW_STATS', variables];
;

export const UserActivityStatsDocument = `
    query USER_ACTIVITY_STATS($user_id: ID!, $end_date: String!, $start_date: String!) {
  userActivityStats(
    user_id: $user_id
    end_date: $end_date
    start_date: $start_date
  ) {
    daily_stats {
      ...ActivityStat
    }
    summary_stats {
      ...ActivityStat
    }
    percent_change {
      ...ActivityStat
    }
  }
}
    ${ActivityStatFragmentDoc}`;
export const useUserActivityStatsQuery = <
      TData = UserActivityStatsQuery,
      TError = unknown
    >(
      variables: UserActivityStatsQueryVariables,
      options?: UseQueryOptions<UserActivityStatsQuery, TError, TData>
    ) =>
    useQuery<UserActivityStatsQuery, TError, TData>(
      ['USER_ACTIVITY_STATS', variables],
      transport<UserActivityStatsQuery, UserActivityStatsQueryVariables>(UserActivityStatsDocument, variables),
      options
    );
useUserActivityStatsQuery.document = UserActivityStatsDocument;


useUserActivityStatsQuery.getKey = (variables: UserActivityStatsQueryVariables) => ['USER_ACTIVITY_STATS', variables];
;

export const UserDailyStatsDocument = `
    query USER_DAILY_STATS($user_id: ID!, $grouping: StatsGrouping!) {
  userDailyStats(user_id: $user_id, grouping: $grouping) {
    total_posts
    total_shares
    total_clicks
    data {
      clicks
      posts
      shares
      calendar_day
    }
  }
}
    `;
export const useUserDailyStatsQuery = <
      TData = UserDailyStatsQuery,
      TError = unknown
    >(
      variables: UserDailyStatsQueryVariables,
      options?: UseQueryOptions<UserDailyStatsQuery, TError, TData>
    ) =>
    useQuery<UserDailyStatsQuery, TError, TData>(
      ['USER_DAILY_STATS', variables],
      transport<UserDailyStatsQuery, UserDailyStatsQueryVariables>(UserDailyStatsDocument, variables),
      options
    );
useUserDailyStatsQuery.document = UserDailyStatsDocument;


useUserDailyStatsQuery.getKey = (variables: UserDailyStatsQueryVariables) => ['USER_DAILY_STATS', variables];
;

export const UserEngagementComparisonDocument = `
    query USER_ENGAGEMENT_COMPARISON($user_id: ID!) {
  userEngagementComparison(user_id: $user_id) {
    engagements_per_share_client_max
    engagements_per_share_client_min
    engagements_per_share_user
    engagements_per_share_user_rank
    reach_growth_client_max
    reach_growth_client_min
    reach_growth_user
    reach_growth_user_rank
    reach_size_client_max
    reach_size_client_min
    reach_size_user
    reach_size_user_rank
  }
}
    `;
export const useUserEngagementComparisonQuery = <
      TData = UserEngagementComparisonQuery,
      TError = unknown
    >(
      variables: UserEngagementComparisonQueryVariables,
      options?: UseQueryOptions<UserEngagementComparisonQuery, TError, TData>
    ) =>
    useQuery<UserEngagementComparisonQuery, TError, TData>(
      ['USER_ENGAGEMENT_COMPARISON', variables],
      transport<UserEngagementComparisonQuery, UserEngagementComparisonQueryVariables>(UserEngagementComparisonDocument, variables),
      options
    );
useUserEngagementComparisonQuery.document = UserEngagementComparisonDocument;


useUserEngagementComparisonQuery.getKey = (variables: UserEngagementComparisonQueryVariables) => ['USER_ENGAGEMENT_COMPARISON', variables];
;

export const UserEngagementHistoryDocument = `
    query USER_ENGAGEMENT_HISTORY($content_ids: [String], $exclude_internal: Boolean, $format: EngagementHistoryFormat, $limit: Int, $network_profile_id: String, $offset: Int, $reverse: Boolean, $timestamp_end: Float, $timestamp_start: Float, $user_id: ID!) {
  userEngagementHistory(
    content_ids: $content_ids
    exclude_internal: $exclude_internal
    format: $format
    limit: $limit
    network_profile_id: $network_profile_id
    offset: $offset
    reverse: $reverse
    timestamp_end: $timestamp_end
    timestamp_start: $timestamp_start
    user_id: $user_id
  ) {
    content_id_times {
      content_id
      timestamps
    }
    content_id
    engagement_type
    followers_count
    following_count
    network_bio
    network_profile_id
    network_profile_handle
    network_profile_image
    network_profile_name
    network_profile_url
    network
    share_url
    timestamp
    total_content_ids {
      content_id
      count
    }
    total_engagement_types {
      engagement_type
      count
    }
    total_engagements
  }
}
    `;
export const useUserEngagementHistoryQuery = <
      TData = UserEngagementHistoryQuery,
      TError = unknown
    >(
      variables: UserEngagementHistoryQueryVariables,
      options?: UseQueryOptions<UserEngagementHistoryQuery, TError, TData>
    ) =>
    useQuery<UserEngagementHistoryQuery, TError, TData>(
      ['USER_ENGAGEMENT_HISTORY', variables],
      transport<UserEngagementHistoryQuery, UserEngagementHistoryQueryVariables>(UserEngagementHistoryDocument, variables),
      options
    );
useUserEngagementHistoryQuery.document = UserEngagementHistoryDocument;


useUserEngagementHistoryQuery.getKey = (variables: UserEngagementHistoryQueryVariables) => ['USER_ENGAGEMENT_HISTORY', variables];
;

export const UserEngagementStatsDocument = `
    query USER_ENGAGEMENT_STATS($user_id: ID!, $grouping: StatsGrouping!, $value: Int!) {
  userEngagementStats(user_id: $user_id, grouping: $grouping, value: $value) {
    clicks
    comments
    reactions
    posts
    shares
    engagements
    groups
  }
}
    `;
export const useUserEngagementStatsQuery = <
      TData = UserEngagementStatsQuery,
      TError = unknown
    >(
      variables: UserEngagementStatsQueryVariables,
      options?: UseQueryOptions<UserEngagementStatsQuery, TError, TData>
    ) =>
    useQuery<UserEngagementStatsQuery, TError, TData>(
      ['USER_ENGAGEMENT_STATS', variables],
      transport<UserEngagementStatsQuery, UserEngagementStatsQueryVariables>(UserEngagementStatsDocument, variables),
      options
    );
useUserEngagementStatsQuery.document = UserEngagementStatsDocument;


useUserEngagementStatsQuery.getKey = (variables: UserEngagementStatsQueryVariables) => ['USER_ENGAGEMENT_STATS', variables];
;

export const UserOverviewStatsDocument = `
    query USER_OVERVIEW_STATS($client_id: ID!, $end_date: String!, $start_date: String!, $page: Int, $per_page: Int, $snapshot: Boolean, $sort: UsersSortFields, $sort_direction: SortDirections, $report: ReportNames, $filter: ReportingFilter) {
  sortedUsers(
    client_id: $client_id
    end_date: $end_date
    start_date: $start_date
    page: $page
    per_page: $per_page
    snapshot: $snapshot
    sort: $sort
    sort_direction: $sort_direction
    report: $report
    filter: $filter
  ) {
    user_id
    name
    user_type
    user_status
    onboarding_completed
    created_at
    last_accessed_at
    clicks
    reach
    shares
    posts
  }
}
    `;
export const useUserOverviewStatsQuery = <
      TData = UserOverviewStatsQuery,
      TError = unknown
    >(
      variables: UserOverviewStatsQueryVariables,
      options?: UseQueryOptions<UserOverviewStatsQuery, TError, TData>
    ) =>
    useQuery<UserOverviewStatsQuery, TError, TData>(
      ['USER_OVERVIEW_STATS', variables],
      transport<UserOverviewStatsQuery, UserOverviewStatsQueryVariables>(UserOverviewStatsDocument, variables),
      options
    );
useUserOverviewStatsQuery.document = UserOverviewStatsDocument;


useUserOverviewStatsQuery.getKey = (variables: UserOverviewStatsQueryVariables) => ['USER_OVERVIEW_STATS', variables];
;

export const UserReachStatsDocument = `
    query USER_REACH_STATS($user_id: ID!, $grouping: StatsGrouping!, $value: Int!) {
  userReachStats(user_id: $user_id, grouping: $grouping, value: $value) {
    reach
    previous_reach
    provider
    profile_identifier
  }
}
    `;
export const useUserReachStatsQuery = <
      TData = UserReachStatsQuery,
      TError = unknown
    >(
      variables: UserReachStatsQueryVariables,
      options?: UseQueryOptions<UserReachStatsQuery, TError, TData>
    ) =>
    useQuery<UserReachStatsQuery, TError, TData>(
      ['USER_REACH_STATS', variables],
      transport<UserReachStatsQuery, UserReachStatsQueryVariables>(UserReachStatsDocument, variables),
      options
    );
useUserReachStatsQuery.document = UserReachStatsDocument;


useUserReachStatsQuery.getKey = (variables: UserReachStatsQueryVariables) => ['USER_REACH_STATS', variables];
;

export const GetCombinedGroupWebhookListDocument = `
    query GET_COMBINED_GROUP_WEBHOOK_LIST($id: ID!) {
  getGroup(id: $id) {
    ...Group
  }
  getGroupWebhookList(group_id: $id) {
    webhooks {
      ...Webhook
    }
    workvivo_workspaces {
      workvivo_workspace_id
      workspace_name
    }
  }
}
    ${GroupFragmentDoc}
${WebhookFragmentDoc}`;
export const useGetCombinedGroupWebhookListQuery = <
      TData = GetCombinedGroupWebhookListQuery,
      TError = unknown
    >(
      variables: GetCombinedGroupWebhookListQueryVariables,
      options?: UseQueryOptions<GetCombinedGroupWebhookListQuery, TError, TData>
    ) =>
    useQuery<GetCombinedGroupWebhookListQuery, TError, TData>(
      ['GET_COMBINED_GROUP_WEBHOOK_LIST', variables],
      transport<GetCombinedGroupWebhookListQuery, GetCombinedGroupWebhookListQueryVariables>(GetCombinedGroupWebhookListDocument, variables),
      options
    );
useGetCombinedGroupWebhookListQuery.document = GetCombinedGroupWebhookListDocument;


useGetCombinedGroupWebhookListQuery.getKey = (variables: GetCombinedGroupWebhookListQueryVariables) => ['GET_COMBINED_GROUP_WEBHOOK_LIST', variables];
;

export const GetFilterChipsDocument = `
    query GET_FILTER_CHIPS {
  getClientLocationsByStatus(data: {location_status: active}) {
    client_locations {
      id
      title
    }
  }
  getClientDepartmentsByStatus(data: {department_status: active}) {
    client_departments {
      id
      title
    }
  }
  getUserSegments(segment_status: active) {
    id
    title
  }
}
    `;
export const useGetFilterChipsQuery = <
      TData = GetFilterChipsQuery,
      TError = unknown
    >(
      variables?: GetFilterChipsQueryVariables,
      options?: UseQueryOptions<GetFilterChipsQuery, TError, TData>
    ) =>
    useQuery<GetFilterChipsQuery, TError, TData>(
      variables === undefined ? ['GET_FILTER_CHIPS'] : ['GET_FILTER_CHIPS', variables],
      transport<GetFilterChipsQuery, GetFilterChipsQueryVariables>(GetFilterChipsDocument, variables),
      options
    );
useGetFilterChipsQuery.document = GetFilterChipsDocument;


useGetFilterChipsQuery.getKey = (variables?: GetFilterChipsQueryVariables) => variables === undefined ? ['GET_FILTER_CHIPS'] : ['GET_FILTER_CHIPS', variables];
;

export const AdminSetPasswordDocument = `
    mutation ADMIN_SET_PASSWORD($user_id: ID!, $password: String!, $permanent: Boolean) {
  adminSetPassword(user_id: $user_id, password: $password, permanent: $permanent) {
    ...UserProfile
  }
}
    ${UserProfileFragmentDoc}`;
export const useAdminSetPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AdminSetPasswordMutation, TError, AdminSetPasswordMutationVariables, TContext>) =>
    useMutation<AdminSetPasswordMutation, TError, AdminSetPasswordMutationVariables, TContext>(
      'ADMIN_SET_PASSWORD',
      (variables?: AdminSetPasswordMutationVariables) => transport<AdminSetPasswordMutation, AdminSetPasswordMutationVariables>(AdminSetPasswordDocument, variables)(),
      options
    );
export const CreateClientDocument = `
    mutation CREATE_CLIENT($data: CreateClientInput!) {
  createClient(data: $data) {
    ...ClientProtected
  }
}
    ${ClientProtectedFragmentDoc}`;
export const useCreateClientMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateClientMutation, TError, CreateClientMutationVariables, TContext>) =>
    useMutation<CreateClientMutation, TError, CreateClientMutationVariables, TContext>(
      'CREATE_CLIENT',
      (variables?: CreateClientMutationVariables) => transport<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, variables)(),
      options
    );
export const CreateScimTokenDocument = `
    mutation CREATE_SCIM_TOKEN($token: ScimTokenInput!) {
  createScimToken(token: $token) {
    ...ScimToken
  }
}
    ${ScimTokenFragmentDoc}`;
export const useCreateScimTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateScimTokenMutation, TError, CreateScimTokenMutationVariables, TContext>) =>
    useMutation<CreateScimTokenMutation, TError, CreateScimTokenMutationVariables, TContext>(
      'CREATE_SCIM_TOKEN',
      (variables?: CreateScimTokenMutationVariables) => transport<CreateScimTokenMutation, CreateScimTokenMutationVariables>(CreateScimTokenDocument, variables)(),
      options
    );
export const CsCreateUserDocument = `
    mutation CS_CREATE_USER($client_id: ID!, $email_address: String!, $password: String!) {
  csCreateUser(
    data: {client_id: $client_id, email_address: $email_address, password: $password}
  ) {
    ...UserProfile
  }
}
    ${UserProfileFragmentDoc}`;
export const useCsCreateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CsCreateUserMutation, TError, CsCreateUserMutationVariables, TContext>) =>
    useMutation<CsCreateUserMutation, TError, CsCreateUserMutationVariables, TContext>(
      'CS_CREATE_USER',
      (variables?: CsCreateUserMutationVariables) => transport<CsCreateUserMutation, CsCreateUserMutationVariables>(CsCreateUserDocument, variables)(),
      options
    );
export const DeleteScimTokenDocument = `
    mutation DELETE_SCIM_TOKEN($id: ID!) {
  deleteScimToken(id: $id)
}
    `;
export const useDeleteScimTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteScimTokenMutation, TError, DeleteScimTokenMutationVariables, TContext>) =>
    useMutation<DeleteScimTokenMutation, TError, DeleteScimTokenMutationVariables, TContext>(
      'DELETE_SCIM_TOKEN',
      (variables?: DeleteScimTokenMutationVariables) => transport<DeleteScimTokenMutation, DeleteScimTokenMutationVariables>(DeleteScimTokenDocument, variables)(),
      options
    );
export const GenerateClientBillingReportAggregateDownloadDocument = `
    mutation GENERATE_CLIENT_BILLING_REPORT_AGGREGATE_DOWNLOAD($search_filter: ClientBillingReportAggregateSearchFilter!) {
  generateClientBillingReportAggregateDownload(search_filter: $search_filter)
}
    `;
export const useGenerateClientBillingReportAggregateDownloadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateClientBillingReportAggregateDownloadMutation, TError, GenerateClientBillingReportAggregateDownloadMutationVariables, TContext>) =>
    useMutation<GenerateClientBillingReportAggregateDownloadMutation, TError, GenerateClientBillingReportAggregateDownloadMutationVariables, TContext>(
      'GENERATE_CLIENT_BILLING_REPORT_AGGREGATE_DOWNLOAD',
      (variables?: GenerateClientBillingReportAggregateDownloadMutationVariables) => transport<GenerateClientBillingReportAggregateDownloadMutation, GenerateClientBillingReportAggregateDownloadMutationVariables>(GenerateClientBillingReportAggregateDownloadDocument, variables)(),
      options
    );
export const GenerateClientBillingUserReportDownloadDocument = `
    mutation GENERATE_CLIENT_BILLING_USER_REPORT_DOWNLOAD($calendar_month: String, $client_id: String) {
  generateClientBillingUserReportDownload(
    calendar_month: $calendar_month
    client_id: $client_id
  )
}
    `;
export const useGenerateClientBillingUserReportDownloadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateClientBillingUserReportDownloadMutation, TError, GenerateClientBillingUserReportDownloadMutationVariables, TContext>) =>
    useMutation<GenerateClientBillingUserReportDownloadMutation, TError, GenerateClientBillingUserReportDownloadMutationVariables, TContext>(
      'GENERATE_CLIENT_BILLING_USER_REPORT_DOWNLOAD',
      (variables?: GenerateClientBillingUserReportDownloadMutationVariables) => transport<GenerateClientBillingUserReportDownloadMutation, GenerateClientBillingUserReportDownloadMutationVariables>(GenerateClientBillingUserReportDownloadDocument, variables)(),
      options
    );
export const SetImpersonationDocument = `
    mutation SET_IMPERSONATION($id: ID!, $impersonate_user_id: ID) {
  updateUserProfile(data: {id: $id, impersonate_user_id: $impersonate_user_id}) {
    id
  }
}
    `;
export const useSetImpersonationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetImpersonationMutation, TError, SetImpersonationMutationVariables, TContext>) =>
    useMutation<SetImpersonationMutation, TError, SetImpersonationMutationVariables, TContext>(
      'SET_IMPERSONATION',
      (variables?: SetImpersonationMutationVariables) => transport<SetImpersonationMutation, SetImpersonationMutationVariables>(SetImpersonationDocument, variables)(),
      options
    );
export const CsUpdateClientDocument = `
    mutation CS_UPDATE_CLIENT($data: CSUpdateClientInput!) {
  csUpdateClient(data: $data) {
    ...ClientProtected
  }
}
    ${ClientProtectedFragmentDoc}`;
export const useCsUpdateClientMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CsUpdateClientMutation, TError, CsUpdateClientMutationVariables, TContext>) =>
    useMutation<CsUpdateClientMutation, TError, CsUpdateClientMutationVariables, TContext>(
      'CS_UPDATE_CLIENT',
      (variables?: CsUpdateClientMutationVariables) => transport<CsUpdateClientMutation, CsUpdateClientMutationVariables>(CsUpdateClientDocument, variables)(),
      options
    );
export const UpdateClientToCapabilitiesDocument = `
    mutation UPDATE_CLIENT_TO_CAPABILITIES($capability_ids: [String]!, $clients: [ClientsFeatureToggleUpdateInput]!) {
  updateClientsToCapabilities(capability_ids: $capability_ids, clients: $clients) {
    ...Capability
  }
}
    ${CapabilityFragmentDoc}`;
export const useUpdateClientToCapabilitiesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateClientToCapabilitiesMutation, TError, UpdateClientToCapabilitiesMutationVariables, TContext>) =>
    useMutation<UpdateClientToCapabilitiesMutation, TError, UpdateClientToCapabilitiesMutationVariables, TContext>(
      'UPDATE_CLIENT_TO_CAPABILITIES',
      (variables?: UpdateClientToCapabilitiesMutationVariables) => transport<UpdateClientToCapabilitiesMutation, UpdateClientToCapabilitiesMutationVariables>(UpdateClientToCapabilitiesDocument, variables)(),
      options
    );
export const UpdateClientToReleaseTogglesDocument = `
    mutation UPDATE_CLIENT_TO_RELEASE_TOGGLES($release_toggle_ids: [String]!, $clients: [ClientsFeatureToggleUpdateInput]!) {
  updateClientsToReleaseToggles(
    release_toggle_ids: $release_toggle_ids
    clients: $clients
  ) {
    ...ReleaseToggle
  }
}
    ${ReleaseToggleFragmentDoc}`;
export const useUpdateClientToReleaseTogglesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateClientToReleaseTogglesMutation, TError, UpdateClientToReleaseTogglesMutationVariables, TContext>) =>
    useMutation<UpdateClientToReleaseTogglesMutation, TError, UpdateClientToReleaseTogglesMutationVariables, TContext>(
      'UPDATE_CLIENT_TO_RELEASE_TOGGLES',
      (variables?: UpdateClientToReleaseTogglesMutationVariables) => transport<UpdateClientToReleaseTogglesMutation, UpdateClientToReleaseTogglesMutationVariables>(UpdateClientToReleaseTogglesDocument, variables)(),
      options
    );
export const UpdateProviderDetailsForClientDocument = `
    mutation UPDATE_PROVIDER_DETAILS_FOR_CLIENT($client_id: ID!, $provider_details: ProviderDetailsInput!, $provider_type: ProviderType!) {
  updateProviderDetailsForClient(
    client_id: $client_id
    provider_details: $provider_details
    provider_type: $provider_type
  ) {
    ...ClientProtected
  }
}
    ${ClientProtectedFragmentDoc}`;
export const useUpdateProviderDetailsForClientMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProviderDetailsForClientMutation, TError, UpdateProviderDetailsForClientMutationVariables, TContext>) =>
    useMutation<UpdateProviderDetailsForClientMutation, TError, UpdateProviderDetailsForClientMutationVariables, TContext>(
      'UPDATE_PROVIDER_DETAILS_FOR_CLIENT',
      (variables?: UpdateProviderDetailsForClientMutationVariables) => transport<UpdateProviderDetailsForClientMutation, UpdateProviderDetailsForClientMutationVariables>(UpdateProviderDetailsForClientDocument, variables)(),
      options
    );
export const UpdateUserMappingsForClientDocument = `
    mutation UPDATE_USER_MAPPINGS_FOR_CLIENT($client_id: ID!, $user_mappings: UserMappingsInput!) {
  updateUserMappingsForClient(
    client_id: $client_id
    user_mappings: $user_mappings
  ) {
    ...UserMappings
  }
}
    ${UserMappingsFragmentDoc}`;
export const useUpdateUserMappingsForClientMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserMappingsForClientMutation, TError, UpdateUserMappingsForClientMutationVariables, TContext>) =>
    useMutation<UpdateUserMappingsForClientMutation, TError, UpdateUserMappingsForClientMutationVariables, TContext>(
      'UPDATE_USER_MAPPINGS_FOR_CLIENT',
      (variables?: UpdateUserMappingsForClientMutationVariables) => transport<UpdateUserMappingsForClientMutation, UpdateUserMappingsForClientMutationVariables>(UpdateUserMappingsForClientDocument, variables)(),
      options
    );
export const GetCapabilitiesDocument = `
    query GET_CAPABILITIES {
  getCapabilities {
    ...Capability
  }
}
    ${CapabilityFragmentDoc}`;
export const useGetCapabilitiesQuery = <
      TData = GetCapabilitiesQuery,
      TError = unknown
    >(
      variables?: GetCapabilitiesQueryVariables,
      options?: UseQueryOptions<GetCapabilitiesQuery, TError, TData>
    ) =>
    useQuery<GetCapabilitiesQuery, TError, TData>(
      variables === undefined ? ['GET_CAPABILITIES'] : ['GET_CAPABILITIES', variables],
      transport<GetCapabilitiesQuery, GetCapabilitiesQueryVariables>(GetCapabilitiesDocument, variables),
      options
    );
useGetCapabilitiesQuery.document = GetCapabilitiesDocument;


useGetCapabilitiesQuery.getKey = (variables?: GetCapabilitiesQueryVariables) => variables === undefined ? ['GET_CAPABILITIES'] : ['GET_CAPABILITIES', variables];
;

export const GetCapabilityDetailsDocument = `
    query GET_CAPABILITY_DETAILS($capability_id: String!) {
  getCapabilityDetails(capability_id: $capability_id) {
    ...Capability
  }
}
    ${CapabilityFragmentDoc}`;
export const useGetCapabilityDetailsQuery = <
      TData = GetCapabilityDetailsQuery,
      TError = unknown
    >(
      variables: GetCapabilityDetailsQueryVariables,
      options?: UseQueryOptions<GetCapabilityDetailsQuery, TError, TData>
    ) =>
    useQuery<GetCapabilityDetailsQuery, TError, TData>(
      ['GET_CAPABILITY_DETAILS', variables],
      transport<GetCapabilityDetailsQuery, GetCapabilityDetailsQueryVariables>(GetCapabilityDetailsDocument, variables),
      options
    );
useGetCapabilityDetailsQuery.document = GetCapabilityDetailsDocument;


useGetCapabilityDetailsQuery.getKey = (variables: GetCapabilityDetailsQueryVariables) => ['GET_CAPABILITY_DETAILS', variables];
;

export const GetClientDocument = `
    query GET_CLIENT($id: ID!) {
  getClient(id: $id) {
    ...ClientProtected
  }
}
    ${ClientProtectedFragmentDoc}`;
export const useGetClientQuery = <
      TData = GetClientQuery,
      TError = unknown
    >(
      variables: GetClientQueryVariables,
      options?: UseQueryOptions<GetClientQuery, TError, TData>
    ) =>
    useQuery<GetClientQuery, TError, TData>(
      ['GET_CLIENT', variables],
      transport<GetClientQuery, GetClientQueryVariables>(GetClientDocument, variables),
      options
    );
useGetClientQuery.document = GetClientDocument;


useGetClientQuery.getKey = (variables: GetClientQueryVariables) => ['GET_CLIENT', variables];
;

export const GetClientsDocument = `
    query GET_CLIENTS($client_status: ClientStatus!) {
  getClients(client_status: $client_status) {
    ...ClientProtected
  }
}
    ${ClientProtectedFragmentDoc}`;
export const useGetClientsQuery = <
      TData = GetClientsQuery,
      TError = unknown
    >(
      variables: GetClientsQueryVariables,
      options?: UseQueryOptions<GetClientsQuery, TError, TData>
    ) =>
    useQuery<GetClientsQuery, TError, TData>(
      ['GET_CLIENTS', variables],
      transport<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, variables),
      options
    );
useGetClientsQuery.document = GetClientsDocument;


useGetClientsQuery.getKey = (variables: GetClientsQueryVariables) => ['GET_CLIENTS', variables];
;

export const GetIdentityProviderForClientDocument = `
    query GET_IDENTITY_PROVIDER_FOR_CLIENT($client_id: ID!) {
  getIdentityProviderForClient(client_id: $client_id) {
    ...IdentityProvider
  }
}
    ${IdentityProviderFragmentDoc}`;
export const useGetIdentityProviderForClientQuery = <
      TData = GetIdentityProviderForClientQuery,
      TError = unknown
    >(
      variables: GetIdentityProviderForClientQueryVariables,
      options?: UseQueryOptions<GetIdentityProviderForClientQuery, TError, TData>
    ) =>
    useQuery<GetIdentityProviderForClientQuery, TError, TData>(
      ['GET_IDENTITY_PROVIDER_FOR_CLIENT', variables],
      transport<GetIdentityProviderForClientQuery, GetIdentityProviderForClientQueryVariables>(GetIdentityProviderForClientDocument, variables),
      options
    );
useGetIdentityProviderForClientQuery.document = GetIdentityProviderForClientDocument;


useGetIdentityProviderForClientQuery.getKey = (variables: GetIdentityProviderForClientQueryVariables) => ['GET_IDENTITY_PROVIDER_FOR_CLIENT', variables];
;

export const GetReleaseTogglesDocument = `
    query GET_RELEASE_TOGGLES {
  getReleaseToggles {
    ...ReleaseToggle
  }
}
    ${ReleaseToggleFragmentDoc}`;
export const useGetReleaseTogglesQuery = <
      TData = GetReleaseTogglesQuery,
      TError = unknown
    >(
      variables?: GetReleaseTogglesQueryVariables,
      options?: UseQueryOptions<GetReleaseTogglesQuery, TError, TData>
    ) =>
    useQuery<GetReleaseTogglesQuery, TError, TData>(
      variables === undefined ? ['GET_RELEASE_TOGGLES'] : ['GET_RELEASE_TOGGLES', variables],
      transport<GetReleaseTogglesQuery, GetReleaseTogglesQueryVariables>(GetReleaseTogglesDocument, variables),
      options
    );
useGetReleaseTogglesQuery.document = GetReleaseTogglesDocument;


useGetReleaseTogglesQuery.getKey = (variables?: GetReleaseTogglesQueryVariables) => variables === undefined ? ['GET_RELEASE_TOGGLES'] : ['GET_RELEASE_TOGGLES', variables];
;

export const GetReleaseToggleDetailsDocument = `
    query GET_RELEASE_TOGGLE_DETAILS($release_toggle_id: String!) {
  getReleaseToggleDetails(release_toggle_id: $release_toggle_id) {
    ...ReleaseToggle
  }
}
    ${ReleaseToggleFragmentDoc}`;
export const useGetReleaseToggleDetailsQuery = <
      TData = GetReleaseToggleDetailsQuery,
      TError = unknown
    >(
      variables: GetReleaseToggleDetailsQueryVariables,
      options?: UseQueryOptions<GetReleaseToggleDetailsQuery, TError, TData>
    ) =>
    useQuery<GetReleaseToggleDetailsQuery, TError, TData>(
      ['GET_RELEASE_TOGGLE_DETAILS', variables],
      transport<GetReleaseToggleDetailsQuery, GetReleaseToggleDetailsQueryVariables>(GetReleaseToggleDetailsDocument, variables),
      options
    );
useGetReleaseToggleDetailsQuery.document = GetReleaseToggleDetailsDocument;


useGetReleaseToggleDetailsQuery.getKey = (variables: GetReleaseToggleDetailsQueryVariables) => ['GET_RELEASE_TOGGLE_DETAILS', variables];
;

export const GetUserMappingsForClientDocument = `
    query GET_USER_MAPPINGS_FOR_CLIENT($client_id: ID!) {
  getUserMappingsForClient(client_id: $client_id) {
    ...UserMappings
  }
}
    ${UserMappingsFragmentDoc}`;
export const useGetUserMappingsForClientQuery = <
      TData = GetUserMappingsForClientQuery,
      TError = unknown
    >(
      variables: GetUserMappingsForClientQueryVariables,
      options?: UseQueryOptions<GetUserMappingsForClientQuery, TError, TData>
    ) =>
    useQuery<GetUserMappingsForClientQuery, TError, TData>(
      ['GET_USER_MAPPINGS_FOR_CLIENT', variables],
      transport<GetUserMappingsForClientQuery, GetUserMappingsForClientQueryVariables>(GetUserMappingsForClientDocument, variables),
      options
    );
useGetUserMappingsForClientQuery.document = GetUserMappingsForClientDocument;


useGetUserMappingsForClientQuery.getKey = (variables: GetUserMappingsForClientQueryVariables) => ['GET_USER_MAPPINGS_FOR_CLIENT', variables];
;

export const SearchClientsDocument = `
    query SEARCH_CLIENTS($search_filter: ClientSearchFilter, $count: Boolean, $limit: Int, $last_evaluated_key: String) {
  searchClients(
    search_filter: $search_filter
    count: $count
    limit: $limit
    last_evaluated_key: $last_evaluated_key
  ) {
    count
    last_evaluated_key
    items {
      ...ClientProtected
    }
  }
}
    ${ClientProtectedFragmentDoc}`;
export const useSearchClientsQuery = <
      TData = SearchClientsQuery,
      TError = unknown
    >(
      variables?: SearchClientsQueryVariables,
      options?: UseQueryOptions<SearchClientsQuery, TError, TData>
    ) =>
    useQuery<SearchClientsQuery, TError, TData>(
      variables === undefined ? ['SEARCH_CLIENTS'] : ['SEARCH_CLIENTS', variables],
      transport<SearchClientsQuery, SearchClientsQueryVariables>(SearchClientsDocument, variables),
      options
    );
useSearchClientsQuery.document = SearchClientsDocument;


useSearchClientsQuery.getKey = (variables?: SearchClientsQueryVariables) => variables === undefined ? ['SEARCH_CLIENTS'] : ['SEARCH_CLIENTS', variables];
;

export const SearchClientBillingReportAggregateDocument = `
    query SEARCH_CLIENT_BILLING_REPORT_AGGREGATE($search_filter: ClientBillingReportAggregateSearchFilter, $last_evaluated_key: String, $limit: Int) {
  searchClientBillingReportAggregate(
    search_filter: $search_filter
    last_evaluated_key: $last_evaluated_key
    limit: $limit
  ) {
    items {
      ...ClientBillingReportAggregate
    }
    count
    last_evaluated_key
  }
}
    ${ClientBillingReportAggregateFragmentDoc}`;
export const useSearchClientBillingReportAggregateQuery = <
      TData = SearchClientBillingReportAggregateQuery,
      TError = unknown
    >(
      variables?: SearchClientBillingReportAggregateQueryVariables,
      options?: UseQueryOptions<SearchClientBillingReportAggregateQuery, TError, TData>
    ) =>
    useQuery<SearchClientBillingReportAggregateQuery, TError, TData>(
      variables === undefined ? ['SEARCH_CLIENT_BILLING_REPORT_AGGREGATE'] : ['SEARCH_CLIENT_BILLING_REPORT_AGGREGATE', variables],
      transport<SearchClientBillingReportAggregateQuery, SearchClientBillingReportAggregateQueryVariables>(SearchClientBillingReportAggregateDocument, variables),
      options
    );
useSearchClientBillingReportAggregateQuery.document = SearchClientBillingReportAggregateDocument;


useSearchClientBillingReportAggregateQuery.getKey = (variables?: SearchClientBillingReportAggregateQueryVariables) => variables === undefined ? ['SEARCH_CLIENT_BILLING_REPORT_AGGREGATE'] : ['SEARCH_CLIENT_BILLING_REPORT_AGGREGATE', variables];
;

export const SearchScimTokensDocument = `
    query SEARCH_SCIM_TOKENS($search_filter: ScimTokenSearchFilter, $count: Boolean, $limit: Int, $last_evaluated_key: String) {
  searchScimTokens(
    search_filter: $search_filter
    count: $count
    limit: $limit
    last_evaluated_key: $last_evaluated_key
  ) {
    count
    last_evaluated_key
    items {
      ...ScimToken
      rate_limit_window_end_at
    }
  }
}
    ${ScimTokenFragmentDoc}`;
export const useSearchScimTokensQuery = <
      TData = SearchScimTokensQuery,
      TError = unknown
    >(
      variables?: SearchScimTokensQueryVariables,
      options?: UseQueryOptions<SearchScimTokensQuery, TError, TData>
    ) =>
    useQuery<SearchScimTokensQuery, TError, TData>(
      variables === undefined ? ['SEARCH_SCIM_TOKENS'] : ['SEARCH_SCIM_TOKENS', variables],
      transport<SearchScimTokensQuery, SearchScimTokensQueryVariables>(SearchScimTokensDocument, variables),
      options
    );
useSearchScimTokensQuery.document = SearchScimTokensDocument;


useSearchScimTokensQuery.getKey = (variables?: SearchScimTokensQueryVariables) => variables === undefined ? ['SEARCH_SCIM_TOKENS'] : ['SEARCH_SCIM_TOKENS', variables];
;
